/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "../node_modules/agentkeepalive/browser.js":
/***/ (function(module, exports) {

module.exports = noop;
module.exports.HttpsAgent = noop;

// Noop function for browser since native api's don't use agents.
function noop () {}


/***/ }),

/***/ "../node_modules/asos-content-api-global-banner/dist/asos-content-api-global-banner.min.js":
/***/ (function(module, exports, __webpack_require__) {

!function(t,n){ true?module.exports=n(__webpack_require__("../node_modules/prop-types/index.js"),__webpack_require__("../node_modules/react/index.js")):"function"==typeof define&&define.amd?define("asos-content-api-global-banner",["prop-types","react"],n):"object"==typeof exports?exports["asos-content-api-global-banner"]=n(require("prop-types"),require("react")):t["asos-content-api-global-banner"]=n(t["prop-types"],t.react)}(this,function(t,n){return function(t){var n={};function o(e){if(n[e])return n[e].exports;var r=n[e]={i:e,l:!1,exports:{}};return t[e].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=t,o.c=n,o.i=function(t){return t},o.d=function(t,n,e){o.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:e})},o.n=function(t){var n=t&&t.__esModule?function(){return t["default"]}:function(){return t};return o.d(n,"a",n),n},o.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},o.p="",o(o.s=12)}([function(t,n){t.exports=__webpack_require__("../node_modules/prop-types/index.js")},function(t,n){t.exports=__webpack_require__("../node_modules/react/index.js")},function(t,n){t.exports=function(t){var n=[];return n.toString=function(){return this.map(function(n){var o=function(t,n){var o=t[1]||"",e=t[3];if(!e)return o;if(n&&"function"==typeof btoa){var r=function(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}(e),l=e.sources.map(function(t){return"/*# sourceURL="+e.sourceRoot+t+" */"});return[o].concat(l).concat([r]).join("\n")}return[o].join("\n")}(n,t);return n[2]?"@media "+n[2]+"{"+o+"}":o}).join("")},n.i=function(t,o){"string"==typeof t&&(t=[[null,t,""]]);for(var e={},r=0;r<this.length;r++){var l=this[r][0];"number"==typeof l&&(e[l]=!0)}for(r=0;r<t.length;r++){var i=t[r];"number"==typeof i[0]&&e[i[0]]||(o&&!i[2]?i[2]=o:o&&(i[2]="("+i[2]+") and ("+o+")"),n.push(i))}},n}},function(t,n,o){var e={},r=function(t){var n;return function(){return void 0===n&&(n=t.apply(this,arguments)),n}}(function(){return window&&document&&document.all&&!window.atob}),l=function(t){var n={};return function(t){if("function"==typeof t)return t();if("undefined"==typeof n[t]){var o=function(t){return document.querySelector(t)}.call(this,t);if(window.HTMLIFrameElement&&o instanceof window.HTMLIFrameElement)try{o=o.contentDocument.head}catch(e){o=null}n[t]=o}return n[t]}}(),i=null,a=0,s=[],c=o(25);function p(t,n){for(var o=0;o<t.length;o++){var r=t[o],l=e[r.id];if(l){l.refs++;for(var i=0;i<l.parts.length;i++)l.parts[i](r.parts[i]);for(;i<r.parts.length;i++)l.parts.push(h(r.parts[i],n))}else{var a=[];for(i=0;i<r.parts.length;i++)a.push(h(r.parts[i],n));e[r.id]={id:r.id,refs:1,parts:a}}}}function u(t,n){for(var o=[],e={},r=0;r<t.length;r++){var l=t[r],i=n.base?l[0]+n.base:l[0],a={css:l[1],media:l[2],sourceMap:l[3]};e[i]?e[i].parts.push(a):o.push(e[i]={id:i,parts:[a]})}return o}function f(t,n){var o=l(t.insertInto);if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var e=s[s.length-1];if("top"===t.insertAt)e?e.nextSibling?o.insertBefore(n,e.nextSibling):o.appendChild(n):o.insertBefore(n,o.firstChild),s.push(n);else if("bottom"===t.insertAt)o.appendChild(n);else{if("object"!=typeof t.insertAt||!t.insertAt.before)throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");var r=l(t.insertInto+" "+t.insertAt.before);o.insertBefore(n,r)}}function d(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var n=s.indexOf(t);n>=0&&s.splice(n,1)}function b(t){var n=document.createElement("style");return t.attrs.type===undefined&&(t.attrs.type="text/css"),_(n,t.attrs),f(t,n),n}function _(t,n){Object.keys(n).forEach(function(o){t.setAttribute(o,n[o])})}function h(t,n){var o,e,r,l;if(n.transform&&t.css){if(!(l=n.transform(t.css)))return function(){};t.css=l}if(n.singleton){var s=a++;o=i||(i=b(n)),e=B.bind(null,o,s,!1),r=B.bind(null,o,s,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(o=function(t){var n=document.createElement("link");return t.attrs.type===undefined&&(t.attrs.type="text/css"),t.attrs.rel="stylesheet",_(n,t.attrs),f(t,n),n}(n),e=function(t,n,o){var e=o.css,r=o.sourceMap,l=n.convertToAbsoluteUrls===undefined&&r;(n.convertToAbsoluteUrls||l)&&(e=c(e));r&&(e+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var i=new Blob([e],{type:"text/css"}),a=t.href;t.href=URL.createObjectURL(i),a&&URL.revokeObjectURL(a)}.bind(null,o,n),r=function(){d(o),o.href&&URL.revokeObjectURL(o.href)}):(o=b(n),e=function(t,n){var o=n.css,e=n.media;e&&t.setAttribute("media",e);if(t.styleSheet)t.styleSheet.cssText=o;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(o))}}.bind(null,o),r=function(){d(o)});return e(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap)return;e(t=n)}else r()}}t.exports=function(t,n){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");if("undefined"==typeof document)return null;(n=n||{}).attrs="object"==typeof n.attrs?n.attrs:{},n.singleton||"boolean"==typeof n.singleton||(n.singleton=r()),n.insertInto||(n.insertInto="head"),n.insertAt||(n.insertAt="bottom");var o=u(t,n);return p(o,n),function(t){for(var r=[],l=0;l<o.length;l++){var i=o[l];(a=e[i.id]).refs--,r.push(a)}t&&p(u(t,n),n);for(l=0;l<r.length;l++){var a;if(0===(a=r[l]).refs){for(var s=0;s<a.parts.length;s++)a.parts[s]();delete e[a.id]}}}};var C=function(){var t=[];return function(n,o){return t[n]=o,t.filter(Boolean).join("\n")}}();function B(t,n,o,e){var r=o?"":e.css;if(t.styleSheet)t.styleSheet.cssText=C(n,r);else{var l=document.createTextNode(r),i=t.childNodes;i[n]&&t.removeChild(i[n]),i.length?t.insertBefore(l,i[n]):t.appendChild(l)}}},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n.handleCtaRef=function(t,n){if(n.length>0&&t){var o="ctaref",e=new RegExp("([?&])ctaref=.*?(&|$)","i"),r=t.includes("?")?"&":"?";return t.match(e)?t.replace(e,"$1ctaref="+n+"$2"):""+t+r+o+"="+n}return t}},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=function(){function t(t,n){for(var o=0;o<n.length;o++){var e=n[o];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}return function(n,o,e){return o&&t(n.prototype,o),e&&t(n,e),n}}(),r=c(o(1)),l=c(o(0)),i=c(o(21)),a=c(o(11)),s=c(o(10));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.style=i["default"],t.state={tooltipVisible:!1},t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].Component),e(n,[{key:"handleUnitHover",value:function(){var t=this;return function(){t.setState({tooltipVisible:!t.state.tooltipVisible})}}},{key:"render",value:function(){return r["default"].createElement("div",{className:this.style.column,style:{backgroundColor:this.props.data.backgroundColor}},r["default"].createElement(a["default"],{data:this.props.data,unitPosition:this.props.columnPosition,handleUnitHover:this.handleUnitHover(),fontSize:this.props.data.fontSize,contentColor:this.props.data.contentColor}),this.props.data.tooltip?r["default"].createElement(s["default"],{content:this.props.data.tooltip,tooltipPosition:this.props.columnPosition,isVisible:this.state.tooltipVisible}):null)}}]),n}();p.defaultProps={data:{tooltip:"",fontSize:"medium",backgroundColor:"#FFF",contentColor:"#000"}},p.propTypes={columnPosition:l["default"].string.isRequired,data:l["default"].shape({tooltip:l["default"].string,fontSize:l["default"].string,backgroundColor:l["default"].string,contentColor:l["default"].string}).isRequired},n["default"]=p},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=function(){function t(t,n){for(var o=0;o<n.length;o++){var e=n[o];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}return function(n,o,e){return o&&t(n.prototype,o),e&&t(n,e),n}}();var r=function(){function t(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,t)}return e(t,[{key:"triggerNewrelicEvent",value:function(t,n){if(this.isUndefined(window)){var o=window.newrelic;o&&o.addPageAction(t,n)}}},{key:"triggerTargetEvent",value:function(t){if(this.isUndefined(window)){var n=new CustomEvent(t,{detail:{message:t,time:new Date},bubbles:!0,cancelable:!0});window.dispatchEvent(n)}}},{key:"isUndefined",value:function(t){return void 0!==t}}]),t}();n["default"]=r},function(t,n,o){var e=o(17);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=a(o(1)),r=a(o(0)),l=o(4),i=a(o(20));function a(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){var n=t.data,o=t.contentColor,r=t.style,a=r===undefined?i["default"]:r;return e["default"].createElement("a",{href:(0,l.handleCtaRef)(n.url,n.ctaRef),className:a.button,target:n.target,style:{color:o,borderColor:o}},n.text)};s.propTypes={data:r["default"].shape({url:r["default"].string.isRequired,text:r["default"].string.isRequired,ctaRef:r["default"].string.isRequired,target:r["default"].string.isRequired}).isRequired,contentColor:r["default"].string.isRequired,style:r["default"].object},n["default"]=s},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=a(o(1)),r=a(o(0)),l=a(o(22)),i=a(o(13));function a(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){var n=t.content,o=t.contentColor,r=t.fontSize,a=t.style,s=a===undefined?l["default"]:a;return e["default"].createElement("div",{className:s.content,style:{fontSize:i["default"][r],color:o}},e["default"].createElement("span",{className:s.copy,dangerouslySetInnerHTML:{__html:n}}))};s.propTypes={content:r["default"].string.isRequired,contentColor:r["default"].string.isRequired,fontSize:r["default"].string.isRequired,style:r["default"].object},n["default"]=s},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=function(){function t(t,n){for(var o=0;o<n.length;o++){var e=n[o];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}return function(n,o,e){return o&&t(n.prototype,o),e&&t(n,e),n}}(),r=a(o(1)),l=a(o(0)),i=a(o(23));function a(t){return t&&t.__esModule?t:{"default":t}}var s=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.style=i["default"],t.state={mouseOverTooltip:!1},t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].Component),e(n,[{key:"createMarkup",value:function(){return{__html:this.props.content}}},{key:"mouseOverTooltip",value:function(){this.setState({mouseOverTooltip:!this.state.mouseOverTooltip})}},{key:"getClasses",value:function(){return this.state.mouseOverTooltip||this.props.isVisible?this.style["wrapper"+this.props.tooltipPosition]:"\n      "+this.style["wrapper"+this.props.tooltipPosition]+" "+this.style.hidden+"\n    "}},{key:"render",value:function(){var t=this;return r["default"].createElement("div",{className:this.getClasses(),onMouseEnter:function(){return t.mouseOverTooltip()},onMouseLeave:function(){return t.mouseOverTooltip()}},r["default"].createElement("div",{className:this.style.tooltip,dangerouslySetInnerHTML:this.createMarkup()}))}}]),n}();s.propTypes={content:l["default"].string.isRequired,tooltipPosition:l["default"].string.isRequired,isVisible:l["default"].bool.isRequired},n["default"]=s},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=c(o(1)),r=c(o(0)),l=o(4),i=c(o(24)),a=c(o(9)),s=c(o(8));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){var n=t.data,o=t.unitPosition,r=t.fontSize,c=t.contentColor,p=t.handleUnitHover,u=t.style,f=u===undefined?i["default"]:u;return n.link?e["default"].createElement("a",{className:f.unitLink+" "+f["unit"+o],href:(0,l.handleCtaRef)(n.link.url,n.link.ctaRef),target:n.link.target,onMouseEnter:function(){return p()},onMouseLeave:function(){return p()}},e["default"].createElement(a["default"],{content:n.content,contentColor:c,fontSize:r})):e["default"].createElement("div",{className:f.unit+" "+f["unit"+o],onMouseEnter:function(){return p()},onMouseLeave:function(){return p()}},n.buttons.length?e["default"].createElement(s["default"],{data:n.buttons[0],contentColor:c}):null,e["default"].createElement(a["default"],{content:n.content,contentColor:c,fontSize:r}),n.buttons.length?e["default"].createElement(s["default"],{data:n.buttons[1],contentColor:c}):null)};p.propTypes={data:r["default"].shape({content:r["default"].string.isRequired,link:r["default"].object}).isRequired,unitPosition:r["default"].string.isRequired,fontSize:r["default"].string.isRequired,handleUnitHover:r["default"].func.isRequired,contentColor:r["default"].string.isRequired,style:r["default"].object},n["default"]=p},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0});var e=function(){function t(t,n){for(var o=0;o<n.length;o++){var e=n[o];e.enumerable=e.enumerable||!1,e.configurable=!0,"value"in e&&(e.writable=!0),Object.defineProperty(t,e.key,e)}}return function(n,o,e){return o&&t(n.prototype,o),e&&t(n,e),n}}(),r=c(o(1)),l=c(o(0)),i=c(o(7)),a=c(o(5)),s=c(o(6));function c(t){return t&&t.__esModule?t:{"default":t}}var p=function(t){function n(){!function(t,n){if(!(t instanceof n))throw new TypeError("Cannot call a class as a function")}(this,n);var t=function(t,n){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!n||"object"!=typeof n&&"function"!=typeof n?t:n}(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return t.eventManager=new s["default"],t.state={isLoading:!0},t.styles=i["default"],t}return function(t,n){if("function"!=typeof n&&null!==n)throw new TypeError("Super expression must either be null or a function, not "+typeof n);t.prototype=Object.create(n&&n.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),n&&(Object.setPrototypeOf?Object.setPrototypeOf(t,n):t.__proto__=n)}(n,r["default"].PureComponent),e(n,[{key:"componentDidUpdate",value:function(){"SUCCESS"===this.props.status&&this.state.isLoading&&(this.setState({isLoading:!1}),this.eventManager.triggerTargetEvent("globalBannerComplete"))}},{key:"getColumnPosition",value:function(t){return 1===this.props.content.columns.length?"Center":0===t?"Left":"Right"}},{key:"render",value:function(){var t=this;return r["default"].createElement("section",{id:"globalBannerComponent",className:this.styles.globalBanner},r["default"].createElement("div",{className:""+("SUCCESS"===this.props.status?this.styles.loaded:this.styles.loading)},"SUCCESS"===this.props.status?this.props.content.columns.map(function(n,o){return r["default"].createElement(a["default"],{key:"column"+o,data:n,columnPosition:t.getColumnPosition(o)})}):null))}}]),n}();p.propTypes={content:l["default"].shape({columns:l["default"].arrayOf(l["default"].object).isRequired}),status:l["default"].string.isRequired},n["default"]=p},function(t,n,o){"use strict";Object.defineProperty(n,"__esModule",{value:!0}),n["default"]={small:"13px",medium:"14px",large:"16px",xlarge:"18px"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,".src-GlobalBanner-Button-Button_button{height:30px;font-size:13px;font-weight:700;width:100px;border-radius:0;display:block;border:2px solid #fff;box-sizing:border-box;line-height:26px;text-decoration:none;color:#fff;margin:9px 0;cursor:pointer;opacity:1;transition:opacity .8s ease}.src-GlobalBanner-Button-Button_button:hover{opacity:.5;transition:opacity .8s ease}",""]),n.locals={button:"src-GlobalBanner-Button-Button_button"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,".src-GlobalBanner-Column-Column_column{width:50%;background:#fff;text-align:center;line-height:15px;height:100%;float:left;box-sizing:border-box;position:relative}.src-GlobalBanner-Column-Column_column:first-child{border-right:1px solid #ddd}.src-GlobalBanner-Column-Column_column:only-child{border-right:none;width:100%}",""]),n.locals={column:"src-GlobalBanner-Column-Column_column"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,'.src-GlobalBanner-Content-Content_content{display:table-cell;vertical-align:middle;margin:auto;width:100%;height:100%;box-sizing:border-box}.src-GlobalBanner-Content-Content_content a,.src-GlobalBanner-Content-Content_content abbr,.src-GlobalBanner-Content-Content_content address,.src-GlobalBanner-Content-Content_content article,.src-GlobalBanner-Content-Content_content aside,.src-GlobalBanner-Content-Content_content audio,.src-GlobalBanner-Content-Content_content b,.src-GlobalBanner-Content-Content_content big,.src-GlobalBanner-Content-Content_content blockquote,.src-GlobalBanner-Content-Content_content canvas,.src-GlobalBanner-Content-Content_content caption,.src-GlobalBanner-Content-Content_content center,.src-GlobalBanner-Content-Content_content dd,.src-GlobalBanner-Content-Content_content del,.src-GlobalBanner-Content-Content_content details,.src-GlobalBanner-Content-Content_content dfn,.src-GlobalBanner-Content-Content_content dl,.src-GlobalBanner-Content-Content_content dt,.src-GlobalBanner-Content-Content_content em,.src-GlobalBanner-Content-Content_content embed,.src-GlobalBanner-Content-Content_content fieldset,.src-GlobalBanner-Content-Content_content figcaption,.src-GlobalBanner-Content-Content_content figure,.src-GlobalBanner-Content-Content_content footer,.src-GlobalBanner-Content-Content_content form,.src-GlobalBanner-Content-Content_content h1,.src-GlobalBanner-Content-Content_content h2,.src-GlobalBanner-Content-Content_content h3,.src-GlobalBanner-Content-Content_content h4,.src-GlobalBanner-Content-Content_content h5,.src-GlobalBanner-Content-Content_content h6,.src-GlobalBanner-Content-Content_content header,.src-GlobalBanner-Content-Content_content hgroup,.src-GlobalBanner-Content-Content_content i,.src-GlobalBanner-Content-Content_content img,.src-GlobalBanner-Content-Content_content label,.src-GlobalBanner-Content-Content_content legend,.src-GlobalBanner-Content-Content_content li,.src-GlobalBanner-Content-Content_content mark,.src-GlobalBanner-Content-Content_content menu,.src-GlobalBanner-Content-Content_content nav,.src-GlobalBanner-Content-Content_content ol,.src-GlobalBanner-Content-Content_content output,.src-GlobalBanner-Content-Content_content p,.src-GlobalBanner-Content-Content_content pre,.src-GlobalBanner-Content-Content_content q,.src-GlobalBanner-Content-Content_content ruby,.src-GlobalBanner-Content-Content_content s,.src-GlobalBanner-Content-Content_content samp,.src-GlobalBanner-Content-Content_content section,.src-GlobalBanner-Content-Content_content small,.src-GlobalBanner-Content-Content_content strike,.src-GlobalBanner-Content-Content_content strong,.src-GlobalBanner-Content-Content_content summary,.src-GlobalBanner-Content-Content_content sup,.src-GlobalBanner-Content-Content_content table,.src-GlobalBanner-Content-Content_content tbody,.src-GlobalBanner-Content-Content_content td,.src-GlobalBanner-Content-Content_content tfoot,.src-GlobalBanner-Content-Content_content th,.src-GlobalBanner-Content-Content_content thead,.src-GlobalBanner-Content-Content_content tr,.src-GlobalBanner-Content-Content_content tt,.src-GlobalBanner-Content-Content_content u,.src-GlobalBanner-Content-Content_content ul,.src-GlobalBanner-Content-Content_content var,.src-GlobalBanner-Content-Content_content video{margin:0;padding:0;border:0;vertical-align:baseline}.src-GlobalBanner-Content-Content_content article,.src-GlobalBanner-Content-Content_content aside,.src-GlobalBanner-Content-Content_content details,.src-GlobalBanner-Content-Content_content figcaption,.src-GlobalBanner-Content-Content_content figure,.src-GlobalBanner-Content-Content_content footer,.src-GlobalBanner-Content-Content_content header,.src-GlobalBanner-Content-Content_content hgroup,.src-GlobalBanner-Content-Content_content menu,.src-GlobalBanner-Content-Content_content nav,.src-GlobalBanner-Content-Content_content section{display:block}.src-GlobalBanner-Content-Content_content ol,.src-GlobalBanner-Content-Content_content ul{list-style:none}.src-GlobalBanner-Content-Content_content blockquote,.src-GlobalBanner-Content-Content_content q{quotes:none}.src-GlobalBanner-Content-Content_content blockquote:after,.src-GlobalBanner-Content-Content_content blockquote:before,.src-GlobalBanner-Content-Content_content q:after,.src-GlobalBanner-Content-Content_content q:before{content:""}.src-GlobalBanner-Content-Content_content a{color:inherit;text-decoration:underline}.src-GlobalBanner-Content-Content_content table{border-collapse:collapse;border-spacing:0}.src-GlobalBanner-Content-Content_copy{text-align:center;max-width:661px;width:100%;display:inline-block;letter-spacing:.5px;vertical-align:middle;margin:auto;box-sizing:border-box}.src-GlobalBanner-Content-Content_copy strong{font-weight:700;letter-spacing:2px}',""]),n.locals={content:"src-GlobalBanner-Content-Content_content",copy:"src-GlobalBanner-Content-Content_copy"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,".src-GlobalBanner-GlobalBanner_globalBanner{display:none}@media (min-width:768px){.src-GlobalBanner-GlobalBanner_globalBanner{width:100%;height:50px;min-height:50px;margin:0 auto;font-family:Futura-pt,Futura STD,Arial,Verdana,sans-serif;font-size:13px;letter-spacing:1px;display:block;position:relative;background-color:#eee;box-sizing:border-box;border-bottom:1px solid #ddd}.src-GlobalBanner-GlobalBanner_loaded{opacity:1;visibility:visible}.src-GlobalBanner-GlobalBanner_loaded,.src-GlobalBanner-GlobalBanner_loading{width:100%;height:50px;box-sizing:border-box;border-bottom:1px solid #ddd;transition:opacity .6s,visibility .6s}.src-GlobalBanner-GlobalBanner_loading{opacity:0;visibility:hidden}}",""]),n.locals={globalBanner:"src-GlobalBanner-GlobalBanner_globalBanner",loaded:"src-GlobalBanner-GlobalBanner_loaded",loading:"src-GlobalBanner-GlobalBanner_loading"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,'.src-GlobalBanner-Tooltip-Tooltip_wrapperCenter,.src-GlobalBanner-Tooltip-Tooltip_wrapperLeft,.src-GlobalBanner-Tooltip-Tooltip_wrapperRight{box-sizing:border-box;transition-property:opacity,visiblity;transition-duration:1s;transition-timing-function:ease;opacity:1;visibility:visible;z-index:100}.src-GlobalBanner-Tooltip-Tooltip_wrapperCenter{max-width:100%;width:auto;padding:0 16px;margin:5px auto 0;position:absolute;left:50%;top:50px;transform:translate(-50%);display:inline-block}.src-GlobalBanner-Tooltip-Tooltip_wrapperLeft{position:absolute;top:52px;padding:0 16px;max-width:646px;width:100%;right:0;margin:0}.src-GlobalBanner-Tooltip-Tooltip_wrapperRight{position:absolute;top:52px;padding:0 16px;max-width:646px;width:100%;left:0;margin:0}.src-GlobalBanner-Tooltip-Tooltip_tooltip{font-size:12px;letter-spacing:.5px;line-height:14px;background:#f2f2f2;padding:8px;text-align:center;box-shadow:3px 3px 0 hsla(0,0%,41%,.5);text-transform:none;box-sizing:border-box}.src-GlobalBanner-Tooltip-Tooltip_tooltip:before{content:"";width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-bottom:5px solid #f2f2f2;position:absolute;top:-5px;margin:0 auto;left:0;right:0}.src-GlobalBanner-Tooltip-Tooltip_tooltip a,.src-GlobalBanner-Tooltip-Tooltip_tooltip abbr,.src-GlobalBanner-Tooltip-Tooltip_tooltip address,.src-GlobalBanner-Tooltip-Tooltip_tooltip article,.src-GlobalBanner-Tooltip-Tooltip_tooltip aside,.src-GlobalBanner-Tooltip-Tooltip_tooltip audio,.src-GlobalBanner-Tooltip-Tooltip_tooltip b,.src-GlobalBanner-Tooltip-Tooltip_tooltip big,.src-GlobalBanner-Tooltip-Tooltip_tooltip blockquote,.src-GlobalBanner-Tooltip-Tooltip_tooltip canvas,.src-GlobalBanner-Tooltip-Tooltip_tooltip caption,.src-GlobalBanner-Tooltip-Tooltip_tooltip center,.src-GlobalBanner-Tooltip-Tooltip_tooltip dd,.src-GlobalBanner-Tooltip-Tooltip_tooltip del,.src-GlobalBanner-Tooltip-Tooltip_tooltip details,.src-GlobalBanner-Tooltip-Tooltip_tooltip dfn,.src-GlobalBanner-Tooltip-Tooltip_tooltip dl,.src-GlobalBanner-Tooltip-Tooltip_tooltip dt,.src-GlobalBanner-Tooltip-Tooltip_tooltip em,.src-GlobalBanner-Tooltip-Tooltip_tooltip embed,.src-GlobalBanner-Tooltip-Tooltip_tooltip fieldset,.src-GlobalBanner-Tooltip-Tooltip_tooltip figcaption,.src-GlobalBanner-Tooltip-Tooltip_tooltip figure,.src-GlobalBanner-Tooltip-Tooltip_tooltip footer,.src-GlobalBanner-Tooltip-Tooltip_tooltip form,.src-GlobalBanner-Tooltip-Tooltip_tooltip h1,.src-GlobalBanner-Tooltip-Tooltip_tooltip h2,.src-GlobalBanner-Tooltip-Tooltip_tooltip h3,.src-GlobalBanner-Tooltip-Tooltip_tooltip h4,.src-GlobalBanner-Tooltip-Tooltip_tooltip h5,.src-GlobalBanner-Tooltip-Tooltip_tooltip h6,.src-GlobalBanner-Tooltip-Tooltip_tooltip header,.src-GlobalBanner-Tooltip-Tooltip_tooltip hgroup,.src-GlobalBanner-Tooltip-Tooltip_tooltip i,.src-GlobalBanner-Tooltip-Tooltip_tooltip img,.src-GlobalBanner-Tooltip-Tooltip_tooltip label,.src-GlobalBanner-Tooltip-Tooltip_tooltip legend,.src-GlobalBanner-Tooltip-Tooltip_tooltip li,.src-GlobalBanner-Tooltip-Tooltip_tooltip mark,.src-GlobalBanner-Tooltip-Tooltip_tooltip menu,.src-GlobalBanner-Tooltip-Tooltip_tooltip nav,.src-GlobalBanner-Tooltip-Tooltip_tooltip ol,.src-GlobalBanner-Tooltip-Tooltip_tooltip output,.src-GlobalBanner-Tooltip-Tooltip_tooltip p,.src-GlobalBanner-Tooltip-Tooltip_tooltip pre,.src-GlobalBanner-Tooltip-Tooltip_tooltip q,.src-GlobalBanner-Tooltip-Tooltip_tooltip ruby,.src-GlobalBanner-Tooltip-Tooltip_tooltip s,.src-GlobalBanner-Tooltip-Tooltip_tooltip samp,.src-GlobalBanner-Tooltip-Tooltip_tooltip section,.src-GlobalBanner-Tooltip-Tooltip_tooltip small,.src-GlobalBanner-Tooltip-Tooltip_tooltip strike,.src-GlobalBanner-Tooltip-Tooltip_tooltip strong,.src-GlobalBanner-Tooltip-Tooltip_tooltip summary,.src-GlobalBanner-Tooltip-Tooltip_tooltip sup,.src-GlobalBanner-Tooltip-Tooltip_tooltip table,.src-GlobalBanner-Tooltip-Tooltip_tooltip tbody,.src-GlobalBanner-Tooltip-Tooltip_tooltip td,.src-GlobalBanner-Tooltip-Tooltip_tooltip tfoot,.src-GlobalBanner-Tooltip-Tooltip_tooltip th,.src-GlobalBanner-Tooltip-Tooltip_tooltip thead,.src-GlobalBanner-Tooltip-Tooltip_tooltip tr,.src-GlobalBanner-Tooltip-Tooltip_tooltip tt,.src-GlobalBanner-Tooltip-Tooltip_tooltip u,.src-GlobalBanner-Tooltip-Tooltip_tooltip ul,.src-GlobalBanner-Tooltip-Tooltip_tooltip var,.src-GlobalBanner-Tooltip-Tooltip_tooltip video{margin:0;padding:0;border:0;vertical-align:baseline}.src-GlobalBanner-Tooltip-Tooltip_tooltip article,.src-GlobalBanner-Tooltip-Tooltip_tooltip aside,.src-GlobalBanner-Tooltip-Tooltip_tooltip details,.src-GlobalBanner-Tooltip-Tooltip_tooltip figcaption,.src-GlobalBanner-Tooltip-Tooltip_tooltip figure,.src-GlobalBanner-Tooltip-Tooltip_tooltip footer,.src-GlobalBanner-Tooltip-Tooltip_tooltip header,.src-GlobalBanner-Tooltip-Tooltip_tooltip hgroup,.src-GlobalBanner-Tooltip-Tooltip_tooltip menu,.src-GlobalBanner-Tooltip-Tooltip_tooltip nav,.src-GlobalBanner-Tooltip-Tooltip_tooltip section{display:block}.src-GlobalBanner-Tooltip-Tooltip_tooltip ol,.src-GlobalBanner-Tooltip-Tooltip_tooltip ul{list-style:none}.src-GlobalBanner-Tooltip-Tooltip_tooltip blockquote,.src-GlobalBanner-Tooltip-Tooltip_tooltip q{quotes:none}.src-GlobalBanner-Tooltip-Tooltip_tooltip blockquote:after,.src-GlobalBanner-Tooltip-Tooltip_tooltip blockquote:before,.src-GlobalBanner-Tooltip-Tooltip_tooltip q:after,.src-GlobalBanner-Tooltip-Tooltip_tooltip q:before{content:""}.src-GlobalBanner-Tooltip-Tooltip_tooltip a{color:inherit;text-decoration:underline}.src-GlobalBanner-Tooltip-Tooltip_tooltip table{border-collapse:collapse;border-spacing:0}.src-GlobalBanner-Tooltip-Tooltip_hidden{opacity:0;transition:opacity .4s,visibility .4s;transition-delay:.2s;visibility:hidden}@media (min-width:1366px){.src-GlobalBanner-Tooltip-Tooltip_wrapperCenter{max-width:1302px;padding:0}}',""]),n.locals={wrapperCenter:"src-GlobalBanner-Tooltip-Tooltip_wrapperCenter",wrapperLeft:"src-GlobalBanner-Tooltip-Tooltip_wrapperLeft",wrapperRight:"src-GlobalBanner-Tooltip-Tooltip_wrapperRight",tooltip:"src-GlobalBanner-Tooltip-Tooltip_tooltip",hidden:"src-GlobalBanner-Tooltip-Tooltip_hidden"}},function(t,n,o){(n=t.exports=o(2)(!1)).push([t.i,".src-GlobalBanner-Unit-Unit_unit,.src-GlobalBanner-Unit-Unit_unitLink{padding:0 16px;box-sizing:border-box;text-align:center;width:100%;height:49px;display:table;position:relative;line-height:15px}.src-GlobalBanner-Unit-Unit_unit{cursor:default}.src-GlobalBanner-Unit-Unit_unitLink{cursor:pointer;opacity:1;transition:opacity .8s ease}.src-GlobalBanner-Unit-Unit_unitLink:hover{opacity:.5;transition:opacity .8s ease}@media (min-width:1366px){.src-GlobalBanner-Unit-Unit_unitLeft{width:661px;right:0;position:absolute}.src-GlobalBanner-Unit-Unit_unitRight{width:661px;left:0;position:absolute}.src-GlobalBanner-Unit-Unit_unitCenter{width:1351px;position:static;margin:0 auto;padding:0 32px}}@media (min-width:1024px){.src-GlobalBanner-Unit-Unit_unitCenter{padding:0 32px}}",""]),n.locals={unit:"src-GlobalBanner-Unit-Unit_unit",unitLink:"src-GlobalBanner-Unit-Unit_unitLink",unitLeft:"src-GlobalBanner-Unit-Unit_unitLeft",unitRight:"src-GlobalBanner-Unit-Unit_unitRight",unitCenter:"src-GlobalBanner-Unit-Unit_unitCenter"}},function(t,n,o){var e=o(14);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n,o){var e=o(15);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n,o){var e=o(16);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n,o){var e=o(18);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n,o){var e=o(19);"string"==typeof e&&(e=[[t.i,e,""]]);var r={singleton:!0,hmr:!0,transform:void 0};r.insertInto=undefined;o(3)(e,r);e.locals&&(t.exports=e.locals)},function(t,n){t.exports=function(t){var n="undefined"!=typeof window&&window.location;if(!n)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var o=n.protocol+"//"+n.host,e=o+n.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,n){var r,l=n.trim().replace(/^"(.*)"$/,function(t,n){return n}).replace(/^'(.*)'$/,function(t,n){return n});return/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(l)?t:(r=0===l.indexOf("//")?l:0===l.indexOf("/")?o+l:e+l.replace(/^\.\//,""),"url("+JSON.stringify(r)+")")})}}])});

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/genderTranslationsByLang.json":
/***/ (function(module, exports) {

module.exports = {"en":{"women":"women","men":"men"},"fr":{"women":"femme","men":"homme"},"de":{"women":"damen","men":"herren"},"it":{"women":"donna","men":"uomo"},"es":{"women":"mujer","men":"hombre"},"ru":{"women":"women","men":"men"},"sv":{"women":"kvinna","men":"man"},"nl":{"women":"dames","men":"heren"}}

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json":
/***/ (function(module, exports) {

module.exports = {"com":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"row":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"roe":{"desktop":{"default":"http://www.asos.com","women":"http://www.asos.com/women","men":"http://www.asos.com/men","secure":"https://secure.asos.com"},"mobile":{"default":"http://m.asos.com","women":"http://m.asos.com/women","men":"http://m.asos.com/men","secure":"https://secure.asos.com"}},"us":{"desktop":{"default":"http://us.asos.com","women":"http://us.asos.com/women","men":"http://us.asos.com/men","secure":"https://secure.asos.com/us"},"mobile":{"default":"http://m.asos.com/us","women":"http://m.asos.com/us/women","men":"http://m.asos.com/us/men","secure":"https://secure.asos.com/us"}},"fr":{"desktop":{"default":"http://www.asos.fr","women":"http://www.asos.fr/femme","men":"http://www.asos.fr/homme","secure":"https://secure.asos.com/fr"},"mobile":{"default":"http://m.asos.com/fr","women":"http://m.asos.com/fr/femme","men":"http://m.asos.com/fr/homme","secure":"https://secure.asos.com/fr"}},"de":{"desktop":{"default":"http://www.asos.de","women":"http://www.asos.de/damen","men":"http://www.asos.de/herren","secure":"https://secure.asos.com/de"},"mobile":{"default":"http://m.asos.com/de","women":"http://m.asos.com/de/damen","men":"http://m.asos.com/de/herren","secure":"https://secure.asos.com/de"}},"it":{"desktop":{"default":"http://www.asos.com/it","women":"http://www.asos.com/it/donna","men":"http://www.asos.com/it/uomo","secure":"https://secure.asos.com/it"},"mobile":{"default":"http://m.asos.com/it","women":"http://m.asos.com/it/donna","men":"http://m.asos.com/it/uomo","secure":"https://secure.asos.com/it"}},"es":{"desktop":{"default":"http://www.asos.com/es","women":"http://www.asos.com/es/mujer","men":"http://www.asos.com/es/hombre","secure":"https://secure.asos.com/es"},"mobile":{"default":"http://m.asos.com/es","women":"http://m.asos.com/es/mujer","men":"http://m.asos.com/es/hombre","secure":"https://secure.asos.com/es"}},"au":{"desktop":{"default":"http://www.asos.com/au","women":"http://www.asos.com/au/women","men":"http://www.asos.com/au/men","secure":"https://secure.asos.com/au"},"mobile":{"default":"http://m.asos.com/au","women":"http://m.asos.com/au/women","men":"http://m.asos.com/au/men","secure":"https://secure.asos.com/au"}},"ru":{"desktop":{"default":"http://www.asos.com/ru","women":"http://www.asos.com/ru/women","men":"http://www.asos.com/ru/men","secure":"https://secure.asos.com/ru"},"mobile":{"default":"http://m.asos.com/ru","women":"http://m.asos.com/ru/women","men":"http://m.asos.com/ru/men","secure":"https://secure.asos.com/ru"}},"se":{"desktop":{"default":"http://www.asos.com/se","women":"http://www.asos.com/se/kvinna","men":"http://www.asos.com/se/man","secure":"https://secure.asos.com/se"},"mobile":{"default":"http://m.asos.com/se","women":"http://m.asos.com/se/kvinna","men":"http://m.asos.com/se/man","secure":"https://secure.asos.com/se"}},"nl":{"desktop":{"default":"http://www.asos.com/nl","women":"http://www.asos.com/nl/dames","men":"http://www.asos.com/nl/heren","secure":"https://secure.asos.com/nl"},"mobile":{"default":"http://m.asos.com/nl","women":"http://m.asos.com/nl/dames","men":"http://m.asos.com/nl/heren","secure":"https://secure.asos.com/nl"}}}

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json":
/***/ (function(module, exports) {

module.exports = {"com":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"row":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"roe":{"desktop":{"default":"http://test.asosservices.com","women":"http://test.asosservices.com/women","men":"http://test.asosservices.com/men","secure":"https://secure.asosservices.com"},"mobile":{"default":"http://m.asosservices.com","women":"http://m.asosservices.com/women","men":"http://m.asosservices.com/men","secure":"https://secure.asosservices.com"}},"us":{"desktop":{"default":"http://ustest.asosservices.com","women":"http://ustest.asosservices.com/women","men":"http://ustest.asosservices.com/men","secure":"https://secure.asosservices.com/us"},"mobile":{"default":"http://m.asosservices.com/us","women":"http://m.asosservices.com/us/women","men":"http://m.asosservices.com/us/men","secure":"https://secure.asosservices.com/us"}},"fr":{"desktop":{"default":"http://test.asosservices.fr","women":"http://test.asosservices.fr/femme","men":"http://test.asosservices.fr/homme","secure":"https://secure.asosservices.com/fr"},"mobile":{"default":"http://m.asosservices.com/fr","women":"http://m.asosservices.com/fr/femme","men":"http://m.asosservices.com/fr/homme","secure":"https://secure.asosservices.com/fr"}},"de":{"desktop":{"default":"http://test.asosservices.de","women":"http://test.asosservices.de/damen","men":"http://test.asosservices.de/herren","secure":"https://secure.asosservices.com/de"},"mobile":{"default":"http://m.asosservices.com/de","women":"http://m.asosservices.com/de/damen","men":"http://m.asosservices.com/de/herren","secure":"https://secure.asosservices.com/de"}},"it":{"desktop":{"default":"http://test.asosservices.com/it","women":"http://test.asosservices.com/it/donna","men":"http://test.asosservices.com/it/uomo","secure":"https://secure.asosservices.com/it"},"mobile":{"default":"http://m.asosservices.com/it","women":"http://m.asosservices.com/it/donna","men":"http://m.asosservices.com/it/uomo","secure":"https://secure.asosservices.com/it"}},"es":{"desktop":{"default":"http://test.asosservices.com/es","women":"http://test.asosservices.com/es/mujer","men":"http://test.asosservices.com/es/hombre","secure":"https://secure.asosservices.com/es"},"mobile":{"default":"http://m.asosservices.com/es","women":"http://m.asosservices.com/es/mujer","men":"http://m.asosservices.com/es/hombre","secure":"https://secure.asosservices.com/es"}},"au":{"desktop":{"default":"http://test.asosservices.com/au","women":"http://test.asosservices.com/au/women","men":"http://test.asosservices.com/au/men","secure":"https://secure.asosservices.com/au"},"mobile":{"default":"http://m.asosservices.com/au","women":"http://m.asosservices.com/au/women","men":"http://m.asosservices.com/au/men","secure":"https://secure.asosservices.com/au"}},"ru":{"desktop":{"default":"http://test.asosservices.com/ru","women":"http://test.asosservices.com/ru/women","men":"http://test.asosservices.com/ru/men","secure":"https://secure.asosservices.com/ru"},"mobile":{"default":"http://m.asosservices.com/ru","women":"http://m.asosservices.com/ru/women","men":"http://m.asosservices.com/ru/men","secure":"https://secure.asosservices.com/ru"}},"se":{"desktop":{"default":"http://test.asosservices.com/se","women":"http://test.asosservices.com/se/kvinna","men":"http://test.asosservices.com/se/man","secure":"https://secure.asosservices.com/se"},"mobile":{"default":"http://m.asosservices.com/se","women":"http://m.asosservices.com/se/kvinna","men":"http://m.asosservices.com/se/man","secure":"https://secure.asosservices.com/se"}},"nl":{"desktop":{"default":"http://test.asosservices.com/nl","women":"http://test.asosservices.com/nl/dames","men":"http://test.asosservices.com/nl/heren","secure":"https://secure.asosservices.com/nl"},"mobile":{"default":"http://m.asosservices.com/nl","women":"http://m.asosservices.com/nl/dames","men":"http://m.asosservices.com/nl/heren","secure":"https://secure.asosservices.com/nl"}}}

/***/ }),

/***/ "../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json":
/***/ (function(module, exports) {

module.exports = [{"storeCode":"COM","defaultCountryCode":"GB","isXSiteUrnFallback":true},{"storeCode":"ROW","defaultCountryCode":"GB"},{"storeCode":"ROE","defaultCountryCode":"GB"},{"storeCode":"AU","defaultCountryCode":"AU"},{"storeCode":"IT","defaultCountryCode":"IT"},{"storeCode":"DE","defaultCountryCode":"DE"},{"storeCode":"FR","defaultCountryCode":"FR"},{"storeCode":"ES","defaultCountryCode":"ES"},{"storeCode":"RU","defaultCountryCode":"RU"},{"storeCode":"US","defaultCountryCode":"US"},{"storeCode":"SE","defaultCountryCode":"SE"},{"storeCode":"NL","defaultCountryCode":"NL"}]

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/array/from.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/get-iterator.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/is-iterable.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/json/stringify.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/map.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/map.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/number/is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/number/is-integer.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/assign.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/create.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/define-property.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/get-own-property-descriptor.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/keys.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/set-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/object/values.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/promise.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/promise.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/symbol.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/symbol/index.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/core-js/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("../node_modules/core-js/library/fn/symbol/iterator.js"), __esModule: true };

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/asyncToGenerator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("../node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/get.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-own-property-descriptor.js");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("../node_modules/babel-runtime/core-js/object/set-prototype-of.js");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("../node_modules/babel-runtime/core-js/object/create.js");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/slicedToArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__("../node_modules/babel-runtime/core-js/is-iterable.js");

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/toConsumableArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("../node_modules/babel-runtime/core-js/array/from.js");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "../node_modules/babel-runtime/helpers/typeof.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("../node_modules/babel-runtime/core-js/symbol/iterator.js");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("../node_modules/babel-runtime/core-js/symbol.js");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "../node_modules/babel-runtime/regenerator/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/regenerator-runtime/runtime-module.js");


/***/ }),

/***/ "../node_modules/classnames/bind.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "../node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/classnames/index.js");

/***/ }),

/***/ "../node_modules/core-js/library/fn/array/from.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.array.from.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Array.from;


/***/ }),

/***/ "../node_modules/core-js/library/fn/get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/core.is-iterable.js");


/***/ }),

/***/ "../node_modules/core-js/library/fn/json/stringify.js":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/map.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.map.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.to-json.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.of.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.map.from.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Map;


/***/ }),

/***/ "../node_modules/core-js/library/fn/number/is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.number.is-integer.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Number.isInteger;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.assign.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.assign;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/create.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.create.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.define-property.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js");
var $Object = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/keys.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.keys.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.keys;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.set-prototype-of.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.setPrototypeOf;


/***/ }),

/***/ "../node_modules/core-js/library/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Object.values;


/***/ }),

/***/ "../node_modules/core-js/library/fn/promise.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.promise.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.promise.finally.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.promise.try.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Promise;


/***/ }),

/***/ "../node_modules/core-js/library/fn/symbol/index.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.symbol.js");
__webpack_require__("../node_modules/core-js/library/modules/es6.object.to-string.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.symbol.async-iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/es7.symbol.observable.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").Symbol;


/***/ }),

/***/ "../node_modules/core-js/library/fn/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.string.iterator.js");
__webpack_require__("../node_modules/core-js/library/modules/web.dom.iterable.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js").f('iterator');


/***/ }),

/***/ "../node_modules/core-js/library/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_add-to-unscopables.js":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "../node_modules/core-js/library/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-from-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/library/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/library/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/library/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
var TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var redefineAll = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var $iterDefine = __webpack_require__("../node_modules/core-js/library/modules/_iter-define.js");
var step = __webpack_require__("../node_modules/core-js/library/modules/_iter-step.js");
var setSpecies = __webpack_require__("../node_modules/core-js/library/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var fastKey = __webpack_require__("../node_modules/core-js/library/modules/_meta.js").fastKey;
var validate = __webpack_require__("../node_modules/core-js/library/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection-to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var from = __webpack_require__("../node_modules/core-js/library/modules/_array-from-iterable.js");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var meta = __webpack_require__("../node_modules/core-js/library/modules/_meta.js");
var fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var redefineAll = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var each = __webpack_require__("../node_modules/core-js/library/modules/_array-methods.js")(0);
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/library/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/library/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../node_modules/core-js/library/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var call = __webpack_require__("../node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/library/modules/_is-array-iter.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var getIterFn = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/library/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../node_modules/core-js/library/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/library/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/library/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var descriptor = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../node_modules/core-js/library/modules/_hide.js")(IteratorPrototype, __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/library/modules/_redefine.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var $iterCreate = __webpack_require__("../node_modules/core-js/library/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/library/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_library.js":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("../node_modules/core-js/library/modules/_uid.js")('meta');
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var setDesc = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var macrotask = __webpack_require__("../node_modules/core-js/library/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("../node_modules/core-js/library/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/library/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var dPs = __webpack_require__("../node_modules/core-js/library/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../node_modules/core-js/library/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../node_modules/core-js/library/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/library/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");

module.exports = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/library/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var gOPN = __webpack_require__("../node_modules/core-js/library/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/library/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/library/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-collection-from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-collection-of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js")(Function.call, __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var dP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../node_modules/core-js/library/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var SPECIES = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var invoke = __webpack_require__("../node_modules/core-js/library/modules/_invoke.js");
var html = __webpack_require__("../node_modules/core-js/library/modules/_html.js");
var cel = __webpack_require__("../node_modules/core-js/library/modules/_dom-create.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("../node_modules/core-js/library/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/library/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/library/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/library/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var wksExt = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js");
var defineProperty = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("../node_modules/core-js/library/modules/_wks.js");


/***/ }),

/***/ "../node_modules/core-js/library/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../node_modules/core-js/library/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
var Symbol = __webpack_require__("../node_modules/core-js/library/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.get-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var get = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/core.is-iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_core.js").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var call = __webpack_require__("../node_modules/core-js/library/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/library/modules/_is-array-iter.js");
var toLength = __webpack_require__("../node_modules/core-js/library/modules/_to-length.js");
var createProperty = __webpack_require__("../node_modules/core-js/library/modules/_create-property.js");
var getIterFn = __webpack_require__("../node_modules/core-js/library/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../node_modules/core-js/library/modules/_add-to-unscopables.js");
var step = __webpack_require__("../node_modules/core-js/library/modules/_iter-step.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/library/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/library/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("../node_modules/core-js/library/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("../node_modules/core-js/library/modules/_is-integer.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/library/modules/_object-assign.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.create.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("../node_modules/core-js/library/modules/_object-create.js") });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/library/modules/_descriptors.js"), 'Object', { defineProperty: __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js").f });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js").f;

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("../node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("../node_modules/core-js/library/modules/_to-object.js");
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");

__webpack_require__("../node_modules/core-js/library/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("../node_modules/core-js/library/modules/_set-proto.js").set });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.object.to-string.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/library/modules/_library.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var ctx = __webpack_require__("../node_modules/core-js/library/modules/_ctx.js");
var classof = __webpack_require__("../node_modules/core-js/library/modules/_classof.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/library/modules/_a-function.js");
var anInstance = __webpack_require__("../node_modules/core-js/library/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/library/modules/_for-of.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_species-constructor.js");
var task = __webpack_require__("../node_modules/core-js/library/modules/_task.js").set;
var microtask = __webpack_require__("../node_modules/core-js/library/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/library/modules/_perform.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/library/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("../node_modules/core-js/library/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("../node_modules/core-js/library/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("../node_modules/core-js/library/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("../node_modules/core-js/library/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("../node_modules/core-js/library/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.string.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("../node_modules/core-js/library/modules/_string-at.js")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("../node_modules/core-js/library/modules/_iter-define.js")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var has = __webpack_require__("../node_modules/core-js/library/modules/_has.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/library/modules/_descriptors.js");
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/library/modules/_redefine.js");
var META = __webpack_require__("../node_modules/core-js/library/modules/_meta.js").KEY;
var $fails = __webpack_require__("../node_modules/core-js/library/modules/_fails.js");
var shared = __webpack_require__("../node_modules/core-js/library/modules/_shared.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/library/modules/_set-to-string-tag.js");
var uid = __webpack_require__("../node_modules/core-js/library/modules/_uid.js");
var wks = __webpack_require__("../node_modules/core-js/library/modules/_wks.js");
var wksExt = __webpack_require__("../node_modules/core-js/library/modules/_wks-ext.js");
var wksDefine = __webpack_require__("../node_modules/core-js/library/modules/_wks-define.js");
var enumKeys = __webpack_require__("../node_modules/core-js/library/modules/_enum-keys.js");
var isArray = __webpack_require__("../node_modules/core-js/library/modules/_is-array.js");
var anObject = __webpack_require__("../node_modules/core-js/library/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/library/modules/_is-object.js");
var toIObject = __webpack_require__("../node_modules/core-js/library/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/library/modules/_to-primitive.js");
var createDesc = __webpack_require__("../node_modules/core-js/library/modules/_property-desc.js");
var _create = __webpack_require__("../node_modules/core-js/library/modules/_object-create.js");
var gOPNExt = __webpack_require__("../node_modules/core-js/library/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("../node_modules/core-js/library/modules/_object-gopd.js");
var $DP = __webpack_require__("../node_modules/core-js/library/modules/_object-dp.js");
var $keys = __webpack_require__("../node_modules/core-js/library/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("../node_modules/core-js/library/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("../node_modules/core-js/library/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("../node_modules/core-js/library/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("../node_modules/core-js/library/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../node_modules/core-js/library/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.from.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("../node_modules/core-js/library/modules/_set-collection-from.js")('Map');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.of.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("../node_modules/core-js/library/modules/_set-collection-of.js")('Map');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.map.to-json.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("../node_modules/core-js/library/modules/_collection-to-json.js")('Map') });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/library/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.promise.finally.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/library/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/library/modules/_species-constructor.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/library/modules/_promise-resolve.js");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.promise.try.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("../node_modules/core-js/library/modules/_export.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/library/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/library/modules/_perform.js");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.symbol.async-iterator.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/_wks-define.js")('asyncIterator');


/***/ }),

/***/ "../node_modules/core-js/library/modules/es7.symbol.observable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/_wks-define.js")('observable');


/***/ }),

/***/ "../node_modules/core-js/library/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/library/modules/es6.array.iterator.js");
var global = __webpack_require__("../node_modules/core-js/library/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/library/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/library/modules/_iterators.js");
var TO_STRING_TAG = __webpack_require__("../node_modules/core-js/library/modules/_wks.js")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_an-instance.js":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-fill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_bind.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var invoke = __webpack_require__("../node_modules/core-js/modules/_invoke.js");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_classof.js":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection-strong.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var $iterDefine = __webpack_require__("../node_modules/core-js/modules/_iter-define.js");
var step = __webpack_require__("../node_modules/core-js/modules/_iter-step.js");
var setSpecies = __webpack_require__("../node_modules/core-js/modules/_set-species.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var fastKey = __webpack_require__("../node_modules/core-js/modules/_meta.js").fastKey;
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection-weak.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var getWeak = __webpack_require__("../node_modules/core-js/modules/_meta.js").getWeak;
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var createArrayMethod = __webpack_require__("../node_modules/core-js/modules/_array-methods.js");
var $has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "../node_modules/core-js/modules/_collection.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var $iterDetect = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("../node_modules/core-js/modules/_inherit-if-required.js");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/modules/_create-property.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "../node_modules/core-js/modules/_enum-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_fix-re-wks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_flags.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_for-of.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var call = __webpack_require__("../node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_html.js":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "../node_modules/core-js/modules/_inherit-if-required.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var setPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_invoke.js":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-array-iter.js":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-call.js":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-create.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var descriptor = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("../node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-define.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var $iterCreate = __webpack_require__("../node_modules/core-js/modules/_iter-create.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-detect.js":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iter-step.js":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_iterators.js":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "../node_modules/core-js/modules/_math-expm1.js":
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),

/***/ "../node_modules/core-js/modules/_math-fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__("../node_modules/core-js/modules/_math-sign.js");
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_math-log1p.js":
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_math-sign.js":
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_meta.js":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("../node_modules/core-js/modules/_uid.js")('meta');
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var setDesc = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "../node_modules/core-js/modules/_microtask.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var macrotask = __webpack_require__("../node_modules/core-js/modules/_task.js").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_new-promise-capability.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-create.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var dPs = __webpack_require__("../node_modules/core-js/modules/_object-dps.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("../node_modules/core-js/modules/_dom-create.js")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("../node_modules/core-js/modules/_html.js").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-dps.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");

module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopd.js":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopn-ext.js":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gopn.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var hiddenKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "../node_modules/core-js/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var Reflect = __webpack_require__("../node_modules/core-js/modules/_global.js").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_perform.js":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "../node_modules/core-js/modules/_promise-resolve.js":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var newPromiseCapability = __webpack_require__("../node_modules/core-js/modules/_new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_redefine-all.js":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "../node_modules/core-js/modules/_same-value.js":
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-proto.js":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("../node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-species.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_set-to-string-tag.js":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var TAG = __webpack_require__("../node_modules/core-js/modules/_wks.js")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "../node_modules/core-js/modules/_species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-at.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-pad.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var repeat = __webpack_require__("../node_modules/core-js/modules/_string-repeat.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_string-repeat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_task.js":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var invoke = __webpack_require__("../node_modules/core-js/modules/_invoke.js");
var html = __webpack_require__("../node_modules/core-js/modules/_html.js");
var cel = __webpack_require__("../node_modules/core-js/modules/_dom-create.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("../node_modules/core-js/modules/_cof.js")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-index.js":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../node_modules/core-js/modules/_typed-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__("../node_modules/core-js/modules/_descriptors.js")) {
  var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
  var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
  var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
  var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
  var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
  var $buffer = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js");
  var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
  var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
  var propertyDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
  var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
  var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
  var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
  var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
  var toIndex = __webpack_require__("../node_modules/core-js/modules/_to-index.js");
  var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
  var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
  var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
  var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
  var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
  var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
  var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
  var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
  var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
  var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
  var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");
  var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
  var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
  var createArrayMethod = __webpack_require__("../node_modules/core-js/modules/_array-methods.js");
  var createArrayIncludes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js");
  var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
  var ArrayIterators = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
  var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
  var $iterDetect = __webpack_require__("../node_modules/core-js/modules/_iter-detect.js");
  var setSpecies = __webpack_require__("../node_modules/core-js/modules/_set-species.js");
  var arrayFill = __webpack_require__("../node_modules/core-js/modules/_array-fill.js");
  var arrayCopyWithin = __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js");
  var $DP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
  var $GOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "../node_modules/core-js/modules/_typed-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefineAll = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toIndex = __webpack_require__("../node_modules/core-js/modules/_to-index.js");
var gOPN = __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f;
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var arrayFill = __webpack_require__("../node_modules/core-js/modules/_array-fill.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),

/***/ "../node_modules/core-js/modules/_typed.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "../node_modules/core-js/modules/_user-agent.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "../node_modules/core-js/modules/_validate-collection.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "../node_modules/core-js/modules/_wks-define.js":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var wksExt = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js");
var defineProperty = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "../node_modules/core-js/modules/_wks-ext.js":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("../node_modules/core-js/modules/_wks.js");


/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "../node_modules/core-js/modules/core.get-iterator-method.js":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
var ITERATOR = __webpack_require__("../node_modules/core-js/modules/_wks.js")('iterator');
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.copy-within.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { copyWithin: __webpack_require__("../node_modules/core-js/modules/_array-copy-within.js") });

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('copyWithin');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.fill.js":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'Array', { fill: __webpack_require__("../node_modules/core-js/modules/_array-fill.js") });

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('fill');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.from.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var call = __webpack_require__("../node_modules/core-js/modules/_iter-call.js");
var isArrayIter = __webpack_require__("../node_modules/core-js/modules/_is-array-iter.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");
var getIterFn = __webpack_require__("../node_modules/core-js/modules/core.get-iterator-method.js");

$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js");
var step = __webpack_require__("../node_modules/core-js/modules/_iter-step.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("../node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.of.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.function.name.js":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("../node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.acosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var log1p = __webpack_require__("../node_modules/core-js/modules/_math-log1p.js");
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.asinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.atanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.cbrt.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var sign = __webpack_require__("../node_modules/core-js/modules/_math-sign.js");

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.clz32.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.cosh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.expm1.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.fround.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { fround: __webpack_require__("../node_modules/core-js/modules/_math-fround.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.hypot.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.imul.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log10.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log1p.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { log1p: __webpack_require__("../node_modules/core-js/modules/_math-log1p.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.log2.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.sign.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', { sign: __webpack_require__("../node_modules/core-js/modules/_math-sign.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.sinh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.tanh.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var expm1 = __webpack_require__("../node_modules/core-js/modules/_math-expm1.js");
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.math.trunc.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.epsilon.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-finite.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var _isFinite = __webpack_require__("../node_modules/core-js/modules/_global.js").isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { isInteger: __webpack_require__("../node_modules/core-js/modules/_is-integer.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-nan.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.is-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isInteger = __webpack_require__("../node_modules/core-js/modules/_is-integer.js");
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.max-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.number.min-safe-integer.js":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.freeze.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var $getOwnPropertyDescriptor = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-own-property-names.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getOwnPropertyNames', function () {
  return __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js").f;
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-frozen.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is-sealed.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.is.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { is: __webpack_require__("../node_modules/core-js/modules/_same-value.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.seal.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js").onFreeze;

__webpack_require__("../node_modules/core-js/modules/_object-sap.js")('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("../node_modules/core-js/modules/_set-proto.js").set });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.promise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("../node_modules/core-js/modules/_library.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var classof = __webpack_require__("../node_modules/core-js/modules/_classof.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anInstance = __webpack_require__("../node_modules/core-js/modules/_an-instance.js");
var forOf = __webpack_require__("../node_modules/core-js/modules/_for-of.js");
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
var task = __webpack_require__("../node_modules/core-js/modules/_task.js").set;
var microtask = __webpack_require__("../node_modules/core-js/modules/_microtask.js")();
var newPromiseCapabilityModule = __webpack_require__("../node_modules/core-js/modules/_new-promise-capability.js");
var perform = __webpack_require__("../node_modules/core-js/modules/_perform.js");
var promiseResolve = __webpack_require__("../node_modules/core-js/modules/_promise-resolve.js");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("../node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("../node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);
__webpack_require__("../node_modules/core-js/modules/_set-species.js")(PROMISE);
Wrapper = __webpack_require__("../node_modules/core-js/modules/_core.js")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("../node_modules/core-js/modules/_iter-detect.js")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.apply.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var rApply = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.construct.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var bind = __webpack_require__("../node_modules/core-js/modules/_bind.js");
var rConstruct = (__webpack_require__("../node_modules/core-js/modules/_global.js").Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.define-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.delete-property.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js").f;
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var getProto = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.get.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.has.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.is-extensible.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.own-keys.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.S, 'Reflect', { ownKeys: __webpack_require__("../node_modules/core-js/modules/_own-keys.js") });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.prevent-extensions.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.set-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var setProto = __webpack_require__("../node_modules/core-js/modules/_set-proto.js");

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.reflect.set.js":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var getPrototypeOf = __webpack_require__("../node_modules/core-js/modules/_object-gpo.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.flags.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__("../node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("../node_modules/core-js/modules/_flags.js")
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.match.js":
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.replace.js":
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.search.js":
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.regexp.split.js":
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__("../node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("../node_modules/core-js/modules/_collection-strong.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.code-point-at.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $at = __webpack_require__("../node_modules/core-js/modules/_string-at.js")(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.ends-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.from-code-point.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.raw.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.repeat.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__("../node_modules/core-js/modules/_string-repeat.js")
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.starts-with.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.symbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var META = __webpack_require__("../node_modules/core-js/modules/_meta.js").KEY;
var $fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js");
var setToStringTag = __webpack_require__("../node_modules/core-js/modules/_set-to-string-tag.js");
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
var wksExt = __webpack_require__("../node_modules/core-js/modules/_wks-ext.js");
var wksDefine = __webpack_require__("../node_modules/core-js/modules/_wks-define.js");
var enumKeys = __webpack_require__("../node_modules/core-js/modules/_enum-keys.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
var _create = __webpack_require__("../node_modules/core-js/modules/_object-create.js");
var gOPNExt = __webpack_require__("../node_modules/core-js/modules/_object-gopn-ext.js");
var $GOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var $DP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("../node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
  __webpack_require__("../node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("../node_modules/core-js/modules/_library.js")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("../node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.array-buffer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $typed = __webpack_require__("../node_modules/core-js/modules/_typed.js");
var buffer = __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js");
var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var ArrayBuffer = __webpack_require__("../node_modules/core-js/modules/_global.js").ArrayBuffer;
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_species-constructor.js");
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__("../node_modules/core-js/modules/_set-species.js")(ARRAY_BUFFER);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.data-view.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.G + $export.W + $export.F * !__webpack_require__("../node_modules/core-js/modules/_typed.js").ABV, {
  DataView: __webpack_require__("../node_modules/core-js/modules/_typed-buffer.js").DataView
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.float32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.float64-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.int8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint16-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint32-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint8-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/core-js/modules/_typed-array.js")('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es6.weak-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(0);
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var meta = __webpack_require__("../node_modules/core-js/modules/_meta.js");
var assign = __webpack_require__("../node_modules/core-js/modules/_object-assign.js");
var weak = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js");
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var fails = __webpack_require__("../node_modules/core-js/modules/_fails.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("../node_modules/core-js/modules/_collection.js")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "../node_modules/core-js/modules/es6.weak-set.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__("../node_modules/core-js/modules/_collection-weak.js");
var validate = __webpack_require__("../node_modules/core-js/modules/_validate-collection.js");
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__("../node_modules/core-js/modules/_collection.js")(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var ownKeys = __webpack_require__("../node_modules/core-js/modules/_own-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var gOPD = __webpack_require__("../node_modules/core-js/modules/_object-gopd.js");
var createProperty = __webpack_require__("../node_modules/core-js/modules/_create-property.js");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.string.pad-end.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/es7.string.pad-start.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $pad = __webpack_require__("../node_modules/core-js/modules/_string-pad.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),

/***/ "../node_modules/core-js/modules/web.dom.iterable.js":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var Iterators = __webpack_require__("../node_modules/core-js/modules/_iterators.js");
var wks = __webpack_require__("../node_modules/core-js/modules/_wks.js");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "../node_modules/core-js/modules/web.immediate.js":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $task = __webpack_require__("../node_modules/core-js/modules/_task.js");
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),

/***/ "../node_modules/core-js/modules/web.timers.js":
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var userAgent = __webpack_require__("../node_modules/core-js/modules/_user-agent.js");
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ "../node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__("../node_modules/debug/src/debug.js");
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/debug/src/debug.js":
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__("../node_modules/ms/index.js");

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ "../node_modules/define-properties/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__("../node_modules/object-keys/index.js");
var foreach = __webpack_require__("../node_modules/foreach/index.js");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),

/***/ "../node_modules/details-polyfill/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;void (function (root, factory) {
  if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if (typeof exports === 'object') module.exports = factory()
  else factory()
}(this, function () {
  var DETAILS = 'details'
  var SUMMARY = 'summary'

  var supported = checkSupport()
  if (supported) return

  // Add a classname
  document.documentElement.className += ' no-details'

  window.addEventListener('click', clickHandler)

  injectStyle('details-polyfill-style',
    'html.no-details ' + DETAILS + ':not([open]) > :not(' + SUMMARY + ') { display: none; }\n' +
    'html.no-details ' + DETAILS + ' > ' + SUMMARY + ':before { content: "\u25b6"; display: inline-block; font-size: .8em; width: 1.5em; }\n' +
    'html.no-details ' + DETAILS + '[open] > ' + SUMMARY + ':before { content: "\u25bc"; }')

  /*
   * Click handler for `<summary>` tags
   */

  function clickHandler (e) {
    if (e.target.nodeName.toLowerCase() === 'summary') {
      var details = e.target.parentNode
      if (!details) return

      if (details.getAttribute('open')) {
        details.open = false
        details.removeAttribute('open')
      } else {
        details.open = true
        details.setAttribute('open', 'open')
      }
    }
  }

  /*
   * Checks for support for `<details>`
   */

  function checkSupport () {
    var el = document.createElement(DETAILS)
    if (!('open' in el)) return false

    el.innerHTML = '<' + SUMMARY + '>a</' + SUMMARY + '>b'
    document.body.appendChild(el)

    var diff = el.offsetHeight
    el.open = true
    var result = (diff != el.offsetHeight)

    document.body.removeChild(el)
    return result
  }

  /*
   * Injects styles (idempotent)
   */

  function injectStyle (id, style) {
    if (document.getElementById(id)) return

    var el = document.createElement('style')
    el.id = id
    el.innerHTML = style

    document.getElementsByTagName('head')[0].appendChild(el)
  }
})); // eslint-disable-line semi


/***/ }),

/***/ "../node_modules/dom-helpers/class/addClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__("../node_modules/dom-helpers/class/hasClass.js");

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/dom-helpers/class/hasClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),

/***/ "../node_modules/dom-helpers/class/removeClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),

/***/ "../node_modules/es-abstract/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__("../node_modules/es-abstract/helpers/isNaN.js");
var $isFinite = __webpack_require__("../node_modules/es-abstract/helpers/isFinite.js");

var sign = __webpack_require__("../node_modules/es-abstract/helpers/sign.js");
var mod = __webpack_require__("../node_modules/es-abstract/helpers/mod.js");

var IsCallable = __webpack_require__("../node_modules/is-callable/index.js");
var toPrimitive = __webpack_require__("../node_modules/es-to-primitive/es5.js");

var has = __webpack_require__("../node_modules/has/src/index.js");

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),

/***/ "../node_modules/es-abstract/helpers/isFinite.js":
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ "../node_modules/es-abstract/helpers/isNaN.js":
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ "../node_modules/es-abstract/helpers/mod.js":
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),

/***/ "../node_modules/es-abstract/helpers/sign.js":
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),

/***/ "../node_modules/es-to-primitive/es5.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__("../node_modules/es-to-primitive/helpers/isPrimitive.js");

var isCallable = __webpack_require__("../node_modules/is-callable/index.js");

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),

/***/ "../node_modules/es-to-primitive/helpers/isPrimitive.js":
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),

/***/ "../node_modules/fbemitter/index.js":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

var fbemitter = {
  EventEmitter: __webpack_require__("../node_modules/fbemitter/lib/BaseEventEmitter.js"),
  EmitterSubscription : __webpack_require__("../node_modules/fbemitter/lib/EmitterSubscription.js")
};

module.exports = fbemitter;


/***/ }),

/***/ "../node_modules/fbemitter/lib/BaseEventEmitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BaseEventEmitter
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EmitterSubscription = __webpack_require__("../node_modules/fbemitter/lib/EmitterSubscription.js");
var EventSubscriptionVendor = __webpack_require__("../node_modules/fbemitter/lib/EventSubscriptionVendor.js");

var emptyFunction = __webpack_require__("../node_modules/fbjs/lib/emptyFunction.js");
var invariant = __webpack_require__("../node_modules/fbjs/lib/invariant.js");

/**
 * @class BaseEventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var BaseEventEmitter = (function () {
  /**
   * @constructor
   */

  function BaseEventEmitter() {
    _classCallCheck(this, BaseEventEmitter);

    this._subscriber = new EventSubscriptionVendor();
    this._currentSubscription = null;
  }

  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
  };

  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  BaseEventEmitter.prototype.once = function once(eventType, listener, context) {
    var emitter = this;
    return this.addListener(eventType, function () {
      emitter.removeCurrentListener();
      listener.apply(context, arguments);
    });
  };

  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */

  BaseEventEmitter.prototype.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  };

  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */

  BaseEventEmitter.prototype.removeCurrentListener = function removeCurrentListener() {
    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : undefined;
    this._subscriber.removeSubscription(this._currentSubscription);
  };

  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @return {array}
   */

  BaseEventEmitter.prototype.listeners = function listeners(eventType) /* TODO: Array<EventSubscription> */{
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  };

  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */

  BaseEventEmitter.prototype.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
    if (subscriptions) {
      var keys = Object.keys(subscriptions);
      for (var ii = 0; ii < keys.length; ii++) {
        var key = keys[ii];
        var subscription = subscriptions[key];
        // The subscription may have been removed during this event loop.
        if (subscription) {
          this._currentSubscription = subscription;
          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
        }
      }
      this._currentSubscription = null;
    }
  };

  /**
   * Provides a hook to override how the emitter emits an event to a specific
   * subscription. This allows you to set up logging and error boundaries
   * specific to your environment.
   *
   * @param {EmitterSubscription} subscription
   * @param {string} eventType
   * @param {*} Arbitrary arguments to be passed to each registered listener
   */

  BaseEventEmitter.prototype.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
    var args = Array.prototype.slice.call(arguments, 2);
    subscription.listener.apply(subscription.context, args);
  };

  return BaseEventEmitter;
})();

module.exports = BaseEventEmitter;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EmitterSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EmitterSubscription
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventSubscription = __webpack_require__("../node_modules/fbemitter/lib/EventSubscription.js");

/**
 * EmitterSubscription represents a subscription with listener and context data.
 */

var EmitterSubscription = (function (_EventSubscription) {
  _inherits(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */

  function EmitterSubscription(subscriber, listener, context) {
    _classCallCheck(this, EmitterSubscription);

    _EventSubscription.call(this, subscriber);
    this.listener = listener;
    this.context = context;
  }

  return EmitterSubscription;
})(EventSubscription);

module.exports = EmitterSubscription;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EventSubscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventSubscription
 * @typechecks
 */



/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var EventSubscription = (function () {

  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */

  function EventSubscription(subscriber) {
    _classCallCheck(this, EventSubscription);

    this.subscriber = subscriber;
  }

  /**
   * Removes this subscription from the subscriber that controls it.
   */

  EventSubscription.prototype.remove = function remove() {
    if (this.subscriber) {
      this.subscriber.removeSubscription(this);
      this.subscriber = null;
    }
  };

  return EventSubscription;
})();

module.exports = EventSubscription;

/***/ }),

/***/ "../node_modules/fbemitter/lib/EventSubscriptionVendor.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 * 
 * @providesModule EventSubscriptionVendor
 * @typechecks
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var invariant = __webpack_require__("../node_modules/fbjs/lib/invariant.js");

/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */

var EventSubscriptionVendor = (function () {
  function EventSubscriptionVendor() {
    _classCallCheck(this, EventSubscriptionVendor);

    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }

  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */

  EventSubscriptionVendor.prototype.addSubscription = function addSubscription(eventType, subscription) {
    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : undefined;
    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }
    var key = this._subscriptionsForType[eventType].length;
    this._subscriptionsForType[eventType].push(subscription);
    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  };

  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */

  EventSubscriptionVendor.prototype.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  };

  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */

  EventSubscriptionVendor.prototype.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;

    var subscriptionsForType = this._subscriptionsForType[eventType];
    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  };

  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @return {?array}
   */

  EventSubscriptionVendor.prototype.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
})();

module.exports = EventSubscriptionVendor;

/***/ }),

/***/ "../node_modules/fbjs/lib/emptyFunction.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/fbjs/lib/emptyFunction.js");

/***/ }),

/***/ "../node_modules/fbjs/lib/invariant.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/fbjs/lib/invariant.js");

/***/ }),

/***/ "../node_modules/for-each/index.js":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("../node_modules/is-function/index.js")

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),

/***/ "../node_modules/foreach/index.js":
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),

/***/ "../node_modules/function-bind/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "../node_modules/function-bind/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("../node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "../node_modules/has/src/index.js":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("../node_modules/function-bind/index.js");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "../node_modules/inobounce/inobounce.js":
/***/ (function(module, exports) {

/*! iNoBounce - v0.1.6
* https://github.com/lazd/iNoBounce/
* Copyright (c) 2013 Larry Davis <lazdnet@gmail.com>; Licensed BSD */
(function(global) {
	// Stores the Y position where the touch started
	var startY = 0;

	// Store enabled status
	var enabled = false;

	var supportsPassiveOption = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function() {
				supportsPassiveOption = true;
			}
		});
		window.addEventListener('test', null, opts);
	} catch (e) {}

	var handleTouchmove = function(evt) {
		// Get the element that was scrolled upon
		var el = evt.target;

		// Check all parent elements for scrollability
		while (el !== document.body && el !== document) {
			// Get some style properties
			var style = window.getComputedStyle(el);

			if (!style) {
				// If we've encountered an element we can't compute the style for, get out
				break;
			}

			// Ignore range input element
			if (el.nodeName === 'INPUT' && el.getAttribute('type') === 'range') {
				return;
			}

			var scrolling = style.getPropertyValue('-webkit-overflow-scrolling');
			var overflowY = style.getPropertyValue('overflow-y');
			var height = parseInt(style.getPropertyValue('height'), 10);

			// Determine if the element should scroll
			var isScrollable = scrolling === 'touch' && (overflowY === 'auto' || overflowY === 'scroll');
			var canScroll = el.scrollHeight > el.offsetHeight;

			if (isScrollable && canScroll) {
				// Get the current Y position of the touch
				var curY = evt.touches ? evt.touches[0].screenY : evt.screenY;

				// Determine if the user is trying to scroll past the top or bottom
				// In this case, the window will bounce, so we have to prevent scrolling completely
				var isAtTop = (startY <= curY && el.scrollTop === 0);
				var isAtBottom = (startY >= curY && el.scrollHeight - el.scrollTop === height);

				// Stop a bounce bug when at the bottom or top of the scrollable element
				if (isAtTop || isAtBottom) {
					evt.preventDefault();
				}

				// No need to continue up the DOM, we've done our job
				return;
			}

			// Test the next parent
			el = el.parentNode;
		}

		// Stop the bouncing -- no parents are scrollable
		evt.preventDefault();
	};

	var handleTouchstart = function(evt) {
		// Store the first Y position of the touch
		startY = evt.touches ? evt.touches[0].screenY : evt.screenY;
	};

	var enable = function() {
		// Listen to a couple key touch events
		window.addEventListener('touchstart', handleTouchstart, supportsPassiveOption ? { passive : false } : false);
		window.addEventListener('touchmove', handleTouchmove, supportsPassiveOption ? { passive : false } : false);
		enabled = true;
	};

	var disable = function() {
		// Stop listening
		window.removeEventListener('touchstart', handleTouchstart, false);
		window.removeEventListener('touchmove', handleTouchmove, false);
		enabled = false;
	};

	var isEnabled = function() {
		return enabled;
	};

	// Enable by default if the browser supports -webkit-overflow-scrolling
	// Test this by setting the property with JavaScript on an element that exists in the DOM
	// Then, see if the property is reflected in the computed style
	var testDiv = document.createElement('div');
	document.documentElement.appendChild(testDiv);
	testDiv.style.WebkitOverflowScrolling = 'touch';
	var scrollSupport = 'getComputedStyle' in window && window.getComputedStyle(testDiv)['-webkit-overflow-scrolling'] === 'touch';
	document.documentElement.removeChild(testDiv);

	if (scrollSupport) {
		enable();
	}

	// A module to support enabling/disabling iNoBounce
	var iNoBounce = {
		enable: enable,
		disable: disable,
		isEnabled: isEnabled
	};

	if (typeof module !== 'undefined' && module.exports) {
		// Node.js Support
		module.exports = iNoBounce;
	}
	if (typeof global.define === 'function') {
		// AMD Support
		(function(define) {
			define('iNoBounce', [], function() { return iNoBounce; });
		}(global.define));
	}
	else {
		// Browser support
		global.iNoBounce = iNoBounce;
	}
}(this));


/***/ }),

/***/ "../node_modules/is-callable/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),

/***/ "../node_modules/is-function/index.js":
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),

/***/ "../node_modules/isomorphic-fetch/fetch-npm-browserify.js":
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__("../node_modules/whatwg-fetch/fetch.js");
module.exports = self.fetch.bind(self);


/***/ }),

/***/ "../node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/js-cookie/src/js.cookie.js");

/***/ }),

/***/ "../node_modules/json-stringify-safe/stringify.js":
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),

/***/ "../node_modules/lodash-es/isPlainObject.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/lodash-es/isPlainObject.js");

/***/ }),

/***/ "../node_modules/lodash.keys/index.js":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "../node_modules/lodash/_SetCache.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "../node_modules/lodash/_Stack.js":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("../node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("../node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("../node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("../node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("../node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "../node_modules/lodash/_arrayMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../node_modules/lodash/_arraySome.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "../node_modules/lodash/_assocIndexOf.js":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("../node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "../node_modules/lodash/_baseGet.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("../node_modules/lodash/_castPath.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ "../node_modules/lodash/_baseHasIn.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ "../node_modules/lodash/_baseIndexOf.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "../node_modules/lodash/_baseIsEqual.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("../node_modules/lodash/_baseIsEqualDeep.js"),
    isObjectLike = __webpack_require__("../node_modules/lodash/isObjectLike.js");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "../node_modules/lodash/_baseIsEqualDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("../node_modules/lodash/_Stack.js"),
    equalArrays = __webpack_require__("../node_modules/lodash/_equalArrays.js"),
    equalByTag = __webpack_require__("../node_modules/lodash/_equalByTag.js"),
    equalObjects = __webpack_require__("../node_modules/lodash/_equalObjects.js"),
    getTag = __webpack_require__("../node_modules/lodash/_getTag.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("../node_modules/lodash/isBuffer.js"),
    isTypedArray = __webpack_require__("../node_modules/lodash/isTypedArray.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "../node_modules/lodash/_baseIsMatch.js":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("../node_modules/lodash/_Stack.js"),
    baseIsEqual = __webpack_require__("../node_modules/lodash/_baseIsEqual.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ "../node_modules/lodash/_baseIteratee.js":
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__("../node_modules/lodash/_baseMatches.js"),
    baseMatchesProperty = __webpack_require__("../node_modules/lodash/_baseMatchesProperty.js"),
    identity = __webpack_require__("../node_modules/lodash/identity.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    property = __webpack_require__("../node_modules/lodash/property.js");

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ "../node_modules/lodash/_baseMap.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../node_modules/lodash/_baseMatches.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__("../node_modules/lodash/_baseIsMatch.js"),
    getMatchData = __webpack_require__("../node_modules/lodash/_getMatchData.js"),
    matchesStrictComparable = __webpack_require__("../node_modules/lodash/_matchesStrictComparable.js");

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ "../node_modules/lodash/_baseMatchesProperty.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("../node_modules/lodash/_baseIsEqual.js"),
    get = __webpack_require__("../node_modules/lodash/get.js"),
    hasIn = __webpack_require__("../node_modules/lodash/hasIn.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    isStrictComparable = __webpack_require__("../node_modules/lodash/_isStrictComparable.js"),
    matchesStrictComparable = __webpack_require__("../node_modules/lodash/_matchesStrictComparable.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ "../node_modules/lodash/_baseOrderBy.js":
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__("../node_modules/lodash/_arrayMap.js"),
    baseIteratee = __webpack_require__("../node_modules/lodash/_baseIteratee.js"),
    baseMap = __webpack_require__("../node_modules/lodash/_baseMap.js"),
    baseSortBy = __webpack_require__("../node_modules/lodash/_baseSortBy.js"),
    baseUnary = __webpack_require__("../node_modules/lodash/_baseUnary.js"),
    compareMultiple = __webpack_require__("../node_modules/lodash/_compareMultiple.js"),
    identity = __webpack_require__("../node_modules/lodash/identity.js");

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ "../node_modules/lodash/_baseProperty.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "../node_modules/lodash/_basePropertyDeep.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("../node_modules/lodash/_baseGet.js");

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ "../node_modules/lodash/_baseSortBy.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ "../node_modules/lodash/_baseUnary.js":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "../node_modules/lodash/_cacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__("../node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "../node_modules/lodash/_castPath.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    stringToPath = __webpack_require__("../node_modules/lodash/_stringToPath.js"),
    toString = __webpack_require__("../node_modules/lodash/toString.js");

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ "../node_modules/lodash/_compareAscending.js":
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__("../node_modules/lodash/isSymbol.js");

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ "../node_modules/lodash/_compareMultiple.js":
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__("../node_modules/lodash/_compareAscending.js");

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ "../node_modules/lodash/_equalArrays.js":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("../node_modules/lodash/_SetCache.js"),
    arraySome = __webpack_require__("../node_modules/lodash/_arraySome.js"),
    cacheHas = __webpack_require__("../node_modules/lodash/_cacheHas.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "../node_modules/lodash/_equalByTag.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../node_modules/lodash/_equalObjects.js":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("../node_modules/lodash/_getAllKeys.js");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "../node_modules/lodash/_freeGlobal.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/lodash/_getAllKeys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../node_modules/lodash/_getMatchData.js":
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__("../node_modules/lodash/_isStrictComparable.js"),
    keys = __webpack_require__("../node_modules/lodash/keys.js");

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ "../node_modules/lodash/_getTag.js":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../node_modules/lodash/_hasPath.js":
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__("../node_modules/lodash/_castPath.js"),
    isArguments = __webpack_require__("../node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isIndex = __webpack_require__("../node_modules/lodash/_isIndex.js"),
    isLength = __webpack_require__("../node_modules/lodash/isLength.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ "../node_modules/lodash/_isIndex.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "../node_modules/lodash/_isKey.js":
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__("../node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("../node_modules/lodash/isSymbol.js");

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ "../node_modules/lodash/_isStrictComparable.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/lodash/isObject.js");

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ "../node_modules/lodash/_listCacheClear.js":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "../node_modules/lodash/_listCacheDelete.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "../node_modules/lodash/_listCacheGet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "../node_modules/lodash/_listCacheHas.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "../node_modules/lodash/_listCacheSet.js":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("../node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "../node_modules/lodash/_matchesStrictComparable.js":
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ "../node_modules/lodash/_memoizeCapped.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/_overArg.js":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "../node_modules/lodash/_root.js":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("../node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "../node_modules/lodash/_stringToPath.js":
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__("../node_modules/lodash/_memoizeCapped.js");

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ "../node_modules/lodash/_toKey.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/debounce.js":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("../node_modules/lodash/isObject.js"),
    now = __webpack_require__("../node_modules/lodash/now.js"),
    toNumber = __webpack_require__("../node_modules/lodash/toNumber.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ "../node_modules/lodash/eq.js":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../node_modules/lodash/get.js":
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__("../node_modules/lodash/_baseGet.js");

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ "../node_modules/lodash/hasIn.js":
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__("../node_modules/lodash/_baseHasIn.js"),
    hasPath = __webpack_require__("../node_modules/lodash/_hasPath.js");

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ "../node_modules/lodash/identity.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/isArguments.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isArray.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "../node_modules/lodash/isBuffer.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isLength.js":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "../node_modules/lodash/isObject.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "../node_modules/lodash/isObjectLike.js":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "../node_modules/lodash/isSymbol.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/isTypedArray.js":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../node_modules/lodash/keys.js":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../node_modules/lodash/now.js":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("../node_modules/lodash/_root.js");

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ "../node_modules/lodash/orderBy.js":
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__("../node_modules/lodash/_baseOrderBy.js"),
    isArray = __webpack_require__("../node_modules/lodash/isArray.js");

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ "../node_modules/lodash/property.js":
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__("../node_modules/lodash/_baseProperty.js"),
    basePropertyDeep = __webpack_require__("../node_modules/lodash/_basePropertyDeep.js"),
    isKey = __webpack_require__("../node_modules/lodash/_isKey.js"),
    toKey = __webpack_require__("../node_modules/lodash/_toKey.js");

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ "../node_modules/lodash/toNumber.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/lodash/toString.js":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../node_modules/ms/index.js":
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ "../node_modules/node-polyglot/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
//     (c) 2012-2016 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documention:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//



var forEach = __webpack_require__("../node_modules/for-each/index.js");
var warning = __webpack_require__("../node_modules/warning/browser.js");
var has = __webpack_require__("../node_modules/has/src/index.js");
var trim = __webpack_require__("../node_modules/string.prototype.trim/index.js");

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimeter = '||||';

// Mapping from pluralization group plural logic.
var pluralTypes = {
  arabic: function (n) {
    // http://www.arabeyes.org/Plural_Forms
    if (n < 3) { return n; }
    if (n % 100 >= 3 && n % 100 <= 10) return 3;
    return n % 100 >= 11 ? 4 : 5;
  },
  chinese: function () { return 0; },
  german: function (n) { return n !== 1 ? 1 : 0; },
  french: function (n) { return n > 1 ? 1 : 0; },
  russian: function (n) {
    if (n % 10 === 1 && n % 100 !== 11) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  czech: function (n) {
    if (n === 1) { return 0; }
    return (n >= 2 && n <= 4) ? 1 : 2;
  },
  polish: function (n) {
    if (n === 1) { return 0; }
    return n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
  },
  icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; }
};

// Mapping from pluralization group to individual locales.
var pluralTypeToLanguages = {
  arabic: ['ar'],
  chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
  german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
  french: ['fr', 'tl', 'pt-br'],
  russian: ['hr', 'ru', 'lt'],
  czech: ['cs', 'sk'],
  polish: ['pl'],
  icelandic: ['is']
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(mapping, function (langs, type) {
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(locale) {
  var langToPluralType = langToTypeMap(pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(locale, count) {
  return pluralTypes[pluralTypeName(locale)](count);
}

var dollarRegex = /\$/g;
var dollarBillsYall = '$$';
var tokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimeter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && result) {
    var texts = split.call(result, delimeter);
    result = trim(texts[pluralTypeIndex(locale || 'en', options.smart_count)] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, tokenRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    // Ensure replacement value is escaped to prevent special $-prefixed regex replace tokens.
    return replace.call(options[argument], dollarRegex, dollarBillsYall);
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(morePhrases, function (phrase, key) {
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(morePhrases, function (phrase, key) {
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};


// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale);
  }
  return result;
};


// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = transformPhrase;

module.exports = Polyglot;


/***/ }),

/***/ "../node_modules/object-keys/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__("../node_modules/object-keys/isArguments.js");
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),

/***/ "../node_modules/object-keys/isArguments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),

/***/ "../node_modules/performance-now/lib/performance-now.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "../node_modules/process/browser.js":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/prop-types/index.js");

/***/ }),

/***/ "../node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/query-string/index.js");

/***/ }),

/***/ "../node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "../node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "../node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("../node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("../node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "../node_modules/querystringify/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String} The decoded string.
 * @api private
 */
function decode(input) {
  return decodeURIComponent(input.replace(/\+/g, ' '));
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  //
  // Little nifty parsing hack, leverage the fact that RegExp.exec increments
  // the lastIndex property so we can continue executing this loop until we've
  // parsed all results.
  //
  for (;
    part = parser.exec(query);
    result[decode(part[1])] = decode(part[2])
  );

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = [];

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (var key in obj) {
    if (has.call(obj, key)) {
      pairs.push(encodeURIComponent(key) +'='+ encodeURIComponent(obj[key]));
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ "../node_modules/raf/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__("../node_modules/performance-now/lib/performance-now.js")
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react-dom/index.js");

/***/ }),

/***/ "../node_modules/react-headroom/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shallowequal = __webpack_require__("../node_modules/shallowequal/modules/index.js");

var _shallowequal2 = _interopRequireDefault(_shallowequal);

var _raf = __webpack_require__("../node_modules/raf/index.js");

var _raf2 = _interopRequireDefault(_raf);

var _shouldUpdate2 = __webpack_require__("../node_modules/react-headroom/dist/shouldUpdate.js");

var _shouldUpdate3 = _interopRequireDefault(_shouldUpdate2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-unresolved


var noop = function noop() {};

var Headroom = function (_Component) {
  _inherits(Headroom, _Component);

  function Headroom(props) {
    _classCallCheck(this, Headroom);

    // Class variables.
    var _this = _possibleConstructorReturn(this, (Headroom.__proto__ || Object.getPrototypeOf(Headroom)).call(this, props));

    _this.setRef = function (ref) {
      return _this.inner = ref;
    };

    _this.setHeightOffset = function () {
      _this.setState({
        height: _this.inner.offsetHeight
      });
      _this.resizeTicking = false;
    };

    _this.getScrollY = function () {
      if (_this.props.parent().pageYOffset !== void 0) {
        return _this.props.parent().pageYOffset;
      } else if (_this.props.parent().scrollTop !== void 0) {
        return _this.props.parent().scrollTop;
      } else {
        return (document.documentElement || document.body.parentNode || document.body).scrollTop;
      }
    };

    _this.getViewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };

    _this.getDocumentHeight = function () {
      var body = document.body;
      var documentElement = document.documentElement;

      return Math.max(body.scrollHeight, documentElement.scrollHeight, body.offsetHeight, documentElement.offsetHeight, body.clientHeight, documentElement.clientHeight);
    };

    _this.getElementPhysicalHeight = function (elm) {
      return Math.max(elm.offsetHeight, elm.clientHeight);
    };

    _this.getElementHeight = function (elm) {
      return Math.max(elm.scrollHeight, elm.offsetHeight, elm.clientHeight);
    };

    _this.getScrollerPhysicalHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getViewportHeight() : _this.getElementPhysicalHeight(parent);
    };

    _this.getScrollerHeight = function () {
      var parent = _this.props.parent();

      return parent === window || parent === document.body ? _this.getDocumentHeight() : _this.getElementHeight(parent);
    };

    _this.isOutOfBound = function (currentScrollY) {
      var pastTop = currentScrollY < 0;

      var scrollerPhysicalHeight = _this.getScrollerPhysicalHeight();
      var scrollerHeight = _this.getScrollerHeight();

      var pastBottom = currentScrollY + scrollerPhysicalHeight > scrollerHeight;

      return pastTop || pastBottom;
    };

    _this.handleScroll = function () {
      if (!_this.scrollTicking) {
        _this.scrollTicking = true;
        (0, _raf2.default)(_this.update);
      }
    };

    _this.handleResize = function () {
      if (!_this.resizeTicking) {
        _this.resizeTicking = true;
        (0, _raf2.default)(_this.setHeightOffset);
      }
    };

    _this.unpin = function () {
      _this.props.onUnpin();

      _this.setState({
        translateY: '-100%',
        className: 'headroom headroom--unpinned'
      }, function () {
        setTimeout(function () {
          _this.setState({ state: 'unpinned' });
        }, 0);
      });
    };

    _this.pin = function () {
      _this.props.onPin();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--pinned',
        state: 'pinned'
      });
    };

    _this.unfix = function () {
      _this.props.onUnfix();

      _this.setState({
        translateY: 0,
        className: 'headroom headroom--unfixed',
        state: 'unfixed'
      });
    };

    _this.update = function () {
      _this.currentScrollY = _this.getScrollY();

      if (!_this.isOutOfBound(_this.currentScrollY)) {
        var _shouldUpdate = (0, _shouldUpdate3.default)(_this.lastKnownScrollY, _this.currentScrollY, _this.props, _this.state),
            action = _shouldUpdate.action;

        if (action === 'pin') {
          _this.pin();
        } else if (action === 'unpin') {
          _this.unpin();
        } else if (action === 'unfix') {
          _this.unfix();
        }
      }

      _this.lastKnownScrollY = _this.currentScrollY;
      _this.scrollTicking = false;
    };

    _this.currentScrollY = 0;
    _this.lastKnownScrollY = 0;
    _this.scrollTicking = false;
    _this.resizeTicking = false;
    _this.state = {
      state: 'unfixed',
      translateY: 0,
      className: 'headroom headroom--unfixed'
    };
    return _this;
  }

  _createClass(Headroom, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setHeightOffset();
      if (!this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.disable && !this.props.disable) {
        this.unfix();
        this.props.parent().removeEventListener('scroll', this.handleScroll);
        this.props.parent().removeEventListener('resize', this.handleResize);
      } else if (!nextProps.disable && this.props.disable) {
        this.props.parent().addEventListener('scroll', this.handleScroll);

        if (this.props.calcHeightOnResize) {
          this.props.parent().addEventListener('resize', this.handleResize);
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state, nextState);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // If children have changed, remeasure height.
      if (prevProps.children !== this.props.children) {
        this.setHeightOffset();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.parent().removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('scroll', this.handleScroll);
      this.props.parent().removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          userClassName = _props.className,
          divProps = _objectWithoutProperties(_props, ['className']);

      delete divProps.onUnpin;
      delete divProps.onPin;
      delete divProps.onUnfix;
      delete divProps.disableInlineStyles;
      delete divProps.disable;
      delete divProps.parent;
      delete divProps.children;
      delete divProps.upTolerance;
      delete divProps.downTolerance;
      delete divProps.pinStart;
      delete divProps.calcHeightOnResize;

      var style = divProps.style,
          wrapperStyle = divProps.wrapperStyle,
          rest = _objectWithoutProperties(divProps, ['style', 'wrapperStyle']);

      var innerStyle = {
        position: this.props.disable || this.state.state === 'unfixed' ? 'relative' : 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1,
        WebkitTransform: 'translateY(' + this.state.translateY + ')',
        MsTransform: 'translateY(' + this.state.translateY + ')',
        transform: 'translateY(' + this.state.translateY + ')'
      };

      var className = this.state.className;

      // Don't add css transitions until after we've done the initial
      // negative transform when transitioning from 'unfixed' to 'unpinned'.
      // If we don't do this, the header will flash into view temporarily
      // while it transitions from 0 — -100%.
      if (this.state.state !== 'unfixed') {
        innerStyle = _extends({}, innerStyle, {
          WebkitTransition: 'all .2s ease-in-out',
          MozTransition: 'all .2s ease-in-out',
          OTransition: 'all .2s ease-in-out',
          transition: 'all .2s ease-in-out'
        });
        className += ' headroom--scrolled';
      }

      if (!this.props.disableInlineStyles) {
        innerStyle = _extends({}, innerStyle, style);
      } else {
        innerStyle = style;
      }

      var wrapperStyles = _extends({}, wrapperStyle, {
        height: this.state.height ? this.state.height : null
      });

      var wrapperClassName = userClassName ? userClassName + ' headroom-wrapper' : 'headroom-wrapper';

      return _react2.default.createElement(
        'div',
        { style: wrapperStyles, className: wrapperClassName },
        _react2.default.createElement(
          'div',
          _extends({
            ref: this.setRef
          }, rest, {
            style: innerStyle,
            className: className
          }),
          this.props.children
        )
      );
    }
  }]);

  return Headroom;
}(_react.Component);

Headroom.propTypes = {
  className: _propTypes2.default.string,
  parent: _propTypes2.default.func,
  children: _propTypes2.default.any.isRequired,
  disableInlineStyles: _propTypes2.default.bool,
  disable: _propTypes2.default.bool,
  upTolerance: _propTypes2.default.number,
  downTolerance: _propTypes2.default.number,
  onPin: _propTypes2.default.func,
  onUnpin: _propTypes2.default.func,
  onUnfix: _propTypes2.default.func,
  wrapperStyle: _propTypes2.default.object,
  pinStart: _propTypes2.default.func,
  style: _propTypes2.default.object,
  calcHeightOnResize: _propTypes2.default.bool
};
Headroom.defaultProps = {
  parent: function parent() {
    return window;
  },
  disableInlineStyles: false,
  disable: false,
  upTolerance: 5,
  downTolerance: 0,
  onPin: noop,
  onUnpin: noop,
  onUnfix: noop,
  wrapperStyle: {},
  pinStart: function pinStart() {
    return 0;
  },
  calcHeightOnResize: true
};
exports.default = Headroom;

/***/ }),

/***/ "../node_modules/react-headroom/dist/shouldUpdate.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var lastKnownScrollY = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var currentScrollY = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    pinStart: function pinStart() {
      return 0;
    }
  };
  var state = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};

  var scrollDirection = currentScrollY >= lastKnownScrollY ? 'down' : 'up';
  var distanceScrolled = Math.abs(currentScrollY - lastKnownScrollY);

  // We're disabled
  if (props.disable) {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're at the top and not fixed yet.
    };
  } else if (currentScrollY <= props.pinStart() && state.state !== 'unfixed') {
    return {
      action: 'unfix',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're unfixed and headed down. Carry on.
    };
  } else if (currentScrollY <= state.height && scrollDirection === 'down' && state.state === 'unfixed') {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're past the header and scrolling down.
      // We transition to "unpinned" if necessary.
    };
  } else if (scrollDirection === 'down' && ['pinned', 'unfixed'].indexOf(state.state) >= 0 && currentScrollY > state.height + props.pinStart() && distanceScrolled > props.downTolerance) {
    return {
      action: 'unpin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're scrolling up, we transition to "pinned"
    };
  } else if (scrollDirection === 'up' && distanceScrolled > props.upTolerance && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
      // We're scrolling up, and inside the header.
      // We transition to pin regardless of upTolerance
    };
  } else if (scrollDirection === 'up' && currentScrollY <= state.height && ['pinned', 'unfixed'].indexOf(state.state) < 0) {
    return {
      action: 'pin',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  } else {
    return {
      action: 'none',
      scrollDirection: scrollDirection,
      distanceScrolled: distanceScrolled
    };
  }
};

/***/ }),

/***/ "../node_modules/react-redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react-redux/es/index.js");

/***/ }),

/***/ "../node_modules/react-transition-group/CSSTransition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__("../node_modules/dom-helpers/class/addClass.js");

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__("../node_modules/dom-helpers/class/removeClass.js");

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__("../node_modules/react-transition-group/Transition.js");

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__("../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter,
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit,
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),

/***/ "../node_modules/react-transition-group/Transition.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__("../node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("../node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__("../node_modules/react-transition-group/utils/PropTypes.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `entering`
 *  - `entered`
 *  - `exiting`
 *  - `exited`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),

/***/ "../node_modules/react-transition-group/utils/PropTypes.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__("../node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),

/***/ "../node_modules/react/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/react/index.js");

/***/ }),

/***/ "../node_modules/redux-devtools-extension/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__("../node_modules/redux/es/index.js").compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),

/***/ "../node_modules/redux-persist/es/utils/setImmediate.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/redux-thunk/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/redux-thunk/lib/index.js");

/***/ }),

/***/ "../node_modules/redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/redux/es/index.js");

/***/ }),

/***/ "../node_modules/regenerator-runtime/runtime-module.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("../node_modules/regenerator-runtime/runtime.js");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/requires-port/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ "../node_modules/reselect/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),

/***/ "../node_modules/shallowequal/modules/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fetchKeys = __webpack_require__("../node_modules/lodash.keys/index.js");

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if (ret !== void 0) {
        return !!ret;
    }

    if (objA === objB) {
        return true;
    }

    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }

    var keysA = fetchKeys(objA);
    var keysB = fetchKeys(objB);

    var len = keysA.length;
    if (len !== keysB.length) {
        return false;
    }

    compareContext = compareContext || null;

    // Test for A's keys different from B.
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for (var i = 0; i < len; i++) {
        var key = keysA[i];
        if (!bHasOwnProperty(key)) {
            return false;
        }
        var valueA = objA[key];
        var valueB = objB[key];

        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (_ret === false || _ret === void 0 && valueA !== valueB) {
            return false;
        }
    }

    return true;
};

/***/ }),

/***/ "../node_modules/string.prototype.trim/implementation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../node_modules/function-bind/index.js");
var ES = __webpack_require__("../node_modules/es-abstract/es5.js");
var replace = bind.call(Function.call, String.prototype.replace);

var leftWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;

module.exports = function trim() {
	var S = ES.ToString(ES.CheckObjectCoercible(this));
	return replace(replace(S, leftWhitespace, ''), rightWhitespace, '');
};


/***/ }),

/***/ "../node_modules/string.prototype.trim/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("../node_modules/function-bind/index.js");
var define = __webpack_require__("../node_modules/define-properties/index.js");

var implementation = __webpack_require__("../node_modules/string.prototype.trim/implementation.js");
var getPolyfill = __webpack_require__("../node_modules/string.prototype.trim/polyfill.js");
var shim = __webpack_require__("../node_modules/string.prototype.trim/shim.js");

var boundTrim = bind.call(Function.call, getPolyfill());

define(boundTrim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundTrim;


/***/ }),

/***/ "../node_modules/string.prototype.trim/polyfill.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("../node_modules/string.prototype.trim/implementation.js");

var zeroWidthSpace = '\u200b';

module.exports = function getPolyfill() {
	if (String.prototype.trim && zeroWidthSpace.trim() === zeroWidthSpace) {
		return String.prototype.trim;
	}
	return implementation;
};


/***/ }),

/***/ "../node_modules/string.prototype.trim/shim.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__("../node_modules/define-properties/index.js");
var getPolyfill = __webpack_require__("../node_modules/string.prototype.trim/polyfill.js");

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, { trim: function () { return String.prototype.trim !== polyfill; } });
	return polyfill;
};


/***/ }),

/***/ "../node_modules/ua-parser-js/src/ua-parser.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.17',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
            ], [NAME, VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w+)*/i,                                                    // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w+)*/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w+)*/i                                                       // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w+)*/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i                                         // OnePlus
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android.+)[;\/].+build/i                                          // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i                                               // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                  // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i                                              // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__("../node_modules/webpack/buildin/amd-options.js")) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),

/***/ "../node_modules/url-parse/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__("../node_modules/requires-port/index.js")
  , qs = __webpack_require__("../node_modules/querystringify/index.js")
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//;

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @api public
 */
function lolcation(loc) {
  loc = loc || global.location || {};

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new URL(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new URL(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @api private
 */
function extractProtocol(address) {
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @api private
 */
function resolve(relative, base) {
  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} location Location defaults for relative paths.
 * @param {Boolean|Function} parser Parser for the query string.
 * @api public
 */
function URL(address, location, parser) {
  if (!(this instanceof URL)) {
    return new URL(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[2] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];
    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL}
 * @api public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String}
 * @api public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

URL.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
URL.extractProtocol = extractProtocol;
URL.location = lolcation;
URL.qs = qs;

module.exports = URL;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("../node_modules/punycode/punycode.js");
var util = __webpack_require__("../node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("../node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "../node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "../node_modules/warning/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),

/***/ "../node_modules/webpack/buildin/amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "../node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/webpack/buildin/global.js");

/***/ }),

/***/ "../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference vendor"))("./node_modules/webpack/buildin/module.js");

/***/ }),

/***/ "../node_modules/whatwg-fetch/fetch.js":
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ "./client/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var api_namespaceObject = {};
__webpack_require__.d(api_namespaceObject, "fetchClientNavigation", function() { return api_fetchClientNavigation; });
__webpack_require__.d(api_namespaceObject, "fetchNavigation", function() { return api_fetchNavigation; });
__webpack_require__.d(api_namespaceObject, "fetchSuggestions", function() { return api_fetchSuggestions; });
__webpack_require__.d(api_namespaceObject, "fetchCountry", function() { return api_fetchCountry; });
__webpack_require__.d(api_namespaceObject, "fetchPaymentProviders", function() { return api_fetchPaymentProviders; });
__webpack_require__.d(api_namespaceObject, "fetchWelcomeMessage", function() { return api_fetchWelcomeMessage; });
__webpack_require__.d(api_namespaceObject, "fetchWelcomeMat", function() { return api_fetchWelcomeMat; });
__webpack_require__.d(api_namespaceObject, "fetchTargetedContent", function() { return api_fetchTargetedContent; });
__webpack_require__.d(api_namespaceObject, "fetchSitecoreBearerToken", function() { return api_fetchSitecoreBearerToken; });
__webpack_require__.d(api_namespaceObject, "updatePreferences", function() { return api_updatePreferences; });
__webpack_require__.d(api_namespaceObject, "fetchPreferences", function() { return api_fetchPreferences; });
__webpack_require__.d(api_namespaceObject, "fetchFeaturesManifest", function() { return api_fetchFeaturesManifest; });
__webpack_require__.d(api_namespaceObject, "sendEventToAlfred", function() { return api_sendEventToAlfred; });

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.array-buffer.js
var es6_typed_array_buffer = __webpack_require__("../node_modules/core-js/modules/es6.typed.array-buffer.js");
var es6_typed_array_buffer_default = /*#__PURE__*/__webpack_require__.n(es6_typed_array_buffer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.data-view.js
var es6_typed_data_view = __webpack_require__("../node_modules/core-js/modules/es6.typed.data-view.js");
var es6_typed_data_view_default = /*#__PURE__*/__webpack_require__.n(es6_typed_data_view);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int8-array.js
var es6_typed_int8_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.int8-array.js");
var es6_typed_int8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int8_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-array.js");
var es6_typed_uint8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
var es6_typed_uint8_clamped_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.uint8-clamped-array.js");
var es6_typed_uint8_clamped_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_clamped_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int16-array.js
var es6_typed_int16_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.int16-array.js");
var es6_typed_int16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int16_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint16-array.js
var es6_typed_uint16_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.uint16-array.js");
var es6_typed_uint16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint16_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.int32-array.js
var es6_typed_int32_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.int32-array.js");
var es6_typed_int32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.uint32-array.js
var es6_typed_uint32_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.uint32-array.js");
var es6_typed_uint32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.float32-array.js
var es6_typed_float32_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.float32-array.js");
var es6_typed_float32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float32_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.typed.float64-array.js
var es6_typed_float64_array = __webpack_require__("../node_modules/core-js/modules/es6.typed.float64-array.js");
var es6_typed_float64_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float64_array);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__("../node_modules/core-js/modules/es6.map.js");
var es6_map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__("../node_modules/core-js/modules/es6.set.js");
var es6_set_default = /*#__PURE__*/__webpack_require__.n(es6_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.weak-map.js
var es6_weak_map = __webpack_require__("../node_modules/core-js/modules/es6.weak-map.js");
var es6_weak_map_default = /*#__PURE__*/__webpack_require__.n(es6_weak_map);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.weak-set.js
var es6_weak_set = __webpack_require__("../node_modules/core-js/modules/es6.weak-set.js");
var es6_weak_set_default = /*#__PURE__*/__webpack_require__.n(es6_weak_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.apply.js
var es6_reflect_apply = __webpack_require__("../node_modules/core-js/modules/es6.reflect.apply.js");
var es6_reflect_apply_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_apply);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__("../node_modules/core-js/modules/es6.reflect.construct.js");
var es6_reflect_construct_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_construct);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.define-property.js
var es6_reflect_define_property = __webpack_require__("../node_modules/core-js/modules/es6.reflect.define-property.js");
var es6_reflect_define_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_define_property);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.delete-property.js
var es6_reflect_delete_property = __webpack_require__("../node_modules/core-js/modules/es6.reflect.delete-property.js");
var es6_reflect_delete_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_delete_property);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get.js
var es6_reflect_get = __webpack_require__("../node_modules/core-js/modules/es6.reflect.get.js");
var es6_reflect_get_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
var es6_reflect_get_own_property_descriptor = __webpack_require__("../node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
var es6_reflect_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_own_property_descriptor);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.get-prototype-of.js
var es6_reflect_get_prototype_of = __webpack_require__("../node_modules/core-js/modules/es6.reflect.get-prototype-of.js");
var es6_reflect_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.has.js
var es6_reflect_has = __webpack_require__("../node_modules/core-js/modules/es6.reflect.has.js");
var es6_reflect_has_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_has);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.is-extensible.js
var es6_reflect_is_extensible = __webpack_require__("../node_modules/core-js/modules/es6.reflect.is-extensible.js");
var es6_reflect_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_is_extensible);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.own-keys.js
var es6_reflect_own_keys = __webpack_require__("../node_modules/core-js/modules/es6.reflect.own-keys.js");
var es6_reflect_own_keys_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_own_keys);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.prevent-extensions.js
var es6_reflect_prevent_extensions = __webpack_require__("../node_modules/core-js/modules/es6.reflect.prevent-extensions.js");
var es6_reflect_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_prevent_extensions);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.set.js
var es6_reflect_set = __webpack_require__("../node_modules/core-js/modules/es6.reflect.set.js");
var es6_reflect_set_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.reflect.set-prototype-of.js
var es6_reflect_set_prototype_of = __webpack_require__("../node_modules/core-js/modules/es6.reflect.set-prototype-of.js");
var es6_reflect_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("../node_modules/core-js/modules/es6.promise.js");
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__("../node_modules/core-js/modules/es6.symbol.js");
var es6_symbol_default = /*#__PURE__*/__webpack_require__.n(es6_symbol);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__("../node_modules/core-js/modules/es6.object.freeze.js");
var es6_object_freeze_default = /*#__PURE__*/__webpack_require__.n(es6_object_freeze);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.seal.js
var es6_object_seal = __webpack_require__("../node_modules/core-js/modules/es6.object.seal.js");
var es6_object_seal_default = /*#__PURE__*/__webpack_require__.n(es6_object_seal);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.prevent-extensions.js
var es6_object_prevent_extensions = __webpack_require__("../node_modules/core-js/modules/es6.object.prevent-extensions.js");
var es6_object_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_object_prevent_extensions);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-frozen.js
var es6_object_is_frozen = __webpack_require__("../node_modules/core-js/modules/es6.object.is-frozen.js");
var es6_object_is_frozen_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_frozen);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-sealed.js
var es6_object_is_sealed = __webpack_require__("../node_modules/core-js/modules/es6.object.is-sealed.js");
var es6_object_is_sealed_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_sealed);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is-extensible.js
var es6_object_is_extensible = __webpack_require__("../node_modules/core-js/modules/es6.object.is-extensible.js");
var es6_object_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_extensible);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js
var es6_object_get_own_property_descriptor = __webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-descriptor.js");
var es6_object_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_descriptor);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-prototype-of.js
var es6_object_get_prototype_of = __webpack_require__("../node_modules/core-js/modules/es6.object.get-prototype-of.js");
var es6_object_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("../node_modules/core-js/modules/es6.object.keys.js");
var es6_object_keys_default = /*#__PURE__*/__webpack_require__.n(es6_object_keys);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.get-own-property-names.js
var es6_object_get_own_property_names = __webpack_require__("../node_modules/core-js/modules/es6.object.get-own-property-names.js");
var es6_object_get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_names);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");
var es6_object_assign_default = /*#__PURE__*/__webpack_require__.n(es6_object_assign);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.is.js
var es6_object_is = __webpack_require__("../node_modules/core-js/modules/es6.object.is.js");
var es6_object_is_default = /*#__PURE__*/__webpack_require__.n(es6_object_is);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.object.set-prototype-of.js
var es6_object_set_prototype_of = __webpack_require__("../node_modules/core-js/modules/es6.object.set-prototype-of.js");
var es6_object_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_set_prototype_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("../node_modules/core-js/modules/es6.function.name.js");
var es6_function_name_default = /*#__PURE__*/__webpack_require__.n(es6_function_name);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.raw.js
var es6_string_raw = __webpack_require__("../node_modules/core-js/modules/es6.string.raw.js");
var es6_string_raw_default = /*#__PURE__*/__webpack_require__.n(es6_string_raw);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.from-code-point.js
var es6_string_from_code_point = __webpack_require__("../node_modules/core-js/modules/es6.string.from-code-point.js");
var es6_string_from_code_point_default = /*#__PURE__*/__webpack_require__.n(es6_string_from_code_point);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.code-point-at.js
var es6_string_code_point_at = __webpack_require__("../node_modules/core-js/modules/es6.string.code-point-at.js");
var es6_string_code_point_at_default = /*#__PURE__*/__webpack_require__.n(es6_string_code_point_at);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.repeat.js
var es6_string_repeat = __webpack_require__("../node_modules/core-js/modules/es6.string.repeat.js");
var es6_string_repeat_default = /*#__PURE__*/__webpack_require__.n(es6_string_repeat);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("../node_modules/core-js/modules/es6.string.starts-with.js");
var es6_string_starts_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_starts_with);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__("../node_modules/core-js/modules/es6.string.ends-with.js");
var es6_string_ends_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_ends_with);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
var es6_string_includes_default = /*#__PURE__*/__webpack_require__.n(es6_string_includes);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.flags.js
var es6_regexp_flags = __webpack_require__("../node_modules/core-js/modules/es6.regexp.flags.js");
var es6_regexp_flags_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_flags);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__("../node_modules/core-js/modules/es6.regexp.match.js");
var es6_regexp_match_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_match);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("../node_modules/core-js/modules/es6.regexp.replace.js");
var es6_regexp_replace_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_replace);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("../node_modules/core-js/modules/es6.regexp.split.js");
var es6_regexp_split_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_split);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__("../node_modules/core-js/modules/es6.regexp.search.js");
var es6_regexp_search_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_search);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__("../node_modules/core-js/modules/es6.array.from.js");
var es6_array_from_default = /*#__PURE__*/__webpack_require__.n(es6_array_from);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.of.js
var es6_array_of = __webpack_require__("../node_modules/core-js/modules/es6.array.of.js");
var es6_array_of_default = /*#__PURE__*/__webpack_require__.n(es6_array_of);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.copy-within.js
var es6_array_copy_within = __webpack_require__("../node_modules/core-js/modules/es6.array.copy-within.js");
var es6_array_copy_within_default = /*#__PURE__*/__webpack_require__.n(es6_array_copy_within);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
var es6_array_find_default = /*#__PURE__*/__webpack_require__.n(es6_array_find);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__("../node_modules/core-js/modules/es6.array.find-index.js");
var es6_array_find_index_default = /*#__PURE__*/__webpack_require__.n(es6_array_find_index);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__("../node_modules/core-js/modules/es6.array.fill.js");
var es6_array_fill_default = /*#__PURE__*/__webpack_require__.n(es6_array_fill);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("../node_modules/core-js/modules/es6.array.iterator.js");
var es6_array_iterator_default = /*#__PURE__*/__webpack_require__.n(es6_array_iterator);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-finite.js
var es6_number_is_finite = __webpack_require__("../node_modules/core-js/modules/es6.number.is-finite.js");
var es6_number_is_finite_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_finite);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-integer.js
var es6_number_is_integer = __webpack_require__("../node_modules/core-js/modules/es6.number.is-integer.js");
var es6_number_is_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-safe-integer.js
var es6_number_is_safe_integer = __webpack_require__("../node_modules/core-js/modules/es6.number.is-safe-integer.js");
var es6_number_is_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.is-nan.js
var es6_number_is_nan = __webpack_require__("../node_modules/core-js/modules/es6.number.is-nan.js");
var es6_number_is_nan_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_nan);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__("../node_modules/core-js/modules/es6.number.epsilon.js");
var es6_number_epsilon_default = /*#__PURE__*/__webpack_require__.n(es6_number_epsilon);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.min-safe-integer.js
var es6_number_min_safe_integer = __webpack_require__("../node_modules/core-js/modules/es6.number.min-safe-integer.js");
var es6_number_min_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_min_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.number.max-safe-integer.js
var es6_number_max_safe_integer = __webpack_require__("../node_modules/core-js/modules/es6.number.max-safe-integer.js");
var es6_number_max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_max_safe_integer);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.acosh.js
var es6_math_acosh = __webpack_require__("../node_modules/core-js/modules/es6.math.acosh.js");
var es6_math_acosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_acosh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.asinh.js
var es6_math_asinh = __webpack_require__("../node_modules/core-js/modules/es6.math.asinh.js");
var es6_math_asinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_asinh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.atanh.js
var es6_math_atanh = __webpack_require__("../node_modules/core-js/modules/es6.math.atanh.js");
var es6_math_atanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_atanh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.cbrt.js
var es6_math_cbrt = __webpack_require__("../node_modules/core-js/modules/es6.math.cbrt.js");
var es6_math_cbrt_default = /*#__PURE__*/__webpack_require__.n(es6_math_cbrt);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.clz32.js
var es6_math_clz32 = __webpack_require__("../node_modules/core-js/modules/es6.math.clz32.js");
var es6_math_clz32_default = /*#__PURE__*/__webpack_require__.n(es6_math_clz32);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.cosh.js
var es6_math_cosh = __webpack_require__("../node_modules/core-js/modules/es6.math.cosh.js");
var es6_math_cosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_cosh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.expm1.js
var es6_math_expm1 = __webpack_require__("../node_modules/core-js/modules/es6.math.expm1.js");
var es6_math_expm1_default = /*#__PURE__*/__webpack_require__.n(es6_math_expm1);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.fround.js
var es6_math_fround = __webpack_require__("../node_modules/core-js/modules/es6.math.fround.js");
var es6_math_fround_default = /*#__PURE__*/__webpack_require__.n(es6_math_fround);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.hypot.js
var es6_math_hypot = __webpack_require__("../node_modules/core-js/modules/es6.math.hypot.js");
var es6_math_hypot_default = /*#__PURE__*/__webpack_require__.n(es6_math_hypot);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.imul.js
var es6_math_imul = __webpack_require__("../node_modules/core-js/modules/es6.math.imul.js");
var es6_math_imul_default = /*#__PURE__*/__webpack_require__.n(es6_math_imul);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log1p.js
var es6_math_log1p = __webpack_require__("../node_modules/core-js/modules/es6.math.log1p.js");
var es6_math_log1p_default = /*#__PURE__*/__webpack_require__.n(es6_math_log1p);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log10.js
var es6_math_log10 = __webpack_require__("../node_modules/core-js/modules/es6.math.log10.js");
var es6_math_log10_default = /*#__PURE__*/__webpack_require__.n(es6_math_log10);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.log2.js
var es6_math_log2 = __webpack_require__("../node_modules/core-js/modules/es6.math.log2.js");
var es6_math_log2_default = /*#__PURE__*/__webpack_require__.n(es6_math_log2);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.sign.js
var es6_math_sign = __webpack_require__("../node_modules/core-js/modules/es6.math.sign.js");
var es6_math_sign_default = /*#__PURE__*/__webpack_require__.n(es6_math_sign);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.sinh.js
var es6_math_sinh = __webpack_require__("../node_modules/core-js/modules/es6.math.sinh.js");
var es6_math_sinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_sinh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.tanh.js
var es6_math_tanh = __webpack_require__("../node_modules/core-js/modules/es6.math.tanh.js");
var es6_math_tanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_tanh);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es6.math.trunc.js
var es6_math_trunc = __webpack_require__("../node_modules/core-js/modules/es6.math.trunc.js");
var es6_math_trunc_default = /*#__PURE__*/__webpack_require__.n(es6_math_trunc);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
var es7_array_includes_default = /*#__PURE__*/__webpack_require__.n(es7_array_includes);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
var es7_object_values_default = /*#__PURE__*/__webpack_require__.n(es7_object_values);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
var es7_object_entries_default = /*#__PURE__*/__webpack_require__.n(es7_object_entries);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__("../node_modules/core-js/modules/es7.object.get-own-property-descriptors.js");
var es7_object_get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(es7_object_get_own_property_descriptors);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.string.pad-start.js
var es7_string_pad_start = __webpack_require__("../node_modules/core-js/modules/es7.string.pad-start.js");
var es7_string_pad_start_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_start);

// EXTERNAL MODULE: ../node_modules/core-js/modules/es7.string.pad-end.js
var es7_string_pad_end = __webpack_require__("../node_modules/core-js/modules/es7.string.pad-end.js");
var es7_string_pad_end_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_end);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__("../node_modules/core-js/modules/web.timers.js");
var web_timers_default = /*#__PURE__*/__webpack_require__.n(web_timers);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__("../node_modules/core-js/modules/web.immediate.js");
var web_immediate_default = /*#__PURE__*/__webpack_require__.n(web_immediate);

// EXTERNAL MODULE: ../node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("../node_modules/core-js/modules/web.dom.iterable.js");
var web_dom_iterable_default = /*#__PURE__*/__webpack_require__.n(web_dom_iterable);

// EXTERNAL MODULE: ../node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("../node_modules/regenerator-runtime/runtime.js");
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// EXTERNAL MODULE: ../node_modules/details-polyfill/index.js
var details_polyfill = __webpack_require__("../node_modules/details-polyfill/index.js");
var details_polyfill_default = /*#__PURE__*/__webpack_require__.n(details_polyfill);

// EXTERNAL MODULE: delegated ../node_modules/react/index.js from dll-reference vendor
var reactfrom_dll_reference_vendor = __webpack_require__("../node_modules/react/index.js");
var reactfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(reactfrom_dll_reference_vendor);

// EXTERNAL MODULE: delegated ../node_modules/react-dom/index.js from dll-reference vendor
var react_domfrom_dll_reference_vendor = __webpack_require__("../node_modules/react-dom/index.js");
var react_domfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(react_domfrom_dll_reference_vendor);

// EXTERNAL MODULE: delegated ../node_modules/react-redux/es/index.js from dll-reference vendor
var esfrom_dll_reference_vendor = __webpack_require__("../node_modules/react-redux/es/index.js");

// CONCATENATED MODULE: ../node_modules/redux-persist/es/constants.js
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';
// EXTERNAL MODULE: delegated ../node_modules/lodash-es/isPlainObject.js from dll-reference vendor
var isPlainObjectfrom_dll_reference_vendor = __webpack_require__("../node_modules/lodash-es/isPlainObject.js");

// CONCATENATED MODULE: ../node_modules/redux-persist/es/utils/isStatePlainEnough.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(isPlainObjectfrom_dll_reference_vendor["default"])(a)) return false;
  return true;
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/autoRehydrate.js
var autoRehydrate__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== REHYDRATE) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (autoRehydrate__typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (isStatePlainEnough(inboundState[key]) && isStatePlainEnough(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}
// EXTERNAL MODULE: ../node_modules/redux-persist/es/utils/setImmediate.js
var setImmediate = __webpack_require__("../node_modules/redux-persist/es/utils/setImmediate.js");

// CONCATENATED MODULE: ../node_modules/redux-persist/es/defaults/asyncLocalStorage.js
var asyncLocalStorage__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : asyncLocalStorage__typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ var asyncLocalStorage = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(setImmediate["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});
// CONCATENATED MODULE: ../node_modules/redux-persist/es/purgeStoredState.js


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}
// EXTERNAL MODULE: ../node_modules/json-stringify-safe/stringify.js
var stringify = __webpack_require__("../node_modules/json-stringify-safe/stringify.js");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ../node_modules/redux-persist/es/createPersistor.js





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || asyncLocalStorage('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return purgeStoredState({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return stringify_default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: REHYDRATE,
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/createTransform.js
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ var es_createTransform = (createTransform);
// CONCATENATED MODULE: ../node_modules/redux-persist/es/getStoredState.js
var getStoredState__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || asyncLocalStorage('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : getStoredState_defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : KEY_PREFIX;

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = getStoredState__extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function getStoredState_defaultDeserializer(serial) {
  return JSON.parse(serial);
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/persistStore.js
var persistStore__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = createPersistor(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(setImmediate["a" /* default */])(function () {
      getStoredState(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(persistStore_rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(setImmediate["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return persistStore__extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function persistStore_rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: REHYDRATE,
    payload: payload,
    error: error
  };
}
// CONCATENATED MODULE: ../node_modules/redux-persist/es/index.js







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};


// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("../node_modules/babel-runtime/helpers/extends.js");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("../node_modules/babel-runtime/core-js/object/get-prototype-of.js");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("../node_modules/babel-runtime/helpers/classCallCheck.js");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("../node_modules/babel-runtime/helpers/createClass.js");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("../node_modules/babel-runtime/helpers/possibleConstructorReturn.js");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/get.js
var get = __webpack_require__("../node_modules/babel-runtime/helpers/get.js");
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("../node_modules/babel-runtime/helpers/inherits.js");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ../node_modules/fbemitter/index.js
var fbemitter = __webpack_require__("../node_modules/fbemitter/index.js");
var fbemitter_default = /*#__PURE__*/__webpack_require__.n(fbemitter);

// EXTERNAL MODULE: ../node_modules/url/url.js
var url_url = __webpack_require__("../node_modules/url/url.js");
var url_default = /*#__PURE__*/__webpack_require__.n(url_url);

// CONCATENATED MODULE: ./helpers/events.js








// file to be replaced by analytics.js implementation?



/* istanbul ignore next */
var events_LoggingEmitter = function (_EventEmitter) {
  inherits_default()(LoggingEmitter, _EventEmitter);

  function LoggingEmitter() {
    classCallCheck_default()(this, LoggingEmitter);

    return possibleConstructorReturn_default()(this, (LoggingEmitter.__proto__ || get_prototype_of_default()(LoggingEmitter)).apply(this, arguments));
  }

  createClass_default()(LoggingEmitter, [{
    key: "emit",
    value: function emit() {
      var _get2;

      var _parse = Object(url_url["parse"])(location.toString(), true),
          query = _parse.query;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (query && query.analytics === "true") {
        var _console;

        (_console = console).log.apply(_console, args); //eslint-disable-line no-console
      }
      return (_get2 = get_default()(LoggingEmitter.prototype.__proto__ || get_prototype_of_default()(LoggingEmitter.prototype), "emit", this)).call.apply(_get2, [this].concat(args));
    }
  }]);

  return LoggingEmitter;
}(fbemitter["EventEmitter"]);

var events_emitter = new events_LoggingEmitter();
var events_emit = function emit(eventName, details) {
  return events_emitter.emit(eventName, details);
};
var pageLoadData = {};
var pageLoadEventsToTrack = ["tracking.productList.pageLoad"];

var events_trackPageLoads = function trackPageLoads() {
  //Capture selected pageLoad events
  pageLoadEventsToTrack.forEach(function (event) {
    events_emitter.addListener(event, function (payload) {
      pageLoadData[event] = payload;
    });
  });

  //re-emit them for signal when they're ready
  events_emitter.addListener("signal-ready", function () {
    keys_default()(pageLoadData).forEach(function (event) {
      var payload = pageLoadData[event];
      events_emit(event + "-signal", payload);
    });
  });
};

events_trackPageLoads();

/* harmony default export */ var events = (events_emitter);

var ANALYTICS_INTERACTION_CLICK = "click";
var ANALYTICS_INTERACTION_EXPAND = "expand";
var ANALYTICS_INTERACTION_HOVER = "hover";
var ANALYTICS_INTERACTION_SAVED = "saved";
var ANALYTICS_POSITION_HEADER = "header";
var ANALYTICS_POSITION_FOOTER = "footer";
var ANALYTICS_POSITION_COUNTRY_SELECTOR = "country selector modal";
var ANALYTICS_CONTEXT = {
  navHover: "nav hover",
  openNav: "open nav section",
  social: "social icon",
  openCountryModal: "open country modal",
  footerExpandable: "concertina",
  countrySelector: "country preferences",
  minibagDeleteItem: "mini bag product delete"
};

var events_getGender = function getGender(str) {
  if (str === "men" || str === "women") return str;
  if (str === "MW") return "men";
  if (str === "WW") return "women";
};

var trackSocialClick = function trackSocialClick(details) {
  return events_emit("tracking.navigation.pageInteraction", details);
};

var trackNavOpen = function trackNavOpen(details) {
  return events_emit("tracking.navigation.pageInteraction", details);
};

var trackOpenCountryModal = function trackOpenCountryModal(details) {
  return events_emit("tracking.navigation.pageInteraction", details);
};

var trackSubmitCountrySelector = function trackSubmitCountrySelector(details) {
  return events_emit("tracking.navigation.pageInteraction", details);
};

var trackMiniBagProductDelete = function trackMiniBagProductDelete(details) {
  return events_emit("tracking.miniBag.miniBagInteraction", details);
};

var trackBannerShown = function trackBannerShown() {
  return events_emit("tracking.gdpr.bannerShow", {
    context: "gdpr banner shown",
    trackingFrequency: "session"
  });
};

var trackBannerClose = function trackBannerClose() {
  return events_emit("tracking.gdpr.bannerClose", {
    context: "gdpr banner closed",
    trackingFrequency: "session"
  });
};

var events_trackGdprKeepSending = function trackGdprKeepSending(basicDetails) {
  return events_emit("tracking.gdpr.pageLoad", extends_default()({}, basicDetails, {
    pageName: "gdpr keep sending",
    pageTitle: "gdpr keep sending"
  }));
};

var events_trackGdprStopSending = function trackGdprStopSending(basicDetails) {
  return events_emit("tracking.gdpr.pageLoad", extends_default()({}, basicDetails, {
    pageName: "gdpr stop sending",
    pageTitle: "gdpr stop sending"
  }));
};

var events_trackOpenGdprModal = function trackOpenGdprModal(basicDetails) {
  return events_emit("tracking.gdpr.pageLoad", extends_default()({}, basicDetails, {
    pageName: "gdpr control my content",
    pageTitle: "gdpr control my content"
  }));
};
// CONCATENATED MODULE: ./helpers/contentTargetingEvents.js




var contentTargetingEvents_ContentTargetingEvents = function () {
  function ContentTargetingEvents() {
    classCallCheck_default()(this, ContentTargetingEvents);

    this.cache = null;
    this.emitter = new fbemitter["EventEmitter"]();
  }

  createClass_default()(ContentTargetingEvents, [{
    key: "subscribe",
    value: function subscribe(callback) {
      this.emitter.addListener("targetedContent", callback);
      if (this.cache) {
        this.emitter.emit("targetedContent", this.cache);
      }
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.emitter.emit("targetedContent", data);
      this.cache = data;
    }
  }]);

  return ContentTargetingEvents;
}();

/* harmony default export */ var contentTargetingEvents = (new contentTargetingEvents_ContentTargetingEvents());
// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/map.js
var map = __webpack_require__("../node_modules/babel-runtime/core-js/map.js");
var map_default = /*#__PURE__*/__webpack_require__.n(map);

// EXTERNAL MODULE: ../node_modules/debug/src/browser.js
var src_browser = __webpack_require__("../node_modules/debug/src/browser.js");
var browser_default = /*#__PURE__*/__webpack_require__.n(src_browser);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/errors/index.js
var errors = {
  StoreServiceError: "StoreServiceError",
  StoreFormatError: "StoreFormatError",
  StoreNotFoundError: "StoreNotFoundError",
  CacheError: "CacheError",
  InvalidArgumentError: "InvalidArgumentError"
};

var storeServiceError = function storeServiceError(message, e) {
  return {
    type: errors.StoreServiceError,
    message: message,
    raw: e
  };
};

var storeFormatError = function storeFormatError(message) {
  return {
    type: errors.StoreFormatError,
    message: message
  };
};

var storeNotFoundError = function storeNotFoundError(message) {
  return {
    type: errors.StoreNotFoundError,
    message: message
  };
};

var cacheError = function cacheError(message) {
  return {
    type: errors.CacheError,
    message: message
  };
};

var invalidArgumentError = function invalidArgumentError(message) {
  return {
    type: errors.InvalidArgumentError,
    message: message
  };
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/cache/index.js




var cacheFactory = {
  create: function create() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        expiryMs = _ref.expiryMs;

    if (typeof expiryMs !== "number") {
      throw cacheError("Invalid argument: Cache expiry (argument name: expiryMs) must be a number");
    }

    var logger = browser_default()("asos-site-chrome-store-presentation:cache");
    var storage = new map_default.a();

    return {
      set: function set(key, value) {
        storage.set(key, {
          value: value,
          expiry: Date.now() + expiryMs
        });
        return value;
      },
      hasKey: function hasKey(key) {
        return storage.has(key);
      },
      hasExpired: function hasExpired(key) {
        var entry = storage.get(key);
        return entry && entry.expiry < Date.now();
      },
      get: function get(key) {
        if (!this.hasKey(key)) {
          logger("Key missing: " + key);
          return null;
        }
        var entry = storage.get(key);
        if (this.hasExpired(key)) {
          logger("Key expired: " + key);
        }
        return entry.value;
      }
    };
  }
};

/* harmony default export */ var factories_cache = (cacheFactory);
// EXTERNAL MODULE: ../node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("../node_modules/babel-runtime/regenerator/index.js");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("../node_modules/babel-runtime/core-js/object/assign.js");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("../node_modules/babel-runtime/helpers/asyncToGenerator.js");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ../node_modules/isomorphic-fetch/fetch-npm-browserify.js
var fetch_npm_browserify = __webpack_require__("../node_modules/isomorphic-fetch/fetch-npm-browserify.js");
var fetch_npm_browserify_default = /*#__PURE__*/__webpack_require__.n(fetch_npm_browserify);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/wrappedFetch/index.js



var handleError = function () {
  var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee2(response, url) {
    var information, errorResponse, status;
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            information = void 0, errorResponse = void 0, status = void 0;
            _context2.prev = 1;

            status = response.status;
            _context2.next = 5;
            return response.json();

          case 5:
            information = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);

            errorResponse = _context2.t0;

          case 11:
            throw storeServiceError("Failed to fetch", {
              url: url,
              status: status,
              information: information,
              errorResponse: errorResponse
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[1, 8]]);
  }));

  return function handleError(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/* global fetch */



/* harmony default export */ var utils_wrappedFetch = ((function () {
  var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(url) {
    var response;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            response = void 0;
            _context.prev = 1;
            _context.next = 4;
            return fetch(url);

          case 4:
            response = _context.sent;
            _context.next = 10;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", handleError(response, url));

          case 10:
            if (!(response.status >= 400)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", handleError(response, url));

          case 12:
            return _context.abrupt("return", response);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 7]]);
  }));

  function wrappedFetch(_x) {
    return _ref.apply(this, arguments);
  }

  return wrappedFetch;
})());
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getVersionManifest/index.js






/*
 * @typedef {Object} SiteChromeVersion
 * @property {boolean} useCurrent
 * @property {string} current
 * @property {string} previous
 */

/*
 * @typedef {Object} VersionManifest
 * @property {string[]} permittedKeyStoreDataversions
 * @property {boolean} useCurrentKeyStoreDataversion
 * @property {{ current: string, previous: string }} keyStoreDataversion
 * @property {string[]} permittedSiteChromeVersions
 * @property {Object.<string, SiteChromeVersion>} siteChromeVersion
 */

/*
 * @returns {VersionManifest} versionManifest
 */
function getVersionManifest_getVersionManifest(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, cache, versionManifestEndpoint, warn, response, json;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              cache = params.cache, versionManifestEndpoint = params.versionManifestEndpoint, warn = params.warn;

              if (!(cache.hasKey(versionManifestEndpoint) && !cache.hasExpired(versionManifestEndpoint))) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", cache.get(versionManifestEndpoint));

            case 4:
              _context.prev = 4;
              _context.next = 7;
              return utils_wrappedFetch(versionManifestEndpoint);

            case 7:
              response = _context.sent;
              _context.next = 10;
              return response.json();

            case 10:
              json = _context.sent;
              return _context.abrupt("return", cache.set(versionManifestEndpoint, json));

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);

              warn("Store presentation failed to fetch valid manifest from", versionManifestEndpoint, _context.t0);

              if (!cache.hasKey(versionManifestEndpoint)) {
                _context.next = 21;
                break;
              }

              warn("Store presentation forced to return a stale manifest cache", _context.t0);
              warn("Resetting the stale cache");

              return _context.abrupt("return", cache.set(versionManifestEndpoint, cache.get(versionManifestEndpoint)));

            case 21:
              throw storeServiceError("Could not obtain a valid manifest", _context.t0);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[4, 14]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/server/cookieReadingAndWriting.js
var oneYearInSeconds = 365 * 24 * 60 * 60;

var cookieReadingAndWriting_getCookieValue = function getCookieValue(req, cookieName) {
  return req.cookies[cookieName] || null;
};

var cookieReadingAndWriting_setCookieValue = function setCookieValue(res, cookieName, value) {
  var expiry = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { maxAge: oneYearInSeconds };

  res.cookie(cookieName, value, expiry);
};

var findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.includes(key + "=");
  })[0] : null;
};

var concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var setKeyedCookieValue = function setKeyedCookieValue(req, res, cookieName, key, value, expiry) {
  cookieReadingAndWriting_setCookieValue(res, cookieName, concatenateKeyValuePairs(cookieReadingAndWriting_getCookieValue(req, cookieName), key, value), expiry);
};

var getKeyedCookieValue = function getKeyedCookieValue(req, cookieName, key) {
  var keyValuePair = findKeyValuePair(cookieReadingAndWriting_getCookieValue(req, cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/gender/index.js
var getGenderByFloorId = function getGenderByFloorId(floorId) {
  switch (Number(floorId)) {
    case 1000:
      return "women";
    case 1001:
      return "men";
    default:
      return "default";
  }
};

var getFloorIdByGender = function getFloorIdByGender(gender) {
  if (typeof gender !== "string") {
    return null;
  }
  switch (gender.toLowerCase()) {
    case "women":
      return 1000;
    case "men":
      return 1001;
    default:
      return null;
  }
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/cookiesMap.js
/* harmony default export */ var cookiesMap = ({
  BrowseCountryKey: "browseCountry",
  FloorCookieName: "floor",
  AsosCookieName: "asos",
  CurrencyCookieName: "currency",
  CurrencyIdKey: "currencyid",
  CurrencyLabelKey: "currencylabel",
  SizeSchemaKey: "sizeSchema",
  PreferredSiteKey: "PreferredSite",
  TopCatIdKey: "topcatid",
  WelcomeMessage: "welcomeMessageClosed",
  BrowseCurrencyKey: "browseCurrency",
  BrowseLanguageKey: "browseLanguage",
  BrowseSizeSchemaKey: "browseSizeSchema",
  StoreCodeKey: "storeCode",
  TemplateVersionKey: "siteChromeVersion",
  KeyStoreDataversionKey: "keyStoreDataversion",
  GeoCountryKey: "geocountry",
  AffiliateCookieName: "asosAffiliate",
  AffiliateKey: "affiliateId",
  WelcomeMatWrong: "welcomeMatWrong",
  WelcomeMatCorrect: "welcomeMatCorrect"
});
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/server/index.js





var oneHourInSeconds = 60 * 60;

var FloorCookieName = cookiesMap.FloorCookieName,
    AsosCookieName = cookiesMap.AsosCookieName,
    SizeSchemaKey = cookiesMap.SizeSchemaKey,
    PreferredSiteKey = cookiesMap.PreferredSiteKey,
    TopCatIdKey = cookiesMap.TopCatIdKey,
    BrowseCountryKey = cookiesMap.BrowseCountryKey,
    KeyStoreDataversionKey = cookiesMap.KeyStoreDataversionKey,
    TemplateVersionKey = cookiesMap.TemplateVersionKey,
    BrowseCurrencyKey = cookiesMap.BrowseCurrencyKey,
    BrowseSizeSchemaKey = cookiesMap.BrowseSizeSchemaKey,
    BrowseLanguageKey = cookiesMap.BrowseLanguageKey;


var server_getSizeSchema = function getSizeSchema(req) {
  return getKeyedCookieValue(req, AsosCookieName, SizeSchemaKey);
};

var server_setSizeSchema = function setSizeSchema(req, res, sizeSchema) {
  if (!sizeSchema) {
    throw invalidArgumentError("Invalid argument: sizeSchema cannot be empty");
  }
  setKeyedCookieValue(req, res, AsosCookieName, SizeSchemaKey, sizeSchema);
};

var server_getFloor = function getFloor(req) {
  return getGenderByFloorId(cookieReadingAndWriting_getCookieValue(req, FloorCookieName));
};

var server_setFloor = function setFloor(req, res, gender) {
  if (!gender) {
    throw invalidArgumentError("Invalid argument: gender cannot be empty");
  }
  var floorId = getFloorIdByGender(gender);
  if (floorId) {
    cookieReadingAndWriting_setCookieValue(res, FloorCookieName, floorId);
    setKeyedCookieValue(req, res, AsosCookieName, TopCatIdKey, floorId);
  }
};

var server_getPreferredSite = function getPreferredSite(req) {
  return getKeyedCookieValue(req, AsosCookieName, PreferredSiteKey);
};

var isFirstVisit = function isFirstVisit(req) {
  return !server_getPreferredSite(req);
};

var server_getBrowseCountry = function getBrowseCountry(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseCountryKey);
};

var server_clearCookies = function clearCookies(res) {
  res.clearCookie(AsosCookieName);
  res.clearCookie(FloorCookieName);
};

var server_getKeyStoreDataversion = function getKeyStoreDataversion(req) {
  return cookieReadingAndWriting_getCookieValue(req, KeyStoreDataversionKey);
};

var server_setKeyStoreDataversion = function setKeyStoreDataversion(res, value) {
  return cookieReadingAndWriting_setCookieValue(res, KeyStoreDataversionKey, value, {
    maxAge: oneHourInSeconds
  });
};

var server_getTemplateVersion = function getTemplateVersion(req, storeCode) {
  return getKeyedCookieValue(req, TemplateVersionKey, storeCode);
};

var server_setTemplateVersion = function setTemplateVersion(req, res, storeCode, value) {
  return setKeyedCookieValue(req, res, TemplateVersionKey, storeCode, value, {
    maxAge: oneHourInSeconds
  });
};

var server_getBrowseCurrency = function getBrowseCurrency(req) {
  return [req.query[BrowseCurrencyKey] || null, cookieReadingAndWriting_getCookieValue(req, BrowseCurrencyKey)].find(function (currencyCode) {
    return currencyCode !== null;
  }) || null;
};

var server_getBrowseSizeSchema = function getBrowseSizeSchema(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseSizeSchemaKey);
};

var server_getBrowseLanguage = function getBrowseLanguage(req) {
  return cookieReadingAndWriting_getCookieValue(req, BrowseLanguageKey);
};

/* harmony default export */ var server = ({
  getSizeSchema: server_getSizeSchema,
  setSizeSchema: server_setSizeSchema,
  getFloor: server_getFloor,
  setFloor: server_setFloor,
  getPreferredSite: server_getPreferredSite,
  isFirstVisit: isFirstVisit,
  clearCookies: server_clearCookies,
  getBrowseCurrency: server_getBrowseCurrency
});
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getKeyStoreDataversion/index.js





function getKeyStoreDataversion_getKeyStoreDataversion(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getVersionManifest, request, response, ksdvInCookie, _ref2, useCurrentKeyStoreDataversion, keyStoreDataversion, permittedKeyStoreDataversions, activeKeyStore;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getVersionManifest = params.getVersionManifest, request = params.request, response = params.response;
              ksdvInCookie = null;

              if (request) {
                ksdvInCookie = server_getKeyStoreDataversion(request);
              }

              _context.next = 6;
              return getVersionManifest();

            case 6:
              _ref2 = _context.sent;
              useCurrentKeyStoreDataversion = _ref2.useCurrentKeyStoreDataversion;
              keyStoreDataversion = _ref2.keyStoreDataversion;
              permittedKeyStoreDataversions = _ref2.permittedKeyStoreDataversions;

              if (!(ksdvInCookie && permittedKeyStoreDataversions.includes(ksdvInCookie))) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", ksdvInCookie);

            case 12:
              activeKeyStore = useCurrentKeyStoreDataversion ? keyStoreDataversion.current : keyStoreDataversion.previous;

              // If cookie is set but isnt permitted

              if (ksdvInCookie && response) {
                server_setKeyStoreDataversion(response, activeKeyStore);
              }

              return _context.abrupt("return", activeKeyStore);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getSiteChromeVersion/index.js






/*
 * @returns {string} siteChromeVersion
 */
function getSiteChromeVersion_getSiteChromeVersion(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountry, getVersionManifest, request, response, _ref2, storeCode, siteChromeVersionInCookie, _ref3, siteChromeVersion, permittedSiteChromeVersions, storesSiteChromeVersion, activeSiteChrome;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountry = params.getCountry, getVersionManifest = params.getVersionManifest, request = params.request, response = params.response;
              _context.next = 4;
              return getCountry({ request: request, response: response });

            case 4:
              _ref2 = _context.sent;
              storeCode = _ref2.storeCode;
              siteChromeVersionInCookie = server_getTemplateVersion(request, storeCode.toLowerCase());
              _context.next = 9;
              return getVersionManifest();

            case 9:
              _ref3 = _context.sent;
              siteChromeVersion = _ref3.siteChromeVersion;
              permittedSiteChromeVersions = _ref3.permittedSiteChromeVersions;

              if (siteChromeVersion) {
                _context.next = 14;
                break;
              }

              throw storeServiceError("Could not get valid version manifest");

            case 14:
              if (!(siteChromeVersionInCookie && permittedSiteChromeVersions.includes(siteChromeVersionInCookie))) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", siteChromeVersionInCookie);

            case 16:
              storesSiteChromeVersion = siteChromeVersion[storeCode] || siteChromeVersion[storeCode.toLowerCase()] || null;

              if (!(storesSiteChromeVersion === null)) {
                _context.next = 19;
                break;
              }

              throw storeServiceError("Could not match store in the version manifest");

            case 19:
              activeSiteChrome = storesSiteChromeVersion.useCurrent ? storesSiteChromeVersion.current : storesSiteChromeVersion.previous;

              // If cookie is set but isn't permitted

              if (siteChromeVersionInCookie && request && response) {
                server_setTemplateVersion(request, response, activeSiteChrome);
              }

              return _context.abrupt("return", activeSiteChrome);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getUseSiteChrome/index.js



/*
 * @returns {boolean} useSiteChrome
 */
function getUseSiteChrome(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getSiteChromeVersion, request, response, siteChromeVersion;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getSiteChromeVersion = params.getSiteChromeVersion, request = params.request, response = params.response;
              _context.next = 4;
              return getSiteChromeVersion({ request: request, response: response });

            case 4:
              siteChromeVersion = _context.sent;
              return _context.abrupt("return", !["1", "2"].includes(String(siteChromeVersion)));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getDefaultCountry/index.js
function getDefaultCountry(req, defaultCountries) {
  var com = defaultCountries.find(function (defaultCountry) {
    return defaultCountry.storeCode === "COM";
  });
  var xSiteUrn = req.get("X-SITE-URN") || com.url;

  var candidateCountries = defaultCountries.filter(function (defaultCountry) {
    return defaultCountry.url === xSiteUrn;
  });

  switch (candidateCountries.length) {
    case 0:
      return com;
    case 1:
      return candidateCountries[0];
    default:
      return candidateCountries.find(function (candidateCountry) {
        return candidateCountry.isXSiteUrnFallback;
      });
  }
}
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("../node_modules/babel-runtime/helpers/typeof.js");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getBrowseCountry/index.js



var getBrowseCountry_getBrowseCountryFromQueryString = function getBrowseCountryFromQueryString(req) {
  return typeof_default()(req.query) === "object" && typeof req.query.browseCountry === "string" && req.query.browseCountry;
};

var getBrowseCountry_getBrowseCountryFromCookie = function getBrowseCountryFromCookie(req) {
  return req.cookies && server_getBrowseCountry(req);
};

function getBrowseCountry_getBrowseCountry(req) {
  return getBrowseCountry_getBrowseCountryFromQueryString(req) || getBrowseCountry_getBrowseCountryFromCookie(req) || "";
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getCountry/index.js






var lc = function lc(str) {
  return str && str.toLowerCase();
};

var getIsCountryValidForDomain = function getIsCountryValidForDomain(country, defaultCountry, defaultCountries) {
  var validStoreCodes = defaultCountries.filter(function (country) {
    return country.url === defaultCountry.url;
  }).map(function (country) {
    return country.storeCode;
  });

  return validStoreCodes.includes(country.storeCode);
};

/*
 * @returns {Country} country
 */
function getCountry_getCountry(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, majorCountries, defaultCountries, defaultCountry, browseCountry, candidateCountry;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              majorCountries = _ref2.majorCountries;
              defaultCountries = _ref2.defaultCountries;
              defaultCountry = getDefaultCountry(request, defaultCountries);
              browseCountry = lc(getBrowseCountry_getBrowseCountry(request));

              if (browseCountry) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 11:
              candidateCountry = majorCountries.find(function (country) {
                return lc(country.countryCode) === browseCountry;
              });

              if (candidateCountry) {
                _context.next = 14;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 14:
              if (getIsCountryValidForDomain(candidateCountry, defaultCountry, defaultCountries)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", defaultCountry);

            case 16:
              return _context.abrupt("return", candidateCountry);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/shouldUseHttps/index.js





/*
 * @returns {boolean} shouldUseHttps
 */
function shouldUseHttps_shouldUseHttps(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, request, getVersionManifest, _ref2, features, httpsFlag;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              request = params.request, getVersionManifest = params.getVersionManifest;
              _context.next = 4;
              return getVersionManifest();

            case 4:
              _ref2 = _context.sent;
              features = _ref2.features;
              httpsFlag = features["gbl-should-use-https"];

              if (!httpsFlag) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", true);

            case 9:
              if (!request) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", server_getKeyStoreDataversion(request) === "f9hk2j3-10");

            case 11:
              return _context.abrupt("return", false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/validate.js


function validate(storeApiEndpoint, versionManifestEndpoint, warn) {
  if (typeof warn !== "function") {
    throw storeServiceError("Invalid argument: warn (must be a function)");
  }

  if (typeof storeApiEndpoint !== "string" || storeApiEndpoint.length === 0) {
    throw storeServiceError("Invalid argument: StoreAPI endpoint (argument name: storeApiEndpoint) must be a string");
  }

  if (typeof versionManifestEndpoint !== "string" || versionManifestEndpoint.length === 0) {
    throw storeServiceError("Invalid argument: StoreAPI endpoint (argument name: versionManifestEndpoint) must be a string");
  }

  return true;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getMajorCountries.js





/*
 * @returns {Country[]} majorCountries
 */
function getMajorCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, majorCountries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              majorCountries = _ref2.majorCountries;

              if (!majorCountries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", majorCountries);

            case 10:
              throw storeServiceError("Major countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// EXTERNAL MODULE: ../node_modules/querystring-es3/index.js
var querystring_es3 = __webpack_require__("../node_modules/querystring-es3/index.js");
var querystring_es3_default = /*#__PURE__*/__webpack_require__.n(querystring_es3);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("../node_modules/babel-runtime/helpers/defineProperty.js");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/enrichMinorCountries/index.js


function enrichMinorCountries(countries) {
  var countryMap = countries.reduce(function (memo, next) {
    return assign_default()(memo, defineProperty_default()({}, next.country, next));
  }, {});

  return countries.map(function (country) {
    if (country.majorCountry === null) {
      return country;
    }

    return looseAssign(countryMap[country.majorCountry], country);
  });
}

function looseAssign(_ref, minor) {
  var store = _ref.store,
      siteUrl = _ref.siteUrl,
      siteId = _ref.siteId,
      languages = _ref.languages,
      currencies = _ref.currencies,
      sizeSchemas = _ref.sizeSchemas;

  return assign_default()(minor, {
    store: store,
    siteUrl: siteUrl,
    siteId: siteId,
    languages: languages,
    currencies: currencies,
    sizeSchemas: sizeSchemas
  });
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getPrimaryAttribute/index.js


var getPrimaryAttribute_getPrimary = function getPrimary(_ref) {
  var list = _ref.list,
      errorMessage = _ref.errorMessage;

  var primaryItem = list.find(function (item) {
    return item.isPrimary;
  });
  if (primaryItem) {
    return primaryItem;
  }
  throw storeFormatError(errorMessage);
};

var getPrimaryLanguage = function getPrimaryLanguage(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.languages,
    errorMessage: "No primary language defined for " + store.country + " store"
  }).language;
};

var getPrimaryCurrency = function getPrimaryCurrency(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.currencies,
    errorMessage: "No primary currency defined for " + store.country + " store"
  }).currency;
};

var getPrimarySizeSchema = function getPrimarySizeSchema(store) {
  return getPrimaryAttribute_getPrimary({
    list: store.sizeSchemas,
    errorMessage: "No primary size defined for " + store.country + " store"
  }).sizeSchema;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/formatCountries/index.js


var formatCountries = function formatCountries(countries, keyStoreDataversion) {
  return countries.map(function (country) {
    return format(country, keyStoreDataversion);
  });
};

/*
 * @typedef {Object} Country
 * @property {string} siteId
 * @property {string} storeCode
 * @property {Object} defaultLanguage
 * @property {Object} defaultSizeSchema
 * @property {Object} defaultCurrency
 * @property {string} url
 * @property {string} countryCode
 * @property {string} imageUrl
 * @property {string} name
 * @property {string} majorCountry
 * @property {string} isDefaultCountry
 * @property {Object[]} currencies
 * @property {Object[]} languages
 * @property {Object[]} sizeSchemas
 * @property {string} keyStoreDataversion
 * @property {Object.<string, Country>} [keyStoreDataversionVariants]
 */

/*
 * @returns {Country} country
 */
function format(country, keyStoreDataversion) {
  return {
    siteId: country.siteId,
    storeCode: country.store,
    defaultLanguage: getPrimaryLanguage(country),
    defaultSizeSchema: getPrimarySizeSchema(country),
    defaultCurrency: getPrimaryCurrency(country),
    url: country.siteUrl,
    countryCode: country.country,
    imageUrl: country.imageUrl,
    name: country.name,
    majorCountry: country.majorCountry,
    isDefaultCountry: false,
    currencies: country.currencies,
    languages: country.languages,
    sizeSchemas: country.sizeSchemas,
    keyStoreDataversion: keyStoreDataversion
  };
}

/* harmony default export */ var utils_formatCountries = (formatCountries);
// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json
var storeToDefaultCountryMappings_storeToDefaultCountryMappings = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/storeToDefaultCountryMappings.json");
var storeToDefaultCountryMappings_default = /*#__PURE__*/__webpack_require__.n(storeToDefaultCountryMappings_storeToDefaultCountryMappings);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/storeToDefaultCountryMappings/index.js


function getStoreToDefaultCountryMappings() {
  storeToDefaultCountryMappings_default.a.forEach(function (storeToDefaultCountryMapping) {
    var defaultCountryCode = storeToDefaultCountryMapping.defaultCountryCode;

    var allMappingsWithThisDefaultCountryCode = storeToDefaultCountryMappings_default.a.filter(function (mapping) {
      return mapping.defaultCountryCode === defaultCountryCode;
    });

    var suchMappingsWithXSiteUrnFallback = allMappingsWithThisDefaultCountryCode.filter(function (mapping) {
      return mapping.isXSiteUrnFallback;
    });

    if (suchMappingsWithXSiteUrnFallback.length > 1) {
      throw "The defaultCountryCode '" + defaultCountryCode + "' has been assigned an 'isXSiteUrnFallback' of true more than once. Each defaultCountryCode can only have up to one xSiteUrnFallback.";
    }

    if (allMappingsWithThisDefaultCountryCode.length > 1 && suchMappingsWithXSiteUrnFallback.length === 0) {
      throw "The defaultCountryCode '" + defaultCountryCode + "' is mapped more than once, but none of these mappings has 'isXSiteUrnFallback' set as true. At least one of them must.";
    }
  });

  return storeToDefaultCountryMappings_default.a;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/getDefaultCountries/index.js



function getDefaultCountries(majorCountries) {
  var storeToDefaultCountryMappings = getStoreToDefaultCountryMappings();
  var stores = getUniqueStoresFromMajorCountries(majorCountries, storeToDefaultCountryMappings);

  var defaultCountries = stores.reduce(function (defaultCountries, store) {
    var storeToDefaultCountryMapping = storeToDefaultCountryMappings.find(function (mapping) {
      return mapping.storeCode === store.storeCode;
    });

    var majorCountry = majorCountries.find(function (country) {
      return country.countryCode === storeToDefaultCountryMapping.defaultCountryCode;
    });

    defaultCountries.push(assign_default()({}, majorCountry, { isDefaultCountry: true }, store, {
      isXSiteUrnFallback: storeToDefaultCountryMapping.isXSiteUrnFallback || false
    }));

    return defaultCountries;
  }, []);

  return defaultCountries;
}

var getUniqueStoresFromMajorCountries = function getUniqueStoresFromMajorCountries(majorCountries, storeToDefaultCountryMappings) {
  var mapped = storeToDefaultCountryMappings.map(function (_ref) {
    var storeCode = _ref.storeCode;

    var country = majorCountries.find(function (c) {
      return c.storeCode === storeCode;
    });

    if (!country) return null;

    return {
      storeCode: storeCode,
      storeId: country.siteId,
      url: country.url
    };
  });

  return mapped.filter(function (v) {
    return v;
  });
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/createCountryCollections/index.js


/*
 * @typedef {Object} CountryCollections
 * @property {Country[]} majorCountries
 * @property {Country[]} defaultCountries
 * @property {Country[]} countries
 */

/*
 * @retuns {CountryCollections} countryCollections
 */
function createCountryCollections(countries) {
  var isMajorCountry = function isMajorCountry(country) {
    return country.majorCountry === null;
  };
  var majorCountries = countries.filter(isMajorCountry);

  return {
    majorCountries: majorCountries,
    defaultCountries: getDefaultCountries(majorCountries),
    countries: countries
  };
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCountryCollections.js











function getCountryCollections_getCountryCollections(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, cache, endpoint, getKeyStoreDataversion, warn, request, response, lang, keyStoreDataversion, queryParams, parsedEndpoint, _response, json;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              cache = params.cache, endpoint = params.endpoint, getKeyStoreDataversion = params.getKeyStoreDataversion, warn = params.warn, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getKeyStoreDataversion({
                request: request,
                response: response
              });

            case 4:
              keyStoreDataversion = _context.sent;
              queryParams = { keyStoreDataversion: keyStoreDataversion };


              if (lang) {
                assign_default()(queryParams, { lang: lang });
              }

              parsedEndpoint = Object(url_url["resolve"])(endpoint, "?" + Object(querystring_es3["stringify"])(queryParams));

              if (!(cache.hasKey(parsedEndpoint) && !cache.hasExpired(parsedEndpoint))) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", cache.get(parsedEndpoint));

            case 10:
              _context.prev = 10;
              _context.next = 13;
              return utils_wrappedFetch(parsedEndpoint);

            case 13:
              _response = _context.sent;
              _context.next = 16;
              return _response.json();

            case 16:
              json = _context.sent;
              return _context.abrupt("return", cache.set(parsedEndpoint, createCountryCollections(utils_formatCountries(enrichMinorCountries(json), keyStoreDataversion))));

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](10);

              warn("Store presentation failed to fetch fresh stores", _context.t0);

              if (!cache.hasKey(parsedEndpoint)) {
                _context.next = 27;
                break;
              }

              warn("Store presentation forced to return stale stores cache", _context.t0);
              warn("Resetting the stale cache");
              return _context.abrupt("return", cache.set(parsedEndpoint, cache.get(parsedEndpoint)));

            case 27:
              throw storeServiceError("Could not obtain stores", _context.t0);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[10, 20]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCountries.js




/*
 * @returns {Country[]} countries
 */
function getCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, countries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              countries = _ref2.countries;

              if (!countries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", countries);

            case 10:
              throw storeServiceError("Countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getDefaultCountries.js




/*
 * @returns {Country[]} defaultCountries
 */
function getDefaultCountries_getDefaultCountries(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, getCountryCollections, request, response, lang, _ref2, defaultCountries;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, request = params.request, response = params.response, lang = params.lang;
              _context.next = 4;
              return getCountryCollections({
                request: request,
                response: response,
                lang: lang
              });

            case 4:
              _ref2 = _context.sent;
              defaultCountries = _ref2.defaultCountries;

              if (!defaultCountries) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", defaultCountries);

            case 10:
              throw storeServiceError("Default countries was not calculated correctly");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("../node_modules/babel-runtime/core-js/get-iterator.js");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/promise.js
var core_js_promise = __webpack_require__("../node_modules/babel-runtime/core-js/promise.js");
var promise_default = /*#__PURE__*/__webpack_require__.n(core_js_promise);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getMajorCountriesWithKSDVVariants.js








/*
 * @returns {Country[]} majorCountries
 */
function getMajorCountriesWithKSDVVariants(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _this = this;

      var params, getCountryCollections, getVersionManifest, getKeyStoreDataversion, request, response, lang, warn, _ref2, permittedKeyStoreDataversions, currentKSDV, countriesByKSDV, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, ksdv, majorCountriesWithKSDV;

      return regenerator_default.a.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              getCountryCollections = params.getCountryCollections, getVersionManifest = params.getVersionManifest, getKeyStoreDataversion = params.getKeyStoreDataversion, request = params.request, response = params.response, lang = params.lang, warn = params.warn;
              _context2.prev = 2;
              _context2.next = 5;
              return getVersionManifest();

            case 5:
              _ref2 = _context2.sent;
              permittedKeyStoreDataversions = _ref2.permittedKeyStoreDataversions;
              _context2.next = 9;
              return getKeyStoreDataversion({ request: request, response: response });

            case 9:
              currentKSDV = _context2.sent;
              countriesByKSDV = {};
              _loop = regenerator_default.a.mark(function _loop(ksdv) {
                var _ref3, majorCountries;

                return regenerator_default.a.wrap(function _loop$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return getCountryCollections({
                          request: request,
                          response: response,
                          lang: lang,
                          getKeyStoreDataversion: function getKeyStoreDataversion() {
                            return promise_default.a.resolve(ksdv);
                          }
                        });

                      case 3:
                        _ref3 = _context.sent;
                        majorCountries = _ref3.majorCountries;


                        if (majorCountries && majorCountries.length) {
                          countriesByKSDV[ksdv] = majorCountries.slice();
                        }
                        _context.next = 11;
                        break;

                      case 8:
                        _context.prev = 8;
                        _context.t0 = _context["catch"](0);

                        warn("Get country collection failed for KSDV: " + ksdv);

                      case 11:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _loop, _this, [[0, 8]]);
              });
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context2.prev = 15;
              _iterator = get_iterator_default()(permittedKeyStoreDataversions);

            case 17:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context2.next = 23;
                break;
              }

              ksdv = _step.value;
              return _context2.delegateYield(_loop(ksdv), "t0", 20);

            case 20:
              _iteratorNormalCompletion = true;
              _context2.next = 17;
              break;

            case 23:
              _context2.next = 29;
              break;

            case 25:
              _context2.prev = 25;
              _context2.t1 = _context2["catch"](15);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 29:
              _context2.prev = 29;
              _context2.prev = 30;

              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }

            case 32:
              _context2.prev = 32;

              if (!_didIteratorError) {
                _context2.next = 35;
                break;
              }

              throw _iteratorError;

            case 35:
              return _context2.finish(32);

            case 36:
              return _context2.finish(29);

            case 37:
              majorCountriesWithKSDV = countriesByKSDV[currentKSDV] || [];

              delete countriesByKSDV[currentKSDV];

              majorCountriesWithKSDV.forEach(function (country) {
                country.keyStoreDataversionVariants = keys_default()(countriesByKSDV).reduce(function (acc, ksdv) {
                  var foundIndex = void 0;
                  var foundCountry = countriesByKSDV[ksdv].find(function (el, index) {
                    if (el.countryCode === country.countryCode) {
                      foundIndex = index;
                      return true;
                    }
                    return false;
                  });

                  if (foundCountry) {
                    acc[ksdv] = foundCountry;
                    countriesByKSDV[ksdv].splice(foundIndex, 1);
                  }

                  return acc;
                }, {});
              });

              return _context2.abrupt("return", majorCountriesWithKSDV);

            case 43:
              _context2.prev = 43;
              _context2.t2 = _context2["catch"](2);
              throw storeServiceError("Failed to getMajorCountriesWithKSDVVariants", _context2.t2);

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee, this, [[2, 43], [15, 25, 29, 37], [30,, 32, 36]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getCurrency.js





/*
 * @param {Country} country
 *
 * @returns {Currency} currency
 */
var getDefaultCurrencyForCountry = function getDefaultCurrencyForCountry(country) {
  return country.currencies.find(function (currency) {
    return currency.isPrimary;
  });
};

/*
 * @param {string} browseCurrency
 * @param {Country} country
 *
 * @returns {Currency} currency
 */
var getCurrencyIfValid = function getCurrencyIfValid(browseCurrency, country) {
  return country.currencies.find(function (_ref) {
    var currency = _ref.currency;
    return browseCurrency === currency;
  });
};

/*
 * @typedef {Object} Currency
 * @property {string} currency
 * @property {string} symbol
 * @property {string} text
 * @property {boolean} isPrimary
 * @property {number} currencyId
 */

/*
 * @typedef {Object} GetCurrencyOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetCurrency
 * @param {GetCurrencyOptions} options
 */

/*
 * @param {GetCurrencyOptions} initialParams
 *
 * @returns {CurriedGetCurrency} curriedGetCurrency
 */
function getCurrency_getCurrency(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseCurrency, validCurrency;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseCurrency = server_getBrowseCurrency(request);
              validCurrency = getCurrencyIfValid(browseCurrency, country);
              return _context.abrupt("return", validCurrency || getDefaultCurrencyForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getLanguage.js





/*
 * @param {Country} country
 *
 * @returns {Language} language
 */
var getDefaultLanguageForCountry = function getDefaultLanguageForCountry(country) {
  return country.languages.find(function (language) {
    return language.isPrimary;
  });
};

/*
 * @param {string} browseLanguage
 * @param {Country} country
 *
 * @returns {Language} language
 */
var getLanguageIfValid = function getLanguageIfValid(browseLanguage, country) {
  return country.languages.find(function (_ref) {
    var language = _ref.language;
    return browseLanguage === language;
  });
};

/*
 * @typedef {Object} Language
 * @property {string} language
 * @property {string} name
 * @property {string} text
 * @property {string} languageShort
 * @property {boolean} isPrimary
 */

/*
 * @typedef {Object} GetLanguageOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetLanguage
 * @param {GetLanguageOptions} options
 */

/*
 * @param {GetLanguageOptions} initialParams
 *
 * @returns {CurriedGetLanguage} curriedGetLanguage
 */
function getLanguage(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseLanguage, validLanguage;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseLanguage = server_getBrowseLanguage(request);
              validLanguage = getLanguageIfValid(browseLanguage, country);
              return _context.abrupt("return", validLanguage || getDefaultLanguageForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getSizeSchema.js





/*
 * @param {Country} country
 *
 * @returns {SizeSchema} sizeSchema
 */
var getDefaultSizeSchemaForCountry = function getDefaultSizeSchemaForCountry(country) {
  return country.sizeSchemas.find(function (sizeSchema) {
    return sizeSchema.isPrimary;
  });
};

/*
 * @param {string} browseSizeSchema
 * @param {Country} country
 *
 * @returns {SizeSchema} sizeSchema
 */
var getSizeSchemaIfValid = function getSizeSchemaIfValid(browseSizeSchema, country) {
  return country.sizeSchemas.find(function (_ref) {
    var sizeSchema = _ref.sizeSchema;
    return browseSizeSchema === sizeSchema;
  });
};

/*
 * @typedef {Object} SizeSchema
 * @property {string} sizeSchema
 * @property {string} text
 * @property {boolean} isPrimary
 */

/*
 * @typedef {Object} GetSizeSchemaOptions
 * @property {Function} getCountry
 * @property {Object} request
 * @property {Object} response
 */

/*
 * @async
 * @callback CurriedGetSizeSchema
 * @param {GetSizeSchemaOptions} options
 */

/*
 * @param {GetSizeSchemaOptions} initialParams
 *
 * @returns {CurriedGetSizeSchema} curriedGetSizeSchema
 */
function getSizeSchema_getSizeSchema(initialParams) {
  return function () {
    var _ref2 = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var _Object$assign, request, response, getCountry, country, browseSizeSchema, validSizeSchema;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _Object$assign = assign_default()({}, initialParams, callParams), request = _Object$assign.request, response = _Object$assign.response, getCountry = _Object$assign.getCountry;
              _context.next = 3;
              return getCountry({ request: request, response: response });

            case 3:
              country = _context.sent;
              browseSizeSchema = server_getBrowseSizeSchema(request);
              validSizeSchema = getSizeSchemaIfValid(browseSizeSchema, country);
              return _context.abrupt("return", validSizeSchema || getDefaultSizeSchemaForCountry(country));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/setProtocol.js
function setProtocol(url) {
  var isHttps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var hasProtocol = url.indexOf("://") != -1;

  if (hasProtocol) {
    url = url.replace(/^https?:\/\//, "");
  }

  var updatedUrl = isHttps ? "https://" + url : url = "http://" + url;
  return updatedUrl;
}
// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/genderTranslationsByLang.json
var genderTranslationsByLang = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/genderTranslationsByLang.json");
var genderTranslationsByLang_default = /*#__PURE__*/__webpack_require__.n(genderTranslationsByLang);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/modifyUrlForGender.js

var modifyUrlForGender_defaultLanguage = "en";

function modifyUrlForGender(gender, lang, url) {
  if (!gender || !lang || !url) {
    return;
  }

  if (!genderTranslationsByLang_default.a[lang]) {
    lang = modifyUrlForGender_defaultLanguage;
  }

  var translationForGender = genderTranslationsByLang_default.a[lang][gender];
  var updatedUrl = url + "/" + translationForGender;

  return updatedUrl;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/generateSecureUrl.js
function generateSecureUrl(storeCode, isTestUrl, isComStoreURL) {
  var baseUrl = void 0;
  if (isTestUrl) {
    baseUrl = "https://secure.asosservices.com";
  } else {
    baseUrl = "https://secure.asos.com";
  }

  if (isComStoreURL) return baseUrl;

  var secureUrl = storeCode ? baseUrl + "/" + storeCode.toLowerCase() : baseUrl;

  return secureUrl;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/generateMobileUrl.js
function generateMobileUrl(storeCode, isTestUrl, isComStoreURL) {
  var baseUrl = void 0;
  if (isTestUrl) {
    baseUrl = "m.asosservices.com";
  } else {
    baseUrl = "m.asos.com";
  }

  if (isComStoreURL) return baseUrl;

  var mobileUrl = storeCode ? baseUrl + "/" + storeCode.toLowerCase() : baseUrl;

  return mobileUrl;
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/isTestUrl.js
function isTestUrl(url) {
  return !!url.match(/asosservices/gi);
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/isComStoreURL.js
function isComStoreURL(url) {
  return url === "www.asos.com" || url === "test.asosservices.com";
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/getStoreUrlByCountryCode.js
















function getStoreUrlByCountryCode(initialParams) {
  return function () {
    var _ref = asyncToGenerator_default()(regenerator_default.a.mark(function _callee(callParams) {
      var params, countryCode, keyStoreDataversion, _params$type, type, _params$shouldUseHttp, shouldUseHttps, _params$includeProtoc, includeProtocol, _params$isMobile, isMobile, cache, storeApiEndpoint, warn, queryParams, parsedEndpoint, response, json, _cache$get, majorCountries, country, url, urlIsTest, urlisComStoreURL, defaultLanguage, languageShort;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = assign_default()({}, initialParams, callParams);
              countryCode = params.countryCode, keyStoreDataversion = params.keyStoreDataversion, _params$type = params.type, type = _params$type === undefined ? "default" : _params$type, _params$shouldUseHttp = params.shouldUseHttps, shouldUseHttps = _params$shouldUseHttp === undefined ? false : _params$shouldUseHttp, _params$includeProtoc = params.includeProtocol, includeProtocol = _params$includeProtoc === undefined ? false : _params$includeProtoc, _params$isMobile = params.isMobile, isMobile = _params$isMobile === undefined ? false : _params$isMobile, cache = params.cache, storeApiEndpoint = params.storeApiEndpoint, warn = params.warn;

              if (!(!countryCode || !keyStoreDataversion)) {
                _context.next = 4;
                break;
              }

              throw storeServiceError("countryCode and keyStoreDataversion are required");

            case 4:
              queryParams = { keyStoreDataversion: keyStoreDataversion };
              parsedEndpoint = storeApiEndpoint + "?" + Object(querystring_es3["stringify"])(queryParams);

              if (!(!cache.hasKey(parsedEndpoint) || cache.hasExpired(parsedEndpoint))) {
                _context.next = 22;
                break;
              }

              _context.prev = 7;
              _context.next = 10;
              return utils_wrappedFetch(parsedEndpoint);

            case 10:
              response = _context.sent;
              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              cache.set(parsedEndpoint, createCountryCollections(utils_formatCountries(enrichMinorCountries(json), keyStoreDataversion)));
              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](7);

              warn("Store presentation failed to fetch fresh stores", _context.t0);

              /* Disabling this line, since it is tested but since it
              * throws istanbul doesn't detect it as tested */
              /* istanbul ignore next */

              if (cache.hasKey(parsedEndpoint)) {
                _context.next = 22;
                break;
              }

              throw storeServiceError("Could not obtain stores", _context.t0);

            case 22:
              _cache$get = cache.get(parsedEndpoint), majorCountries = _cache$get.majorCountries;
              country = majorCountries.find(function (c) {
                return c.countryCode === countryCode;
              });
              url = country.url;
              urlIsTest = isTestUrl(url);
              urlisComStoreURL = isComStoreURL(url);

              if (!(type === "secure")) {
                _context.next = 29;
                break;
              }

              return _context.abrupt("return", generateSecureUrl(country.storeCode, urlIsTest, urlisComStoreURL));

            case 29:

              if (isMobile) {
                url = generateMobileUrl(country.storeCode, urlIsTest, urlisComStoreURL);
              }

              if (includeProtocol) {
                url = setProtocol(url, shouldUseHttps);
              }

              if (type === "women" || type === "men") {
                defaultLanguage = country.languages.find(function (language) {
                  return language.isPrimary;
                });
                languageShort = defaultLanguage.languageShort;

                url = modifyUrlForGender(type, languageShort, url);
              }

              return _context.abrupt("return", url);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 17]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/factories/store/index.js


















var fiveMinutes = 1000 * 60 * 5;

var storeFactory = {
  create: function create() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        storeApiEndpoint = _ref.storeApiEndpoint,
        _ref$storeExpiryMs = _ref.storeExpiryMs,
        storeExpiryMs = _ref$storeExpiryMs === undefined ? fiveMinutes : _ref$storeExpiryMs,
        versionManifestEndpoint = _ref.versionManifestEndpoint,
        _ref$versionManifestE = _ref.versionManifestExpiryMs,
        versionManifestExpiryMs = _ref$versionManifestE === undefined ? fiveMinutes : _ref$versionManifestE,
        warn = _ref.warn;

    validate(storeApiEndpoint, versionManifestEndpoint, warn);

    var storeCache = factories_cache.create({ expiryMs: storeExpiryMs });
    var versionManifestCache = factories_cache.create({
      expiryMs: versionManifestExpiryMs
    });

    /*
     * Needs no parameters
     * @returns {VersionManifest}
     */
    var curriedGetVersionManifest = getVersionManifest_getVersionManifest({
      cache: versionManifestCache,
      versionManifestEndpoint: versionManifestEndpoint,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {string} keyStoreDataversion
     */
    var curriedGetKeyStoreDataversion = getKeyStoreDataversion_getKeyStoreDataversion({
      getVersionManifest: curriedGetVersionManifest
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @param {Object} cache,
     * @param {string} endpoint,
     * @param {Function} getKeyStoreDataversion
     * @returns {CountryCollections} countryCollections
     */
    var curriedGetCountryCollections = getCountryCollections_getCountryCollections({
      cache: storeCache,
      endpoint: storeApiEndpoint,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} countries
     */
    var curriedGetCountries = getCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} majorCountries
     */
    var curriedGetMajorCountries = getMajorCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} defaultCountries
     */
    var curriedGetDefaultCountries = getDefaultCountries_getDefaultCountries({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country} country
     */
    var curriedGetCountry = getCountry_getCountry({
      getCountryCollections: curriedGetCountryCollections
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @param {string} lang
     * @returns {Country[]} majorCountries
     */
    var curriedGetMajorCountriesWithKSDVVariants = getMajorCountriesWithKSDVVariants({
      getCountryCollections: curriedGetCountryCollections,
      getVersionManifest: curriedGetVersionManifest,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      warn: warn
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {string} siteChromeVersion
     */
    var curriedGetSiteChromeVersion = getSiteChromeVersion_getSiteChromeVersion({
      getCountry: curriedGetCountry,
      getVersionManifest: curriedGetVersionManifest
    });

    /*
     * @param {Object} request
     *        Express request
     * @param {Object} response
     *        Express response
     * @returns {boolean} useSiteChrome
     */
    var curriedGetUseSiteChrome = getUseSiteChrome({
      getSiteChromeVersion: curriedGetSiteChromeVersion
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetCurrency = getCurrency_getCurrency({
      getCountry: curriedGetCountry
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetLanguage = getLanguage({
      getCountry: curriedGetCountry
    });

    /*
     * @param {Object} options
     * @param {Object} options.request
     * @param {Object} options.response
     */
    var curriedGetSizeSchema = getSizeSchema_getSizeSchema({
      getCountry: curriedGetCountry
    });

    /*
     * @param {Function} options.request
     */
    var curriedShouldUseHttps = shouldUseHttps_shouldUseHttps({
      getVersionManifest: curriedGetVersionManifest
    });

    var curriedGetStoreUrlByCountryCode = getStoreUrlByCountryCode({
      cache: storeCache,
      storeApiEndpoint: storeApiEndpoint,
      warn: warn
    });

    return {
      getCountries: curriedGetCountries,
      getMajorCountries: curriedGetMajorCountries,
      getMajorCountriesWithKSDVVariants: curriedGetMajorCountriesWithKSDVVariants,
      getDefaultCountries: curriedGetDefaultCountries,
      getCountry: curriedGetCountry,
      getKeyStoreDataversion: curriedGetKeyStoreDataversion,
      getVersionManifest: curriedGetVersionManifest,
      getSiteChromeVersion: curriedGetSiteChromeVersion,
      getUseSiteChrome: curriedGetUseSiteChrome,
      getCurrency: curriedGetCurrency,
      getLanguage: curriedGetLanguage,
      getSizeSchema: curriedGetSizeSchema,
      shouldUseHttps: curriedShouldUseHttps,
      getStoreUrlByCountryCode: curriedGetStoreUrlByCountryCode
    };
  }
};

/* harmony default export */ var factories_store = (storeFactory);
// EXTERNAL MODULE: delegated ../node_modules/js-cookie/src/js.cookie.js from dll-reference vendor
var js_cookiefrom_dll_reference_vendor = __webpack_require__("../node_modules/js-cookie/src/js.cookie.js");
var js_cookiefrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(js_cookiefrom_dll_reference_vendor);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/client/cookieReadingAndWriting.js


var oneYearInDays = 365;

var client_cookieReadingAndWriting_getCookieValue = function getCookieValue(cookieName) {
  return js_cookiefrom_dll_reference_vendor_default.a.get(cookieName) || undefined;
};

var client_cookieReadingAndWriting_setCookieValue = function setCookieValue(cookieName, value) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : oneYearInDays;

  var options = { expires: expires };
  js_cookiefrom_dll_reference_vendor_default.a.set(cookieName, value, options);
};

var cookieReadingAndWriting_findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.includes(key + "=");
  })[0] : null;
};

var cookieReadingAndWriting_concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = cookieReadingAndWriting_findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var cookieReadingAndWriting_setKeyedCookieValue = function setKeyedCookieValue(cookieName, key, value) {
  var expires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : oneYearInDays;

  client_cookieReadingAndWriting_setCookieValue(cookieName, cookieReadingAndWriting_concatenateKeyValuePairs(client_cookieReadingAndWriting_getCookieValue(cookieName), key, value), expires);
};

var cookieReadingAndWriting_getKeyedCookieValue = function getKeyedCookieValue(cookieName, key) {
  var keyValuePair = cookieReadingAndWriting_findKeyValuePair(client_cookieReadingAndWriting_getCookieValue(cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/cookies/client/index.js








var client_BrowseCountryKey = cookiesMap.BrowseCountryKey,
    client_FloorCookieName = cookiesMap.FloorCookieName,
    client_AsosCookieName = cookiesMap.AsosCookieName,
    CurrencyCookieName = cookiesMap.CurrencyCookieName,
    CurrencyIdKey = cookiesMap.CurrencyIdKey,
    CurrencyLabelKey = cookiesMap.CurrencyLabelKey,
    client_SizeSchemaKey = cookiesMap.SizeSchemaKey,
    client_PreferredSiteKey = cookiesMap.PreferredSiteKey,
    client_TopCatIdKey = cookiesMap.TopCatIdKey,
    client_WelcomeMessage = cookiesMap.WelcomeMessage,
    client_BrowseCurrencyKey = cookiesMap.BrowseCurrencyKey,
    client_BrowseLanguageKey = cookiesMap.BrowseLanguageKey,
    client_BrowseSizeSchemaKey = cookiesMap.BrowseSizeSchemaKey,
    StoreCodeKey = cookiesMap.StoreCodeKey,
    client_TemplateVersionKey = cookiesMap.TemplateVersionKey,
    GeoCountryKey = cookiesMap.GeoCountryKey,
    client_KeyStoreDataversionKey = cookiesMap.KeyStoreDataversionKey,
    AffiliateCookieName = cookiesMap.AffiliateCookieName,
    AffiliateKey = cookiesMap.AffiliateKey,
    WelcomeMatWrong = cookiesMap.WelcomeMatWrong,
    WelcomeMatCorrect = cookiesMap.WelcomeMatCorrect;


var defaultCurrency = -1;

var thirtyDays = 30;
var inOneHour = 1 / 24;
var oneWeek = 7;
var oneYear = 365;

var client_getBrowseCountry = function getBrowseCountry() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseCountryKey);
};
var client_setBrowseCountry = function setBrowseCountry(country) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseCountryKey, country);
};

var client_getCurrency = function getCurrency() {
  var currencyId = cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, CurrencyIdKey);
  var currencyLabel = cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, CurrencyLabelKey);

  return {
    currencyId: parseInt(currencyId) || defaultCurrency,
    currencyLabel: currencyLabel
  };
};

var client_setCurrency = function setCurrency(_ref) {
  var currencyCode = _ref.currencyCode,
      currencyId = _ref.currencyId;

  if (!currencyId || isNaN(currencyId)) throw invalidArgumentError("Invalid argument: currencyId needs to be a number");

  if (!currencyCode) throw invalidArgumentError("Invalid argument: currencyCode cannot be empty");

  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, CurrencyIdKey, currencyId);
  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, CurrencyLabelKey, currencyCode);

  // legacy cookie
  client_cookieReadingAndWriting_setCookieValue(CurrencyCookieName, currencyId);
};

var client_getSizeSchema = function getSizeSchema() {
  return cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, client_SizeSchemaKey);
};

var client_setSizeSchema = function setSizeSchema(sizeSchema) {
  if (!sizeSchema) {
    throw invalidArgumentError("Invalid argument: sizeSchema cannot be empty");
  }
  cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, client_SizeSchemaKey, sizeSchema);
};

var client_getFloor = function getFloor() {
  return getGenderByFloorId(client_cookieReadingAndWriting_getCookieValue(client_FloorCookieName));
};

var client_setFloor = function setFloor(gender) {
  if (!gender) {
    throw invalidArgumentError("Invalid argument: gender cannot be empty");
  }
  var floorId = getFloorIdByGender(gender);
  if (floorId) {
    client_cookieReadingAndWriting_setCookieValue(client_FloorCookieName, floorId);
    cookieReadingAndWriting_setKeyedCookieValue(client_AsosCookieName, client_TopCatIdKey, floorId);
  }
};

var client_getPreferredSite = function getPreferredSite() {
  return cookieReadingAndWriting_getKeyedCookieValue(client_AsosCookieName, client_PreferredSiteKey);
};

var client_isFirstVisit = function isFirstVisit() {
  return !client_getBrowseCountry();
};

var client_clearCookies = function clearCookies() {
  client_cookieReadingAndWriting_setCookieValue(client_AsosCookieName, "");
  js_cookiefrom_dll_reference_vendor_default.a.remove(client_FloorCookieName);
  js_cookiefrom_dll_reference_vendor_default.a.remove(client_WelcomeMessage);
  js_cookiefrom_dll_reference_vendor_default.a.remove(AffiliateCookieName);
};

var client_getWelcomeMessage = function getWelcomeMessage() {
  return client_cookieReadingAndWriting_getCookieValue(client_WelcomeMessage);
};

var client_setWelcomeMessage = function setWelcomeMessage(messageSeen) {
  return client_cookieReadingAndWriting_setCookieValue(client_WelcomeMessage, messageSeen);
};

var client_getWelcomeMatClosedForWrongCountry = function getWelcomeMatClosedForWrongCountry() {
  return client_cookieReadingAndWriting_getCookieValue(WelcomeMatWrong);
};

var client_setWelcomeMatClosedForWrongCountry = function setWelcomeMatClosedForWrongCountry(value) {
  return client_cookieReadingAndWriting_setCookieValue(WelcomeMatWrong, value, oneWeek);
};

var client_getWelcomeMatClosedForCorrectCountry = function getWelcomeMatClosedForCorrectCountry() {
  return client_cookieReadingAndWriting_getCookieValue(WelcomeMatCorrect);
};

var client_setWelcomeMatClosedForCorrectCountry = function setWelcomeMatClosedForCorrectCountry(value) {
  return client_cookieReadingAndWriting_setCookieValue(WelcomeMatCorrect, value, oneYear);
};

var client_setBrowseCurrency = function setBrowseCurrency(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseCurrencyKey, val);
};
var client_setBrowseLanguage = function setBrowseLanguage(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseLanguageKey, val);
};
var client_setBrowseSizeSchema = function setBrowseSizeSchema(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_BrowseSizeSchemaKey, val);
};
var client_setStoreCode = function setStoreCode(val) {
  return client_cookieReadingAndWriting_setCookieValue(StoreCodeKey, val);
};
var client_setTemplateVersion = function setTemplateVersion(storeCode, val) {
  return cookieReadingAndWriting_setKeyedCookieValue(client_TemplateVersionKey, storeCode, val, inOneHour);
};

var client_setTemplateVersions = function setTemplateVersions(templateVersions) {
  var keyValuePairs = keys_default()(templateVersions).sort().map(function (storeCode) {
    return storeCode + "=" + templateVersions[storeCode];
  }).join("&");

  client_cookieReadingAndWriting_setCookieValue(client_TemplateVersionKey, keyValuePairs, inOneHour);
};

var client_setKeyStoreDataversion = function setKeyStoreDataversion(val) {
  return client_cookieReadingAndWriting_setCookieValue(client_KeyStoreDataversionKey, val, inOneHour);
};

var client_getBrowseCurrency = function getBrowseCurrency() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseCurrencyKey);
};
var client_getBrowseLanguage = function getBrowseLanguage() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseLanguageKey);
};
var client_getBrowseSizeSchema = function getBrowseSizeSchema() {
  return client_cookieReadingAndWriting_getCookieValue(client_BrowseSizeSchemaKey);
};
var client_getStoreCode = function getStoreCode() {
  return client_cookieReadingAndWriting_getCookieValue(StoreCodeKey);
};
var client_getTemplateVersion = function getTemplateVersion(storeCode) {
  return cookieReadingAndWriting_getKeyedCookieValue(client_TemplateVersionKey, storeCode);
};
var client_getKeyStoreDataversion = function getKeyStoreDataversion() {
  return client_cookieReadingAndWriting_getCookieValue(client_KeyStoreDataversionKey);
};

var client_getGeoCountry = function getGeoCountry() {
  return client_cookieReadingAndWriting_getCookieValue(GeoCountryKey);
};

var client_setAffiliateId = function setAffiliateId(val) {
  return cookieReadingAndWriting_setKeyedCookieValue(AffiliateCookieName, AffiliateKey, val, thirtyDays);
};
var client_getAffiliateId = function getAffiliateId() {
  return cookieReadingAndWriting_getKeyedCookieValue(AffiliateCookieName, AffiliateKey);
};

var client_initAsosCookie = function initAsosCookie() {
  if (!client_cookieReadingAndWriting_getCookieValue(client_AsosCookieName) && client_cookieReadingAndWriting_getCookieValue(client_AsosCookieName) !== "") {
    client_cookieReadingAndWriting_setCookieValue(client_AsosCookieName, "");
  }
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/desktopToMobile.js
var desktopUrls = new RegExp(/https?:\/\/((www|us|test|ustest)\.)?asos(services)?\.(com|de|fr)(\/(es|it|au|ru|nl|se))?\//i);

var desktopToMobile = function desktopToMobile(link, storeUrl) {
  if (link && storeUrl) {
    link = link.replace(desktopUrls, storeUrl);
  }
  return link;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/urls/setHttpUrlsToHttps.js
var setHttpUrlsToHttps = function setHttpUrlsToHttps(url) {
  var httpUrlRegexPattern = /^http:\/\//i;

  var formattedUrl = url.match(httpUrlRegexPattern) ? url.replace(httpUrlRegexPattern, "https://") : url;

  return formattedUrl;
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/dataPlatform/index.js
var MOBILE = "mobile";
var TABLET = "tablet";
var DESKTOP = "desktop";

var dataPlatform_isMobile = function isMobile(req) {
  return req.get("IsMobile") === "true";
};
var isTablet = function isTablet(req) {
  return req.get("IsTablet") === "true";
};
var isStopMobileSet = function isStopMobileSet(req) {
  return req.query.stop_mobi === "yes";
};
var getPlatform = function getPlatform(req) {
  switch (true) {
    case isTablet(req):
      return TABLET;
    case dataPlatform_isMobile(req):
      return MOBILE;
    default:
      return DESKTOP;
  }
};
// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json
var store_stores = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores.json");
var stores_default = /*#__PURE__*/__webpack_require__.n(store_stores);

// EXTERNAL MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json
var stores_prod = __webpack_require__("../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/stores-prod.json");
var stores_prod_default = /*#__PURE__*/__webpack_require__.n(stores_prod);

// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/utils/store/index.js





var store_normalise = function normalise(_ref) {
  var storeCode = _ref.storeCode,
      _ref$gender = _ref.gender,
      gender = _ref$gender === undefined ? "default" : _ref$gender,
      isMobile = _ref.isMobile,
      environmentMode = _ref.environmentMode;
  return {
    storeCode: storeCode.toLowerCase(),
    platform: isMobile ? MOBILE : DESKTOP,
    gender: ["women", "men", "default", "secure"].includes(gender) ? gender : "default",
    storeUrls: environmentMode === "prod" ? stores_prod_default.a : stores_default.a
  };
};

var store_getStoreUrlByStoreCode = function getStoreUrlByStoreCode(options) {
  var _normalise = store_normalise(options),
      storeCode = _normalise.storeCode,
      platform = _normalise.platform,
      gender = _normalise.gender,
      storeUrls = _normalise.storeUrls;

  if (!storeUrls.hasOwnProperty(storeCode)) {
    throw storeServiceError("Invalid storeCode " + storeCode);
  }
  return storeUrls[storeCode][platform][gender];
};
// CONCATENATED MODULE: ../node_modules/asos-site-chrome-store-presentation/lib/module/index.js










var module_storePresentation = function storePresentation() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      storeApiEndpoint = _ref.storeApiEndpoint,
      storeExpiryMs = _ref.storeExpiryMs,
      versionManifestEndpoint = _ref.versionManifestEndpoint,
      versionManifestExpiryMs = _ref.versionManifestExpiryMs,
      warn = _ref.warn;

  return {
    store: factories_store.create({
      storeApiEndpoint: storeApiEndpoint,
      storeExpiryMs: storeExpiryMs,
      versionManifestEndpoint: versionManifestEndpoint,
      versionManifestExpiryMs: versionManifestExpiryMs,
      warn: warn
    })
  };
};
// EXTERNAL MODULE: delegated ../node_modules/prop-types/index.js from dll-reference vendor
var prop_typesfrom_dll_reference_vendor = __webpack_require__("../node_modules/prop-types/index.js");
var prop_typesfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(prop_typesfrom_dll_reference_vendor);

// EXTERNAL MODULE: ./template/clientConfig.js
var clientConfig = __webpack_require__("./template/clientConfig.js");

// CONCATENATED MODULE: ./template/state/modules/layout/helpers/bounceeffect.js


var BounceEffect = !clientConfig["a" /* default */].isServer() ? __webpack_require__("../node_modules/inobounce/inobounce.js") : { enable: function enable() {}, disable: function disable() {} };
// CONCATENATED MODULE: ./template/state/modules/layout/constants.js
var UPDATE_VIEWPORT_CATEGORY = "update-viewport-category";
var SMALL_VIEWPORT = "small-viewport";
var MEDIUM_VIEWPORT = "medium-viewport";
var LARGE_VIEWPORT = "large-viewport";
var CLOSE_SIDE_PANEL = "CLOSE_SIDE_PANEL";
var OPEN_SIDE_PANEL = "OPEN_SIDE_PANEL";
var SET_GENDER = "SET_GENDER";
var MALE = "men";
var FEMALE = "women";
var DEFAULT = "default";
var SECURE = "secure";
var OPEN_COOKIE_MESSAGE = "OPEN_COOKIE_MESSAGE";
var CLOSE_COOKIE_MESSAGE = "CLOSE_COOKIE_MESSAGE";
// CONCATENATED MODULE: ./template/state/modules/layout/actions.js


var actions_updateViewportCategory = function updateViewportCategory(viewportCategory) {
  return {
    type: UPDATE_VIEWPORT_CATEGORY,
    payload: {
      viewportCategory: viewportCategory
    }
  };
};

var actions_setGender = function setGender(gender) {
  return {
    type: SET_GENDER,
    payload: gender
  };
};

var actions_openSidePanel = function openSidePanel() {
  return {
    type: OPEN_SIDE_PANEL
  };
};

var actions_closeSidePanel = function closeSidePanel() {
  return {
    type: CLOSE_SIDE_PANEL
  };
};

var actions_closeCookieMessage = function closeCookieMessage() {
  return {
    type: CLOSE_COOKIE_MESSAGE
  };
};

var actions_openCookieMessage = function openCookieMessage() {
  return {
    type: OPEN_COOKIE_MESSAGE
  };
};
// EXTERNAL MODULE: ../node_modules/reselect/lib/index.js
var lib = __webpack_require__("../node_modules/reselect/lib/index.js");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./template/state/modules/layout/selectors.js



var getLayout = function getLayout(state) {
  return state.layout;
};

var getViewport = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.viewportCategory;
});

var selectors_isSidePanelOpen = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.isSidePanelOpen;
});

var hasGender = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.gender === FEMALE || layout.gender === MALE;
});

var selectors_isFemale = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.gender === FEMALE;
});

var selectors_isMale = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.gender === MALE;
});

var getCurrentGender = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.gender;
});

var isCookieMessageOpen = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.isCookieMessageOpen;
});

var selectors_getPlatform = Object(lib["createSelector"])(getLayout, function (layout) {
  return layout.platform;
});
// CONCATENATED MODULE: ./template/state/modules/layout/index.js











var genderPropType = prop_typesfrom_dll_reference_vendor_default.a.oneOf([MALE, FEMALE, DEFAULT]);
var viewportPropType = prop_typesfrom_dll_reference_vendor_default.a.oneOf([SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT]);

var layout_initialState = {
  viewportCategory: SMALL_VIEWPORT,
  isSidePanelOpen: false,
  isCookieMessageOpen: false,
  gender: DEFAULT,
  platform: "desktop"
};

var needsBounceEffect = function needsBounceEffect() {
  var testDiv = document.createElement("div");
  document.documentElement.appendChild(testDiv);
  testDiv.style.WebkitOverflowScrolling = "touch";
  var scrollSupport = "getComputedStyle" in window && window.getComputedStyle(testDiv)["-webkit-overflow-scrolling"] === "touch";
  document.documentElement.removeChild(testDiv);
  return scrollSupport;
};

BounceEffect.disable();

var layout_validateViewport = function validateViewport(state, viewportCategory) {
  return [SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT].indexOf(viewportCategory) !== -1 ? viewportCategory : state.viewportCategory;
};

/* harmony default export */ var modules_layout = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : layout_initialState;
  var action = arguments[1];

  switch (action.type) {
    case UPDATE_VIEWPORT_CATEGORY:
      return extends_default()({}, state, {
        viewportCategory: layout_validateViewport(state, action.payload.viewportCategory)
      });
    case SET_GENDER:
      return extends_default()({}, state, {
        gender: action.payload
      });
    case OPEN_SIDE_PANEL:
      document.body.classList.add("chrome-hide-overflow");
      if (needsBounceEffect()) {
        BounceEffect.enable();
      }
      return extends_default()({}, state, {
        isSidePanelOpen: true
      });
    case CLOSE_SIDE_PANEL:
      document.body.classList.remove("chrome-hide-overflow");
      BounceEffect.disable();
      return extends_default()({}, state, {
        isSidePanelOpen: false
      });

    case OPEN_COOKIE_MESSAGE:
      return extends_default()({}, state, {
        isCookieMessageOpen: true
      });
    case CLOSE_COOKIE_MESSAGE:
      return extends_default()({}, state, {
        isCookieMessageOpen: false
      });
  }

  return state;
});
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("../node_modules/babel-runtime/helpers/objectWithoutProperties.js");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// CONCATENATED MODULE: ./template/state/modules/regionalStore/constants.js
var SET_KEY_STORE_DATA_VERSION = "SET_KEY_STORE_DATA_VERSION";
var SET_BROWSE_CURRENCY = "SET_BROWSE_CURRENCY";
var KSDV_PROPS_OVERWRITE = ["storeCode", "siteId", "currencies", "sizeSchemas", "defaultLanguage", "defaultSizeSchema", "defaultCurrency", "storeUrls"];
var SEARCH_PATH = "search/";
// CONCATENATED MODULE: ./template/state/modules/regionalStore/actions.js


var actions_setKeyStoreDataversion = function setKeyStoreDataversion(keyStoreDataversion) {
  return {
    type: SET_KEY_STORE_DATA_VERSION,
    payload: keyStoreDataversion
  };
};

var actions_setBrowseCurrency = function setBrowseCurrency(currency) {
  return {
    type: SET_BROWSE_CURRENCY,
    payload: currency
  };
};
// CONCATENATED MODULE: ./client/context/checkForMismatch.js
var checkForMismatch_shouldRedirect = function shouldRedirect(_ref) {
  var inRollback = _ref.inRollback,
      cookieValue = _ref.cookieValue,
      manifestValue = _ref.manifestValue;

  if (!manifestValue) {
    return false;
  }
  return inRollback && cookieValue !== manifestValue;
};

/* Note that we only set the cookie when not in rollback if the cookie doesn't exist.
This is so that we don't force the user on to a new experience during the same session. */
var shouldSetCookie = function shouldSetCookie(_ref2) {
  var inRollback = _ref2.inRollback,
      cookieValue = _ref2.cookieValue;
  return inRollback || !cookieValue;
};

function checkForMismatch(versionData, setCookie) {
  if (shouldSetCookie(versionData)) {
    setCookie();
  }

  return checkForMismatch_shouldRedirect(versionData);
}
// CONCATENATED MODULE: ./client/context/getters.js
function getters(values) {
  return {
    /**
     * User selected (country dropdown) or system selected Country code
     * @returns {string} ßISO 3166-1 alpha-2 code
     */
    getBrowseCountry: function getBrowseCountry() {
      return values.browseCountry;
    },

    /**
     * The currency the customer is using for their purchase
     * @returns {string} - ISO 4217 code
     */
    getBrowseCurrency: function getBrowseCurrency() {
      return values.browseCurrency;
    },

    /**
     * Language tag representing the language of the site the customer is currently viewing.
     * @returns {string} - RFC 5646 Language tag
     */
    getBrowseLanguage: function getBrowseLanguage() {
      return values.browseLanguage;
    },

    /**
     * The asos size schema identifier representing the sizing scheme the customer is currently shopping using.
     * @returns {string} - Size Schema name
     */
    getBrowseSizeSchema: function getBrowseSizeSchema() {
      return values.browseSizeSchema;
    },

    /**
     * Asos store identifier representing store associated with a country
     * @returns {string} store identifier
     */
    getStoreId: function getStoreId() {
      return values.storeId;
    },

    /**
     *  System default Country code for a specific site
     * @returns {string} - ISO 3166-1 alpha-2 code
     */
    getDefaultCountry: function getDefaultCountry() {
      return values.defaultCountry;
    },

    /**
     * Returns flag indicating whether response is using store V1 (store mode) or Store V2 (Country mode)
     * @returns {boolean}
     */
    getEnableStoreBasedOperation: function getEnableStoreBasedOperation() {
      return values.enableStoreBasedOperation;
    },

    /**
     * The version of Store API data that should be used by all the dependent services & APIs
     * @returns {number}
     */
    getKeyStoreDataversion: function getKeyStoreDataversion() {
      return values.keyStoreDataversion;
    },
    /**
     * The version of the current template
     * @returns {number}
     */
    getTemplateVersion: function getTemplateVersion() {
      return values.templateVersion;
    },

    /**
     * The current geo country from the akamai cookie
     * @returns {string}
     */
    getGeoCountry: function getGeoCountry() {
      return values.geoCountry;
    },

    /**
     * Returns affiliateId from cookies
     * @return {string}
     */
    getAffiliateId: function getAffiliateId() {
      return values.affiliateId;
    },

    /**
     * @type {webContext}
     * @property {string} affiliateId - Asos affiliate identifier
     * @property {string} storeId - Asos Store Id
     * @property {string} browseCountry - ISO code for chosen country
     * @property {string} defaultCountry - ISO code for template country
     * @property {string} geoCountry - ISO code for Geo Country
     * @property {string} browseCurrency - Users currency
     * @property {string} browseLanguage - users language
     * @property {string} browseSizeSchema - users size schema
     * @property {string} enableStoreBasedOperation - store or country mode
     * @property {number} keyStoreDataversion - version of Store API data
     * @property {number} templateVersion - version of Store API data
     */

    /**
     * Convenience collection of each individual properties
     * @returns {webContext}
     */
    getWebContext: function getWebContext() {
      return values;
    }
  };
}
// CONCATENATED MODULE: ./client/context/getAllVersions.js






var getAllVersions_getAllKeyStoreDataversions = function getAllKeyStoreDataversions(state, manifest) {
  return {
    inRollback: !manifest.useCurrentKeyStoreDataversion,
    templateValue: selectors_getKeyStoreDataversion(state),
    cookieValue: client_getKeyStoreDataversion(),
    manifestValue: manifest.useCurrentKeyStoreDataversion ? manifest.keyStoreDataversion.current : manifest.keyStoreDataversion.previous
  };
};

var getAllVersions_getAllSiteChromeVersions = function getAllSiteChromeVersions(state, manifest) {
  var storeCode = selectors_getStoreCode(state).toLowerCase();
  var liveObject = manifest.siteChromeVersion[storeCode];

  return {
    templateValue: state.version,
    cookieValue: client_getTemplateVersion(storeCode),
    inRollback: !liveObject.useCurrent,
    manifestValue: liveObject.useCurrent ? liveObject.current : liveObject.previous
  };
};

var getAllVersions_getSiteChromeVersionMappingsFromCookie = function getSiteChromeVersionMappingsFromCookie(manifest) {
  return keys_default()(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var templateVersion = client_getTemplateVersion(storeCode);

    if (templateVersion) {
      mappings[storeCode] = templateVersion;
    }

    return mappings;
  }, {});
};

var getAllVersions_getStoreCodeToSiteChromeVersionMappings = function getStoreCodeToSiteChromeVersionMappings(manifest) {
  var mappingsFromManifestNotInRollback = keys_default()(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var mapping = manifest.siteChromeVersion[storeCode];

    if (mapping.useCurrent) {
      mappings[storeCode] = mapping.current;
    }

    return mappings;
  }, {});

  var mappingsFromCookie = getAllVersions_getSiteChromeVersionMappingsFromCookie(manifest);

  var mappingsFromManifestInRollback = keys_default()(manifest.siteChromeVersion).reduce(function (mappings, storeCode) {
    var mapping = manifest.siteChromeVersion[storeCode];

    if (!mapping.useCurrent) {
      mappings[storeCode] = mapping.previous;
    }

    return mappings;
  }, {});

  return assign_default()(mappingsFromManifestNotInRollback, mappingsFromCookie, mappingsFromManifestInRollback);
};
// EXTERNAL MODULE: ./template/constants.js
var constants = __webpack_require__("./template/constants.js");

// CONCATENATED MODULE: ./helpers/currency.js


var currency_getCurrency = function getCurrency(currencyId, currencyCode, currencies) {
  var currency = void 0;
  if (currencyId) {
    currency = findCurrencyById(currencyId, currencies);
  } else if (currencyCode) {
    currency = findCurrencyByCode(currencyCode, currencies);
  } else {
    currency = findCurrencyByCode(client_getBrowseCurrency(), currencies);
  }

  if (currency) {
    return currency;
  }

  return currency_getPrimaryCurrency(currencies);
};

function findCurrencyById(id, currencies) {
  return currencies.find(function (_ref) {
    var currencyId = _ref.currencyId;
    return currencyId === id;
  });
}

function findCurrencyByCode(currencyCode, currencies) {
  var code = currencyCode && currencyCode.toLowerCase();
  return currencies.find(function (_ref2) {
    var currency = _ref2.currency;
    return currency.toLowerCase() === code;
  });
}

function currency_getPrimaryCurrency(currencies) {
  return currencies.find(function (_ref3) {
    var isPrimary = _ref3.isPrimary;
    return isPrimary;
  });
}
// CONCATENATED MODULE: ./client/context/cookies.js


var cookies_oneYearInDays = 365;

var cookies_getCookieValue = function getCookieValue(cookieName) {
  return js_cookiefrom_dll_reference_vendor_default.a.get(cookieName) || undefined;
};

var cookies_setCookieValue = function setCookieValue(cookieName, value) {
  var expires = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : cookies_oneYearInDays;

  var options = { expires: expires };
  js_cookiefrom_dll_reference_vendor_default.a.set(cookieName, value, options);
};

var cookies_removeCookie = function removeCookie(name, domain) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "/";

  js_cookiefrom_dll_reference_vendor_default.a.remove(name, {
    domain: domain,
    path: path
  });
};

var cookies_findKeyValuePair = function findKeyValuePair(values, key) {
  return values ? values.split("&").filter(function (keyValue) {
    return keyValue.indexOf(key + "=") !== -1;
  })[0] : null;
};

var cookies_concatenateKeyValuePairs = function concatenateKeyValuePairs(cookieValue, newKey, newValue) {
  if (cookieValue) {
    var keyValueInCookie = cookies_findKeyValuePair(cookieValue, newKey);
    if (keyValueInCookie) {
      return cookieValue.replace(keyValueInCookie, newKey + "=" + newValue);
    } else {
      return cookieValue + "&" + newKey + "=" + newValue;
    }
  }
  return newKey + "=" + newValue;
};

var cookies_setKeyedCookieValue = function setKeyedCookieValue(cookieName, key, value) {
  var expires = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : cookies_oneYearInDays;

  cookies_setCookieValue(cookieName, cookies_concatenateKeyValuePairs(cookies_getCookieValue(cookieName), key, value), expires);
};

var cookies_getKeyedCookieValue = function getKeyedCookieValue(cookieName, key) {
  var keyValuePair = cookies_findKeyValuePair(cookies_getCookieValue(cookieName), key);
  return keyValuePair ? keyValuePair.split("=")[1] : null;
};
// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("../node_modules/babel-runtime/core-js/object/values.js");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: delegated ../node_modules/redux/es/index.js from dll-reference vendor
var redux_esfrom_dll_reference_vendor = __webpack_require__("../node_modules/redux/es/index.js");

// CONCATENATED MODULE: ./helpers/url.js
function getParamValue(urlParam) {
  var params = window.location.search.substring(1).split("&");
  var browseUrl = params.find(function (p) {
    return p.toLowerCase().startsWith(urlParam.toLowerCase() + "=");
  }) || "";

  return browseUrl.split("=")[1];
}

function getCurrentUrl() {
  var _window$location = window.location,
      host = _window$location.host,
      pathname = _window$location.pathname;

  return host + pathname;
}

function isProtocolHttps(url) {
  var delimiter = "://";
  return url.split(delimiter)[0] === "https";
}

function removeURLParameter(url, parameter) {
  var urlParts = url.split("?");
  if (urlParts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = urlParts[1].split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    return urlParts[0] + (parts.length ? "?" + parts.join("&") : "");
  } else {
    return url;
  }
}

var stripSubdomain = function stripSubdomain(hostname) {
  return hostname.split(".").slice(1).join(".");
};
// CONCATENATED MODULE: ./client/redirectToPreferredSite/index.js





var withoutProtocol = function withoutProtocol(url) {
  return url.replace(/^https?:\/\//, "");
};

var withoutTrailingSlash = function withoutTrailingSlash(str) {
  return str.replace(/\/$/, "");
};

var normaliseUrl = Object(redux_esfrom_dll_reference_vendor["compose"])(withoutProtocol, withoutTrailingSlash);

var normaliseCountryCode = function normaliseCountryCode(str) {
  return str.toLowerCase();
};

/* harmony default export */ var redirectToPreferredSite = (function (manifest, state, keyStoreDataversion) {
  var preferredSiteRedirects = manifest.preferredSiteRedirects;

  if (!preferredSiteRedirects) {
    return false;
  }

  var enabled = preferredSiteRedirects.enabled,
      keyStoreDataversionVariants = preferredSiteRedirects.keyStoreDataversionVariants;

  if (!enabled || !keyStoreDataversionVariants) {
    return false;
  }

  var redirectsForKeyStoreDataversion = keyStoreDataversionVariants[keyStoreDataversion];

  if (!redirectsForKeyStoreDataversion) {
    return false;
  }

  var qsBrowseCountry = getParamValue("browseCountry");

  if (qsBrowseCountry) {
    return false;
  }

  var browseCountry = normaliseCountryCode(client_getBrowseCountry() || "");
  if (!browseCountry) {
    return false;
  }

  var match = redirectsForKeyStoreDataversion.find(function (_ref) {
    var countryCodes = _ref.countryCodes;
    return countryCodes.map(normaliseCountryCode).indexOf(browseCountry) !== -1;
  });

  if (!match) {
    return false;
  }

  var storeUrls = state.regionalStore.storeUrls;

  var floorUrls = values_default()(storeUrls).map(normaliseUrl);
  var _window$location = window.location,
      hostname = _window$location.hostname,
      pathname = _window$location.pathname;

  var currentUrl = normaliseUrl("" + hostname + pathname);
  var isFloorUrl = floorUrls.find(function (url) {
    return url === currentUrl;
  });

  if (!isFloorUrl) {
    return false;
  }

  var platform = state.layout.platform;
  var mobileUrl = match.mobileUrl,
      desktopUrl = match.desktopUrl;


  var redirectUrl = platform === "mobile" ? mobileUrl : desktopUrl;

  if (currentUrl.indexOf(normaliseUrl(redirectUrl)) !== -1) {
    return false;
  }

  window.location.replace("//" + redirectUrl);

  return true;
});
// CONCATENATED MODULE: ./client/context/templateMatchesCountry.js



function templateMatchesCountry(contextObject) {
  if (getParamValue("browseCountry")) {
    return true;
  }

  if (templateMatchesCountry_userHasAPreferredCountry()) {
    return true;
  }

  if (!client_getGeoCountry()) {
    return true;
  }

  if (!contextObject || !contextObject.browseCountry) {
    return true;
  }

  if (templateMatchesCountry_templateMatchesGeolocation(contextObject.browseCountry)) {
    return true;
  }

  return false;
}

var templateMatchesCountry_userHasAPreferredCountry = function userHasAPreferredCountry() {
  return client_getBrowseCountry();
};
var templateMatchesCountry_templateMatchesGeolocation = function templateMatchesGeolocation(templateCountry) {
  return client_getGeoCountry() === templateCountry;
};
// CONCATENATED MODULE: ./helpers/manifest.js


var getPreferredSiteRedirects = function getPreferredSiteRedirects(manifest) {
  var keyStoreDataversion = manifest.keyStoreDataversion,
      preferredSiteRedirects = manifest.preferredSiteRedirects;

  var currentVersion = keyStoreDataversion.current;

  return preferredSiteRedirects.keyStoreDataversionVariants[currentVersion];
};

var getNonComCountryCodes = function getNonComCountryCodes(manifest) {
  return getPreferredSiteRedirects(manifest).map(function (item) {
    return item.countryCodes;
  }).reduce(function (a, v) {
    return a.concat(v);
  }, []);
};

var mapsToTheComStore = function mapsToTheComStore(geoCountry, manifest) {
  return !(getNonComCountryCodes(manifest).indexOf(geoCountry.toLowerCase()) !== -1);
};

var manifest_getCurrentStore = function getCurrentStore(manifest) {
  var url = getCurrentUrl();

  return getPreferredSiteRedirects(manifest).find(function (store) {
    return url.startsWith(store.desktopUrl) || url.startsWith(store.mobileUrl);
  });
};
// CONCATENATED MODULE: ./client/context/geoCountryMapsToCurrentStore.js


function geoCountryMapsToCurrentStore(geoCountry, manifest) {
  var store = manifest_getCurrentStore(manifest);

  if (!store) {
    // current store is COM
    return mapsToTheComStore(geoCountry, manifest);
  }

  return store.countryCodes.indexOf(geoCountry.toLowerCase()) !== -1;
}
// CONCATENATED MODULE: ./client/context/index.js
















var context_findAffiliateId = function findAffiliateId() {
  var affiliateId = getParamValue("affid") || getParamValue("xaffid");
  var affiliateIdFromCookie = client_getAffiliateId();
  if (affiliateId && affiliateId !== affiliateIdFromCookie) {
    client_setAffiliateId(affiliateId);
    return affiliateId;
  }
  return affiliateIdFromCookie;
};

var context_getBrowseCurrency = function getBrowseCurrency(currencies) {
  var _getCurrency = currency_getCurrency(parseInt(getParamValue("currencyId")), getParamValue("browseCurrency"), currencies),
      currency = _getCurrency.currency,
      currencyId = _getCurrency.currencyId;

  return {
    browseCurrency: currency,
    browseCurrencyId: currencyId
  };
};

var context_getSharedBaseContext = function getSharedBaseContext(_ref) {
  var currencies = _ref.currencies,
      defaultLanguage = _ref.defaultLanguage,
      defaultSizeSchema = _ref.defaultSizeSchema,
      storeCode = _ref.storeCode;
  return extends_default()({}, context_getBrowseCurrency(currencies), {
    browseLanguage: defaultLanguage,
    browseSizeSchema: defaultSizeSchema,
    storeId: storeCode
  });
};

var context_getBase = function getBase(_ref2) {
  var browseCountry = _ref2.browseCountry,
      regionalStoreVariant = _ref2.regionalStoreVariant,
      regionalStoreFromState = objectWithoutProperties_default()(_ref2, ["browseCountry", "regionalStoreVariant"]);

  var affiliateId = context_findAffiliateId();
  var geoCountry = client_getGeoCountry() || browseCountry;

  var base = extends_default()({
    affiliateId: affiliateId,
    browseCountry: browseCountry && browseCountry.toUpperCase(),
    enableStoreBasedOperation: false,
    geoCountry: geoCountry
  }, context_getSharedBaseContext(regionalStoreFromState));

  if (regionalStoreVariant) {
    return extends_default()({}, base, context_getSharedBaseContext(regionalStoreVariant));
  }

  return base;
};

var context_buildContextObject = function buildContextObject(store, keyStoreDataversion, siteChromeVersions, latestManifest) {
  var contextObject = assign_default()({}, {
    keyStoreDataversion: keyStoreDataversion,
    templateVersion: siteChromeVersions.cookieValue || siteChromeVersions.templateValue
  });

  var updateRegionalStore = function updateRegionalStore(callback) {
    // update the keystoredataversion in state
    store.dispatch(actions_setKeyStoreDataversion(contextObject.keyStoreDataversion));
    // update browseCurrency in state
    store.dispatch(actions_setBrowseCurrency(contextObject.browseCurrency));

    if (callback) {
      callback();
    }
  };

  var state = store.getState();
  var base = context_getBase({
    browseCountry: getCountryCode(state),
    storeCode: selectors_getStoreCode(state),
    defaultLanguage: getDefaultLanguage(state),
    defaultSizeSchema: getDefaultSizeSchema(state),
    currencies: getCurrencies(state),
    regionalStoreVariant: getRegionalStoreVariant(getStore(state), contextObject.keyStoreDataversion)
  });

  contextObject = extends_default()({}, base, contextObject);

  if (!templateMatchesCountry(contextObject)) {
    if (geoCountryMapsToCurrentStore(client_getGeoCountry(), latestManifest)) {
      client_setBrowseCountry(client_getGeoCountry());
      return window.location.reload();
    }
  }

  // Set new page cookies
  setCookies(contextObject);

  // Remove browse parameters from URL
  var url = ["browseCurrency", "browseCountry"].reduce(function (current, value) {
    return context_removeURLParameter(current, value);
  }, window.location.href);
  window.history.replaceState({}, "", url);

  // create context getters object, the external interface
  var contextGetters = getters(contextObject);

  return { context: contextGetters, updateRegionalStore: updateRegionalStore };
};

var context_mustReload = function mustReload(latestManifest, keyStoreDataversions, siteChromeVersions) {
  var storeCodeToSiteChromeVersionMappings = getAllVersions_getStoreCodeToSiteChromeVersionMappings(latestManifest);

  var setTemplateVersionsCookie = client_setTemplateVersions.bind(null, storeCodeToSiteChromeVersionMappings);

  var setKeyStoreDataVersionCookie = client_setKeyStoreDataversion.bind(null, keyStoreDataversions.manifestValue);

  var siteChromeMismatch = checkForMismatch(siteChromeVersions, setTemplateVersionsCookie);

  var ksdvMismatch = checkForMismatch(keyStoreDataversions, setKeyStoreDataVersionCookie);

  var shouldRedirect = siteChromeMismatch || ksdvMismatch;

  return shouldRedirect;
};

var context_updateCookieExpiry = function updateCookieExpiry(latestManifest) {
  client_setTemplateVersions(getAllVersions_getSiteChromeVersionMappingsFromCookie(latestManifest));
  client_setKeyStoreDataversion(client_getKeyStoreDataversion());
};

function context_context(store) {
  var latestManifest = window[constants["b" /* manifestWindowKey */]];
  var state = store.getState();

  var keyStoreDataversions = getAllVersions_getAllKeyStoreDataversions(state, latestManifest);

  var keyStoreDataversion = keyStoreDataversions.cookieValue || keyStoreDataversions.manifestValue;

  if (redirectToPreferredSite(latestManifest, state, keyStoreDataversion)) {
    return;
  }

  var siteChromeVersions = getAllVersions_getAllSiteChromeVersions(state, latestManifest);

  var shouldReload = context_mustReload(latestManifest, keyStoreDataversions, siteChromeVersions);

  context_updateCookieExpiry(latestManifest);

  if (shouldReload) {
    window.location.reload();
  }

  return context_buildContextObject(store, keyStoreDataversion, siteChromeVersions, latestManifest);
}

function context_removeURLParameter(url, parameter) {
  var urlParts = url.split("?");
  if (urlParts.length >= 2) {
    var prefix = encodeURIComponent(parameter) + "=";
    var parts = urlParts[1].split(/[&;]/g);

    for (var i = parts.length; i-- > 0;) {
      if (parts[i].lastIndexOf(prefix, 0) !== -1) {
        parts.splice(i, 1);
      }
    }

    return urlParts[0] + (parts.length > 0 ? "?" + parts.join("&") : "");
  } else {
    return url;
  }
}

function stripPrefSiteFromAsosCookie() {
  cookies_setKeyedCookieValue("asos", "PreferredSite", "");
}

/*
 * @param {Object} webContext
 * @param {string} webContext.browseCountry
 * @param {string} webContext.browseCurrency
 * @param {string} webContext.browseLanguage
 * @param {string} webContext.browseSizeSchema
 * @param {string} webContext.storeId
 * @param {string} webContext.browseCurrencyId
 */
function setCookies(webContext) {
  // true represents session cookie
  //initAsosCookie();
  stripPrefSiteFromAsosCookie();
  client_setBrowseCountry(webContext.browseCountry);
  client_setBrowseCurrency(webContext.browseCurrency);
  client_setBrowseLanguage(webContext.browseLanguage);
  client_setBrowseSizeSchema(webContext.browseSizeSchema);
  client_setStoreCode(webContext.storeId);
  client_setCurrency({
    currencyCode: webContext.browseCurrency,
    currencyId: webContext.browseCurrencyId
  });
}

function getContext() {
  return typeof window !== "undefined" && window[constants["e" /* siteChromePublicWindowApi */]] && window[constants["e" /* siteChromePublicWindowApi */]].context;
}
// CONCATENATED MODULE: ./template/helpers/removeProtocolFromUrl.js
function removeProtocolFromUrl(string) {
  return string.replace(/(^\w+:|^)/, "");
}
// CONCATENATED MODULE: ./template/state/modules/regionalStore/selectors.js






var getStore = function getStore(state) {
  return state.regionalStore;
};

var selectors_getSocialLinks = Object(lib["createSelector"])(getStore, getCurrentGender, function (store, gender) {
  return store.socialLinks[gender];
});

var getCountryName = Object(lib["createSelector"])(getStore, function (store) {
  return store.countryName;
});

var getCountryCode = Object(lib["createSelector"])(getStore, function (store) {
  return store.countryCode;
});

var selectors_isCorrectCountry = Object(lib["createSelector"])(getStore, function (store) {
  var context = getContext();
  var geoCountry = context && context.getGeoCountry();
  return geoCountry === store.countryCode;
});

var getCountryFlag = Object(lib["createSelector"])(getStore, function (store) {
  return store.countryFlag;
});

var getDefaultLanguage = Object(lib["createSelector"])(getStore, function (store) {
  return store.defaultLanguage;
});

var getDefaultStoreUrl = Object(lib["createSelector"])(getStore, function (store) {
  return store.storeUrls[DEFAULT];
});

var getSearchUrl = Object(lib["createSelector"])(getDefaultStoreUrl, function (url) {
  return removeProtocolFromUrl(url) + SEARCH_PATH;
});

var getStoreUrlForWomen = Object(lib["createSelector"])(getStore, function (store) {
  return store.storeUrls[FEMALE];
});

var getStoreUrlForMen = Object(lib["createSelector"])(getStore, function (store) {
  return store.storeUrls[MALE];
});

var getSecureStoreUrl = Object(lib["createSelector"])(getStore, function (store) {
  return store.storeUrls[SECURE];
});

var selectors_getStoreCode = Object(lib["createSelector"])(getStore, function (store) {
  return store.storeCode;
});

var selectors_getKeyStoreDataversion = Object(lib["createSelector"])(getStore, function (store) {
  return store.keyStoreDataversion;
});

var getDefaultSizeSchema = Object(lib["createSelector"])(getStore, function (store) {
  return store.defaultSizeSchema;
});

var getDefaultCurrency = Object(lib["createSelector"])(getStore, function (store) {
  return store.defaultCurrency;
});

var selectors_getCurrency = Object(lib["createSelector"])(getStore, getDefaultCurrency, function (store, defaultCurrency) {
  return store.browseCurrency || defaultCurrency;
});

var getCurrencies = Object(lib["createSelector"])(getStore, function (store) {
  return store.currencies;
});

var getCurrencyId = Object(lib["createSelector"])(selectors_getCurrency, getCurrencies, function (currencyCode, currencies) {
  return currencies.find(function (_ref) {
    var currency = _ref.currency;
    return currency === currencyCode;
  }).currencyId;
});

var selectors_getDefaultCountry = Object(lib["createSelector"])(getStore, function (store) {
  return store.defaultCountry;
});

var getPaymentProviders = Object(lib["createSelector"])(getStore, function (store) {
  return store.paymentProviders;
});

var getSiteId = Object(lib["createSelector"])(getStore, function (store) {
  return store.siteId;
});

var getPhrases = Object(lib["createSelector"])(getStore, function (store) {
  return store.phrases;
});
// CONCATENATED MODULE: ./template/state/modules/regionalStore/index.js




var regionalStore_initialState = {
  storeUrls: {}
};





var regionalStore_ksdvOverrides = function ksdvOverrides(variants) {
  return keys_default()(variants).reduce(function (overrides, key) {
    if (KSDV_PROPS_OVERWRITE.indexOf(key) !== -1) {
      overrides[key] = variants[key];
    }
    return overrides;
  }, {});
};

var getRegionalStoreVariant = function getRegionalStoreVariant(state, keyStoreDataversion) {
  return state.variants && state.variants[keyStoreDataversion] && regionalStore_ksdvOverrides(state.variants[keyStoreDataversion]);
};

/* harmony default export */ var modules_regionalStore = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : regionalStore_initialState;
  var action = arguments[1];

  var keyStoreDataversion = action.payload;
  switch (action.type) {
    case SET_KEY_STORE_DATA_VERSION:
      return extends_default()({}, state, {
        keyStoreDataversion: keyStoreDataversion
      }, getRegionalStoreVariant(state, keyStoreDataversion));
    case SET_BROWSE_CURRENCY:
      return extends_default()({}, state, {
        browseCurrency: action.payload
      });
  }
  return state;
});
// CONCATENATED MODULE: ./template/components/translation/addLanguage.js



var addLanguage_mapStateToProps = function mapStateToProps(state) {
  return {
    language: getDefaultLanguage(state),
    phrases: getPhrases(state)
  };
};

var addLanguage_addLanguage = function addLanguage(Component) {
  return Object(esfrom_dll_reference_vendor["connect"])(addLanguage_mapStateToProps)(Component);
};
// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/json/stringify.js
var json_stringify = __webpack_require__("../node_modules/babel-runtime/core-js/json/stringify.js");
var json_stringify_default = /*#__PURE__*/__webpack_require__.n(json_stringify);

// EXTERNAL MODULE: ../node_modules/node-polyglot/index.js
var node_polyglot = __webpack_require__("../node_modules/node-polyglot/index.js");
var node_polyglot_default = /*#__PURE__*/__webpack_require__.n(node_polyglot);

// CONCATENATED MODULE: ./helpers/get.js
function get_get(object, path) {
  var splitPath = path.split(".");
  var length = splitPath.length;
  var index = 0;

  while (object != null && index < length) {
    object = object[splitPath[index++]];
  }

  return index && index === length ? object : undefined;
}
// CONCATENATED MODULE: ../i18n/utilities/socialLinks.js
/* harmony default export */ var socialLinks = ({
  com: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  row: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  roe: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  fr: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_fr/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_fr/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  us: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_us/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_us/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  au: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_au/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_au/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  de: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos_de/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_de/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  it: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_it/"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_it/"
    }
  },
  es: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_es/"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_es/"
    }
  },
  ru: {
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_ru/",
      Vk: "https://vk.com/asos"
    },
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "http://www.instagram.com/asos_ru/",
      Vk: "https://vk.com/asos"
    }
  },
  nl: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  },
  se: {
    women: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    },
    men: {
      Facebook: "https://www.facebook.com/ASOS/",
      Instagram: "https://www.instagram.com/asos/",
      Snapchat: "https://www.snapchat.com/add/asosfashion"
    }
  }
});
// CONCATENATED MODULE: ./helpers/lowerEntries.js




function lowerEntries(obj) {
  if ((typeof obj === "undefined" ? "undefined" : typeof_default()(obj)) !== "object" || !obj) return obj;

  return keys_default()(obj).reduce(function (lowered, key) {
    return extends_default()({}, lowered, defineProperty_default()({}, key, typeof obj[key] === "string" ? obj[key].toLowerCase() : obj[key]));
  }, {});
}
// CONCATENATED MODULE: ../i18n/utilities/index.js







var utilities_getLanguage = function getLanguage(languageCode) {
  return languageCode.split("-")[0];
};

var utilities_getSocialLinks = function getSocialLinks(params) {
  var _lowerEntries = lowerEntries(params),
      floor = _lowerEntries.floor,
      storeCode = _lowerEntries.storeCode;

  if (!floor || !storeCode) {
    throw new Error("cannot retrieve social networks without storeCode and floor");
  }

  var defaultedFloor = floor === DEFAULT ? FEMALE : floor;
  var linksPath = storeCode + "." + defaultedFloor;

  return get_get(socialLinks, linksPath);
};
// CONCATENATED MODULE: ./template/components/translation/buildTranslationFormatter.js




var buildTranslationFormatter_buildTranslationFormatter = function buildTranslationFormatter(language, phrases) {
  var locale = utilities_getLanguage(language);
  var polyglot = new node_polyglot_default.a({
    locale: locale,
    phrases: phrases,
    onMissingKey: function onMissingKey(key, args, language) {
      throw new Error("No translations for \"" + key + "\" with arguments " + json_stringify_default()(args) + " in " + language + " locale.");
    }
  });

  return function () {
    return polyglot.t.apply(polyglot, arguments);
  };
};
// CONCATENATED MODULE: ./template/components/translation/index.js







var translation_withTranslation = function withTranslation(Component) {
  var ComposedComponent = function ComposedComponent(_ref) {
    var language = _ref.language,
        phrases = _ref.phrases,
        props = objectWithoutProperties_default()(_ref, ["language", "phrases"]);

    return reactfrom_dll_reference_vendor_default.a.createElement(Component, extends_default()({}, props, {
      formatTranslation: buildTranslationFormatter_buildTranslationFormatter(language, phrases)
    }));
  };

  ComposedComponent.displayName = "withTranslation(" + (Component.displayName || Component.name || "Component") + ")";
  ComposedComponent.WrappedComponent = Component;
  ComposedComponent.initActions = Component.initActions;

  return addLanguage_addLanguage(ComposedComponent);
};

/* harmony default export */ var translation = (translation_withTranslation);
// EXTERNAL MODULE: delegated ../node_modules/classnames/index.js from dll-reference vendor
var classnamesfrom_dll_reference_vendor = __webpack_require__("../node_modules/classnames/index.js");
var classnamesfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(classnamesfrom_dll_reference_vendor);

// EXTERNAL MODULE: ./template/components/CountrySelectorButton/index.css
var components_CountrySelectorButton = __webpack_require__("./template/components/CountrySelectorButton/index.css");
var CountrySelectorButton_default = /*#__PURE__*/__webpack_require__.n(components_CountrySelectorButton);

// CONCATENATED MODULE: ./template/components/CountrySelectorButton/CountrySelectorButton.js












var cx = classnamesfrom_dll_reference_vendor_default.a.bind(CountrySelectorButton_default.a);

var CountrySelectorButton_CountrySelectorButton = function (_Component) {
  inherits_default()(CountrySelectorButton, _Component);

  function CountrySelectorButton() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, CountrySelectorButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = CountrySelectorButton.__proto__ || get_prototype_of_default()(CountrySelectorButton)).call.apply(_ref, [this].concat(args))), _this), _this.trackOpenCountrySelector = function () {
      var position = _this.props.position;

      trackOpenCountryModal({
        context: ANALYTICS_CONTEXT.openCountryModal,
        interaction: ANALYTICS_INTERACTION_CLICK,
        properties: {
          positionOnPage: position
        }
      });
    }, _this.handleClick = function () {
      var _this$props = _this.props,
          openCountrySelector = _this$props.openCountrySelector,
          closeSidePanel = _this$props.closeSidePanel;

      closeSidePanel();
      openCountrySelector();
      _this.trackOpenCountrySelector();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(CountrySelectorButton, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          formatTranslation = _props.formatTranslation,
          countryFlag = _props.countryFlag,
          countryName = _props.countryName,
          withLabels = _props.withLabels;


      var containerClass = withLabels ? cx(CountrySelectorButton_default.a.container, CountrySelectorButton_default.a.withLabels) : CountrySelectorButton_default.a.container;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: containerClass, "data-testid": "country-selector" },
        withLabels && reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          { className: CountrySelectorButton_default.a.header },
          formatTranslation("CountrySelectorButton.Heading")
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "button",
          {
            className: CountrySelectorButton_default.a.button,
            "data-testid": "country-selector-btn",
            type: "button",
            "aria-label": formatTranslation("CountrySelectorButton.Heading") + " " + countryName + ". " + formatTranslation("CountrySelectorButton.ChangeCountry"),
            onClick: this.handleClick
          },
          withLabels && reactfrom_dll_reference_vendor_default.a.createElement(
            "span",
            { className: CountrySelectorButton_default.a.locationText },
            formatTranslation("CountrySelectorButton.LocationText")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement("img", {
            src: countryFlag,
            alt: countryName,
            className: CountrySelectorButton_default.a.countryFlag
          }),
          withLabels && reactfrom_dll_reference_vendor_default.a.createElement(
            "span",
            { className: CountrySelectorButton_default.a.changeLabel },
            formatTranslation("CountrySelectorButton.ChangeButton")
          )
        )
      );
    }
  }]);

  return CountrySelectorButton;
}(reactfrom_dll_reference_vendor["Component"]);

CountrySelectorButton_CountrySelectorButton.defaultProps = {
  withLabels: false
};

/* harmony default export */ var components_CountrySelectorButton_CountrySelectorButton = (translation(CountrySelectorButton_CountrySelectorButton));
// CONCATENATED MODULE: ./template/state/modules/countrySelector/constants.js
var OPEN_COUNTRY_SELECTOR = "OPEN_COUNTRY_SELECTOR";
var CLOSE_COUNTRY_SELECTOR = "CLOSE_COUNTRY_SELECTOR";
var SET_COUNTRY = "SET_COUNTRY";
var LOAD_COUNTRY = "LOAD_COUNTRY";
var LOAD_CURRENCY = "LOAD_CURRENCY";
var SET_CURRENCY = "SET_CURRENCY";
var VOUCHER_CURRENCY_ERROR = "cannotchangetonongbpcurrencyifvoucherisinbag";
// EXTERNAL MODULE: ../node_modules/url-parse/index.js
var url_parse = __webpack_require__("../node_modules/url-parse/index.js");
var url_parse_default = /*#__PURE__*/__webpack_require__.n(url_parse);

// CONCATENATED MODULE: ./template/state/modules/bag/constants.js
var SET_BAG = "SET_BAG";

var START_REMOVE_BAG_ITEM = "START_REMOVE_BAG_ITEM";
var FINISH_REMOVE_BAG_ITEM = "FINISH_REMOVE_BAG_ITEM";
var SHOW_RESERVATION_MESSAGE = "SHOW_RESERVATION_MESSAGE";
var HIDE_RESERVATION_MESSAGE = "HIDE_RESERVATION_MESSAGE";
var START_CHECKOUT = "START_CHECKOUT";

var BAG_ITEM_DELETE_TRANSITION_END = "BAG_ITEM_DELETE_TRANSITION_END";
var BAG_ERROR = "BAG_ERROR";
var DISMISS_BAG_ERROR = "DISMISS_BAG_ERROR";
var SET_LOADING = "SET_LOADING";
// CONCATENATED MODULE: ./template/state/modules/bag/actions.js


var actions_deleteBagItem = function deleteBagItem(bagItem) {
  return function (dispatch) {
    dispatch({
      type: START_REMOVE_BAG_ITEM,
      item: bagItem
    });
  };
};

var actions_startCheckout = function startCheckout() {
  return function (dispatch) {
    dispatch({
      type: START_CHECKOUT
    });
  };
};
// CONCATENATED MODULE: ./template/state/modules/bag/selectors.js



var selectors_getBag = function getBag(state) {
  return state.bag;
};

var getLoading = Object(lib["createSelector"])(selectors_getBag, function (_ref) {
  var loading = _ref.loading;
  return loading;
});

var getBagItems = Object(lib["createSelector"])(selectors_getBag, function (_ref2) {
  var items = _ref2.items;
  return items;
});

var selectors_getBagSummary = Object(lib["createSelector"])(selectors_getBag, function (_ref3) {
  var summary = _ref3.summary;
  return summary;
});

var getTotalPrice = Object(lib["createSelector"])(selectors_getBagSummary, function (_ref4) {
  var totalPrice = _ref4.totalPrice;
  return totalPrice || {};
});

var getTotalPriceText = Object(lib["createSelector"])(getTotalPrice, function (_ref5) {
  var text = _ref5.text;
  return text;
});

var getTotalQuantity = Object(lib["createSelector"])(selectors_getBagSummary, function (_ref6) {
  var totalQuantity = _ref6.totalQuantity;
  return totalQuantity;
});

var selectors_displayReservationMessage = Object(lib["createSelector"])(selectors_getBag, function (_ref7) {
  var displayReservationMessage = _ref7.displayReservationMessage;
  return displayReservationMessage;
});

var bagError = Object(lib["createSelector"])(selectors_getBag, function (_ref8) {
  var bagError = _ref8.bagError;
  return bagError;
});

var selectors_dismissBagError = function dismissBagError() {
  return function (dispatch) {
    dispatch({
      type: DISMISS_BAG_ERROR
    });
  };
};

var getUpdated = Object(lib["createSelector"])(selectors_getBag, function (_ref9) {
  var isUpdated = _ref9.isUpdated;
  return isUpdated;
});

var selectors_bagItemDeleteTransitionEnd = function bagItemDeleteTransitionEnd(itemId) {
  return function (dispatch) {
    return dispatch({
      type: BAG_ITEM_DELETE_TRANSITION_END,
      itemId: itemId
    });
  };
};
// CONCATENATED MODULE: ./template/state/modules/bag/index.js









var bag_initialState = {
  summary: {
    totalPrice: {}
  },
  loading: true
};

/* harmony default export */ var modules_bag = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bag_initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_BAG:
      {
        var _action$payload = action.payload,
            bag = _action$payload.bag,
            messages = _action$payload.messages;

        return extends_default()({}, state, bag, {
          messages: messages,
          bagError: false,
          loading: false
        });
      }
    case SET_LOADING:
      {
        return extends_default()({}, state, {
          loading: true
        });
      }
    case START_REMOVE_BAG_ITEM:
      {
        return extends_default()({}, state);
      }
    case SHOW_RESERVATION_MESSAGE:
      {
        return extends_default()({}, state, {
          displayReservationMessage: true
        });
      }
    case HIDE_RESERVATION_MESSAGE:
      {
        return extends_default()({}, state, {
          displayReservationMessage: false
        });
      }

    case BAG_ERROR:
      {
        return extends_default()({}, state, {
          bagError: true,
          loading: false
        });
      }
    case DISMISS_BAG_ERROR:
      {
        return extends_default()({}, state, {
          bagError: false
        });
      }
    case FINISH_REMOVE_BAG_ITEM:
      {
        return extends_default()({}, state, {
          lastItemRemoved: action.itemId
        });
      }
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./helpers/monitoring.js
var noticeError = function noticeError(error) {
  if (window.NREUM && window.NREUM.noticeError && error) {
    window.NREUM.noticeError(error);
  }
};
// CONCATENATED MODULE: ./template/state/modules/countrySelector/actions.js




var actions__this = this;







var actions_openCountrySelector = function openCountrySelector() {
  return function (dispatch, getState) {
    dispatch({ type: OPEN_COUNTRY_SELECTOR });

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    return dispatch(actions_setCountry(regionalStore.countryCode, regionalStore.defaultLanguage));
  };
};

var actions_closeCountrySelector = function closeCountrySelector() {
  return {
    type: CLOSE_COUNTRY_SELECTOR
  };
};

var actions_setCountry = function setCountry(country, defaultLanguage) {
  return function () {
    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState, _ref) {
      var api = _ref.api;
      var state, platform, response;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              state = getState();
              platform = state.layout.platform;

              dispatch({ type: LOAD_COUNTRY });
              _context.next = 6;
              return api.fetchCountry(country, defaultLanguage, platform);

            case 6:
              response = _context.sent;
              return _context.abrupt("return", dispatch({ type: SET_COUNTRY, payload: response.data }));

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", dispatch({ type: SET_COUNTRY, error: true, payload: _context.t0 }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, actions__this, [[0, 10]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var actions_setCurrency = function () {
  var _ref3 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(currencyCode) {
    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(window.asos.sdk.bag && window.asos.sdk.bag.updateCurrency && currencyCode)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", window.asos.sdk.bag.updateCurrency(currencyCode));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, actions__this);
  }));

  return function setCurrency(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var actions_updatePreferences = function updatePreferences(countryCode, currencyCode, storeUrl, initialCountryCode, affiliateId) {
  return function () {
    var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(dispatch) {
      var res, url, xSiteOrigin;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!(countryCode === initialCountryCode)) {
                _context3.next = 8;
                break;
              }

              dispatch({ type: LOAD_CURRENCY });
              _context3.next = 5;
              return actions_setCurrency(currencyCode);

            case 5:
              res = _context3.sent;

              dispatch({ type: SET_CURRENCY });
              if (res && res.bag && res.bag.summary) {
                dispatch({ type: SET_BAG, payload: res.bag.summary });
              }

            case 8:
              url = url_parse_default()(storeUrl || window.location.href, true);
              xSiteOrigin = clientConfig["a" /* default */].getXSiteOrigin();


              if (countryCode) {
                url.query = extends_default()({}, url.query, { browseCountry: countryCode });
              }
              if (currencyCode) {
                url.query = extends_default()({}, url.query, { browseCurrency: currencyCode });
              }
              if (affiliateId) {
                url.query = extends_default()({}, url.query, { xaffid: affiliateId });
              }
              if (xSiteOrigin) {
                url.query = extends_default()({}, url.query, { "x-site-origin": xSiteOrigin });
              }
              url.query = extends_default()({}, url.query, { r: 1 });

              window.location.href = url.toString();
              _context3.next = 22;
              break;

            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](0);

              noticeError(_context3.t0);
              dispatch({ type: SET_CURRENCY, payload: _context3.t0.message, error: true });

            case 22:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, actions__this, [[0, 18]]);
    }));

    return function (_x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
// CONCATENATED MODULE: ./template/state/modules/countrySelector/selectors.js


var getCountrySelector = function getCountrySelector(state) {
  return state.countrySelector;
};

var getCountrySelectorVisibility = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.isOpen;
});

var getCountrySelectorLoading = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.isLoading;
});

var getCountrySelectorError = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.error;
});

var getCountrySelectorCountry = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.country;
});

var getCountrySelectorAlternateUrls = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.alternateUrls;
});

var getHasVoucherError = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.hasVoucherError;
});

var getHasSetCurrencyError = Object(lib["createSelector"])(getCountrySelector, function (countrySelector) {
  return countrySelector.hasSetCurrencyError;
});
// CONCATENATED MODULE: ./template/state/modules/countrySelector/index.js






var countrySelector_initialState = {
  isOpen: false,
  isLoading: true,
  hasVoucherError: false,
  hasSetCurrencyError: false
};

var countrySelector_hasVoucherError = function hasVoucherError(messages) {
  return !!(messages && messages.some(function (_ref) {
    var errorCode = _ref.errorCode;
    return errorCode && errorCode.toLowerCase() === VOUCHER_CURRENCY_ERROR;
  }));
};

/* harmony default export */ var countrySelector = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : countrySelector_initialState;
  var action = arguments[1];

  switch (action.type) {
    case OPEN_COUNTRY_SELECTOR:
      return extends_default()({}, state, {
        isOpen: true,
        isLoading: true,
        hasVoucherError: false,
        hasSetCurrencyError: false
      });
    case CLOSE_COUNTRY_SELECTOR:
      return extends_default()({}, state, {
        isOpen: false
      });
    case LOAD_COUNTRY:
      return extends_default()({}, state, { isLoading: true });
    case SET_COUNTRY:
      return extends_default()({}, state, {
        country: !action.error ? action.payload : null,
        isLoading: false,
        error: action.error,
        isOpen: !action.error
      });
    case LOAD_CURRENCY:
      return extends_default()({}, state, { isLoading: true });
    case SET_CURRENCY:
      return extends_default()({}, state, {
        isLoading: false,
        hasSetCurrencyError: action.error,
        hasVoucherError: countrySelector_hasVoucherError(action.payload)
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/CountrySelectorButton/index.js







var CountrySelectorButton_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    openCountrySelector: actions_openCountrySelector,
    closeSidePanel: actions_closeSidePanel
  }, dispatch);
};

var CountrySelectorButton_mapStateToProps = function mapStateToProps(state) {
  return {
    countryName: getCountryName(state),
    countryFlag: getCountryFlag(state)
  };
};

/* harmony default export */ var template_components_CountrySelectorButton = (Object(esfrom_dll_reference_vendor["connect"])(CountrySelectorButton_mapStateToProps, CountrySelectorButton_mapDispatchToProps)(components_CountrySelectorButton_CountrySelectorButton));
// EXTERNAL MODULE: ./template/components/MiscBar/MiscBar.css
var MiscBar_MiscBar = __webpack_require__("./template/components/MiscBar/MiscBar.css");
var MiscBar_default = /*#__PURE__*/__webpack_require__.n(MiscBar_MiscBar);

// CONCATENATED MODULE: ./template/helpers/externalLinks.js


var externalLinks_getMarketplaceUrl = function getMarketplaceUrl() {
  return clientConfig["a" /* default */].get().MARKETPLACE_URL;
};
var externalLinks_getMyAccountBaseUrl = function getMyAccountBaseUrl() {
  return clientConfig["a" /* default */].get().MY_ACCOUNT_BASE_URL;
};
var externalLinks_getIdentitySdkAuthHost = function getIdentitySdkAuthHost() {
  return clientConfig["a" /* default */].get().IDENTITY_SDK_AUTH_HOST;
};
// CONCATENATED MODULE: ./helpers/queryString.js



var queryString_withParams = function withParams(link) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var parsedLink = url_parse_default()(link, true);

  parsedLink.query = extends_default()({}, parsedLink.query, params);

  return parsedLink.toString();
};
// CONCATENATED MODULE: ./template/components/MiscBar/MiscBar.js









var MiscBar_marketplaceUrl = function marketplaceUrl() {
  return queryString_withParams(externalLinks_getMarketplaceUrl(), {
    ctaref: "Global nav"
  });
};

var MiscBar_MiscBar_MiscBar = function MiscBar(_ref) {
  var formatTranslation = _ref.formatTranslation,
      defaultStoreUrl = _ref.defaultStoreUrl;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: MiscBar_default.a.container, "data-testid": "topbar" },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: MiscBar_default.a.body },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "ul",
        { className: MiscBar_default.a.navigation },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            { href: MiscBar_marketplaceUrl(), "data-testid": "marketplace" },
            formatTranslation("MiscBar.Marketplace")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("MiscBar.HelpLink")),
              "data-testid": "help"
            },
            formatTranslation("MiscBar.Help")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(template_components_CountrySelectorButton, { position: ANALYTICS_POSITION_HEADER })
        )
      )
    )
  );
};

/* harmony default export */ var components_MiscBar_MiscBar = (translation(MiscBar_MiscBar_MiscBar));
// CONCATENATED MODULE: ./template/components/MiscBar/index.js





function MiscBar_mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

/* harmony default export */ var components_MiscBar = (Object(esfrom_dll_reference_vendor["connect"])(MiscBar_mapStateToProps)(components_MiscBar_MiscBar));
// EXTERNAL MODULE: ../node_modules/classnames/bind.js
var bind = __webpack_require__("../node_modules/classnames/bind.js");
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// CONCATENATED MODULE: ./template/globalEventHandler.js


var globalEventHandler = new fbemitter["EventEmitter"]();

var globalEventHandler_events = {
  focusFirstPrimaryNavigationItem: "focusFirstPrimaryNavigationItem",
  closeSearchOverlay: "closeSearchOverlay",
  focusBackToFloor: "focusBackToFloor",
  keyDown: "keydown",
  click: "click",
  scroll: "scroll",
  resize: "resize"
};

var globalEventHandler_keys = {
  tab: "Tab",
  escape: "Escape"
};

var normaliseKey = function normaliseKey(event) {
  if (event.key) {
    return event.key;
  }

  switch (event.which) {
    case 9:
      return globalEventHandler_keys.tab;
    case 27:
      return globalEventHandler_keys.escape;
  }
};

typeof window !== "undefined" && window.addEventListener(globalEventHandler_events.keyDown, function (event) {
  return globalEventHandler.emit(globalEventHandler_events.keyDown, {
    key: normaliseKey(event),
    originalEvent: event
  });
});

typeof window !== "undefined" && window.addEventListener(globalEventHandler_events.click, function (event) {
  return globalEventHandler.emit(globalEventHandler_events.click, event);
});

typeof window !== "undefined" && window.addEventListener(globalEventHandler_events.scroll, function () {
  return globalEventHandler.emit(globalEventHandler_events.scroll);
});

typeof window !== "undefined" && window.addEventListener(globalEventHandler_events.resize, function () {
  return globalEventHandler.emit(globalEventHandler_events.resize);
});

/* harmony default export */ var template_globalEventHandler = (globalEventHandler);

var focusPrimaryNavigationFor = function focusPrimaryNavigationFor(gender) {
  return globalEventHandler.emit(globalEventHandler_events.focusFirstPrimaryNavigationItem, gender);
};

var focusFloorNavigationFor = function focusFloorNavigationFor(gender) {
  return globalEventHandler.emit(globalEventHandler_events.focusBackToFloor, gender);
};

var closeSearchOverlay = function closeSearchOverlay() {
  return globalEventHandler.emit(globalEventHandler_events.closeSearchOverlay);
};
// EXTERNAL MODULE: ./template/components/FloorNavigation/FloorNavigation.css
var FloorNavigation_FloorNavigation = __webpack_require__("./template/components/FloorNavigation/FloorNavigation.css");
var FloorNavigation_default = /*#__PURE__*/__webpack_require__.n(FloorNavigation_FloorNavigation);

// CONCATENATED MODULE: ./template/components/FloorNavigation/FloorNavigation.js















var FloorNavigation_cx = bind_default.a.bind(FloorNavigation_default.a);

var FloorNavigation_FloorNavigation_FloorNavigation = function (_PureComponent) {
  inherits_default()(FloorNavigation, _PureComponent);

  function FloorNavigation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, FloorNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = FloorNavigation.__proto__ || get_prototype_of_default()(FloorNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.floors = {}, _this.selectFloor /* istanbul ignore next - focus is not supported in jsdom */ = function (gender) {
      _this.floors[gender].focus();
    }, _this.handleFemaleClick = function () {
      _this.setGender(FEMALE);
    }, _this.handleMaleClick = function () {
      _this.setGender(MALE);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(FloorNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusFloorEventHandler = template_globalEventHandler.addListener(globalEventHandler_events.focusBackToFloor, this.selectFloor);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.focusFloorEventHandler && this.focusFloorEventHandler.remove();
    }
  }, {
    key: "setGender",
    value: function setGender(gender) {
      this.props.setGender(gender);
      focusPrimaryNavigationFor(gender);
    }
  }, {
    key: "isSelected",
    value: function isSelected(gender) {
      var _props = this.props,
          isFemale = _props.isFemale,
          isMale = _props.isMale,
          viewport = _props.viewport;


      if (gender === MALE) {
        return isMale;
      }

      if (viewport === LARGE_VIEWPORT) {
        return isFemale;
      }

      return !isMale;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          formatTranslation = _props2.formatTranslation,
          menStoreUrl = _props2.menStoreUrl,
          womenStoreUrl = _props2.womenStoreUrl,
          viewport = _props2.viewport,
          viewable = _props2.viewable;


      var MenuTagType = viewport === LARGE_VIEWPORT ? "a" : "button";
      var womenMenuActionProp = viewport === LARGE_VIEWPORT ? { href: womenStoreUrl } : { onClick: this.handleFemaleClick };
      var menMenuActionProp = viewport === LARGE_VIEWPORT ? { href: menStoreUrl } : { onClick: this.handleMaleClick };

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "ul",
        {
          className: FloorNavigation_cx(FloorNavigation_default.a.container, defineProperty_default()({}, FloorNavigation_default.a.container__large, viewable.indexOf(LARGE_VIEWPORT) !== -1)),
          "data-testid": "floornav"
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            MenuTagType,
            extends_default()({
              className: FloorNavigation_cx(FloorNavigation_default.a.button, defineProperty_default()({}, FloorNavigation_default.a.selected, this.isSelected(FEMALE))),
              "data-testid": "women-floor",
              ref: function ref(el) {
                return _this2.floors[FEMALE] = el;
              }
            }, womenMenuActionProp, {
              "aria-label": formatTranslation("Header.WomensProductsAriaLabel")
            }),
            formatTranslation("Header.WomenFloor")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            MenuTagType,
            extends_default()({
              className: FloorNavigation_cx(FloorNavigation_default.a.button, defineProperty_default()({}, FloorNavigation_default.a.selected, this.isSelected(MALE))),
              "data-testid": "men-floor",
              ref: function ref(el) {
                return _this2.floors[MALE] = el;
              }
            }, menMenuActionProp, {
              "aria-label": formatTranslation("Header.MensProductsAriaLabel")
            }),
            formatTranslation("Header.MenFloor")
          )
        )
      );
    }
  }]);

  return FloorNavigation;
}(reactfrom_dll_reference_vendor["PureComponent"]);

FloorNavigation_FloorNavigation_FloorNavigation.defaultProps = {
  isFemale: false,
  isMale: false,
  viewable: []
};

/* harmony default export */ var components_FloorNavigation_FloorNavigation = (translation(FloorNavigation_FloorNavigation_FloorNavigation));
// CONCATENATED MODULE: ./template/components/FloorNavigation/index.js






function FloorNavigation_mapStateToProps(state) {
  return {
    isMale: selectors_isMale(state),
    isFemale: selectors_isFemale(state),
    viewport: getViewport(state),
    menStoreUrl: getStoreUrlForMen(state),
    womenStoreUrl: getStoreUrlForWomen(state)
  };
}
function FloorNavigation_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ setGender: actions_setGender }, dispatch);
}

/* harmony default export */ var components_FloorNavigation = (Object(esfrom_dll_reference_vendor["connect"])(FloorNavigation_mapStateToProps, FloorNavigation_mapDispatchToProps)(components_FloorNavigation_FloorNavigation));
// EXTERNAL MODULE: ./template/components/Burger/Burger.css
var Burger_Burger = __webpack_require__("./template/components/Burger/Burger.css");
var Burger_default = /*#__PURE__*/__webpack_require__.n(Burger_Burger);

// CONCATENATED MODULE: ./template/components/Burger/Burger.js










var Burger_Burger_Burger = function (_Component) {
  inherits_default()(Burger, _Component);

  function Burger() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Burger);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Burger.__proto__ || get_prototype_of_default()(Burger)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (component) {
      return _this.component = component;
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Burger, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          openSidePanel = _props.openSidePanel,
          formatTranslation = _props.formatTranslation;

      return reactfrom_dll_reference_vendor_default.a.createElement("button", {
        className: Burger_default.a.burger,
        onClick: openSidePanel,
        ref: this.saveRef,
        "aria-label": formatTranslation("Burger.OpenNavigationLabel"),
        tabIndex: this.props.isSidePanelOpen ? -1 : 0,
        "data-testid": "burger-menu-button"
      });
    }
  }]);

  return Burger;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Burger_Burger = (translation(Burger_Burger_Burger));
// CONCATENATED MODULE: ./template/helpers/searchTermCleanser.js
function searchTermCleanser(string) {
  return string.toLowerCase().trim().replace(/<\/?[^>]+(>|$)|\t/g, "");
}
// CONCATENATED MODULE: ./template/state/modules/search/constants.js
var MINIMUM_SUGGESTIONS_CHARS = 2;
var MAXIMUM_RECENT_SEARCHES = 5;

var REQUEST_SUGGESTIONS = "REQUEST_SUGGESTIONS";
var RECEIVE_SUGGESTIONS = "RECEIVE_SUGGESTIONS";
var SUBMIT_SEARCH = "SUBMIT_SEARCH";
var CLEAR_RECENT_SEARCHES = "CLEAR_RECENT_SEARCHES";
var SET_SEARCH_TERM = "SET_SEARCH_TERM";
var CLOSE_SEARCH = "CLOSE_SEARCH";
var OPEN_SEARCH = "OPEN_SEARCH";
// CONCATENATED MODULE: ./template/state/modules/search/selectors.js



var getSearch = function getSearch(state) {
  return state.search;
};

var hasHistoryOrSuggestions = function hasHistoryOrSuggestions(suggestions, history) {
  return suggestions.length > 0 || history.length > 0;
};

var getSearchSuggestions = Object(lib["createSelector"])(getSearch, function (search) {
  return search.suggestions;
});

var getSearchTerm = Object(lib["createSelector"])(getSearch, function (search) {
  return search.term;
});

var getSearchHistory = Object(lib["createSelector"])(getSearch, function (search) {
  return search.recent;
});

var getVisibility = Object(lib["createSelector"])(getSearch, function (search) {
  return search.isVisible || false;
});

var termLongEnoughToSearch = Object(lib["createSelector"])(getSearch, function (search) {
  return search.term.length >= MINIMUM_SUGGESTIONS_CHARS;
});

// needs to add loading icon
var getLoadingStatus = Object(lib["createSelector"])(getSearch,
/* istanbul ignore next */function (search) {
  return search.isLoading;
});

var getResultVisibility = Object(lib["createSelector"])(getVisibility, getSearchHistory, getSearchSuggestions, function (isVisible, history, suggestions) {
  return isVisible && hasHistoryOrSuggestions(suggestions, history);
});

var isSearchResultsPanelOpen = Object(lib["createSelector"])(getSearchSuggestions, getSearchHistory, function (suggestions, history) {
  return hasHistoryOrSuggestions(suggestions, history);
});
// CONCATENATED MODULE: ./template/state/modules/search/actions.js



var search_actions__this = this;






var actions_requestSuggestions = function requestSuggestions(term) {
  return {
    type: REQUEST_SUGGESTIONS,
    payload: term
  };
};

var actions_receiveSuggestions = function receiveSuggestions(term, suggestions) {
  return {
    type: RECEIVE_SUGGESTIONS,
    payload: suggestions,
    meta: { term: term }
  };
};

var actions_submitSearch = function submitSearch(term) {
  return {
    type: SUBMIT_SEARCH,
    payload: term
  };
};

var actions_clearRecentSearches = function clearRecentSearches() {
  return { type: CLEAR_RECENT_SEARCHES };
};

var actions_closeSearch = function closeSearch() {
  return {
    type: CLOSE_SEARCH
  };
};

var actions_openSearch = function openSearch() {
  return {
    type: OPEN_SEARCH
  };
};

var actions_setSearchTerm = function setSearchTerm(term) {
  return {
    type: SET_SEARCH_TERM,
    payload: searchTermCleanser(term)
  };
};

var actions_loadSuggestions = function loadSuggestions() {
  return function () {
    var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, getState, _ref) {
      var api = _ref.api;
      var state, regionalStore, search, suggestions;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              regionalStore = state.regionalStore, search = state.search;

              if (termLongEnoughToSearch(state)) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", dispatch(actions_receiveSuggestions(search.term, [])));

            case 4:

              dispatch(actions_requestSuggestions(search.term));

              _context.prev = 5;
              _context.next = 8;
              return api.fetchSuggestions(regionalStore.siteId, regionalStore.defaultLanguage, search.term, regionalStore.countryCode);

            case 8:
              suggestions = _context.sent;


              dispatch(actions_receiveSuggestions(search.term, parse(suggestions)));
              _context.next = 14;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, search_actions__this, [[5, 12]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

function parse(responseJson) {
  return responseJson && responseJson.suggestionGroups && responseJson.suggestionGroups[0] && responseJson.suggestionGroups[0].suggestions || [];
}
// CONCATENATED MODULE: ./template/state/modules/search/index.js









var search_initialState = {
  recent: [],
  suggestions: [],
  term: "",
  isVisible: false
};

var search_addToSearchArray = function addToSearchArray(arr, newItem) {
  var item = searchTermCleanser(newItem);
  if (!item && !item.length) {
    return arr;
  }

  if (arr.length === MAXIMUM_RECENT_SEARCHES) {
    arr.pop();
  }

  arr.unshift(item);

  return arr;
};

/* harmony default export */ var modules_search = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search_initialState;
  var action = arguments[1];

  if (action.type === SUBMIT_SEARCH) {
    if (state.recent.indexOf(action.payload) === -1) {
      return extends_default()({}, state, {
        recent: search_addToSearchArray(state.recent, action.payload)
      });
    } else {
      return state;
    }
  }

  if (action.type === SET_SEARCH_TERM) {
    return extends_default()({}, state, {
      term: action.payload
    });
  }

  if (action.type === RECEIVE_SUGGESTIONS) {
    if (state.term === action.meta.term) {
      return extends_default()({}, state, {
        suggestions: action.meta.term.length < MINIMUM_SUGGESTIONS_CHARS || action.payload.length > 0 ? action.payload : state.suggestions,
        isLoading: false
      });
    }

    return extends_default()({}, state, {
      isLoading: false
    });
  }

  if (action.type === REHYDRATE && action.payload && action.payload.search) {
    return extends_default()({}, state, { recent: action.payload.search.recent });
  }

  if (action.type === CLOSE_SEARCH) {
    return extends_default()({}, state, {
      isVisible: false
    });
  }

  if (action.type === OPEN_SEARCH) {
    return extends_default()({}, state, {
      isVisible: true
    });
  }

  if (action.type === CLEAR_RECENT_SEARCHES) {
    return extends_default()({}, state, { recent: [] });
  }

  if (action.type === REQUEST_SUGGESTIONS) {
    return extends_default()({}, state, { isLoading: true });
  }

  return state;
});
// CONCATENATED MODULE: ./template/components/Burger/index.js






function Burger_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ openSidePanel: actions_openSidePanel }, dispatch);
}

function Burger_mapStateToProps(state) {
  return {
    isSidePanelOpen: selectors_isSidePanelOpen(state),
    isSearchVisible: getVisibility(state)
  };
}

/* harmony default export */ var components_Burger = (Object(esfrom_dll_reference_vendor["connect"])(Burger_mapStateToProps, Burger_mapDispatchToProps)(components_Burger_Burger));
// CONCATENATED MODULE: ./template/components/SearchIcon/index.js




var SearchIcon_SearchIcon = function SearchIcon(_ref) {
  var formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "svg",
    { viewBox: "0 0 17 17", role: "img", "aria-labelledby": "search-icon" },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "title",
      { id: "search-icon" },
      formatTranslation("Icon.Search")
    ),
    reactfrom_dll_reference_vendor_default.a.createElement("path", {
      fill: "currentColor",
      fillRule: "nonzero",
      d: "M7.65 15.3a7.65 7.65 0 1 1 5.997-2.9c-.01.012 3.183 3.297 3.183 3.297l-1.22 1.18s-3.144-3.283-3.154-3.275A7.618 7.618 0 0 1 7.65 15.3zm0-2a5.65 5.65 0 1 0 0-11.3 5.65 5.65 0 0 0 0 11.3z"
    })
  );
};

/* harmony default export */ var components_SearchIcon = (translation(SearchIcon_SearchIcon));
// EXTERNAL MODULE: ./template/components/Icon/index.css
var components_Icon = __webpack_require__("./template/components/Icon/index.css");
var Icon_default = /*#__PURE__*/__webpack_require__.n(components_Icon);

// CONCATENATED MODULE: ./template/components/Icon/index.js








var Icon_Icon = function Icon(_ref) {
  var icon = _ref.icon,
      size = _ref.size,
      props = objectWithoutProperties_default()(_ref, ["icon", "size"]);

  var svg = __webpack_require__("./template/styles/icons recursive ^\\.\\/.*\\.svg$")("./" + icon + ".svg");

  return reactfrom_dll_reference_vendor_default.a.createElement("span", extends_default()({}, props, {
    className: classnamesfrom_dll_reference_vendor_default()(Icon_default.a.container, Icon_default.a[size]),
    dangerouslySetInnerHTML: { __html: svg }
  }));
};

Icon_Icon.defaultProps = {
  size: "medium"
};

/* harmony default export */ var template_components_Icon = (Icon_Icon);
// EXTERNAL MODULE: ./template/components/IconButton/index.css
var components_IconButton = __webpack_require__("./template/components/IconButton/index.css");
var IconButton_default = /*#__PURE__*/__webpack_require__.n(components_IconButton);

// CONCATENATED MODULE: ./template/components/IconButton/index.js







/* eslint-disable jsx-a11y/label-has-for */






var IconButton_cx = classnamesfrom_dll_reference_vendor_default.a.bind(IconButton_default.a);

var IconButton_IconButton = function (_Component) {
  inherits_default()(IconButton, _Component);

  function IconButton() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = IconButton.__proto__ || get_prototype_of_default()(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.icon = function () {
      return reactfrom_dll_reference_vendor_default.a.createElement(template_components_Icon, {
        style: _this.props.iconStyles || {},
        icon: _this.props.icon,
        size: _this.props.size
      });
    }, _this.classes = function () {
      return IconButton_cx(IconButton_default.a.button, _this.props.className);
    }, _this.button = function (props) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "button",
        extends_default()({ type: "button" }, props, { className: _this.classes() }),
        _this.icon()
      );
    }, _this.label = function (props) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "label",
        extends_default()({}, props, { className: _this.classes() }),
        _this.icon()
      );
    }, _this.link = function (props) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "a",
        extends_default()({}, props, { className: _this.classes() }),
        _this.icon(),
        _this.props.children
      );
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(IconButton, [{
    key: "render",
    value: function render() {
      var p = assign_default()({}, this.props);

      if (p.iconStyles) {
        delete p.iconStyles;
      }
      switch (this.props.type) {
        case "a":
          return this.link(p);
        case "label":
          return this.label(p);
        case "button":
        default:
          return this.button(p);
      }
    }
  }]);

  return IconButton;
}(reactfrom_dll_reference_vendor["Component"]);

IconButton_IconButton.defaultProps = {
  type: "button"
};


/* harmony default export */ var template_components_IconButton = (IconButton_IconButton);
// EXTERNAL MODULE: ./template/components/SearchDropdown/index.css
var components_SearchDropdown = __webpack_require__("./template/components/SearchDropdown/index.css");
var SearchDropdown_default = /*#__PURE__*/__webpack_require__.n(components_SearchDropdown);

// EXTERNAL MODULE: ./template/components/SearchDropdown/ResultItem/index.css
var SearchDropdown_ResultItem = __webpack_require__("./template/components/SearchDropdown/ResultItem/index.css");
var ResultItem_default = /*#__PURE__*/__webpack_require__.n(SearchDropdown_ResultItem);

// CONCATENATED MODULE: ./template/components/SearchDropdown/ResultItem/index.js









var ResultItem_ResultItem = function (_Component) {
  inherits_default()(ResultItem, _Component);

  function ResultItem() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, ResultItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ResultItem.__proto__ || get_prototype_of_default()(ResultItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
      var _this$props = _this.props,
          setSearchTerm = _this$props.setSearchTerm,
          searchTerm = _this$props.item.searchTerm;


      setSearchTerm(searchTerm);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(ResultItem, [{
    key: "renderResultLabel",
    value: function renderResultLabel(label) {
      var term = this.props.term;


      var text = ResultItem.formatText(label);
      var bolded = ResultItem.boldTermInText(text, term);

      return bolded;
    }
  }, {
    key: "renderResultCount",
    value: function renderResultCount(resultCount) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        { className: ResultItem_default.a.count },
        resultCount.toLocaleString().replace(/\.00$/, "")
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          onKeyDown = _props.onKeyDown,
          _props$item = _props.item,
          numberOfResults = _props$item.numberOfResults,
          searchTerm = _props$item.searchTerm;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "li",
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(
          "button",
          {
            role: "link",
            ref: this.props.buttonRef,
            onKeyDown: onKeyDown,
            className: ResultItem_default.a.button,
            onClick: this.handleSubmit,
            type: "submit"
          },
          reactfrom_dll_reference_vendor_default.a.createElement("span", {
            className: ResultItem_default.a.label,
            dangerouslySetInnerHTML: {
              __html: this.renderResultLabel(searchTerm)
            }
          }),
          numberOfResults && this.renderResultCount(numberOfResults)
        )
      );
    }
  }]);

  return ResultItem;
}(reactfrom_dll_reference_vendor["Component"]);

ResultItem_ResultItem.bold = function (match, word) {
  var boldIndex = word.toLowerCase().indexOf(match.toLowerCase());

  return word.substring(0, boldIndex) + ("<span class=\"" + ResultItem_default.a.bold + "\">" + word.substr(boldIndex, match.length) + "</span>") + word.substring(boldIndex + match.length);
};

ResultItem_ResultItem.boldTermInText = function (suggestion, term) {
  var searchWords = term.split(/ /g);
  var suggestionWords = suggestion.split(/ /g);

  return suggestionWords.map(function (suggestionWord) {
    var firstMatch = searchWords.find(function (searchTerm) {
      return suggestionWord.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
    });

    return firstMatch ? ResultItem_ResultItem.bold(firstMatch, suggestionWord) : suggestionWord;
  }).join(" ");
};

ResultItem_ResultItem.formatText = function (phrase) {
  return phrase.replace(/asos/i, "ASOS").split(/ /g).map(function (word) {
    return "" + word.substring(0, 1).toUpperCase() + word.substring(1);
  }).join(" ");
};

/* harmony default export */ var components_SearchDropdown_ResultItem = (ResultItem_ResultItem);
// CONCATENATED MODULE: ./template/components/SearchDropdown/ResultList/ResultList.js











var ResultList_ResultList = function (_Component) {
  inherits_default()(ResultList, _Component);

  function ResultList() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, ResultList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ResultList.__proto__ || get_prototype_of_default()(ResultList)).call.apply(_ref, [this].concat(args))), _this), _this.items = [], _this.handleKeyDown = /* istanbul ignore next */function (e) {
      var currentIndex = _this.items.indexOf(e.target);

      if (e.keyCode === 40) {
        var next = _this.items[currentIndex + 1];

        if (!next) {
          return _this.props.focusSearchBox();
        }

        next.focus();
      }

      if (e.keyCode === 38) {
        if (currentIndex === 0) {
          return _this.props.focusSearchBox();
        }

        var _next = _this.items[currentIndex - 1] || _this.items[0];
        _next.focus();
      }

      if (e.keyCode === 9 && !e.shiftKey) {
        var _next2 = _this.items[currentIndex + 1];

        if (!_next2) {
          closeSearchOverlay();
        }
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(ResultList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          setSearchTerm = _props.setSearchTerm,
          term = _props.term,
          focusSearchBox = _props.focusSearchBox;


      return items && reactfrom_dll_reference_vendor_default.a.createElement(
        "ul",
        {
          className: SearchDropdown_default.a.list,
          "aria-live": "polite",
          role: "region",
          id: "search-results",
          ref: this.props.listRef
        },
        items.map(function (item, i) {
          return reactfrom_dll_reference_vendor_default.a.createElement(components_SearchDropdown_ResultItem, {
            buttonRef: function buttonRef(el) {
              return _this2.items[i] = el;
            },
            key: i,
            item: item,
            term: term,
            setSearchTerm: setSearchTerm,
            focusSearchBox: focusSearchBox,
            onKeyDown: _this2.handleKeyDown
          });
        })
      );
    }
  }]);

  return ResultList;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var SearchDropdown_ResultList_ResultList = (ResultList_ResultList);
// CONCATENATED MODULE: ./template/components/SearchDropdown/ResultList/index.js





function ResultList_mapStateToProps(state) {
  return {
    term: getSearchTerm(state)
  };
}

function ResultList_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    setSearchTerm: actions_setSearchTerm
  }, dispatch);
}

/* harmony default export */ var SearchDropdown_ResultList = (Object(esfrom_dll_reference_vendor["connect"])(ResultList_mapStateToProps, ResultList_mapDispatchToProps)(SearchDropdown_ResultList_ResultList));
// CONCATENATED MODULE: ./template/components/SearchDropdown/SearchDropdown.js











var SearchDropdown_SearchDropdown = function (_Component) {
  inherits_default()(SearchDropdown, _Component);

  function SearchDropdown() {
    classCallCheck_default()(this, SearchDropdown);

    return possibleConstructorReturn_default()(this, (SearchDropdown.__proto__ || get_prototype_of_default()(SearchDropdown)).apply(this, arguments));
  }

  createClass_default()(SearchDropdown, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          recentSearches = _props.recentSearches,
          suggestions = _props.suggestions;

      if (!recentSearches.length && !suggestions.length) return null;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: SearchDropdown_default.a.container },
        suggestions.length ? this.renderSuggestions() : this.renderSearches()
      );
    }
  }, {
    key: "renderSuggestions",
    value: function renderSuggestions() {
      return reactfrom_dll_reference_vendor_default.a.createElement(SearchDropdown_ResultList, {
        items: this.props.suggestions,
        focusSearchBox: this.props.focusSearchBox,
        listRef: this.props.listRef
      });
    }
  }, {
    key: "renderSearches",
    value: function renderSearches() {
      var _props2 = this.props,
          recentSearches = _props2.recentSearches,
          formatTranslation = _props2.formatTranslation,
          clearRecentSearches = _props2.clearRecentSearches,
          focusSearchBox = _props2.focusSearchBox;

      // normalise searches to be the same format as suggestions

      var searches = recentSearches.map(function (searchTerm) {
        return { searchTerm: searchTerm };
      });

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          { className: SearchDropdown_default.a.recentSearchesHeader },
          formatTranslation("SearchBar.RecentSearches")
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "button",
          {
            className: SearchDropdown_default.a.recentSearchesClear,
            "aria-label": formatTranslation("SearchBar.ClearRecentSearchesLabel"),
            onClick: function onClick() {
              clearRecentSearches();
              focusSearchBox();
            },
            "data-testid": "clear-recent-searches"
          },
          formatTranslation("SearchBar.ClearRecentSearchesText")
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(SearchDropdown_ResultList, {
          items: searches,
          focusSearchBox: focusSearchBox,
          listRef: this.props.listRef
        })
      );
    }
  }]);

  return SearchDropdown;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_SearchDropdown_SearchDropdown = (translation(SearchDropdown_SearchDropdown));
// CONCATENATED MODULE: ./template/components/SearchDropdown/index.js





function SearchDropdown_mapStateToProps(state) {
  return {
    recentSearches: getSearchHistory(state),
    suggestions: getSearchSuggestions(state)
  };
}

function SearchDropdown_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ clearRecentSearches: actions_clearRecentSearches }, dispatch);
}

/* harmony default export */ var template_components_SearchDropdown = (Object(esfrom_dll_reference_vendor["connect"])(SearchDropdown_mapStateToProps, SearchDropdown_mapDispatchToProps)(components_SearchDropdown_SearchDropdown));
// CONCATENATED MODULE: ./template/components/Viewport/withViewport.js







var viewportsPropType = prop_typesfrom_dll_reference_vendor_default.a.oneOf([SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT]);

function withViewport(WrappedComponent) {
  var ComposedComponent = function ComposedComponent(_ref) {
    var _ref$viewable = _ref.viewable,
        viewable = _ref$viewable === undefined ? [] : _ref$viewable,
        viewportCategory = _ref.viewportCategory,
        rest = objectWithoutProperties_default()(_ref, ["viewable", "viewportCategory"]);

    if (!viewable.length || viewable.indexOf(viewportCategory) !== -1) {
      return reactfrom_dll_reference_vendor_default.a.createElement(WrappedComponent, extends_default()({ isVisible: true }, rest));
    }

    return null;
  };

  ComposedComponent.displayName = "withViewport(" + (WrappedComponent.displayName || WrappedComponent.name) + ")";


  function mapStateToProps(state) {
    return {
      viewportCategory: getViewport(state)
    };
  }

  return Object(esfrom_dll_reference_vendor["connect"])(mapStateToProps)(ComposedComponent);
}

/* harmony default export */ var Viewport_withViewport = (withViewport);
// EXTERNAL MODULE: ./template/components/SearchForm/SearchControls/index.css
var SearchForm_SearchControls = __webpack_require__("./template/components/SearchForm/SearchControls/index.css");
var SearchControls_default = /*#__PURE__*/__webpack_require__.n(SearchForm_SearchControls);

// CONCATENATED MODULE: ./template/components/SearchForm/SearchControls/index.js







var SearchControls_cx = bind_default.a.bind(SearchControls_default.a);

var SearchControls_SearchControls = function SearchControls(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    {
      className: SearchControls_cx(SearchControls_default.a.container, defineProperty_default()({}, SearchControls_default.a.container__hidden, !isVisible))
    },
    children
  );
};

/* harmony default export */ var components_SearchForm_SearchControls = (Viewport_withViewport(SearchControls_SearchControls));
// EXTERNAL MODULE: ./template/components/SearchForm/SearchForm.css
var SearchForm_SearchForm = __webpack_require__("./template/components/SearchForm/SearchForm.css");
var SearchForm_default = /*#__PURE__*/__webpack_require__.n(SearchForm_SearchForm);

// CONCATENATED MODULE: ./template/components/SearchForm/SearchForm.js



















var SearchForm_cx = bind_default.a.bind(SearchForm_default.a);

var SEARCH_SUGGESTIONS_DEBOUNCE_INTERVAL = 300;
var MAX_CHARACTER_VALUE_FOR_SEARCH = "150";

var SearchForm_SearchForm_SearchForm = function (_Component) {
  inherits_default()(SearchForm, _Component);

  function SearchForm() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, SearchForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = SearchForm.__proto__ || get_prototype_of_default()(SearchForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (_ref2) {
      var target = _ref2.target;

      _this.changeTerm(target.value);
    }, _this.handleClose = function () {
      _this.props.closeSearch();
      _this.props.setSearchTerm("");

      /* istanbul ignore next */
      if (_this.term) _this.term.value = "";
    }, _this.handleSubmit = function (event) {
      var _this$props = _this.props,
          onSearch = _this$props.onSearch,
          term = _this$props.term,
          closeSearch = _this$props.closeSearch;


      if (term.length === 0) {
        event.preventDefault();
      } else {
        /* istanbul ignore next */
        if (_this.term) {
          _this.term.value = term;
        }

        closeSearch();
        onSearch(term);
      }
    }, _this.handleFocus = /* istanbul ignore next */function () {
      _this.props.openSearch();
    }, _this.handleBlur = function () {
      var _this$props2 = _this.props,
          closeSearch = _this$props2.closeSearch,
          viewport = _this$props2.viewport;

      if (viewport !== SMALL_VIEWPORT) {
        closeSearch();
      }
    }, _this.handleKeyDown = /* istanbul ignore next */function (e) {
      if (e.keyCode === 40) {
        //Down arrow
        _this.listRef.firstElementChild.firstElementChild.focus();
      } else if (e.shiftKey && e.keyCode === 9) {
        //Shift + Tab
        _this.handleBlur();
      }
    }, _this.handleCloseKeyDown = /* istanbul ignore next */function (e) {
      if (e.keyCode === 9) {
        //Tab
        _this.focusSelf();
      }
    }, _this.handleSearchInputBlur = /* istanbul ignore next */function (p, e, ignoreTerm) {
      var _this$props3 = _this.props,
          isSearchResultsPanelOpen = _this$props3.isSearchResultsPanelOpen,
          term = _this$props3.term;

      if (!isSearchResultsPanelOpen && (ignoreTerm || !term)) {
        _this.handleBlur();
      }
    }, _this.handleSearchButtonBlur = /* istanbul ignore next */function () {
      _this.handleSearchInputBlur(null, null, true);
    }, _this.focusSelf = /* istanbul ignore next */function () {
      setTimeout(function () {
        return _this.term.focus();
      }, 0);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(SearchForm, [{
    key: "componentWillReceiveProps",

    /* istanbul ignore next */
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var isVisible = this.props.isVisible;

      var blockScrollStyle = "chrome-hide-overflow";

      if (!isVisible && nextProps.isVisible) {
        typeof document !== "undefined" && document.body.classList.add(blockScrollStyle);
        setTimeout(function () {
          return _this2.term.focus();
        }, 0);
      } else if (isVisible && !nextProps.isVisible) {
        typeof document !== "undefined" && document.body.classList.remove(blockScrollStyle);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.closeSearchOverlay = template_globalEventHandler.addListener(globalEventHandler_events.closeSearchOverlay, this.handleBlur);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.closeSearchOverlay && this.closeSearchOverlay.remove();
    }
  }, {
    key: "changeTerm",
    value: function changeTerm(term) {
      var _props = this.props,
          setSearchTerm = _props.setSearchTerm,
          loadSuggestions = _props.loadSuggestions;


      setSearchTerm(term);

      clearTimeout(this.timer);
      this.timer = setTimeout(loadSuggestions, SEARCH_SUGGESTIONS_DEBOUNCE_INTERVAL);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx5,
          _this3 = this;

      var _props2 = this.props,
          isVisible = _props2.isVisible,
          hasVisibleResults = _props2.hasVisibleResults,
          term = _props2.term,
          formatTranslation = _props2.formatTranslation;


      var buttonClassName = SearchForm_cx(SearchForm_default.a.button, defineProperty_default()({}, SearchForm_default.a.button__active, term));

      var resultsClassName = SearchForm_cx(SearchForm_default.a.results, defineProperty_default()({}, SearchForm_default.a.results__active, hasVisibleResults));

      var containerClassName = SearchForm_cx(SearchForm_default.a.container, defineProperty_default()({}, SearchForm_default.a.container__active, isVisible));

      var backdropClassName = SearchForm_cx(SearchForm_default.a.backdrop, defineProperty_default()({}, SearchForm_default.a.backdrop__active, isVisible));

      var fieldClassName = SearchForm_cx((_cx5 = {}, defineProperty_default()(_cx5, SearchForm_default.a.field, true), defineProperty_default()(_cx5, SearchForm_default.a.field__active, isVisible), _cx5));

      var searchAction = this.props.searchUrl;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          className: SearchForm_default.a.searchContainer,
          onTouchMove: function onTouchMove(event) {
            return event.preventDefault();
          }
        },
        reactfrom_dll_reference_vendor_default.a.createElement("div", {
          className: backdropClassName,
          "aria-hidden": "true",
          onClick: this.handleBlur,
          "data-testid": "search-overlay-shadow"
        }),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "form",
          {
            action: searchAction,
            method: "get",
            onSubmit: this.handleSubmit,
            className: containerClassName,
            "data-testid": "search-form"
          },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: SearchForm_default.a.fieldContainer, "data-testid": "search-field" },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "label",
              { htmlFor: "chrome-search" },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "span",
                { className: SearchForm_default.a.label },
                formatTranslation("SearchBar.Label")
              ),
              reactfrom_dll_reference_vendor_default.a.createElement("input", {
                id: "chrome-search",
                name: "q",
                role: "combobox",
                className: fieldClassName,
                type: "search",
                autoComplete: "off",
                placeholder: formatTranslation("SearchBar.Placeholder"),
                onChange: this.handleChange,
                onFocus: this.handleFocus,
                onKeyDown: this.handleKeyDown,
                onBlur: this.handleSearchInputBlur,
                "data-testid": "search-input",
                ref: /* istanbul ignore next */function ref(c) {
                  return _this3.term = c;
                },
                "aria-autocomplete": "both",
                "aria-controls": "search-results",
                "aria-expanded": hasVisibleResults,
                maxLength: MAX_CHARACTER_VALUE_FOR_SEARCH
              })
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "button",
              {
                className: buttonClassName,
                type: "submit",
                onBlur: this.handleSearchButtonBlur,
                "data-testid": "search-button-inline",
                disabled: term.length === 0
              },
              reactfrom_dll_reference_vendor_default.a.createElement(components_SearchIcon, null)
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "section",
              { className: resultsClassName },
              reactfrom_dll_reference_vendor_default.a.createElement(template_components_SearchDropdown, {
                focusSearchBox: this.focusSelf,
                listRef: /* istanbul ignore next */function listRef(el) {
                  return _this3.listRef = el;
                }
              })
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            components_SearchForm_SearchControls,
            { viewable: [SMALL_VIEWPORT] },
            reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
              height: 50,
              icon: "close",
              onClick: this.handleClose,
              onKeyDown: this.handleCloseKeyDown,
              "aria-label": formatTranslation("Icon.Close")
            })
          )
        )
      );
    }
  }]);

  return SearchForm;
}(reactfrom_dll_reference_vendor["Component"]);

SearchForm_SearchForm_SearchForm.defaultProps = {
  isVisible: false,
  hasVisibleResults: false
};

/* harmony default export */ var components_SearchForm_SearchForm = (translation(SearchForm_SearchForm_SearchForm));
// CONCATENATED MODULE: ./template/components/SearchForm/index.js








function SearchForm_mapStateToProps(state) {
  return {
    isVisible: getVisibility(state),
    hasVisibleResults: getResultVisibility(state),
    viewport: getViewport(state),
    term: getSearchTerm(state),
    isSearchResultsPanelOpen: isSearchResultsPanelOpen(state),
    searchUrl: getSearchUrl(state),
    storeUrl: getDefaultStoreUrl(state)
  };
}

function SearchForm_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    onSearch: actions_submitSearch,
    loadSuggestions: actions_loadSuggestions,
    setSearchTerm: actions_setSearchTerm,
    closeSearch: actions_closeSearch,
    openSearch: actions_openSearch
  }, dispatch);
}

/* harmony default export */ var components_SearchForm = (Object(esfrom_dll_reference_vendor["connect"])(SearchForm_mapStateToProps, SearchForm_mapDispatchToProps)(components_SearchForm_SearchForm));
// EXTERNAL MODULE: ../node_modules/react-transition-group/CSSTransition.js
var CSSTransition = __webpack_require__("../node_modules/react-transition-group/CSSTransition.js");
var CSSTransition_default = /*#__PURE__*/__webpack_require__.n(CSSTransition);

// EXTERNAL MODULE: ./template/components/IconNotification/index.css
var components_IconNotification = __webpack_require__("./template/components/IconNotification/index.css");
var IconNotification_default = /*#__PURE__*/__webpack_require__.n(components_IconNotification);

// CONCATENATED MODULE: ./template/components/IconNotification/index.js



var IconNotification_IconNotification = function IconNotification() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "span",
    { className: IconNotification_default.a.notification, "aria-label": "You have one notification" },
    "1"
  );
};

/* harmony default export */ var template_components_IconNotification = (IconNotification_IconNotification);
// EXTERNAL MODULE: ./template/components/Widgets/Widget/index.css
var Widgets_Widget = __webpack_require__("./template/components/Widgets/Widget/index.css");
var Widget_default = /*#__PURE__*/__webpack_require__.n(Widgets_Widget);

// CONCATENATED MODULE: ./template/components/Widgets/Widget/index.js







var Widget_cx = bind_default.a.bind(Widget_default.a);

var Widget_Widget = function Widget(_ref) {
  var style = _ref.style,
      children = _ref.children,
      isVisible = _ref.isVisible,
      className = _ref.className;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    {
      style: style,
      className: Widget_cx(Widget_default.a.container, className, defineProperty_default()({}, Widget_default.a.container__hidden, !isVisible))
    },
    children
  );
};

/* harmony default export */ var components_Widgets_Widget = (Viewport_withViewport(Widget_Widget));
// EXTERNAL MODULE: ./template/components/Widgets/Widgets.css
var Widgets_Widgets = __webpack_require__("./template/components/Widgets/Widgets.css");
var Widgets_default = /*#__PURE__*/__webpack_require__.n(Widgets_Widgets);

// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("../node_modules/babel-runtime/helpers/slicedToArray.js");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ../node_modules/lodash/debounce.js
var lodash_debounce = __webpack_require__("../node_modules/lodash/debounce.js");
var debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./helpers/gesture.js

/*

https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10511224/

Edge browser running on a device with touch capability (such as Surface tablet) currently fires mouseover, mouseout, mouseover, click, and mouseout events when you tap.

If you have a component that reacts to both tap and hover events (e.g., onMouseEnter, onMouseLeave), then you're going to need to filter out the additional mouse events to ensure the expected behaviour for tap on Edge + Surface.

*/



var eventList = [];

var processEvents = debounce_default()(function () {
  var validEvent = eventList.find(function (_ref) {
    var _ref2 = slicedToArray_default()(_ref, 1),
        type = _ref2[0].type;

    return type === "click";
  }) || eventList[0];

  var _validEvent = slicedToArray_default()(validEvent, 2),
      e = _validEvent[0],
      callbackFn = _validEvent[1];

  callbackFn(e);

  eventList = [];
}, 1);

/* will call callbackFn with e if it thinks e is a valid event and not a multi gesture variant */
var gesture_validate = function validate(e, callbackFn) {
  eventList.push([e.nativeEvent || e, callbackFn]);
  processEvents();
};
// EXTERNAL MODULE: ./template/components/Dropdown/index.css
var components_Dropdown = __webpack_require__("./template/components/Dropdown/index.css");
var Dropdown_default = /*#__PURE__*/__webpack_require__.n(components_Dropdown);

// CONCATENATED MODULE: ./helpers/accessibility.js
var accessibility_tabIndex = function tabIndex() {
  var focusable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return focusable ? 0 : -1;
};
// CONCATENATED MODULE: ./template/components/Dropdown/Dropdown.js






/* eslint-disable jsx-a11y/no-static-element-interactions */










var Dropdown_cx = bind_default.a.bind(Dropdown_default.a);
var ESCAPE_KEY = 27;
var ENTER_KEY = 13;
var keyCode = function keyCode(e) {
  return e.keyCode || e.which;
};

var Dropdown_Dropdown = function (_Component) {
  inherits_default()(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Dropdown.__proto__ || get_prototype_of_default()(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.onClick = function (e) {
      return gesture_validate(e, _this.props.open);
    }, _this.onMouseEnter = function (e) {
      return gesture_validate(e, _this.props.open);
    }, _this.onMouseLeave = function (e) {
      return gesture_validate(e, _this.props.onCloseWithMouse);
    }, _this.closeWithMouse = function (e) {
      e.stopPropagation();
      gesture_validate(e, _this.props.onCloseWithMouse);
    }, _this.handleKeyDown = function (e) {
      if (keyCode(e) === ESCAPE_KEY) {
        _this.props.onCloseWithKeyboard(e);
      }
    }, _this.handleEnterKeyDown = function (e) {
      if (keyCode(e) === ENTER_KEY) {
        _this.props.onCloseWithKeyboard(e);
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Dropdown, [{
    key: "componentWillReceiveProps",

    /*
      If the Dropdown is conditionally rendered, it may not animate if rendered and opened in the same frame. Using a setTimeout fixes this issue by queuing the enter transition for the next phase.
    */
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!this.props.isOpen && nextProps.isOpen) {
        setTimeout(function () {
          _this2.setState({
            isOpen: true
          });
        }, 0);
      }
      if (!nextProps.isOpen) {
        this.setState({
          isOpen: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this3 = this;

      var _props = this.props,
          body = _props.body,
          children = _props.children,
          footer = _props.footer,
          formatTranslation = _props.formatTranslation,
          header = _props.header,
          isHidden = _props.isHidden,
          isKeyboardAccessible = _props.isKeyboardAccessible,
          isOpen = _props.isOpen,
          name = _props.name,
          _onTransitionEnd = _props.onTransitionEnd;


      var wrapperClassnames = Dropdown_cx(Dropdown_default.a.wrapper, (_cx = {}, defineProperty_default()(_cx, Dropdown_default.a.wrapper__open, this.state.isOpen), defineProperty_default()(_cx, Dropdown_default.a.wrapper__hidden, isHidden), _cx));

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          id: name + "Dropdown",
          className: wrapperClassnames,
          onClick: this.onClick,
          onMouseEnter: this.onMouseEnter,
          onMouseLeave: this.onMouseLeave,
          onKeyDown: this.handleKeyDown,
          role: "presentation"
        },
        children,
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: Dropdown_default.a.outerWrapper,
            "data-testid": name.toLowerCase() + "-dropdown",
            id: name.toLowerCase() + "-dropdown"
          },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Dropdown_default.a.innerWrapper },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              {
                className: Dropdown_default.a.slidedown,
                onTransitionEnd: function onTransitionEnd() {
                  if (!isOpen) {
                    _this3.body.scrollTop = 0;
                    _onTransitionEnd();
                  }
                }
              },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                { className: Dropdown_default.a.header },
                header && reactfrom_dll_reference_vendor_default.a.cloneElement(header, { focusable: isOpen }),
                reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
                  icon: "close",
                  onClick: this.closeWithMouse,
                  onKeyDown: this.handleEnterKeyDown,
                  className: Dropdown_default.a.close,
                  tabIndex: accessibility_tabIndex(isKeyboardAccessible && isOpen),
                  "data-testid": name.toLowerCase() + "-close-btn",
                  "aria-label": formatTranslation("Icon.Close")
                })
              ),
              reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                { className: Dropdown_default.a.body, ref: function ref(el) {
                    return _this3.body = el;
                  } },
                body && reactfrom_dll_reference_vendor_default.a.cloneElement(body, {
                  focusable: isOpen,
                  queryParams: { nlid: "nav header" }
                })
              ),
              footer && reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                { className: Dropdown_default.a.footer },
                reactfrom_dll_reference_vendor_default.a.cloneElement(footer, { focusable: isOpen })
              )
            )
          )
        )
      );
    }
  }]);

  return Dropdown;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Dropdown_Dropdown = (translation(Dropdown_Dropdown));
// CONCATENATED MODULE: ./template/components/ClickOutside/index.js








var ClickOutside_ClickOutside = function (_Component) {
  inherits_default()(ClickOutside, _Component);

  function ClickOutside() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, ClickOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ClickOutside.__proto__ || get_prototype_of_default()(ClickOutside)).call.apply(_ref, [this].concat(args))), _this), _this.handler = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          callback = _this$props.callback;


      if (!_this.el || disabled) {
        return;
      }

      var el = _this.el;
      var target = e.target;


      if (target === el || el.contains(target)) {
        return;
      }

      callback(e);

      if (_this.validPropagationTargets.find(function (t) {
        return t && t.contains(target);
      })) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(ClickOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("click", this.handler, true);
      document.addEventListener("touchend", this.handler, true);
      this.validPropagationTargets = (this.props.validPropagationTargets || []).map(function (selector) {
        return document.querySelector(selector);
      }).filter(function (v) {
        return v;
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("click", this.handler);
      document.removeEventListener("touchend", this.handler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          ref: function ref(el) {
            _this2.el = el;
          }
        },
        this.props.children
      );
    }
  }]);

  return ClickOutside;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_ClickOutside = (ClickOutside_ClickOutside);
// CONCATENATED MODULE: ./template/components/TabOutside/index.js








var TAB_KEY = 9;

var TabOutside_TabOutside = function (_Component) {
  inherits_default()(TabOutside, _Component);

  function TabOutside() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, TabOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = TabOutside.__proto__ || get_prototype_of_default()(TabOutside)).call.apply(_ref, [this].concat(args))), _this), _this.handler = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          callback = _this$props.callback;


      if (disabled) {
        return;
      }

      var el = _this.el;
      var target = e.target;

      var key = e.keyCode || e.which;

      if (key !== TAB_KEY) {
        return;
      }

      if (target === el || el.contains(target)) {
        return;
      }

      callback(e);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(TabOutside, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handler, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handler);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          ref: function ref(el) {
            _this2.el = el;
          }
        },
        this.props.children
      );
    }
  }]);

  return TabOutside;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_TabOutside = (TabOutside_TabOutside);
// CONCATENATED MODULE: ./template/components/Dropdown/DropdownContainer.js






var returnFocusToWidgetIcon = function returnFocusToWidgetIcon(e) {
  e.preventDefault();
  var focusTarget = document.getElementById("accountIcon");
  return focusTarget && focusTarget.focus();
};

var DropdownContainer_DropdownContainer = function DropdownContainer(_ref) {
  var body = _ref.body,
      children = _ref.children,
      close = _ref.close,
      footer = _ref.footer,
      header = _ref.header,
      isHidden = _ref.isHidden,
      isOpen = _ref.isOpen,
      name = _ref.name,
      open = _ref.open,
      openComplete = _ref.openComplete,
      closed = _ref.closed,
      isKeyboardAccessible = _ref.isKeyboardAccessible;

  return reactfrom_dll_reference_vendor_default.a.createElement(
    components_TabOutside,
    { disabled: !isOpen, callback: close },
    reactfrom_dll_reference_vendor_default.a.createElement(
      components_ClickOutside,
      {
        disabled: !isOpen,
        callback: close,
        validPropagationTargets: ["#chrome-header", "#chrome-breadcrumb"]
      },
      reactfrom_dll_reference_vendor_default.a.createElement(
        components_Dropdown_Dropdown,
        {
          name: name,
          isOpen: isOpen,
          isHidden: isHidden,
          open: open,
          openComplete: openComplete,
          onCloseWithMouse: close,
          onCloseWithKeyboard: function onCloseWithKeyboard(e) {
            close();
            returnFocusToWidgetIcon(e);
          },
          header: header,
          body: body,
          footer: footer,
          onTransitionEnd: closed,
          isKeyboardAccessible: isKeyboardAccessible
        },
        children
      )
    )
  );
};

DropdownContainer_DropdownContainer.defaultProps = {
  closed: prop_typesfrom_dll_reference_vendor_default.a.func,
  isKeyboardAccessible: true
};

/* harmony default export */ var Dropdown_DropdownContainer = (DropdownContainer_DropdownContainer);
// CONCATENATED MODULE: ./template/state/modules/dropdown/constants.js
var OPEN_DROPDOWN = "OPEN_DROPDOWN";
var OPEN_COMPLETE = "OPEN_COMPLETE";
var CLOSE_DROPDOWN = "CLOSE_DROPDOWN";
var MY_ACCOUNT = "myAccount";
var MINIBAG = "miniBag";
var DROPDOWN_NAMES = [MY_ACCOUNT, MINIBAG];
var DROPDOWN_CLOSED = "DROPDOWN_CLOSED";
// CONCATENATED MODULE: ./template/state/modules/dropdown/actions.js


var actions_openDropdown = function openDropdown(name) {
  return { type: OPEN_DROPDOWN, name: name };
};

var actions_openComplete = function openComplete(name) {
  return { type: OPEN_COMPLETE, name: name };
};

var actions_closeDropdown = function closeDropdown(name) {
  return { type: CLOSE_DROPDOWN, name: name };
};

var actions_dropdownClosed = function dropdownClosed(name) {
  return { type: DROPDOWN_CLOSED, name: name };
};
// CONCATENATED MODULE: ./template/state/modules/dropdown/selectors.js
var getDropdownIsOpen = function getDropdownIsOpen(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].isOpen;
};

var getDropdownIsHidden = function getDropdownIsHidden(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].isHidden;
};

var getDropdownProgrammatic = function getDropdownProgrammatic(state, props) {
  return state.dropdown[props.name] && state.dropdown[props.name].programmatic;
};
// CONCATENATED MODULE: ./template/state/modules/dropdown/index.js







var initDropdownStates = function initDropdownStates(dropdownNames) {
  return dropdownNames.reduce(function (dropdowns, name) {
    dropdowns[name] = {
      isOpen: false
    };
    return dropdowns;
  }, {});
};

var dropdown_initialState = initDropdownStates(DROPDOWN_NAMES);

/* harmony default export */ var dropdown = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dropdown_initialState;
  var action = arguments[1];

  switch (action.type) {
    case OPEN_DROPDOWN:
      {
        var dropdownToggles = DROPDOWN_NAMES.reduce(function (dropdowns, name) {
          dropdowns[name] = name === action.name ? { isOpen: true, programmatic: action.programmatic } : { isOpen: false, isHidden: true };
          return dropdowns;
        }, {});

        return extends_default()({}, state, dropdownToggles);
      }
    case CLOSE_DROPDOWN:
      return extends_default()({}, state, defineProperty_default()({}, action.name, { isOpen: false }));
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/Dropdown/index.js




var Dropdown_mapStateToProps = function mapStateToProps(state, props) {
  return {
    isOpen: getDropdownIsOpen(state, props),
    isHidden: getDropdownIsHidden(state, props)
  };
};

var Dropdown_mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var name = _ref.name;
  return {
    open: function open() {
      return dispatch(actions_openDropdown(name));
    },
    close: function close() {
      return dispatch(actions_closeDropdown(name));
    },
    closed: function closed() {
      return dispatch(actions_dropdownClosed(name));
    }
  };
};

/* harmony default export */ var template_components_Dropdown = (Object(esfrom_dll_reference_vendor["connect"])(Dropdown_mapStateToProps, Dropdown_mapDispatchToProps)(Dropdown_DropdownContainer));
// EXTERNAL MODULE: ./template/components/Greeter/index.css
var components_Greeter = __webpack_require__("./template/components/Greeter/index.css");
var Greeter_default = /*#__PURE__*/__webpack_require__.n(components_Greeter);

// EXTERNAL MODULE: ./template/components/Spinner/index.css
var components_Spinner = __webpack_require__("./template/components/Spinner/index.css");
var Spinner_default = /*#__PURE__*/__webpack_require__.n(components_Spinner);

// CONCATENATED MODULE: ./template/components/Spinner/index.js





var Spinner_Spinner = function Spinner(_ref) {
  var size = _ref.size,
      position = _ref.position;
  return reactfrom_dll_reference_vendor_default.a.createElement("div", { className: classnamesfrom_dll_reference_vendor_default()(Spinner_default.a.spinner, Spinner_default.a[size], Spinner_default.a[position]) });
};

Spinner_Spinner.defaultProps = {
  size: "small",
  position: "default"
};

/* harmony default export */ var template_components_Spinner = (Spinner_Spinner);
// EXTERNAL MODULE: ./template/components/Button/index.css
var components_Button = __webpack_require__("./template/components/Button/index.css");
var Button_default = /*#__PURE__*/__webpack_require__.n(components_Button);

// CONCATENATED MODULE: ./template/components/Button/index.js








var Button_cx = bind_default.a.bind(Button_default.a);

var Button_Button = function Button(_ref) {
  var children = _ref.children,
      hasInvertedSize = _ref.hasInvertedSize,
      hasSpinner = _ref.hasSpinner,
      href = _ref.href,
      theme = _ref.theme,
      type = _ref.type,
      rest = objectWithoutProperties_default()(_ref, ["children", "hasInvertedSize", "hasSpinner", "href", "theme", "type"]);

  var tag = href ? "a" : "button";
  var className = Button_cx("button", {
    button__hasInvertedSize: hasInvertedSize,
    button__isPrimary: theme === "primary",
    button__isSecondary: theme === "secondary",
    button__isTertiary: theme === "tertiary",
    button__isGreen: theme === "green"
  });

  var content = reactfrom_dll_reference_vendor_default.a.createElement(
    reactfrom_dll_reference_vendor["Fragment"],
    null,
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      {
        className: Button_cx("content", {
          content__isHidden: hasSpinner
        })
      },
      children
    ),
    hasSpinner && reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Button_default.a.spinner },
      reactfrom_dll_reference_vendor_default.a.createElement(template_components_Spinner, { size: "small" })
    )
  );

  return reactfrom_dll_reference_vendor_default.a.createElement(tag, extends_default()({}, rest, { className: className, href: href, type: type }), content);
};

Button_Button.defaultProps = {
  type: "button"
};

/* harmony default export */ var template_components_Button = (Button_Button);
// EXTERNAL MODULE: ./template/components/GDPR/Banner/Banner.css
var Banner_Banner = __webpack_require__("./template/components/GDPR/Banner/Banner.css");
var Banner_default = /*#__PURE__*/__webpack_require__.n(Banner_Banner);

// CONCATENATED MODULE: ./template/components/GDPR/Banner/Banner.js















var ANIMATION_INITIAL_WAIT_MS = 800;

var Banner_Banner_Banner = function (_Component) {
  inherits_default()(Banner, _Component);

  function Banner(props) {
    classCallCheck_default()(this, Banner);

    var _this = possibleConstructorReturn_default()(this, (Banner.__proto__ || get_prototype_of_default()(Banner)).call(this, props));

    _this.handleClose = function () {
      var animationDurationMs = parseInt(Banner_default.a.transitionDurationMs, 10);
      _this.setState({ revealBanner: false });
      trackBannerClose();

      setTimeout(function () {
        _this.props.dismissAction();
        _this.setState({ displayBanner: false });
      }, animationDurationMs);
    };

    _this.handleOpen = function () {
      _this.setState({ revealBanner: true });
      trackBannerShown();
    };

    _this.state = {
      displayBanner: true,
      revealBanner: false
    };
    return _this;
  }

  createClass_default()(Banner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(this.handleOpen, ANIMATION_INITIAL_WAIT_MS);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _cx;

      var _props = this.props,
          chooseOptionsAction = _props.chooseOptionsAction,
          firstName = _props.firstName,
          formatTranslation = _props.formatTranslation,
          greeting = _props.greeting,
          hasErrored = _props.hasErrored,
          isLoading = _props.isLoading;


      if (!this.state.displayBanner) {
        return null;
      }

      var greetingText = greeting || formatTranslation("GDPR.Greeting");

      var greetingContent = hasErrored ? formatTranslation("GDPR.GreetingLabelError") : formatTranslation("GDPR.GreetingLabel", {
        name: firstName,
        greeting: greetingText
      });

      var buttonContent = formatTranslation("GDPR.GreetingButton".concat(hasErrored ? "Error" : ""));

      var handleButtonClick = function handleButtonClick() {
        chooseOptionsAction(_this2.handleClose);
      };

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Banner_default.a.wrapper, "data-testid": "gdpr-wrapper-banner-div" },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: classnamesfrom_dll_reference_vendor_default()((_cx = {}, defineProperty_default()(_cx, Banner_default.a.container, true), defineProperty_default()(_cx, Banner_default.a.error, hasErrored), defineProperty_default()(_cx, Banner_default.a.show, this.state.revealBanner), _cx))
          },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Banner_default.a.content, "data-testid": "gdpr-banner-div" },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: Banner_default.a.greeting },
              greetingContent
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: Banner_default.a.cta },
              reactfrom_dll_reference_vendor_default.a.createElement(
                template_components_Button,
                {
                  "data-testid": "gdpr-banner-button",
                  hasSpinner: isLoading,
                  hasInvertedSize: true,
                  theme: "primary",
                  onClick: handleButtonClick
                },
                buttonContent
              )
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
              "aria-label": formatTranslation("Icon.Close"),
              className: Banner_default.a.close,
              icon: "close",
              onClick: this.handleClose
            })
          )
        )
      );
    }
  }]);

  return Banner;
}(reactfrom_dll_reference_vendor["Component"]);

Banner_Banner_Banner.defaultProps = {
  isLoading: false
};


/* harmony default export */ var GDPR_Banner_Banner = (translation(Banner_Banner_Banner));
// CONCATENATED MODULE: ./template/state/modules/user/constants.js
var FAILED = "FAILED";
var FETCHING = "FETCHING";
var LOADING_OPT_IN = "LOADING_OPT_IN";
var LOADING_OPT_OUT = "LOADING_OPT_OUT";
var LOG_IN_USER = "LOG_IN_USER";
var SET_OPT_IN = "SET_OPT_IN";
var SET_OPT_OUT = "SET_OPT_OUT";
var SET_USER_FETCHING_STATUS = "SET_USER_FETCHING_STATUS";
var SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
var SET_USER_PROFILE = "SET_USER_PROFILE";
var SET_USER_RECONSENT_STATUS = "SET_USER_RECONSENT_STATUS";
var SUCCESS = "SUCCESS";
// CONCATENATED MODULE: ./template/state/modules/user/selectors.js



var getUser = function getUser(state) {
  return state.user;
};

var selectors_isLoggedIn = Object(lib["createSelector"])(getUser, function (user) {
  return user.isLoggedIn;
});

var getHasErrors = Object(lib["createSelector"])(getUser, function (user) {
  return user.hasError;
});

var getFirstName = Object(lib["createSelector"])(getUser, function (user) {
  return user.profile.firstName;
});

var getIsOptInLoading = Object(lib["createSelector"])(getUser, function (user) {
  return user.isOptInLoading;
});

var getIsOptOutLoading = Object(lib["createSelector"])(getUser, function (user) {
  return user.isOptOutLoading;
});

var getCustomerGuid = Object(lib["createSelector"])(getUser, function (user) {
  return user.profile.customerGuid;
});

var getIsRecognised = Object(lib["createSelector"])(getUser, function (user) {
  return user.profile.isRecognised;
});

var getCustomerId = Object(lib["createSelector"])(getUser, function (user) {
  return user.profile.customerId;
});

var getHasReconsented = Object(lib["createSelector"])(getUser, function (user) {
  return user.hasReconsented;
});

var getIsReconsentRequired = Object(lib["createSelector"])(getUser, function (user) {
  return user.isReconsentRequired;
});

var getIdentityHasResponded = Object(lib["createSelector"])(getUser, function (user) {
  return [SUCCESS, FAILED].indexOf(user.fetchingStatus) !== -1;
});

var getIsPremier = Object(lib["createSelector"])(getUser, function (user) {
  return !!(user && user.profile && user.profile.subscriptions);
});

var getPreferences = Object(lib["createSelector"])(getUser, function (user) {
  return user.preferences;
});

var getPrivacyUrlSegment = Object(lib["createSelector"])(getUser, function (user) {
  return user.privacyUrlSegment;
});

var getTermsUrlSegment = Object(lib["createSelector"])(getUser, function (user) {
  return user.termsUrlSegment;
});
// CONCATENATED MODULE: ./template/state/modules/user/actions.js






var user_actions__this = this;



var ACCEPTED_PREFERENCE_IDS = ["newness", "promos", "lifestyle", "partner"];

var formatPreferences = function formatPreferences(preferences, isOptOut) {
  return preferences.filter(function (_ref) {
    var id = _ref.preferenceId;
    return ACCEPTED_PREFERENCE_IDS.indexOf(id) !== -1;
  }).map(function (_ref2) {
    var customerChannels = _ref2.customerChannels,
        preferenceId = _ref2.preferenceId;
    return {
      customerChannels: isOptOut ? [] : customerChannels,
      preferenceId: preferenceId
    };
  });
};

var actions_optIn = function optIn() {
  return function () {
    var _ref4 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch, _, _ref3) {
      var api = _ref3.api,
          identity = _ref3.identity;
      var userPreferences, userProfile, preferences, response;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              dispatch({ type: LOADING_OPT_IN });
              _context.next = 4;
              return identity.customer.preferences();

            case 4:
              userPreferences = _context.sent;
              _context.next = 7;
              return identity.customer.profile();

            case 7:
              userProfile = _context.sent;
              preferences = formatPreferences(userPreferences, false);
              _context.next = 11;
              return api.updatePreferences(userProfile.customerGuid, preferences);

            case 11:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              identity.customer.resetLocalCopy();
              dispatch({ type: SET_OPT_IN });
              _context.next = 18;
              break;

            case 17:
              throw new Error(response.statusText);

            case 18:
              _context.next = 23;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](0);

              dispatch({ type: SET_OPT_IN, error: true, payload: _context.t0 });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, user_actions__this, [[0, 20]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var actions_optOut = function optOut() {
  return function () {
    var _ref6 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2(dispatch, _, _ref5) {
      var api = _ref5.api,
          identity = _ref5.identity;
      var userPreferences, userProfile, preferences, response;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              dispatch({ type: LOADING_OPT_OUT });
              _context2.next = 4;
              return identity.customer.preferences();

            case 4:
              userPreferences = _context2.sent;
              _context2.next = 7;
              return identity.customer.profile();

            case 7:
              userProfile = _context2.sent;
              preferences = formatPreferences(userPreferences, true);
              _context2.next = 11;
              return api.updatePreferences(userProfile.customerGuid, preferences);

            case 11:
              response = _context2.sent;

              if (!response.ok) {
                _context2.next = 17;
                break;
              }

              identity.customer.resetLocalCopy();
              dispatch({ type: SET_OPT_OUT });
              _context2.next = 18;
              break;

            case 17:
              throw new Error(response.statusText);

            case 18:
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](0);

              dispatch({ type: SET_OPT_OUT, error: true, payload: _context2.t0 });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, user_actions__this, [[0, 20]]);
    }));

    return function (_x4, _x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var actions_setLoggedInState = function setLoggedInState(loggedInState) {
  return {
    type: LOG_IN_USER,
    payload: loggedInState
  };
};

var actions_setUserProfile = function setUserProfile(profile) {
  return {
    type: SET_USER_PROFILE,
    payload: profile
  };
};

var actions_setUserFetchingState = function setUserFetchingState(status) {
  return {
    type: SET_USER_FETCHING_STATUS,
    payload: status
  };
};

var actions_setUserReconsentStatus = function setUserReconsentStatus(status) {
  return {
    type: SET_USER_RECONSENT_STATUS,
    payload: status
  };
};

var actions_setUserPreferences = function setUserPreferences() {
  return function () {
    var _ref8 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3(dispatch, getState, _ref7) {
      var api = _ref7.api,
          identity = _ref7.identity;

      var serviceId, _getState, regionalStore, userPreferencesPromise, systemPreferencesPromise, _ref9, _ref10, userPreferences, systemPreferences, service, mergedPreferences;

      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              serviceId = "marketing";
              _getState = getState(), regionalStore = _getState.regionalStore;
              userPreferencesPromise = identity.customer.preferences();
              systemPreferencesPromise = api.fetchPreferences(regionalStore.countryCode, regionalStore.defaultLanguage);
              _context3.next = 7;
              return promise_default.a.all([userPreferencesPromise, systemPreferencesPromise]);

            case 7:
              _ref9 = _context3.sent;
              _ref10 = slicedToArray_default()(_ref9, 2);
              userPreferences = _ref10[0];
              systemPreferences = _ref10[1];
              service = systemPreferences.services.find(function (service) {
                return service.serviceId == serviceId;
              });
              mergedPreferences = service.preferences.map(function (systemPreference) {
                var preference = userPreferences.find(function (userPreference) {
                  return userPreference.preferenceId == systemPreference.preferenceId;
                });

                return extends_default()({}, systemPreference, preference);
              });


              service.preferences = mergedPreferences;

              return _context3.abrupt("return", dispatch({ type: SET_USER_PREFERENCES, payload: service }));

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](0);

              dispatch({
                error: true,
                payload: _context3.t0,
                type: SET_USER_PREFERENCES
              });

              throw _context3.t0;

            case 21:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, user_actions__this, [[0, 17]]);
    }));

    return function (_x7, _x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }();
};
// CONCATENATED MODULE: ./template/state/modules/user/index.js







var user_initialState = {
  fetchingStatus: null,
  isLoggedIn: false,
  isReconsentRequired: false,
  preferences: [],
  profile: {}
};

/* harmony default export */ var modules_user = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_initialState;
  var action = arguments[1];

  switch (action.type) {
    case LOADING_OPT_IN:
      return extends_default()({}, state, {
        isOptInLoading: true
      });
    case LOADING_OPT_OUT:
      return extends_default()({}, state, {
        isOptOutLoading: true
      });
    case LOG_IN_USER:
      return extends_default()({}, state, {
        isLoggedIn: action.payload
      });
    case SET_USER_PROFILE:
      return extends_default()({}, state, {
        profile: action.payload
      });
    case SET_USER_FETCHING_STATUS:
      return extends_default()({}, state, {
        fetchingStatus: action.payload
      });
    case SET_USER_RECONSENT_STATUS:
      return extends_default()({}, state, {
        isReconsentRequired: action.payload
      });
    case SET_USER_PREFERENCES:
      return extends_default()({}, state, {
        preferences: action.payload.preferences,
        privacyUrlSegment: action.payload.privacyPolicyUrlSegment,
        termsUrlSegment: action.payload.termsConditionsUrlSegment
      });
    case SET_OPT_IN:
      return extends_default()({}, state, {
        hasError: !!action.error,
        hasReconsented: action.error ? null : true,
        isOptInLoading: false,
        isReconsentRequired: !!action.error
      });
    case SET_OPT_OUT:
      return extends_default()({}, state, {
        hasError: !!action.error,
        hasReconsented: action.error ? null : false,
        isOptOutLoading: false,
        isReconsentRequired: !!action.error
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/GDPR/Banner/index.js





function Banner_mapStateToProps(state) {
  return {
    firstName: getFirstName(state)
  };
}

/* harmony default export */ var GDPR_Banner = (Object(esfrom_dll_reference_vendor["connect"])(Banner_mapStateToProps)(GDPR_Banner_Banner));
// CONCATENATED MODULE: ./template/helpers/pageInfoProvider.js
var SITE_SECTIONS = {
  bag: "bag",
  category: "category",
  creative: "creative",
  homepage: "homepage",
  product: "product",
  savedItems: "saved-items",
  search: "search"
};

var getPageInfo = function getPageInfo() {
  var page = {
    section: "",
    gender: ""
  };
  if (typeof window !== "undefined" && window.location && window.location.pathname) {
    var path = window.location.pathname.toLowerCase().replace(/\/$/, "");
    if (path === "" || path === "/fr" || path === "/it" || path === "/de" || path === "/us" || path === "/au" || path === "/es" || path === "/ru") {
      page.section = SITE_SECTIONS.homepage;
    } else if (path.search(/\/search\//) > -1) {
      page.section = SITE_SECTIONS.search;
    } else if (path.match(/\/cat$/)) {
      page.section = SITE_SECTIONS.category;
    } else if (path.match(/\/prd\/[0-9]+$/) || path.match(/\/grp\/[0-9]+$/)) {
      page.section = SITE_SECTIONS.product;
    } else if (path.match(/\/women$/) || path.match(/\/donna$/) || path.match(/\/mujer$/) || path.match(/\/damen$/) || path.match(/\/femme$/)) {
      page.section = SITE_SECTIONS.homepage;
      page.gender = "women";
    } else if (path.match(/\/men$/) || path.match(/\/uomo$/) || path.match(/\/hombre$/) || path.match(/\/herren$/) || path.match(/\/homme$/)) {
      page.section = SITE_SECTIONS.homepage;
      page.gender = "men";
    } else if (path.match(/\/saved-items$/)) {
      page.section = SITE_SECTIONS.savedItems;
    } else if (path.match(/\/bag$/)) {
      page.section = SITE_SECTIONS.bag;
    } else {
      page.section = SITE_SECTIONS.creative;
    }
  }
  return page;
};
// CONCATENATED MODULE: ./template/state/modules/analytics/actions.js






var actions_buildBasicPayload = function buildBasicPayload() {
  return function (dispatch, getState) {
    var state = getState();

    var _getPageInfo = getPageInfo(),
        section = _getPageInfo.section;

    return {
      countryCode: getCountryCode(state),
      currency: selectors_getCurrency(state),
      customerID: getCustomerId(state),
      language: getDefaultLanguage(state),
      pageName: "",
      pageTitle: "",
      pageType: section,
      platform: selectors_getPlatform(state),
      premierUser: getIsPremier(state),
      recognizedUser: getIsRecognised(state),
      storeCode: selectors_getStoreCode(state),
      storeID: getSiteId(state),
      trackingFrequency: "always"
    };
  };
};
// EXTERNAL MODULE: ./template/components/GDPR/Confirmation/Confirmation.css
var Confirmation = __webpack_require__("./template/components/GDPR/Confirmation/Confirmation.css");
var Confirmation_default = /*#__PURE__*/__webpack_require__.n(Confirmation);

// CONCATENATED MODULE: ./template/components/GDPR/Confirmation/Confirmation.js
















var Confirmation_cx = bind_default.a.bind(Confirmation_default.a);

var Confirmation_ConfirmationSuccess = function (_Component) {
  inherits_default()(ConfirmationSuccess, _Component);

  function ConfirmationSuccess() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, ConfirmationSuccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ConfirmationSuccess.__proto__ || get_prototype_of_default()(ConfirmationSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var onClose = _this.props.onClose;


      onClose();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(ConfirmationSuccess, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          buildBasicPayload = _props.buildBasicPayload,
          isOptedIn = _props.isOptedIn;

      var details = buildBasicPayload();
      if (isOptedIn) {
        events_trackGdprKeepSending(details);
      } else {
        events_trackGdprStopSending(details);
      }
    }
  }, {
    key: "buildMyAccountURL",
    value: function buildMyAccountURL() {
      var _props2 = this.props,
          countryCode = _props2.countryCode,
          ctaRef = _props2.ctaRef,
          keyStoreDataversion = _props2.keyStoreDataversion,
          lang = _props2.lang,
          storeCode = _props2.storeCode;


      var params = Object(querystring_es3["stringify"])({
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion,
        ctaRef: ctaRef
      });

      return [externalLinks_getMyAccountBaseUrl() + "/contact-preferences", params].join("?");
    }
  }, {
    key: "getLabel",
    value: function getLabel(label) {
      var _props3 = this.props,
          formatTranslation = _props3.formatTranslation,
          isOptedIn = _props3.isOptedIn;

      var optInLabel = isOptedIn ? "In" : "Out";

      return formatTranslation("GDPR." + optInLabel + "Confirmation" + label);
    }
  }, {
    key: "render",
    value: function render() {
      var _props4 = this.props,
          formatTranslation = _props4.formatTranslation,
          isOptedIn = _props4.isOptedIn;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "section",
        {
          className: Confirmation_cx("container", {
            container__isIn: isOptedIn
          })
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "h1",
          { className: Confirmation_default.a.heading, "data-testid": "gdpr-confirmation-heading" },
          this.getLabel("Heading")
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "p",
          { className: Confirmation_default.a.body, "data-testid": "gdpr-confirmation-body" },
          this.getLabel("Body")
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: Confirmation_default.a.actions },
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Button,
            { theme: "primary", onClick: this.handleClick },
            formatTranslation("GDPR.ShoppingButton")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Button,
            { theme: "secondary", href: this.buildMyAccountURL() },
            formatTranslation("GDPR.PreferencesButton")
          )
        )
      );
    }
  }]);

  return ConfirmationSuccess;
}(reactfrom_dll_reference_vendor["Component"]);

Confirmation_ConfirmationSuccess.defaultProps = {
  isOptedIn: false
};

/* harmony default export */ var Confirmation_Confirmation = (translation(Confirmation_ConfirmationSuccess));
// CONCATENATED MODULE: ./template/components/GDPR/Confirmation/index.js





var Confirmation_mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    storeCode: selectors_getStoreCode(state)
  };
};

var Confirmation_mapDispatchToProps = {
  buildBasicPayload: actions_buildBasicPayload
};

/* harmony default export */ var GDPR_Confirmation = (Object(esfrom_dll_reference_vendor["connect"])(Confirmation_mapStateToProps, Confirmation_mapDispatchToProps)(Confirmation_Confirmation));
// EXTERNAL MODULE: ./template/components/GDPR/Option/Option.css
var Option_Option = __webpack_require__("./template/components/GDPR/Option/Option.css");
var Option_default = /*#__PURE__*/__webpack_require__.n(Option_Option);

// CONCATENATED MODULE: ./template/components/GDPR/Option/Option.js





var Option_cx = bind_default.a.bind(Option_default.a);

var Option_Option_Option = function Option(_ref) {
  var name = _ref.name,
      isSelected = _ref.isSelected,
      src = _ref.src;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    {
      className: Option_cx("container", {
        optedOut: !isSelected
      })
    },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: Option_default.a.wrapper },
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        className: Option_default.a.image,
        style: { backgroundImage: "url(" + src + ")" }
      })
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Option_default.a.name },
      name
    )
  );
};

/* harmony default export */ var GDPR_Option_Option = (Option_Option_Option);
// CONCATENATED MODULE: ./template/components/GDPR/Option/index.js


/* harmony default export */ var GDPR_Option = (GDPR_Option_Option);
// EXTERNAL MODULE: ./template/components/GDPR/ContactPreferences/ContactPreferences.css
var ContactPreferences_ContactPreferences = __webpack_require__("./template/components/GDPR/ContactPreferences/ContactPreferences.css");
var ContactPreferences_default = /*#__PURE__*/__webpack_require__.n(ContactPreferences_ContactPreferences);

// CONCATENATED MODULE: ./template/components/GDPR/ContactPreferences/ContactPreferences.js















var ContactPreferences_ContactPreferences_ContactPreferences = function (_Component) {
  inherits_default()(ContactPreferences, _Component);

  function ContactPreferences() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, ContactPreferences);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = ContactPreferences.__proto__ || get_prototype_of_default()(ContactPreferences)).call.apply(_ref, [this].concat(args))), _this), _this.handleInClick = function () {
      var optIn = _this.props.optIn;


      optIn();
    }, _this.handleOutClick = function () {
      var optOut = _this.props.optOut;


      optOut();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(ContactPreferences, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var buildBasicPayload = this.props.buildBasicPayload;


      events_trackOpenGdprModal(buildBasicPayload());
    }
  }, {
    key: "buildMyAccountURL",
    value: function buildMyAccountURL() {
      var _props = this.props,
          countryCode = _props.countryCode,
          ctaRef = _props.ctaRef,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          storeCode = _props.storeCode;


      var params = Object(querystring_es3["stringify"])({
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion,
        ctaRef: ctaRef
      });

      return [externalLinks_getMyAccountBaseUrl() + "/contact-preferences", params].join("?");
    }
  }, {
    key: "getTitleSubtitle",
    value: function getTitleSubtitle() {
      var _props2 = this.props,
          firstName = _props2.firstName,
          formatTranslation = _props2.formatTranslation,
          gdprDeadlineCopyFeature = _props2.gdprDeadlineCopyFeature;


      var path = "GDPR.ContactPreferences" + (gdprDeadlineCopyFeature ? ".Deadline" : "");

      return {
        title: formatTranslation(path + ".Header", { name: firstName }),
        subtitle: formatTranslation(path + ".Description")
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          ctaRef = _props3.ctaRef,
          formatTranslation = _props3.formatTranslation,
          gdprDeadlineCopyFeature = _props3.gdprDeadlineCopyFeature,
          hasError = _props3.hasError,
          isLoggedIn = _props3.isLoggedIn,
          isOptInLoading = _props3.isOptInLoading,
          isOptOutLoading = _props3.isOptOutLoading,
          preferences = _props3.preferences,
          privacyUrlSegment = _props3.privacyUrlSegment,
          testContent = _props3.testContent,
          termsUrlSegment = _props3.termsUrlSegment;


      var translate = function translate(key) {
        return formatTranslation("GDPR.ContactPreferences." + key);
      };

      var _ref2 = testContent ? testContent : this.getTitleSubtitle(),
          title = _ref2.title,
          subtitle = _ref2.subtitle;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: ContactPreferences_default.a.container },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "h1",
          { className: ContactPreferences_default.a.header },
          title
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "p",
          { className: ContactPreferences_default.a.body },
          subtitle
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: ContactPreferences_default.a.optionListWrapper },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "ul",
            { className: ContactPreferences_default.a.optionList },
            preferences.map(function (preference) {
              return reactfrom_dll_reference_vendor_default.a.createElement(GDPR_Option, {
                key: preference.preferenceId,
                name: preference.title,
                src: preference.imageUrl,
                isSelected: !!preference.customerChannels.length
              });
            })
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "p",
          { className: ContactPreferences_default.a.small },
          translate("Channels")
        ),
        hasError && reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: ContactPreferences_default.a.errorWrapper },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: ContactPreferences_default.a.errorMessage },
            formatTranslation("GDPR.GreetingLabelError")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: ContactPreferences_default.a.cta },
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Button,
            {
              "data-testid": "gdpr-modal-keep-button",
              theme: "primary",
              hasSpinner: isOptInLoading,
              onClick: this.handleInClick
            },
            translate(gdprDeadlineCopyFeature ? "Deadline.KeepButton" : "KeepButton")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Button,
            {
              "data-testid": "gdpr-modal-myaccount-button",
              theme: "secondary",
              href: this.buildMyAccountURL()
            },
            isLoggedIn ? translate("EditButton") : translate("LoginButton")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Button,
            {
              "data-testid": "gdpr-modal-optout-button",
              theme: "secondary",
              hasSpinner: isOptOutLoading,
              onClick: this.handleOutClick
            },
            translate(gdprDeadlineCopyFeature ? "Deadline.OptOutButton" : "OptOutButton")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "p",
          { className: ContactPreferences_default.a.footer },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            { href: privacyUrlSegment + "?ctaref=" + ctaRef, target: "_blank" },
            translate("PrivacyLink")
          ),
          " & ",
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            { href: termsUrlSegment + "?ctaref=" + ctaRef, target: "_blank" },
            translate("Terms")
          )
        )
      );
    }
  }]);

  return ContactPreferences;
}(reactfrom_dll_reference_vendor["Component"]);

ContactPreferences_ContactPreferences_ContactPreferences.defaultProps = {
  gdprDeadlineCopyFeature: false,
  preferences: []
};

/* harmony default export */ var GDPR_ContactPreferences_ContactPreferences = (translation(ContactPreferences_ContactPreferences_ContactPreferences));
// CONCATENATED MODULE: ./template/state/modules/features/constants.js
var SET_FEATURES = "SET_FEATURES";
// CONCATENATED MODULE: ./template/state/modules/features/actions.js


var actions_setFeatures = function setFeatures(features) {
  return {
    type: SET_FEATURES,
    payload: features
  };
};

var setGlobalFeatureName = function setGlobalFeatureName(testName) {
  /* istanbul ignore else */
  if (typeof window !== "undefined") {
    window.mvtTestName = testName;
  }
};
// CONCATENATED MODULE: ./template/state/modules/features/selectors.js



var getFeaturesStore = function getFeaturesStore(state) {
  return state.features;
};

var getMvt = Object(lib["createSelector"])(getFeaturesStore, function (feature) {
  return feature.mvt;
});

var getFeatures = Object(lib["createSelector"])(getFeaturesStore, function (feature) {
  return feature.features;
});

var selectors_getFlatFeaturesStore = function getFlatFeaturesStore(state) {
  return extends_default()({}, getFeatures(state), getMvt(state));
};

var getFeature = function getFeature(state, key) {
  return selectors_getFlatFeaturesStore(state)[key];
};

var isFeatureActive = function isFeatureActive(state, key) {
  var features = selectors_getFlatFeaturesStore(state);
  var feature = key in features ? features[key] : false;

  return feature;
};

var getFeaturesLoaded = Object(lib["createSelector"])(getFeaturesStore, function (feature) {
  return feature.loadComplete;
});
// CONCATENATED MODULE: ./template/state/modules/features/index.js







var features_initialState = {
  features: {},
  mvt: {},
  loadComplete: false
};

/* harmony default export */ var modules_features = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : features_initialState;
  var action = arguments[1];

  switch (action.type) {
    case SET_FEATURES:
      return extends_default()({}, state, action.payload);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/GDPR/ContactPreferences/index.js







var ContactPreferences_mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state),
    isLoggedIn: selectors_isLoggedIn(state),
    firstName: getFirstName(state),
    gdprDeadlineCopyFeature: getFeature(state, "stc-gdpr-deadline-copy"),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    storeCode: selectors_getStoreCode(state)
  };
};

var ContactPreferences_mapDispatchToProps = {
  buildBasicPayload: actions_buildBasicPayload
};

/* harmony default export */ var GDPR_ContactPreferences = (Object(esfrom_dll_reference_vendor["connect"])(ContactPreferences_mapStateToProps, ContactPreferences_mapDispatchToProps)(GDPR_ContactPreferences_ContactPreferences));
// EXTERNAL MODULE: ./template/components/Modal/Backdrop.css
var Modal_Backdrop = __webpack_require__("./template/components/Modal/Backdrop.css");
var Backdrop_default = /*#__PURE__*/__webpack_require__.n(Modal_Backdrop);

// CONCATENATED MODULE: ./template/components/Modal/Backdrop.js




var Backdrop_Backdrop = function Backdrop(_ref) {
  var children = _ref.children;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: Backdrop_default.a.backdrop },
    children
  );
};

/* harmony default export */ var components_Modal_Backdrop = (Backdrop_Backdrop);
// EXTERNAL MODULE: ./template/components/Modal/Container.css
var Modal_Container = __webpack_require__("./template/components/Modal/Container.css");
var Container_default = /*#__PURE__*/__webpack_require__.n(Modal_Container);

// CONCATENATED MODULE: ./template/components/Modal/Container.js










var Container_Container = function (_Component) {
  inherits_default()(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Container.__proto__ || get_prototype_of_default()(Container)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = /* istanbul ignore next */function (e) {
      var onClose = _this.props.onClose;

      // Escape

      if (e.keyCode === 27) {
        e.preventDefault();
      }

      onClose();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Container, [{
    key: "componentDidMount",


    /* istanbul ignore next */
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handleClose);
    }

    /* istanbul ignore next */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handleClose);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "section",
        { className: Container_default.a.wrapper },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: Container_default.a.container },
          reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
            icon: "close",
            onClick: this.handleClose,
            className: Container_default.a.close
          }),
          children
        )
      );
    }
  }]);

  return Container;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Modal_Container = (Container_Container);
// EXTERNAL MODULE: ./template/components/Modal/Fade.css
var Modal_Fade = __webpack_require__("./template/components/Modal/Fade.css");
var Fade_default = /*#__PURE__*/__webpack_require__.n(Modal_Fade);

// EXTERNAL MODULE: ../node_modules/ua-parser-js/src/ua-parser.js
var ua_parser = __webpack_require__("../node_modules/ua-parser-js/src/ua-parser.js");
var ua_parser_default = /*#__PURE__*/__webpack_require__.n(ua_parser);

// CONCATENATED MODULE: ./helpers/deviceDetection.js




var deviceDetection_getUserAgent = function getUserAgent() {
  return ua_parser_default()(typeof navigator !== "undefined" && navigator.userAgent);
};

var parseUserAgent = function parseUserAgent(agent) {
  return {
    browser: agent.browser.name || "",
    os: agent.os.name || ""
  };
};

var deviceDetection_DeviceDetection = function () {
  function DeviceDetection() {
    classCallCheck_default()(this, DeviceDetection);

    var _parseUserAgent = parseUserAgent(deviceDetection_getUserAgent()),
        browser = _parseUserAgent.browser,
        os = _parseUserAgent.os;

    this.browser = browser;
    this.os = os;
  }

  createClass_default()(DeviceDetection, [{
    key: "isIos",
    value: function isIos() {
      return this.os === "iOS";
    }
  }, {
    key: "isAndroidChrome",
    value: function isAndroidChrome() {
      return this.browser === "Chrome [WebView]" && this.os === "Android";
    }
  }]);

  return DeviceDetection;
}();

/* harmony default export */ var deviceDetection = (deviceDetection_DeviceDetection);
// CONCATENATED MODULE: ./template/components/Modal/Fade.js













var Fade_Fade = function (_Component) {
  inherits_default()(Fade, _Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Fade.__proto__ || get_prototype_of_default()(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.deviceDetection = new deviceDetection(), _this.handleEnter = /* istanbul ignore next */function () {
      _this.y = window.scrollY;
      scrollTo(0, 0);

      document.body.classList.add("chrome-bodylock");
    }, _this.handleExit = /* istanbul ignore next */function () {
      document.body.classList.remove("chrome-bodylock");

      scrollTo(0, _this.y);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }
  // HACK: iOS 10 and below do not like fixed with forms


  createClass_default()(Fade, [{
    key: "render",

    // end

    value: function render() {
      var _cx;

      var _props = this.props,
          isActive = _props.isActive,
          children = _props.children;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        CSSTransition_default.a,
        {
          "in": isActive,
          mountOnEnter: true,
          unmountOnExit: true,
          timeout: 500,
          onEnter: this.handleEnter,
          onExited: this.handleExit,
          classNames: {
            enter: Fade_default.a.fade__entered,
            enterActive: Fade_default.a.fade__entering,
            exit: Fade_default.a.fade__exited,
            exitActive: Fade_default.a.fade__exiting
          }
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: classnamesfrom_dll_reference_vendor_default()(Fade_default.a.fade, (_cx = {}, defineProperty_default()(_cx, Fade_default.a.isAndroid, this.deviceDetection.isAndroidChrome()), defineProperty_default()(_cx, Fade_default.a.isIos, this.deviceDetection.isIos()), _cx))
          },
          children
        )
      );
    }
  }]);

  return Fade;
}(reactfrom_dll_reference_vendor["Component"]);

Fade_Fade.defaultProps = {
  isActive: false
};

/* harmony default export */ var components_Modal_Fade = (Fade_Fade);
// CONCATENATED MODULE: ./template/components/Modal/index.js











var Modal_Modal = function (_Component) {
  inherits_default()(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Modal.__proto__ || get_prototype_of_default()(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.handleClose = /* istanbul ignore next */function () {
      var onClose = _this.props.onClose;


      if (onClose) {
        onClose();
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Modal, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isOpen = _props.isOpen;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        components_Modal_Fade,
        { isActive: isOpen },
        reactfrom_dll_reference_vendor_default.a.createElement(components_Modal_Backdrop, null),
        reactfrom_dll_reference_vendor_default.a.createElement(
          components_Modal_Container,
          { onClose: this.handleClose },
          children
        )
      );
    }
  }]);

  return Modal;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Modal = (Modal_Modal);
// CONCATENATED MODULE: ./helpers/webStorage.js
var getValueFromSessionStorage = function getValueFromSessionStorage(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var hasSessionStorageKey = function hasSessionStorageKey(key) {
  try {
    return !!sessionStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var setSessionStorage = function setSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    return false;
  }
};

var setLocalStorage = function setLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    return false;
  }
};

var getValueFromLocalStorage = function getValueFromLocalStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return false;
  }
};

var removeValueFromLocalStorage = function removeValueFromLocalStorage(key) {
  try {
    return localStorage.removeItem(key);
  } catch (e) {
    return false;
  }
};
// CONCATENATED MODULE: ./template/components/GDPR/GDPR.js


















var GDPR_STORAGE_KEY = "Asos.GdprBanner";

var GDPR_GDPR = function (_Component) {
  inherits_default()(GDPR, _Component);

  function GDPR() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    classCallCheck_default()(this, GDPR);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = GDPR.__proto__ || get_prototype_of_default()(GDPR)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fetchPreferencesError: false,
      preferencesInitialised: false,
      showBanner: true,
      showModal: false
    }, _this.dismissGdprNotificationsForSession = function () {
      var customerGuid = _this.props.customerGuid;

      var expiryDate = new Date();
      expiryDate.setHours(expiryDate.getHours() + 8); // set 8 hour expiry from now

      var setLocalStorageValues = json_stringify_default()({
        customerGuid: customerGuid,
        expiry: expiryDate.toISOString()
      });

      setLocalStorage(GDPR_STORAGE_KEY, setLocalStorageValues);
    }, _this.handleBannerClick = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var _this$props, setUserPreferences, gdprPhaseTwoFeature;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, setUserPreferences = _this$props.setUserPreferences, gdprPhaseTwoFeature = _this$props.gdprPhaseTwoFeature;


              _this.setState({
                isPreferencesLoading: true
              });

              _context.prev = 2;
              _context.next = 5;
              return setUserPreferences();

            case 5:

              _this.dismissGdprNotificationsForSession();

              _this.setState({
                fetchPreferencesError: false,
                isPreferencesLoading: false,
                showBanner: gdprPhaseTwoFeature,
                showModal: true
              });
              callback();
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);

              _this.setState({
                fetchPreferencesError: true,
                isPreferencesLoading: false
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 10]]);
    })), _this.handleClose = function () {
      _this.setState({
        showBanner: false,
        showModal: false
      });

      var url = removeURLParameter(window.location.href, "contact");
      window.history.replaceState({}, "", url);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(GDPR, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        showModal: !!this.isContactAvailable()
      });
    }
  }, {
    key: "showModalGdprPhaseTwo",
    value: function showModalGdprPhaseTwo(shouldShowBanner) {
      var _this3 = this;

      if (this.props.gdprPhaseTwoFeature && this.props.testIsLoaded && !this.state.preferencesInitialised && shouldShowBanner) {
        setTimeout(function () {
          return _this3.handleBannerClick();
        }, 4000);

        this.setState({ preferencesInitialised: true });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var gdprSessionStorageObject = JSON.parse(getValueFromLocalStorage(GDPR_STORAGE_KEY));

      var customerShouldSeeBanner = !(gdprSessionStorageObject && nextProps.customerGuid === gdprSessionStorageObject.customerGuid && gdprSessionStorageObject.expiry > new Date().toISOString());

      this.setState(function (state) {
        return {
          showBanner: state.showBanner && customerShouldSeeBanner
        };
      });

      this.showModalGdprPhaseTwo(customerShouldSeeBanner);
    }
  }, {
    key: "isContactAvailable",
    value: function isContactAvailable() {
      if (typeof window !== "undefined" && window.location) {
        return "contact" in url_parse_default()(window.location.href, true).query;
      }
      return false;
    }
  }, {
    key: "getContact",
    value: function getContact() {
      if (typeof window !== "undefined" && window.location) {
        var url = url_parse_default()(window.location.href, true);
        return url.query.contact;
      }
      return false;
    }
  }, {
    key: "getOptedIn",
    value: function getOptedIn() {
      var hasReconsented = this.props.hasReconsented;

      var hasContactInAsAQueryParam = this.getContact() ? !!(this.getContact().toLowerCase() === "in") : false;

      return hasReconsented || hasContactInAsAQueryParam;
    }
  }, {
    key: "renderPreferences",
    value: function renderPreferences() {
      var _props = this.props,
          ctaRef = _props.ctaRef,
          hasError = _props.hasError,
          isOptInLoading = _props.isOptInLoading,
          isOptOutLoading = _props.isOptOutLoading,
          isReconsentRequired = _props.isReconsentRequired,
          optIn = _props.optIn,
          optOut = _props.optOut,
          preferences = _props.preferences,
          privacyUrlSegment = _props.privacyUrlSegment,
          testContent = _props.testContent,
          termsUrlSegment = _props.termsUrlSegment;


      if (this.isContactAvailable()) {
        return null;
      }

      if (!isReconsentRequired) {
        return null;
      }

      return reactfrom_dll_reference_vendor_default.a.createElement(GDPR_ContactPreferences, {
        ctaRef: ctaRef,
        hasError: hasError,
        isOptInLoading: isOptInLoading,
        isOptOutLoading: isOptOutLoading,
        optIn: optIn,
        optOut: optOut,
        preferences: preferences,
        privacyUrlSegment: privacyUrlSegment,
        testContent: testContent,
        termsUrlSegment: termsUrlSegment
      });
    }
  }, {
    key: "renderConfirmation",
    value: function renderConfirmation() {
      var _props2 = this.props,
          ctaRef = _props2.ctaRef,
          isReconsentRequired = _props2.isReconsentRequired,
          hasReconsented = _props2.hasReconsented;


      if (!this.isContactAvailable()) {
        if (isReconsentRequired) {
          return null;
        }

        if (hasReconsented === null) {
          return null;
        }
      }

      return reactfrom_dll_reference_vendor_default.a.createElement(GDPR_Confirmation, {
        ctaRef: ctaRef,
        isOptedIn: this.getOptedIn(),
        onClose: this.handleClose
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          isReconsentRequired = _props3.isReconsentRequired,
          testContent = _props3.testContent,
          testIsLoaded = _props3.testIsLoaded,
          gdprPhaseTwoFeature = _props3.gdprPhaseTwoFeature,
          hasReconsented = _props3.hasReconsented;
      var _state = this.state,
          fetchPreferencesError = _state.fetchPreferencesError,
          isPreferencesLoading = _state.isPreferencesLoading,
          showBanner = _state.showBanner,
          showModal = _state.showModal;


      var shouldShowBanner = isReconsentRequired && showBanner && testIsLoaded;

      return gdprPhaseTwoFeature ? reactfrom_dll_reference_vendor_default.a.createElement(
        reactfrom_dll_reference_vendor["Fragment"],
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(
          components_Modal,
          {
            isOpen: showModal && (shouldShowBanner || this.isContactAvailable() || hasReconsented !== null),
            onClose: this.handleClose
          },
          this.renderPreferences(),
          this.renderConfirmation()
        )
      ) : reactfrom_dll_reference_vendor_default.a.createElement(
        reactfrom_dll_reference_vendor["Fragment"],
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(
          components_Modal,
          { isOpen: showModal, onClose: this.handleClose },
          this.renderPreferences(),
          this.renderConfirmation()
        ),
        shouldShowBanner && reactfrom_dll_reference_vendor_default.a.createElement(GDPR_Banner, {
          chooseOptionsAction: this.handleBannerClick,
          dismissAction: this.dismissGdprNotificationsForSession,
          hasErrored: fetchPreferencesError,
          greeting: testContent && testContent.greeting,
          isLoading: isPreferencesLoading,
          onClick: this.handleBannerClick
        })
      );
    }
  }]);

  return GDPR;
}(reactfrom_dll_reference_vendor["Component"]);

GDPR_GDPR.defaultProps = {
  gdprPhaseTwoFeature: false,
  hasReconsented: null,
  preferences: [],
  testIsLoaded: false
};

/* harmony default export */ var components_GDPR_GDPR = (GDPR_GDPR);
// CONCATENATED MODULE: ./template/components/Greeter/Greeter.js






/* eslint-disable no-underscore-dangle */











var Greeter_getGreetingMessage = function getGreetingMessage(isKnown, firstName, formatTranslation) {
  return isKnown && reactfrom_dll_reference_vendor_default.a.createElement(
    "span",
    { className: Greeter_default.a.welcome },
    formatTranslation("MyAccountLinks.Greeting", { name: firstName })
  );
};

var Greeter_getButtonLinks = function getButtonLinks(isLoggedIn, isRecognised, signUpLink, signInLink, formatTranslation, focusable) {
  var identitySdk = typeof window !== "undefined" && window.asos && window.asos.sdk.identity;

  if (!isLoggedIn && !isRecognised) {
    return reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Greeter_default.a.links },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "a",
        {
          className: Greeter_default.a.link,
          href: signInLink,
          "data-testid": "signin-link",
          tabIndex: accessibility_tabIndex(focusable),
          onClick: function onClick(e) {
            if (!identitySdk) {
              return;
            }
            e.preventDefault();
            identitySdk.login();
          }
        },
        formatTranslation("MyAccountLinks.SignInLabel")
      ),
      reactfrom_dll_reference_vendor_default.a.createElement("div", { className: Greeter_default.a.pipe }),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "a",
        {
          className: Greeter_default.a.link,
          href: signUpLink,
          "data-testid": "signup-link",
          tabIndex: accessibility_tabIndex(focusable)
        },
        formatTranslation("MyAccountLinks.SignUpLabel")
      )
    );
  }

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "span",
    { className: Greeter_default.a.links },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "a",
      {
        className: Greeter_default.a.link,
        href: "",
        onClick: function onClick(e) {
          e.preventDefault();
          removeValueFromLocalStorage(GDPR_STORAGE_KEY);
          identitySdk && identitySdk.logout();
        },
        "data-testid": "signout-link",
        tabIndex: accessibility_tabIndex(focusable)
      },
      formatTranslation("MyAccountLinks.SignOutLabel")
    )
  );
};

var Greeter_Greeter = function (_Component) {
  inherits_default()(Greeter, _Component);

  function Greeter(props) {
    classCallCheck_default()(this, Greeter);

    var _this = possibleConstructorReturn_default()(this, (Greeter.__proto__ || get_prototype_of_default()(Greeter)).call(this, props));

    _this.state = {
      returnUrl: false
    };
    return _this;
  }

  createClass_default()(Greeter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        returnUrl: window.location.href
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          isLoggedIn = _props.isLoggedIn,
          isRecognised = _props.isRecognised,
          firstName = _props.firstName,
          formatTranslation = _props.formatTranslation,
          lang = _props.lang,
          countryCode = _props.countryCode,
          storeCode = _props.storeCode,
          keyStoreDataversion = _props.keyStoreDataversion,
          focusable = _props.focusable;


      var params = {
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion
      };

      var signUpBaseUrl = externalLinks_getIdentitySdkAuthHost() + formatTranslation("MyAccountLinks.SignUpLink");

      var signUpLink = queryString_withParams(signUpBaseUrl, extends_default()({}, params, {
        returnUrl: this.state.returnUrl
      }));

      var signInLink = queryString_withParams(externalLinks_getMyAccountBaseUrl(), params);

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Greeter_default.a.container },
        Greeter_getGreetingMessage(isLoggedIn || isRecognised, firstName, formatTranslation),
        Greeter_getButtonLinks(isLoggedIn, isRecognised, signUpLink, signInLink, formatTranslation, focusable)
      );
    }
  }]);

  return Greeter;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Greeter_Greeter = (Viewport_withViewport(translation(Greeter_Greeter)));
// CONCATENATED MODULE: ./template/components/Greeter/index.js





function Greeter_mapStateToProps(state) {
  return {
    isLoggedIn: selectors_isLoggedIn(state),
    firstName: getFirstName(state),
    isRecognised: getIsRecognised(state),
    storeCode: selectors_getStoreCode(state),
    lang: getDefaultLanguage(state),
    countryCode: getCountryCode(state),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state)
  };
}

/* harmony default export */ var template_components_Greeter = (Object(esfrom_dll_reference_vendor["connect"])(Greeter_mapStateToProps)(components_Greeter_Greeter));
// EXTERNAL MODULE: delegated ../node_modules/query-string/index.js from dll-reference vendor
var query_stringfrom_dll_reference_vendor = __webpack_require__("../node_modules/query-string/index.js");
var query_stringfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(query_stringfrom_dll_reference_vendor);

// EXTERNAL MODULE: ./template/components/MyAccountLinks/index.css
var components_MyAccountLinks = __webpack_require__("./template/components/MyAccountLinks/index.css");
var MyAccountLinks_default = /*#__PURE__*/__webpack_require__.n(components_MyAccountLinks);

// CONCATENATED MODULE: ./template/components/MyAccountLinks/MyAccountLinks.js

















var CONTACT_PREFERENCES = "ContactPreferences";
var MyAccountLinks_MY_ACCOUNT = "MyAccount";
var MY_ORDERS = "MyOrders";
var RETURNS_INFORMATION = "ReturnsInformation";
var MY_ACCOUNT_CRISTMAS_LOGGEDOUT = "MyAccountChristmasLoggedOut";
var MY_ACCOUNT_CRISTMAS_LOGGEDIN = "MyAccountChristmasLoggedIn";

var MyAccountLinks_cx = classnamesfrom_dll_reference_vendor_default.a.bind(MyAccountLinks_default.a);

var MyAccountLinks_MyAccountLinks = function (_PureComponent) {
  inherits_default()(MyAccountLinks, _PureComponent);

  function MyAccountLinks() {
    classCallCheck_default()(this, MyAccountLinks);

    return possibleConstructorReturn_default()(this, (MyAccountLinks.__proto__ || get_prototype_of_default()(MyAccountLinks)).apply(this, arguments));
  }

  createClass_default()(MyAccountLinks, [{
    key: "buildLinks",
    value: function buildLinks() {
      var _props = this.props,
          countryCode = _props.countryCode,
          defaultStoreUrl = _props.defaultStoreUrl,
          formatTranslation = _props.formatTranslation,
          isReconsentRequired = _props.isReconsentRequired,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          _props$queryParams = _props.queryParams,
          queryParams = _props$queryParams === undefined ? {} : _props$queryParams,
          storeCode = _props.storeCode;


      var queryString = "?" + Object(query_stringfrom_dll_reference_vendor["stringify"])(extends_default()({}, queryParams, {
        lang: lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion: keyStoreDataversion
      }));

      var baseUrl = externalLinks_getMyAccountBaseUrl();

      var links = [{
        id: MyAccountLinks_MY_ACCOUNT,
        href: baseUrl + queryString,
        showNotification: false
      }, {
        id: MY_ORDERS,
        href: baseUrl + "/orders" + queryString,
        showNotification: false
      }, {
        id: RETURNS_INFORMATION,
        href: defaultStoreUrl.concat(formatTranslation("MyAccountLinks." + RETURNS_INFORMATION + "Link"), "&", Object(query_stringfrom_dll_reference_vendor["stringify"])(queryParams)),
        showNotification: false
      }, {
        id: CONTACT_PREFERENCES,
        href: baseUrl + "/contact-preferences" + queryString,
        showNotification: isReconsentRequired
      }];

      return links;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          eventIconToggle = _props2.eventIconToggle,
          focusable = _props2.focusable,
          formatTranslation = _props2.formatTranslation,
          isLoggedIn = _props2.isLoggedIn,
          isVisible = _props2.isVisible;
      var christmas = eventIconToggle.christmas;

      var eventIconWithLoggedInStatus = isLoggedIn ? MY_ACCOUNT_CRISTMAS_LOGGEDIN : MY_ACCOUNT_CRISTMAS_LOGGEDOUT;

      if (!isVisible) return null;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        reactfrom_dll_reference_vendor["Fragment"],
        null,
        this.buildLinks().map(function (_ref) {
          var id = _ref.id,
              href = _ref.href,
              showNotification = _ref.showNotification;
          return reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              href: href,
              className: MyAccountLinks_cx(MyAccountLinks_default.a.link, christmas && id === MyAccountLinks_MY_ACCOUNT ? MyAccountLinks_default.a[eventIconWithLoggedInStatus] : MyAccountLinks_default.a[id]),
              key: id,
              tabIndex: accessibility_tabIndex(focusable),
              "data-testid": id.toLowerCase() + "-link"
            },
            showNotification && reactfrom_dll_reference_vendor_default.a.createElement(
              "span",
              { className: MyAccountLinks_cx(MyAccountLinks_default.a.notificationContainer) },
              reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconNotification, null)
            ),
            formatTranslation("MyAccountLinks." + id)
          );
        })
      );
    }
  }]);

  return MyAccountLinks;
}(reactfrom_dll_reference_vendor["PureComponent"]);

MyAccountLinks_MyAccountLinks.defaultProps = {
  eventIconToggle: {
    christmas: false
  }
};

/* harmony default export */ var components_MyAccountLinks_MyAccountLinks = (Viewport_withViewport(translation(MyAccountLinks_MyAccountLinks)));
// CONCATENATED MODULE: ./template/components/MyAccountLinks/index.js






function MyAccountLinks_mapStateToProps(state) {
  return {
    countryCode: getCountryCode(state),
    defaultStoreUrl: getDefaultStoreUrl(state),
    eventIconToggle: isFeatureActive(state, "web-event-icon"),
    isLoggedIn: selectors_isLoggedIn(state),
    isReconsentRequired: getIsReconsentRequired(state),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    storeCode: selectors_getStoreCode(state)
  };
}

/* harmony default export */ var template_components_MyAccountLinks = (Object(esfrom_dll_reference_vendor["connect"])(MyAccountLinks_mapStateToProps)(components_MyAccountLinks_MyAccountLinks));
// EXTERNAL MODULE: ./template/components/MiniBag/LineItem/DeleteItem/index.css
var LineItem_DeleteItem = __webpack_require__("./template/components/MiniBag/LineItem/DeleteItem/index.css");
var DeleteItem_default = /*#__PURE__*/__webpack_require__.n(LineItem_DeleteItem);

// CONCATENATED MODULE: ./template/components/MiniBag/LineItem/DeleteItem/DeleteItem.js






var DeleteItem_DeleteItem = function DeleteItem(_ref) {
  var deleteBagItem = _ref.deleteBagItem,
      id = _ref.id,
      formatTranslation = _ref.formatTranslation;

  function deleteBagItemWithTracking(id) {
    deleteBagItem(id);
    trackMiniBagProductDelete({
      interaction: ANALYTICS_INTERACTION_CLICK,
      context: ANALYTICS_CONTEXT.minibagDeleteItem,
      productId: id
    });
  }

  return reactfrom_dll_reference_vendor_default.a.createElement("button", {
    "aria-label": formatTranslation("MiniBag.DeleteBagItemText"),
    className: DeleteItem_default.a.deleteItem,
    onClick: function onClick(e) {
      e.stopPropagation();
      deleteBagItemWithTracking(id);
    },
    tabIndex: "-1"
  });
};

/* harmony default export */ var LineItem_DeleteItem_DeleteItem = (translation(DeleteItem_DeleteItem));
// CONCATENATED MODULE: ./template/components/MiniBag/LineItem/DeleteItem/index.js




var DeleteItem_mapDispatchToProps = {
  deleteBagItem: actions_deleteBagItem
};

/* harmony default export */ var MiniBag_LineItem_DeleteItem = (Object(esfrom_dll_reference_vendor["connect"])(null, DeleteItem_mapDispatchToProps)(LineItem_DeleteItem_DeleteItem));
// EXTERNAL MODULE: ./template/components/MiniBag/Price/index.css
var MiniBag_Price = __webpack_require__("./template/components/MiniBag/Price/index.css");
var Price_default = /*#__PURE__*/__webpack_require__.n(MiniBag_Price);

// CONCATENATED MODULE: ./template/components/MiniBag/Price/index.js







var Price_cx = bind_default.a.bind(Price_default.a);

var Price_Price = function Price(_ref) {
  var text = _ref.text,
      current = _ref.current,
      previous = _ref.previous,
      rrp = _ref.rrp,
      isMarkedDown = _ref.isMarkedDown,
      isOutletPrice = _ref.isOutletPrice,
      formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: Price_default.a.container },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      {
        className: Price_cx([Price_default.a.current], defineProperty_default()({}, Price_default.a.highlight, isMarkedDown || isOutletPrice))
      },
      text || current.text
    ),
    isOutletPrice && reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Price_default.a.rrp },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        { className: Price_default.a.rrpLabel },
        formatTranslation("MiniBag.RRP")
      ),
      rrp.text
    ),
    isMarkedDown && reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Price_default.a.previous },
      previous.text
    )
  );
};

Price_Price.defaultProps = {
  current: {}
};

/* harmony default export */ var components_MiniBag_Price = (translation(Price_Price));
// EXTERNAL MODULE: ./template/components/MiniBag/LineItem/index.css
var MiniBag_LineItem = __webpack_require__("./template/components/MiniBag/LineItem/index.css");
var LineItem_default = /*#__PURE__*/__webpack_require__.n(MiniBag_LineItem);

// CONCATENATED MODULE: ./template/helpers/formatImageUrl.js
var formatImageUrl = function formatImageUrl(url) {
  var urlWithoutProtocol = url.replace(/(^\w+:|^)\/\//, "");
  return "//" + urlWithoutProtocol;
};

/* harmony default export */ var helpers_formatImageUrl = (formatImageUrl);
// CONCATENATED MODULE: ./template/components/MiniBag/LineItem/index.js










var LineItem_cx = bind_default.a.bind(LineItem_default.a);

var LineItem_getProductUrl = function getProductUrl(images, size) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Standard1";

  var filteredImagesBySize = images.find(function (image) {
    return image.size === size;
  });
  var filteredImagesByType = images.find(function (image) {
    return image.type === type;
  });

  if (filteredImagesBySize) {
    return filteredImagesBySize.url;
  }

  if (filteredImagesByType) {
    return helpers_formatImageUrl(filteredImagesByType.url);
  }

  return null;
};

var containerClassNames = function containerClassNames() {
  var itemType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return LineItem_cx("container", "item", itemType.toLowerCase());
};

var LineItem_LineItem = function LineItem(_ref) {
  var color = _ref.colour,
      defaultStoreUrl = _ref.defaultStoreUrl,
      formatTranslation = _ref.formatTranslation,
      id = _ref.id,
      images = _ref.images,
      imageUrl = _ref.imageUrl,
      itemType = _ref.itemType,
      name = _ref.name,
      price = _ref.price,
      productUrl = _ref.productUrl,
      quantity = _ref.quantity,
      size = _ref.size;

  var voucherUrl = defaultStoreUrl + "gift-vouchers/?edit=true";
  var itemUrl = itemType === "Voucher" ? voucherUrl : productUrl;

  var linkWithAnalytics = queryString_withParams(itemUrl, {
    ctaref: "mini bag",
    featureref1: "mini bag"
  });

  var productImage = LineItem_getProductUrl(images, "l");
  var largeProductImage = LineItem_getProductUrl(images, "xl");

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: containerClassNames(itemType) },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "a",
      { href: linkWithAnalytics, className: LineItem_default.a.link, tabIndex: "-1" },
      imageUrl && reactfrom_dll_reference_vendor_default.a.createElement("img", { src: imageUrl, alt: "", className: LineItem_default.a.image }),
      images.length > 0 && reactfrom_dll_reference_vendor_default.a.createElement("img", {
        src: productImage,
        srcSet: largeProductImage + " 2x",
        alt: "",
        className: LineItem_default.a.image
      }),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "dl",
        { className: LineItem_default.a.details },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: LineItem_default.a.price },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "dt",
            null,
            formatTranslation("MiniBag.Price")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "dd",
            null,
            reactfrom_dll_reference_vendor_default.a.createElement(components_MiniBag_Price, price)
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: LineItem_default.a.name },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "dt",
            null,
            formatTranslation("MiniBag.Name")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "dd",
            null,
            name
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: LineItem_default.a.meta },
          color && itemType === "Product" && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: LineItem_default.a.color },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dt",
              null,
              formatTranslation("MiniBag.Color")
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dd",
              null,
              color
            )
          ),
          size && itemType === "Product" && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: LineItem_default.a.size },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dt",
              null,
              formatTranslation("MiniBag.Size")
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dd",
              null,
              size
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: LineItem_default.a.quantity },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dt",
              { className: LineItem_default.a.term },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "abbr",
                { title: formatTranslation("MiniBag.Quantity") },
                formatTranslation("MiniBag.Qty")
              )
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "dd",
              { className: LineItem_default.a.quantity },
              quantity
            )
          )
        )
      )
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(MiniBag_LineItem_DeleteItem, { id: id })
  );
};

LineItem_LineItem.defaultProps = {
  images: []
};

/* harmony default export */ var components_MiniBag_LineItem = (translation(LineItem_LineItem));
// EXTERNAL MODULE: ./template/components/Notification/index.css
var components_Notification = __webpack_require__("./template/components/Notification/index.css");
var Notification_default = /*#__PURE__*/__webpack_require__.n(components_Notification);

// CONCATENATED MODULE: ./template/components/Notification/index.js













var Notification_Notification = function (_Component) {
  inherits_default()(Notification, _Component);

  function Notification() {
    classCallCheck_default()(this, Notification);

    return possibleConstructorReturn_default()(this, (Notification.__proto__ || get_prototype_of_default()(Notification)).apply(this, arguments));
  }

  createClass_default()(Notification, [{
    key: "render",
    value: function render() {
      var _classnames;

      var ariaLiveForType = {
        alert: "assertive",
        error: "assertive",
        promotion: "polite",
        success: "polite"
      };

      var _props = this.props,
          children = _props.children,
          hasIcon = _props.hasIcon,
          type = _props.type,
          onClose = _props.onClose,
          closeLabel = _props.closeLabel;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          "aria-live": ariaLiveForType[type],
          className: classnamesfrom_dll_reference_vendor_default()((_classnames = {}, defineProperty_default()(_classnames, Notification_default.a.notification, true), defineProperty_default()(_classnames, Notification_default.a[type], true), defineProperty_default()(_classnames, Notification_default.a.hasBackground, true), defineProperty_default()(_classnames, Notification_default.a.hasIcon, hasIcon), _classnames))
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: Notification_default.a.text },
          children
        ),
        onClose && reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
          icon: "close",
          className: Notification_default.a.close,
          "data-testid": "notification-close-btn",
          size: "small",
          onClick: onClose,
          "aria-label": closeLabel ? closeLabel : "Dismiss this message"
        })
      );
    }
  }]);

  return Notification;
}(reactfrom_dll_reference_vendor["Component"]);

Notification_Notification.defaultProps = {
  hasIcon: true
};

/* harmony default export */ var template_components_Notification = (Notification_Notification);
// CONCATENATED MODULE: ./template/components/MiniBag/ReservationMessage/ReservationMessage.js





var mapProductToMessage = {
  Product: "reservationMessage",
  Subscription: "subscriptionConfirmationMessage",
  Voucher: "voucherConfirmationMessage"
};

var ReservationMessage_ReservationMessage = function ReservationMessage(_ref) {
  var formatTranslation = _ref.formatTranslation,
      displayReservationMessage = _ref.displayReservationMessage,
      items = _ref.items;

  return displayReservationMessage ? reactfrom_dll_reference_vendor_default.a.createElement(
    template_components_Notification,
    { type: "success" },
    formatTranslation("MiniBag." + mapProductToMessage[items[0].itemType])
  ) : null;
};

ReservationMessage_ReservationMessage.defaultProps = {
  displayReservationMessage: false
};

/* harmony default export */ var MiniBag_ReservationMessage_ReservationMessage = (translation(ReservationMessage_ReservationMessage));
// CONCATENATED MODULE: ./template/components/MiniBag/ReservationMessage/index.js




var ReservationMessage_mapStateToProps = function mapStateToProps(state) {
  return {
    displayReservationMessage: selectors_displayReservationMessage(state),
    items: getBagItems(state)
  };
};

/* harmony default export */ var MiniBag_ReservationMessage = (Object(esfrom_dll_reference_vendor["connect"])(ReservationMessage_mapStateToProps)(MiniBag_ReservationMessage_ReservationMessage));
// EXTERNAL MODULE: ./template/components/TransitionList/index.css
var components_TransitionList = __webpack_require__("./template/components/TransitionList/index.css");
var TransitionList_default = /*#__PURE__*/__webpack_require__.n(components_TransitionList);

// CONCATENATED MODULE: ./template/components/TransitionList/index.js






var TransitionList_cx = bind_default.a.bind(TransitionList_default.a);

var TransitionList_TransitionList = function TransitionList(_ref) {
  var children = _ref.children,
      itemDeletedLabel = _ref.itemDeletedLabel,
      _onTransitionEnd = _ref.onTransitionEnd;

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "ul",
    { className: TransitionList_default.a.transitionList },
    children.map(function (child) {
      var classes = TransitionList_cx("transitionList__element", {
        "transitionList__element--exiting": child.props.transition === "exiting"
      });

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "li",
        { key: child.key, className: TransitionList_default.a.wrapper },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: classes,
            onTransitionEnd: function onTransitionEnd(e) {
              if (e.nativeEvent.propertyName === "height") {
                _onTransitionEnd(child.props.id);
              }
            }
          },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: TransitionList_default.a.transitionList_itemDeletedLabel },
            itemDeletedLabel
          ),
          child,
          reactfrom_dll_reference_vendor_default.a.createElement("div", { className: TransitionList_default.a.transitionList__overlay })
        )
      );
    })
  );
};

/* harmony default export */ var template_components_TransitionList = (TransitionList_TransitionList);
// EXTERNAL MODULE: ./template/components/MiniBag/index.css
var components_MiniBag = __webpack_require__("./template/components/MiniBag/index.css");
var MiniBag_default = /*#__PURE__*/__webpack_require__.n(components_MiniBag);

// CONCATENATED MODULE: ./template/components/MiniBag/MiniBag.js












var firstTwentyItems = function firstTwentyItems(items) {
  return items.slice(0, 20);
};

var MiniBag_MiniBag = function MiniBag(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      bagItemDeleteTransitionEnd = _ref.bagItemDeleteTransitionEnd,
      formatTranslation = _ref.formatTranslation,
      items = _ref.items,
      loading = _ref.loading;

  var moreThanTwentyItems = items.length > 20;
  var loaded = items.length && !loading;
  var itemsToRender = firstTwentyItems(items);

  return loaded ? reactfrom_dll_reference_vendor_default.a.createElement(
    reactfrom_dll_reference_vendor_default.a.Fragment,
    null,
    reactfrom_dll_reference_vendor_default.a.createElement(MiniBag_ReservationMessage, null),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: MiniBag_default.a.miniBag },
      reactfrom_dll_reference_vendor_default.a.createElement(
        template_components_TransitionList,
        {
          onTransitionEnd: bagItemDeleteTransitionEnd,
          itemDeletedLabel: formatTranslation("MiniBag.ItemDeleted")
        },
        itemsToRender.map(function (item) {
          return reactfrom_dll_reference_vendor_default.a.createElement(components_MiniBag_LineItem, extends_default()({
            key: item.id
          }, item, {
            defaultStoreUrl: defaultStoreUrl
          }));
        })
      ),
      moreThanTwentyItems && reactfrom_dll_reference_vendor_default.a.createElement(
        template_components_Notification,
        {
          type: "alert",
          withClose: true,
          closeLabel: formatTranslation("MiniBag.DismissNotificationBtnText")
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: MiniBag_default.a.notification },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "span",
            null,
            formatTranslation("MiniBag.Footer.MaximumItemsMessage")
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "span",
            null,
            formatTranslation("MiniBag.Footer.ViewBagMessage.PartOne"),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "a",
              {
                className: MiniBag_default.a.link,
                href: defaultStoreUrl.concat(formatTranslation("Bag.Link"))
              },
              formatTranslation("MiniBag.Footer.ViewBagMessage.Link")
            ),
            formatTranslation("MiniBag.Footer.ViewBagMessage.PartTwo")
          )
        )
      )
    )
  ) : reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: MiniBag_default.a.spinnerContainer },
    reactfrom_dll_reference_vendor_default.a.createElement(template_components_Spinner, { size: "large" })
  );
};

MiniBag_MiniBag.defaultProps = {
  items: [],
  loading: false
};

/* harmony default export */ var components_MiniBag_MiniBag = (translation(MiniBag_MiniBag));
// CONCATENATED MODULE: ./template/components/MiniBag/index.js





var MiniBag_mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state),
    items: getBagItems(state),
    loading: getLoading(state)
  };
};

var MiniBag_mapDispatchToProps = {
  bagItemDeleteTransitionEnd: selectors_bagItemDeleteTransitionEnd
};

/* harmony default export */ var template_components_MiniBag = (Object(esfrom_dll_reference_vendor["connect"])(MiniBag_mapStateToProps, MiniBag_mapDispatchToProps)(components_MiniBag_MiniBag));
// EXTERNAL MODULE: ./template/components/MiniBag/Header/index.css
var MiniBag_Header = __webpack_require__("./template/components/MiniBag/Header/index.css");
var Header_default = /*#__PURE__*/__webpack_require__.n(MiniBag_Header);

// CONCATENATED MODULE: ./template/components/MiniBag/Header/MinibagHeader.js





var MinibagHeader_MinibagHeader = function MinibagHeader(_ref) {
  var totalQuantity = _ref.totalQuantity,
      formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { "data-test-id": "miniBagHeader", className: Header_default.a.container },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: Header_default.a.bagTitle },
      formatTranslation("MiniBag.MyBag"),
      ","
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { "data-test-id": "miniBagItemCount" },
      formatTranslation("MiniBag.ItemCount", {
        smart_count: totalQuantity
      })
    )
  );
};

/* harmony default export */ var Header_MinibagHeader = (translation(MinibagHeader_MinibagHeader));
// CONCATENATED MODULE: ./template/components/MiniBag/Header/index.js




var Header_mapStateToProps = function mapStateToProps(state) {
  return {
    totalQuantity: getTotalQuantity(state)
  };
};

/* harmony default export */ var components_MiniBag_Header = (Object(esfrom_dll_reference_vendor["connect"])(Header_mapStateToProps)(Header_MinibagHeader));
// EXTERNAL MODULE: ./template/components/MiniBag/Footer/index.css
var MiniBag_Footer = __webpack_require__("./template/components/MiniBag/Footer/index.css");
var Footer_default = /*#__PURE__*/__webpack_require__.n(MiniBag_Footer);

// EXTERNAL MODULE: ./template/components/MiniBag/Footer/DeliveryProposition/index.css
var Footer_DeliveryProposition = __webpack_require__("./template/components/MiniBag/Footer/DeliveryProposition/index.css");
var DeliveryProposition_default = /*#__PURE__*/__webpack_require__.n(Footer_DeliveryProposition);

// CONCATENATED MODULE: ./template/components/MiniBag/Footer/DeliveryProposition/DeliveryProposition.js






var DeliveryProposition_DeliveryProposition = function DeliveryProposition(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: DeliveryProposition_default.a.deliveryProposition },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: DeliveryProposition_default.a.title },
      formatTranslation("MiniBag.Footer.DeliveryProposition.Title")
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: DeliveryProposition_default.a.description },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        null,
        formatTranslation("MiniBag.Footer.DeliveryProposition.Description")
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "a",
        {
          className: DeliveryProposition_default.a.descriptionLink,
          href: defaultStoreUrl.concat(formatTranslation("MiniBag.Footer.DeliveryProposition.DeliveryInformationLink")),
          tabIndex: "-1"
        },
        formatTranslation("MiniBag.Footer.DeliveryProposition.LinkText")
      )
    )
  );
};

/* harmony default export */ var Footer_DeliveryProposition_DeliveryProposition = (translation(DeliveryProposition_DeliveryProposition));
// CONCATENATED MODULE: ./template/components/MiniBag/Footer/DeliveryProposition/index.js




var DeliveryProposition_mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
};

/* harmony default export */ var MiniBag_Footer_DeliveryProposition = (Object(esfrom_dll_reference_vendor["connect"])(DeliveryProposition_mapStateToProps)(Footer_DeliveryProposition_DeliveryProposition));
// EXTERNAL MODULE: ./template/components/MiniBag/Footer/BagLinks/index.css
var BagLinks = __webpack_require__("./template/components/MiniBag/Footer/BagLinks/index.css");
var BagLinks_default = /*#__PURE__*/__webpack_require__.n(BagLinks);

// CONCATENATED MODULE: ./template/components/MiniBag/Footer/BagLinks/BagLinks.js








var BagLinks_DeliveryProposition = function DeliveryProposition(_ref) {
  var defaultStoreUrl = _ref.defaultStoreUrl,
      formatTranslation = _ref.formatTranslation,
      startCheckout = _ref.startCheckout;

  function linkWithAnalytics(link) {
    return queryString_withParams(link, { ctaref: "mini bag" });
  }
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: BagLinks_default.a.bagLinks },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: BagLinks_default.a.buttonContainer },
      reactfrom_dll_reference_vendor_default.a.createElement(
        template_components_Button,
        {
          theme: "secondary",
          href: linkWithAnalytics(defaultStoreUrl.concat(formatTranslation("Bag.Link"))),
          "data-test-id": "bag-link",
          tabIndex: "-1"
        },
        formatTranslation("MiniBag.Footer.BagLinks.Bag.Text")
      )
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: BagLinks_default.a.buttonContainer },
      reactfrom_dll_reference_vendor_default.a.createElement(
        template_components_Button,
        {
          theme: "green",
          href: "#",
          onClick: function onClick() {
            return startCheckout();
          },
          "data-test-id": "checkout-link",
          tabIndex: "-1"
        },
        formatTranslation("MiniBag.Footer.BagLinks.Checkout.Text")
      )
    )
  );
};

/* harmony default export */ var BagLinks_BagLinks = (translation(BagLinks_DeliveryProposition));
// CONCATENATED MODULE: ./template/components/MiniBag/Footer/BagLinks/index.js





var BagLinks_mapStateToProps = function mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
};

var BagLinks_mapDispatchToProps = {
  startCheckout: actions_startCheckout
};

/* harmony default export */ var Footer_BagLinks = (Object(esfrom_dll_reference_vendor["connect"])(BagLinks_mapStateToProps, BagLinks_mapDispatchToProps)(BagLinks_BagLinks));
// EXTERNAL MODULE: ./template/components/MiniBag/Footer/SubTotal/index.css
var Footer_SubTotal = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/index.css");
var SubTotal_default = /*#__PURE__*/__webpack_require__.n(Footer_SubTotal);

// EXTERNAL MODULE: ./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.css
var SubTotal_GermanVATIncluded = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.css");
var GermanVATIncluded_default = /*#__PURE__*/__webpack_require__.n(SubTotal_GermanVATIncluded);

// CONCATENATED MODULE: ./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.js




var GermanVATIncluded_GermanVATIncluded = function GermanVATIncluded(_ref) {
  var storeCode = _ref.storeCode;
  return storeCode === "DE" ? reactfrom_dll_reference_vendor_default.a.createElement(
    "small",
    { className: GermanVATIncluded_default.a.germanVATInc },
    "inkl. MwSt."
  ) : null;
};

/* harmony default export */ var Footer_SubTotal_GermanVATIncluded = (GermanVATIncluded_GermanVATIncluded);
// EXTERNAL MODULE: ./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.css
var SubTotal_USSalesTax = __webpack_require__("./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.css");
var USSalesTax_default = /*#__PURE__*/__webpack_require__.n(SubTotal_USSalesTax);

// CONCATENATED MODULE: ./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.js





var USSalesTax_USSalesTax = function USSalesTax(_ref) {
  var countryCode = _ref.countryCode,
      USSalesTaxToggle = _ref.USSalesTaxToggle,
      formatTranslation = _ref.formatTranslation;
  return countryCode === "US" && USSalesTaxToggle ? reactfrom_dll_reference_vendor_default.a.createElement(
    "small",
    { className: USSalesTax_default.a.USSalesTax },
    formatTranslation("MiniBag.SubTotal.USSalesTax")
  ) : null;
};

/* harmony default export */ var Footer_SubTotal_USSalesTax = (translation(USSalesTax_USSalesTax));
// CONCATENATED MODULE: ./template/components/MiniBag/Footer/SubTotal/SubTotal.js







var SubTotal_SubTotal = function SubTotal(_ref) {
  var text = _ref.text,
      formatTranslation = _ref.formatTranslation,
      countryCode = _ref.countryCode,
      storeCode = _ref.storeCode,
      USSalesTaxToggle = _ref.USSalesTaxToggle;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: SubTotal_default.a.subTotalContainer },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "h1",
      null,
      formatTranslation("MiniBag.SubTotal.Title"),
      reactfrom_dll_reference_vendor_default.a.createElement(Footer_SubTotal_USSalesTax, {
        countryCode: countryCode,
        USSalesTaxToggle: USSalesTaxToggle
      })
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { "data-test-id": "miniBagSubTotal" },
      text,
      reactfrom_dll_reference_vendor_default.a.createElement(Footer_SubTotal_GermanVATIncluded, { storeCode: storeCode })
    )
  );
};

SubTotal_SubTotal.defaultProps = {
  text: null
};

/* harmony default export */ var Footer_SubTotal_SubTotal = (translation(SubTotal_SubTotal));
// CONCATENATED MODULE: ./template/components/MiniBag/Footer/SubTotal/index.js






var SubTotal_mapStateToProps = function mapStateToProps(state) {
  return {
    text: getTotalPriceText(state),
    storeCode: selectors_getStoreCode(state),
    countryCode: getCountryCode(state),
    USSalesTaxToggle: isFeatureActive(state, "gbl-us-sales-tax")
  };
};

/* harmony default export */ var MiniBag_Footer_SubTotal = (Object(esfrom_dll_reference_vendor["connect"])(SubTotal_mapStateToProps)(Footer_SubTotal_SubTotal));
// CONCATENATED MODULE: ./template/components/MiniBag/ErrorMessage/ErrorMessage.js





var ErrorMessage_ErrorMessage = function ErrorMessage(_ref) {
  var formatTranslation = _ref.formatTranslation,
      dismissBagError = _ref.dismissBagError,
      showError = _ref.showError;

  return showError ? reactfrom_dll_reference_vendor_default.a.createElement(
    template_components_Notification,
    { type: "alert", onClose: dismissBagError },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "p",
      null,
      formatTranslation("MiniBag.ErrorMessage.firstLine")
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "p",
      null,
      formatTranslation("MiniBag.ErrorMessage.secondLine")
    )
  ) : null;
};

/* harmony default export */ var MiniBag_ErrorMessage_ErrorMessage = (translation(ErrorMessage_ErrorMessage));
// CONCATENATED MODULE: ./template/components/MiniBag/ErrorMessage/index.js




var ErrorMessage_mapStateToProps = function mapStateToProps(state) {
  return {
    showError: bagError(state)
  };
};

var ErrorMessage_mapDispatchToProps = { dismissBagError: selectors_dismissBagError };

/* harmony default export */ var MiniBag_ErrorMessage = (Object(esfrom_dll_reference_vendor["connect"])(ErrorMessage_mapStateToProps, ErrorMessage_mapDispatchToProps)(MiniBag_ErrorMessage_ErrorMessage));
// CONCATENATED MODULE: ./template/components/MiniBag/Footer/index.js







var Footer_MinibagFooter = function MinibagFooter() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { "data-test-id": "miniBagFooter", className: Footer_default.a.minibagFooter },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: Footer_default.a.error },
      reactfrom_dll_reference_vendor_default.a.createElement(MiniBag_ErrorMessage, null)
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(MiniBag_Footer_SubTotal, null),
    reactfrom_dll_reference_vendor_default.a.createElement(Footer_BagLinks, null),
    reactfrom_dll_reference_vendor_default.a.createElement(MiniBag_Footer_DeliveryProposition, null)
  );
};

/* harmony default export */ var components_MiniBag_Footer = (Footer_MinibagFooter);
// CONCATENATED MODULE: ./template/helpers/isBagPage.js
// n.b. any changes made here should be mirrored in the Signal.Util.isBagPage function (signal.js)
var isBagPage_isBagPage = function isBagPage(path) {
  return !!path.match(/^(\/[a-zA-Z]{2})?\/bag(\/$|$)/);
};

/* harmony default export */ var helpers_isBagPage = (isBagPage_isBagPage);
// CONCATENATED MODULE: ./template/components/Widgets/Widgets.js

























var trackingQuery = "?nlid=nav header";

var Widgets_ENTER_KEY = 13;
var Widgets_keyCode = function keyCode(e) {
  return e.keyCode || e.which;
};

var Widgets_Widgets_Widgets = function (_Component) {
  inherits_default()(Widgets, _Component);

  function Widgets() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Widgets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Widgets.__proto__ || get_prototype_of_default()(Widgets)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isBagIconAnimating: false,
      isBagPage: false
    }, _this.componentDidMount = function () {
      var getSavedItemsFromSDK = _this.props.getSavedItemsFromSDK;

      getSavedItemsFromSDK();
      _this.setState({
        isBagPage: helpers_isBagPage(window.location.pathname)
      });
    }, _this.componentWillReceiveProps = function (nextProps) {
      var noOfBagItems = _this.props.noOfBagItems;


      if (nextProps.isUpdated && nextProps.noOfBagItems > noOfBagItems) {
        _this.toggleAnimation();
      }
    }, _this.handleSearch = function () {
      var openSearch = _this.props.openSearch;

      openSearch();
    }, _this.toggleAnimation = function () {
      _this.setState(function (state) {
        return {
          isBagIconAnimating: !state.isBagIconAnimating
        };
      });
    }, _this.searchWidget = function () {
      var formatTranslation = _this.props.formatTranslation;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        components_Widgets_Widget,
        { viewable: [SMALL_VIEWPORT] },
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
          type: "button",
          icon: "search",
          onClick: _this.handleSearch,
          "data-testid": "searchIcon",
          className: Widgets_default.a.widgetButton,
          "aria-label": formatTranslation("Icon.Search")
        })
      );
    }, _this.accountWidget = function () {
      var _this$props = _this.props,
          countryCode = _this$props.countryCode,
          eventIconToggle = _this$props.eventIconToggle,
          formatTranslation = _this$props.formatTranslation,
          isLoggedIn = _this$props.isLoggedIn,
          isReconsentRequired = _this$props.isReconsentRequired,
          keyStoreDataversion = _this$props.keyStoreDataversion,
          lang = _this$props.lang,
          myAccountOpen = _this$props.myAccountOpen,
          storeCode = _this$props.storeCode,
          viewport = _this$props.viewport;
      var christmas = eventIconToggle.christmas;


      var iconName = isLoggedIn ? "accountFilled" : "accountUnfilled";

      if (christmas) {
        iconName = isLoggedIn ? "accountChristmasFilled" : "accountChristmasUnfilled";
      }

      if (viewport !== SMALL_VIEWPORT) {
        return reactfrom_dll_reference_vendor_default.a.createElement(
          components_Widgets_Widget,
          { className: Widget_default.a.myAccountWidget },
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_Dropdown,
            {
              name: MY_ACCOUNT,
              header: reactfrom_dll_reference_vendor_default.a.createElement(template_components_Greeter, null),
              body: reactfrom_dll_reference_vendor_default.a.createElement(template_components_MyAccountLinks, null),
              footer: null
            },
            reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
              type: "button",
              icon: iconName,
              "data-testid": "accountIcon",
              className: Widgets_default.a.widgetButton,
              "aria-expanded": myAccountOpen,
              "aria-controls": "myaccount-dropdown",
              "aria-label": formatTranslation("Icon.MyAccount")
            }),
            isReconsentRequired ? reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconNotification, { "data-testid": "gdpr-icon-notification" }) : null
          )
        );
      } else {
        var params = {
          lang: lang,
          store: storeCode,
          country: countryCode,
          keyStoreDataversion: keyStoreDataversion,
          nlid: "nav header"
        };

        var href = queryString_withParams(externalLinks_getMyAccountBaseUrl(), params);

        return reactfrom_dll_reference_vendor_default.a.createElement(
          components_Widgets_Widget,
          { className: Widget_default.a.myAccountWidget },
          reactfrom_dll_reference_vendor_default.a.createElement(
            template_components_IconButton,
            {
              type: "a",
              href: href,
              icon: iconName,
              "data-testid": "accountIcon",
              className: Widgets_default.a.widgetButton,
              "aria-label": formatTranslation("Icon.MyAccount")
            },
            isReconsentRequired ? reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconNotification, { "data-testid": "gdpr-icon-notification" }) : null
          )
        );
      }
    }, _this.bagWidget = function () {
      var _this$props2 = _this.props,
          viewport = _this$props2.viewport,
          noOfBagItems = _this$props2.noOfBagItems,
          defaultStoreUrl = _this$props2.defaultStoreUrl,
          miniBagToggle = _this$props2.miniBagToggle,
          formatTranslation = _this$props2.formatTranslation;
      var isBagPage = _this.state.isBagPage;

      var bagIconName = noOfBagItems ? "bagFilled" : "bagUnfilled";

      var bagUrl = defaultStoreUrl.concat(formatTranslation("Bag.Link"), trackingQuery);

      var bagAriaLabel = formatTranslation("Icon.Bag") + " " + formatTranslation("MiniBag.ItemCount", {
        smart_count: noOfBagItems
      });

      var bagIcon = function bagIcon() {
        var hasDropdown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return reactfrom_dll_reference_vendor_default.a.createElement(
          template_components_IconButton,
          {
            type: "a",
            href: bagUrl,
            onClick: function onClick(e) {
              return hasDropdown && e.preventDefault();
            },
            onKeyDown: function onKeyDown(e) {
              if (Widgets_keyCode(e) === Widgets_ENTER_KEY) {
                window.location.assign(bagUrl);
                e.preventDefault();
              }
            },
            icon: bagIconName,
            "data-testid": "bagIcon",
            className: Widgets_default.a.widgetButton,
            "aria-label": bagAriaLabel
          },
          noOfBagItems && reactfrom_dll_reference_vendor_default.a.createElement(
            "span",
            { className: Widgets_default.a.noOfBagItems },
            noOfBagItems
          )
        );
      };

      return reactfrom_dll_reference_vendor_default.a.createElement(
        components_Widgets_Widget,
        null,
        !isBagPage && viewport !== SMALL_VIEWPORT && miniBagToggle && noOfBagItems ? reactfrom_dll_reference_vendor_default.a.createElement(
          template_components_Dropdown,
          {
            name: MINIBAG,
            header: reactfrom_dll_reference_vendor_default.a.createElement(components_MiniBag_Header, null),
            body: reactfrom_dll_reference_vendor_default.a.createElement(template_components_MiniBag, null),
            footer: reactfrom_dll_reference_vendor_default.a.createElement(components_MiniBag_Footer, null),
            isKeyboardAccessible: false
          },
          bagIcon(true)
        ) : reactfrom_dll_reference_vendor_default.a.createElement(
          CSSTransition_default.a,
          {
            "in": _this.state.isBagIconAnimating,
            timeout: 1000,
            classNames: "bounce",
            onEntered: _this.toggleAnimation
          },
          bagIcon()
        )
      );
    }, _this.savedItemsWidget = function () {
      var _this$props3 = _this.props,
          hasSavedItems = _this$props3.hasSavedItems,
          formatTranslation = _this$props3.formatTranslation,
          defaultStoreUrl = _this$props3.defaultStoreUrl;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        components_Widgets_Widget,
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
          type: "a",
          href: defaultStoreUrl.concat(formatTranslation("SavedItems.Link"), trackingQuery),
          icon: hasSavedItems ? "heartFilled" : "heartUnfilled",
          "data-testid": "savedItemsIcon",
          className: Widgets_default.a.widgetButton,
          "aria-label": formatTranslation("Icon.SavedItems")
        })
      );
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Widgets, [{
    key: "render",
    value: function render() {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "ul",
        { className: Widgets_default.a.container, "data-testid": "widgets" },
        this.searchWidget(),
        this.accountWidget(),
        this.savedItemsWidget(),
        this.bagWidget()
      );
    }
  }]);

  return Widgets;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Widgets_Widgets = (translation(Widgets_Widgets_Widgets));
// CONCATENATED MODULE: ./template/state/modules/savedItems/constants.js
var GET_SAVED_ITEMS = "GET_SAVED_ITEMS";
// CONCATENATED MODULE: ./template/state/modules/savedItems/selectors.js


var getSavedItems = function getSavedItems(state) {
  return state.savedItems;
};

var getItems = Object(lib["createSelector"])(getSavedItems, function (saved) {
  return saved.items;
});

var selectors_hasSavedItems = Object(lib["createSelector"])(getItems, function (items) {
  return items.length > 0;
});
// CONCATENATED MODULE: ./template/state/modules/savedItems/actions.js




var savedItems_actions__this = this;


// import logger from "../../../../helpers/logger";

var sdkRequest = /* istanbul ignore next */function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(dispatch) {
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // try {
            //   const { savedItemProducts } = await window.asos.sdk.savedItems.getSavedItems();
            //
            //   dispatch({ type: GET_SAVED_ITEMS, payload: savedItemProducts });
            // } catch (err) {
            //   logger.error(`Error while fetching saved items: ${err}`);
            //
            //   dispatch({ type: GET_SAVED_ITEMS, error: true, payload: err });
            // }
            dispatch({ type: GET_SAVED_ITEMS, payload: [] });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, savedItems_actions__this);
  }));

  return function sdkRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var actions_getSavedItemsFromSDK = /* istanbul ignore next */function getSavedItemsFromSDK() {
  return (/* istanbul ignore next */function (dispatch) {
      return new promise_default.a(function (resolve) {
        if (window.asos.sdk.savedItems) return resolve(sdkRequest(dispatch));

        window.asos.eventBus.addListener("sdk-ready", function () {
          return resolve(sdkRequest(dispatch));
        });
      });
    }
  );
};
// CONCATENATED MODULE: ./template/state/modules/savedItems/index.js






var savedItems_initialState = {
  items: []
};

/* harmony default export */ var savedItems = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : savedItems_initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_SAVED_ITEMS:
      return extends_default()({}, state, { items: action.payload });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/Widgets/index.js












var Widgets_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    openSearch: actions_openSearch,
    getSavedItemsFromSDK: actions_getSavedItemsFromSDK
  }, dispatch);
};

var Widgets_mapStateToProps = function mapStateToProps(state) {
  return {
    eventIconToggle: isFeatureActive(state, "web-event-icon"),
    countryCode: getCountryCode(state),
    defaultStoreUrl: getDefaultStoreUrl(state),
    hasSavedItems: selectors_hasSavedItems(state),
    isLoggedIn: selectors_isLoggedIn(state),
    isReconsentRequired: getIsReconsentRequired(state),
    isUpdated: getUpdated(state),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state),
    lang: getDefaultLanguage(state),
    miniBagToggle: isFeatureActive(state, "stc-minibag-dropdown"),
    myAccountOpen: getDropdownIsOpen(state, { name: "myAccount" }),
    noOfBagItems: getTotalQuantity(state),
    storeCode: selectors_getStoreCode(state),
    viewport: getViewport(state)
  };
};

/* harmony default export */ var components_Widgets = (Object(esfrom_dll_reference_vendor["connect"])(Widgets_mapStateToProps, Widgets_mapDispatchToProps)(components_Widgets_Widgets));
// EXTERNAL MODULE: ./template/components/Header/Logo/index.css
var Header_Logo = __webpack_require__("./template/components/Header/Logo/index.css");
var Logo_default = /*#__PURE__*/__webpack_require__.n(Header_Logo);

// CONCATENATED MODULE: ./template/components/Header/Logo/index.js





var Logo_Logo = function Logo(_ref) {
  var formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "svg",
    {
      className: Logo_default.a.logo,
      width: "104",
      height: "30",
      viewBox: "0 0 104 30",
      role: "img",
      "aria-labelledby": "home-logo"
    },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "title",
      { id: "home-logo" },
      formatTranslation("Header.HomeAlt")
    ),
    reactfrom_dll_reference_vendor_default.a.createElement("path", {
      fill: "#FFF",
      fillRule: "evenodd",
      d: "M71.83 21.983c-1.558 1.666-3.56 2.51-5.95 2.51-2.387 0-4.39-.844-5.947-2.51-1.488-1.587-2.343-4.124-2.343-6.96 0-2.766.864-5.27 2.37-6.867 1.572-1.667 3.565-2.516 5.92-2.523 2.36.007 4.35.856 5.924 2.523 1.506 1.598 2.37 4.1 2.37 6.867 0 2.836-.855 5.373-2.343 6.96zm-20.915-6.96c0 .128.005.255.008.38-2.39-2.166-5.845-2.974-7.957-3.394-3.907-.82-6.89-1.58-6.89-4.35 0-1.96 1.757-3.38 5.132-3.14 3.085.224 4.384 2.102 4.74 3.914.05.3.19.515.53.517l5.547.05c.026 0 .048-.003.072-.004-.783 1.816-1.182 3.84-1.182 6.015zM41.48 25.19c-2.683 0-5.64-.95-6.32-4.624-.06-.35-.225-.496-.495-.503l-5.364-.07v-9.446c.71 2.768 3.04 4.684 8.09 5.816 3.38.806 9.24 1.318 9.24 4.774 0 2.408-1.78 4.11-5.15 4.054zm-26.714-.69c-4.327 0-8.29-3.394-8.29-9.47 0-4.77 2.97-9.39 8.32-9.39 2.315 0 8.188.79 8.188 9.39 0 8.62-6.132 9.47-8.218 9.47zm65.922-11.792c1.232 1.636 3.453 2.848 7.063 3.657 3.38.805 9.25 1.318 9.25 4.775 0 2.403-1.78 4.11-5.15 4.05-2.68 0-5.64-.95-6.32-4.625-.052-.35-.22-.497-.49-.504L80.06 20c.523-1.54.79-3.21.79-4.974 0-.793-.056-1.566-.16-2.317zM91.474 30c5.95 0 12.965-2.208 12.416-9.366-.606-6.355-7.244-7.964-10.562-8.625-3.907-.82-6.892-1.58-6.892-4.35 0-1.96 1.758-3.38 5.134-3.14 3.084.224 4.384 2.102 4.74 3.914.05.3.19.515.53.517l5.546.048c.422.002.554-.216.5-.516C101.8 1.874 96.246 0 91.133 0 86.03 0 79.88 1.43 79.443 7.754c-.015.246-.02.486-.02.722-.814-1.683-1.985-3.23-3.495-4.597C73.142 1.37 69.666.03 65.878 0h-.127c-1.81 0-3.58.333-5.26.99a15.26 15.26 0 0 0-4.65 2.888c-1.43 1.295-2.56 2.747-3.36 4.327C51.27 1.822 45.81 0 40.77 0 36.084 0 30.517 1.208 29.3 6.305v-5.06a.49.49 0 0 0-.49-.488h-5.224c-.27 0-.49.22-.49.49V2.61c0 .23-.155.31-.343.175-1.858-1.34-4.607-2.782-7.915-2.782-1.86 0-3.635.326-5.277.968-1.64.65-3.2 1.63-4.64 2.92C3.29 5.37 2.05 7.05 1.23 8.9.417 10.742 0 12.807 0 15.027 0 17.1.367 19.043 1.088 20.8c.722 1.756 1.82 3.382 3.267 4.83 1.446 1.45 3.063 2.553 4.804 3.276 1.74.722 3.66 1.09 5.7 1.09 3.51 0 6.15-1.493 7.88-2.85.19-.144.342-.067.342.17v1.435c0 .27.22.49.49.49H28.8c.27 0 .49-.22.49-.49v-4.83C31.766 29.7 38.04 30 41.113 30c5.137 0 11.06-1.647 12.234-6.7.55.818 1.192 1.597 1.924 2.33 2.8 2.807 6.47 4.316 10.62 4.362h.17c1.97 0 3.87-.377 5.648-1.12a14.82 14.82 0 0 0 4.79-3.242 15.25 15.25 0 0 0 2.594-3.43c1.86 7.438 9.035 7.8 12.387 7.8z"
    })
  );
};

var Logo_Component = Logo_Logo;
/* harmony default export */ var components_Header_Logo = (translation(Logo_Logo));
// EXTERNAL MODULE: ./template/components/Header/HomeLogo/index.css
var Header_HomeLogo = __webpack_require__("./template/components/Header/HomeLogo/index.css");
var HomeLogo_default = /*#__PURE__*/__webpack_require__.n(Header_HomeLogo);

// CONCATENATED MODULE: ./template/components/Header/HomeLogo/HomeLogo.js





var HomeLogo_HomeLogo = function HomeLogo(_ref) {
  var storeUrls = _ref.storeUrls,
      _ref$gender = _ref.gender,
      gender = _ref$gender === undefined ? "default" : _ref$gender;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "a",
    { className: HomeLogo_default.a.link, href: storeUrls[gender], "data-testid": "asoslogo" },
    reactfrom_dll_reference_vendor_default.a.createElement(components_Header_Logo, null)
  );
};

/* harmony default export */ var Header_HomeLogo_HomeLogo = (HomeLogo_HomeLogo);
// CONCATENATED MODULE: ./template/components/Header/HomeLogo/index.js




function HomeLogo_mapStateToProps(state) {
  return {
    storeUrls: state.regionalStore.storeUrls,
    gender: getCurrentGender(state)
  };
}

/* harmony default export */ var components_Header_HomeLogo = (Object(esfrom_dll_reference_vendor["connect"])(HomeLogo_mapStateToProps)(Header_HomeLogo_HomeLogo));
// EXTERNAL MODULE: ./template/components/Header/index.css
var components_Header = __webpack_require__("./template/components/Header/index.css");
var components_Header_default = /*#__PURE__*/__webpack_require__.n(components_Header);

// CONCATENATED MODULE: ./template/components/Header/Header.js










var Header_Header = function Header(_ref) {
  var clearNavActiveItem = _ref.clearNavActiveItem;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: components_Header_default.a.container, onMouseEnter: clearNavActiveItem },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: components_Header_default.a.body, "data-testid": "header" },
      reactfrom_dll_reference_vendor_default.a.createElement(components_Burger, null),
      reactfrom_dll_reference_vendor_default.a.createElement(components_Header_HomeLogo, null),
      reactfrom_dll_reference_vendor_default.a.createElement(components_FloorNavigation, { viewable: [LARGE_VIEWPORT] }),
      reactfrom_dll_reference_vendor_default.a.createElement(components_SearchForm, null),
      reactfrom_dll_reference_vendor_default.a.createElement(components_Widgets, null)
    )
  );
};

/* harmony default export */ var components_Header_Header = (Header_Header);
// CONCATENATED MODULE: ./template/state/modules/navigation/constants.js
var WOMEN_FLOOR_ALIAS = "WW";
var MEN_FLOOR_ALIAS = "MW";
var SET_NAV_ACTIVE_ITEM = "SET_NAV_ACTIVE_ITEM";
var CLEAR_NAV_ACTIVE_ITEM = "CLEAR_NAV_ACTIVE_ITEM";
var UPDATE_NAVIGATION_TREE = "UPDATE_NAVIGATION_TREE";
var UL_ITEM_COUNT = 11;
var PRIMARY = "primary";
var SECONDARY = "secondary";
// CONCATENATED MODULE: ./template/state/modules/navigation/actions.js


var actions_setNavActiveItem = function setNavActiveItem(id) {
  return {
    type: SET_NAV_ACTIVE_ITEM,
    payload: id
  };
};

var actions_clearNavActiveItem = function clearNavActiveItem() {
  return {
    type: CLEAR_NAV_ACTIVE_ITEM
  };
};

var actions_updateNavigationTree = function updateNavigationTree(navigationTree) {
  return {
    type: UPDATE_NAVIGATION_TREE,
    payload: navigationTree
  };
};
// EXTERNAL MODULE: ../node_modules/lodash/orderBy.js
var orderBy = __webpack_require__("../node_modules/lodash/orderBy.js");
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);

// CONCATENATED MODULE: ./template/state/modules/navigation/helpers/mapNavigationTree.js




var mapNavigationTree_sort = function sort(items, viewport) {
  return viewport === LARGE_VIEWPORT ? orderBy_default()(items, ["largeScreenPriority"], ["desc"]) : items;
};

var shouldExcludeForViewport = function shouldExcludeForViewport(item, viewport) {
  return item.excludes.indexOf(viewport) !== -1;
};

var mapNavigationTree_filterTreeByViewport = function filterTreeByViewport(tree, forViewport) {
  return mapNavigationTree_sort(tree.reduce(function (filteredTree, item) {
    if (shouldExcludeForViewport(item, forViewport)) {
      return filteredTree;
    }
    filteredTree.push(extends_default()({}, item, {
      items: mapNavigationTree_sort(filterTreeByViewport(item.items, forViewport), forViewport)
    }));
    return filteredTree;
  }, []), forViewport);
};

var mapSidePrimaryNavigationForViewport = function mapSidePrimaryNavigationForViewport(tree, forViewport) {
  return mapNavigationTree_filterTreeByViewport(tree, forViewport);
};

var mapNavigationTree_mapLargePrimaryNavigation = function mapLargePrimaryNavigation(tree) {
  return mapSidePrimaryNavigationForViewport(tree, LARGE_VIEWPORT).reduce(function (items, secondLevelItems) {
    return items.concat(secondLevelItems.items);
  }, []);
};
// CONCATENATED MODULE: ./template/state/modules/navigation/selectors.js





var selectors_selectFemaleNavigationTree = function selectFemaleNavigationTree(state) {
  var femaleNav = state.navigation.tree.find(function (item) {
    return item.alias === WOMEN_FLOOR_ALIAS;
  });
  if (femaleNav && femaleNav.items) {
    return femaleNav.items;
  }

  return [];
};

var selectors_selectMaleNavigationTree = function selectMaleNavigationTree(state) {
  var maleNav = state.navigation.tree.find(function (item) {
    return item.alias === MEN_FLOOR_ALIAS;
  });
  if (maleNav && maleNav.items) {
    return maleNav.items;
  }

  return [];
};

var selectNavActiveItem = function selectNavActiveItem(state) {
  return state.navigation.activeNavItem;
};
var selectFooterLinks = function selectFooterLinks(state) {
  return state.navigation.footer;
};

var femaleLargePrimaryNavigationItems = Object(lib["createSelector"])(selectors_selectFemaleNavigationTree, mapNavigationTree_mapLargePrimaryNavigation);

var maleLargePrimaryNavigationItems = Object(lib["createSelector"])(selectors_selectMaleNavigationTree, mapNavigationTree_mapLargePrimaryNavigation);

var femaleSidePrimaryNavigationItems = Object(lib["createSelector"])(selectors_selectFemaleNavigationTree, getViewport, mapSidePrimaryNavigationForViewport);

var maleSidePrimaryNavigationItems = Object(lib["createSelector"])(selectors_selectMaleNavigationTree, getViewport, mapSidePrimaryNavigationForViewport);

var getNavActiveItem = Object(lib["createSelector"])(selectNavActiveItem, function (id) {
  return id;
});

var footerNavigation = Object(lib["createSelector"])(selectFooterLinks, function (footer) {
  return footer;
});
// CONCATENATED MODULE: ./template/state/modules/navigation/index.js






var navigationShape = {
  id: prop_typesfrom_dll_reference_vendor_default.a.string.isRequired,
  alias: prop_typesfrom_dll_reference_vendor_default.a.string,
  label: prop_typesfrom_dll_reference_vendor_default.a.string,
  linkType: prop_typesfrom_dll_reference_vendor_default.a.string,
  subtitle: prop_typesfrom_dll_reference_vendor_default.a.string,
  link: prop_typesfrom_dll_reference_vendor_default.a.string,
  excludes: prop_typesfrom_dll_reference_vendor_default.a.array.isRequired,
  largeScreenPriority: prop_typesfrom_dll_reference_vendor_default.a.number,
  smallAndMediumImageUrl: prop_typesfrom_dll_reference_vendor_default.a.string
};

var navigationItemPropType = prop_typesfrom_dll_reference_vendor_default.a.shape(navigationShape);

var navigationPropType = prop_typesfrom_dll_reference_vendor_default.a.shape(extends_default()({}, navigationShape, {
  items: prop_typesfrom_dll_reference_vendor_default.a.arrayOf(navigationItemPropType).isRequired
}));





var navigation_initialState = {};

/* harmony default export */ var modules_navigation = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigation_initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case SET_NAV_ACTIVE_ITEM:
      return extends_default()({}, state, {
        activeNavItem: payload
      });

    case CLEAR_NAV_ACTIVE_ITEM:
      return extends_default()({}, state, {
        activeNavItem: null
      });

    case UPDATE_NAVIGATION_TREE:
      return extends_default()({}, state, {
        tree: payload.tree,
        footer: payload.footer || state.footer
      });
  }

  return state;
});
// CONCATENATED MODULE: ./template/components/Header/index.js





function Header_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    clearNavActiveItem: actions_clearNavActiveItem
  }, dispatch);
}

/* harmony default export */ var template_components_Header = (Object(esfrom_dll_reference_vendor["connect"])(null, Header_mapDispatchToProps)(components_Header_Header));
// EXTERNAL MODULE: ./template/components/Navigation/LargeSecondaryNavigation/index.css
var Navigation_LargeSecondaryNavigation = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/index.css");
var LargeSecondaryNavigation_default = /*#__PURE__*/__webpack_require__.n(Navigation_LargeSecondaryNavigation);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("../node_modules/babel-runtime/core-js/number/is-integer.js");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// CONCATENATED MODULE: ./template/helpers/navigationBackgroundImageResolver.js


var navigationBackgroundImageResolver_getBackgroundImageUrl = function getBackgroundImageUrl(imageUrl, width) {
  if (!imageUrl) {
    return "";
  }

  var backgroundImageUrl = url_parse_default()(imageUrl);

  if (width) {
    backgroundImageUrl.query += "&$n_" + width + "w$";
  }

  return backgroundImageUrl.toString();
};
// CONCATENATED MODULE: ./template/helpers/addAnalyticsDataToLink.js

var prep = function prep(string) {
  return encodeURIComponent(string.toLowerCase()).replace(/%20/g, "+");
};

var addQuerystringSuffix = function addQuerystringSuffix(link) {
  return link.indexOf("?") !== -1 ? link + "&" : link + "?";
};

var addAnalyticsDataToLink_addAnalyticsDataToLink = function addAnalyticsDataToLink(_ref) {
  var link = _ref.link,
      gender = _ref.gender,
      labelPath = _ref.labelPath;

  if (!link) {
    return null;
  }

  if (!gender) {
    return link;
  }

  if (labelPath.length === 6) {
    var _labelPath = slicedToArray_default()(labelPath, 5),
        section = _labelPath[3],
        container = _labelPath[4];

    if (section && container) {
      return addQuerystringSuffix(link) + "nlid=" + prep(gender) + "|" + prep(section) + "|" + prep(container);
    }
  }

  if (labelPath.length === 4) {
    var _labelPath2 = slicedToArray_default()(labelPath, 3),
        _section = _labelPath2[2];

    if (_section) {
      return addQuerystringSuffix(link) + "nlid=" + prep(gender) + "|" + prep(_section);
    }
  }

  return link;
};
// CONCATENATED MODULE: ./template/components/Navigation/NavAnchor/index.js








var NavAnchor_NavAnchor = function NavAnchor(props) {
  var item = props.item,
      children = props.children,
      restOfProps = objectWithoutProperties_default()(props, ["item", "children"]);

  var gender = item.gender,
      label = item.label;


  var handleClick = function handleClick() {
    trackNavOpen({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: events_getGender(gender)
      }
    });
  };

  var isExternal = item.linkType === "external";

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "a",
    extends_default()({}, restOfProps, {
      onClick: handleClick,
      href: addAnalyticsDataToLink_addAnalyticsDataToLink(item),
      target: isExternal ? "_blank" : "_self"
    }),
    children
  );
};

/* harmony default export */ var Navigation_NavAnchor = (NavAnchor_NavAnchor);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css
var SideNavigationContainer_CircleImageRightItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css");
var CircleImageRightItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_CircleImageRightItem);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.js












var CircleImageRightItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(CircleImageRightItem_default.a);

var CircleImageRightItem_CircleImageRightItem = function CircleImageRightItem(_ref) {
  var item = _ref.item;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: CircleImageRightItem_default.a.container },
    reactfrom_dll_reference_vendor_default.a.createElement(
      Navigation_NavAnchor,
      { "data-navid": item.id, className: CircleImageRightItem_default.a.menuItem, item: item },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        {
          className: CircleImageRightItem_cx(CircleImageRightItem_default.a.label, defineProperty_default()({}, CircleImageRightItem_default.a.label__sale, item.smallAndMediumStyleType === "sale"))
        },
        item.label.substring(0, 36)
      ),
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        "aria-hidden": "true",
        className: CircleImageRightItem_default.a.image,
        role: "presentation",
        style: {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 240) + ")"
        }
      })
    )
  );
};

/* harmony default export */ var Navigation_SideNavigationContainer_CircleImageRightItem = (CircleImageRightItem_CircleImageRightItem);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css
var SideNavigationContainer_CircleImageLeftItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css");
var CircleImageLeftItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_CircleImageLeftItem);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.js










var CircleImageLeftItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(CircleImageLeftItem_default.a);

var CircleImageLeftItem_CircleImageLeftItem = function CircleImageLeftItem(_ref) {
  var _cx;

  var item = _ref.item;
  var label = item.label,
      smallAndMediumImageUrl = item.smallAndMediumImageUrl,
      smallAndMediumStyleType = item.smallAndMediumStyleType;


  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: CircleImageLeftItem_default.a.menuItem },
    reactfrom_dll_reference_vendor_default.a.createElement(
      Navigation_NavAnchor,
      { className: CircleImageLeftItem_default.a.button, item: item },
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        "aria-hidden": "true",
        className: CircleImageLeftItem_default.a.circleImage,
        role: "presentation",
        style: {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(smallAndMediumImageUrl, 240) + ")"
        },
        title: label
      }),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        {
          className: CircleImageLeftItem_cx(CircleImageLeftItem_default.a.label, (_cx = {}, defineProperty_default()(_cx, CircleImageLeftItem_default.a.label__sale, smallAndMediumStyleType === "sale"), defineProperty_default()(_cx, CircleImageLeftItem_default.a.label__bold, smallAndMediumStyleType === "premium"), _cx))
        },
        label.substring(0, 40)
      )
    )
  );
};

/* harmony default export */ var Navigation_SideNavigationContainer_CircleImageLeftItem = (CircleImageLeftItem_CircleImageLeftItem);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css
var SideNavigationContainer_InspirationItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css");
var InspirationItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_InspirationItem);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/InspirationItem/index.js









var InspirationItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(InspirationItem_default.a);

var InspirationItem_InspirationItem = function InspirationItem(_ref) {
  var item = _ref.item;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    Navigation_NavAnchor,
    { className: InspirationItem_default.a.card, item: item },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: InspirationItem_default.a.wrapper },
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        "aria-hidden": "true",
        className: InspirationItem_default.a.image,
        role: "presentation",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 320) + ")"
        }
      }),
      item.smallAndMediumStyleType !== "noTitle" && reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        {
          className: InspirationItem_cx(InspirationItem_default.a.title, InspirationItem_default.a[item.smallAndMediumStyleType])
        },
        item.label.substring(0, 24)
      )
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: InspirationItem_default.a.description },
      item.subtitle && item.subtitle.substring(0, 45)
    )
  );
};

/* harmony default export */ var Navigation_SideNavigationContainer_InspirationItem = (InspirationItem_InspirationItem);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/MenuItem/index.css
var SideNavigationContainer_MenuItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/MenuItem/index.css");
var MenuItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_MenuItem);

// CONCATENATED MODULE: ./helpers/formatting.js
var truncateTitle = function truncateTitle(item) {
  return item.subtitle && item.subtitle.length > 0 ? item.label.substring(0, 24) : item.label.substring(0, 36);
};
// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/MenuItem/index.js










var MenuItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(MenuItem_default.a);

var MenuItem_MenuItem = function MenuItem(_ref) {
  var _cx;

  var className = _ref.className,
      item = _ref.item,
      setNavActiveItem = _ref.setNavActiveItem,
      saveNavigationItem = _ref.saveNavigationItem,
      tabIndex = _ref.tabIndex;

  var clickItem = function clickItem() {
    setNavActiveItem(item.id);
    trackNavOpen({
      context: ANALYTICS_CONTEXT.openNav,
      interaction: ANALYTICS_INTERACTION_CLICK,
      elementText: item.label,
      properties: {
        positionOnPage: ANALYTICS_POSITION_HEADER,
        gender: events_getGender(item.gender)
      }
    });
  };

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: MenuItem_cx(MenuItem_default.a.container, className) },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "button",
      {
        key: item.id,
        "data-navid": item.id,
        className: MenuItem_default.a.menuItem,
        type: "button",
        onClick: clickItem,
        ref: saveNavigationItem,
        tabIndex: tabIndex,
        "data-testid": "menu-item",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        {
          className: MenuItem_cx(MenuItem_default.a.label, (_cx = {}, defineProperty_default()(_cx, MenuItem_default.a.label__sale, item.smallAndMediumStyleType === "sale"), defineProperty_default()(_cx, MenuItem_default.a.label__light, item.smallAndMediumStyleType === "light"), _cx))
        },
        item.smallAndMediumStyleType !== "noTitle" && reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          null,
          truncateTitle(item)
        ),
        item.subtitle && reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          { className: MenuItem_default.a.subtitle },
          item.subtitle.substring(0, 24)
        )
      )
    )
  );
};

MenuItem_MenuItem.defaultProps = {
  tabIndex: 0
};

/* harmony default export */ var Navigation_SideNavigationContainer_MenuItem = (MenuItem_MenuItem);
// CONCATENATED MODULE: ./template/helpers/navigationLinkResolver.js



var navigationLinkResolver_resolveLink = function resolveLink(href, alias) {
  if (alias === "app_download" && typeof navigator !== "undefined") {
    var agent = ua_parser_default()(navigator.userAgent);
    var os = agent ? agent.os.name.toLowerCase() : "";
    switch (os) {
      case "android":
        return clientConfig["a" /* default */].get().APP_DOWNLOAD_PLAY_STORE_URI;
      case "ios":
        return clientConfig["a" /* default */].get().APP_DOWNLOAD_APP_STORE_URI;
    }
  }
  return href;
};
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/SquareItem/index.css
var SideNavigationContainer_SquareItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/SquareItem/index.css");
var SquareItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_SquareItem);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/SquareItem/index.js














var SquareItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(SquareItem_default.a);

var SquareItem_SquareItem = function (_Component) {
  inherits_default()(SquareItem, _Component);

  function SquareItem(props) {
    classCallCheck_default()(this, SquareItem);

    var _this = possibleConstructorReturn_default()(this, (SquareItem.__proto__ || get_prototype_of_default()(SquareItem)).call(this, props));

    _this.state = { link: props && props.item && props.item.link };
    return _this;
  }

  createClass_default()(SquareItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props$item = this.props.item,
          link = _props$item.link,
          alias = _props$item.alias;


      if (alias === "app_download") {
        this.setState({
          link: navigationLinkResolver_resolveLink(link, alias)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          item = _props.item,
          saveNavigationItem = _props.saveNavigationItem,
          tabIndex = _props.tabIndex;


      var isExternal = item.linkType === "external";

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "li",
        { className: SquareItem_cx(SquareItem_default.a.container, className), "data-testid": "square-item" },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "a",
          {
            "data-navid": item.id,
            className: SquareItem_default.a.link,
            href: this.state.link,
            ref: saveNavigationItem,
            tabIndex: tabIndex,
            target: isExternal ? "_blank" : "_self"
          },
          item.smallAndMediumImageUrl && reactfrom_dll_reference_vendor_default.a.createElement("div", {
            "aria-hidden": "true",
            className: SquareItem_default.a.image,
            role: "presentation",
            style: {
              backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 320) + ")"
            }
          }),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "p",
            {
              className: SquareItem_cx(SquareItem_default.a.label, defineProperty_default()({}, SquareItem_default.a.label__sale, item.smallAndMediumStyleType === "sale"))
            },
            item.label
          )
        )
      );
    }
  }]);

  return SquareItem;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var Navigation_SideNavigationContainer_SquareItem = (SquareItem_SquareItem);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/FlatItem/index.css
var SideNavigationContainer_FlatItem = __webpack_require__("./template/components/Navigation/SideNavigationContainer/FlatItem/index.css");
var FlatItem_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_FlatItem);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/FlatItem/index.js







var FlatItem_cx = classnamesfrom_dll_reference_vendor_default.a.bind(FlatItem_default.a);

var FlatItem_FlatItem = function FlatItem(_ref) {
  var className = _ref.className,
      item = _ref.item,
      saveNavigationItem = _ref.saveNavigationItem,
      tabIndex = _ref.tabIndex;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: FlatItem_cx(FlatItem_default.a.container, className) },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "a",
      {
        href: item.link,
        "data-navid": item.id,
        className: FlatItem_cx(FlatItem_default.a.menuItem, FlatItem_default.a.flatMenuItem),
        ref: saveNavigationItem,
        tabIndex: tabIndex,
        "data-testid": "menu-item",
        style: item.smallAndMediumImageUrl && {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        {
          className: FlatItem_cx(FlatItem_default.a.label, defineProperty_default()({}, FlatItem_default.a.label__light, item.smallAndMediumStyleType === "light"))
        },
        item.label.substring(0, 24)
      )
    )
  );
};

FlatItem_FlatItem.defaultProps = {
  tabIndex: 0
};

/* harmony default export */ var Navigation_SideNavigationContainer_FlatItem = (FlatItem_FlatItem);
// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/TextList/index.js







var TextList_cx = classnamesfrom_dll_reference_vendor_default.a.bind(LargeSecondaryNavigation_default.a);

var TextList_makeUl = function makeUl(items, i) {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "ul",
    { key: i, className: LargeSecondaryNavigation_default.a.textList },
    items.map(function (item) {
      var _cx;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "li",
        { key: item.id },
        reactfrom_dll_reference_vendor_default.a.createElement(
          Navigation_NavAnchor,
          {
            className: TextList_cx(LargeSecondaryNavigation_default.a.textLink, (_cx = {}, defineProperty_default()(_cx, LargeSecondaryNavigation_default.a.textLink__sale, item.largeScreenStyleType === "sale"), defineProperty_default()(_cx, LargeSecondaryNavigation_default.a.textLink__bold, item.largeScreenStyleType === "premium"), _cx)),
            item: item,
            "data-testid": "text-link"
          },
          item.label.substring(0, 32)
        )
      );
    })
  );
};

var TextList_TextList = function TextList(_ref) {
  var item = _ref.item;

  // split items array into a set of arrays
  // with max size of 9 (max text list length)
  var lists = [];
  var items = [].concat(item.items);
  var maxUlLength = items.length / 2 > UL_ITEM_COUNT ? Math.ceil(items.length / 2) : UL_ITEM_COUNT;
  while (items.length) {
    lists.push(items.splice(0, maxUlLength));
  }return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    null,
    lists.map(TextList_makeUl)
  );
};

/* harmony default export */ var LargeSecondaryNavigation_TextList = (TextList_TextList);
// EXTERNAL MODULE: ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css
var LargeSecondaryNavigation_MarketingImage = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css");
var MarketingImage_default = /*#__PURE__*/__webpack_require__.n(LargeSecondaryNavigation_MarketingImage);

// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.js









var MarketingImage_cx = classnamesfrom_dll_reference_vendor_default.a.bind(MarketingImage_default.a);

var MarketingImage_MarketingImage = function MarketingImage(_ref) {
  var item = _ref.item;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    {
      className: MarketingImage_cx(MarketingImage_default.a.container, defineProperty_default()({}, MarketingImage_default.a.container__column, item.largeScreenColumnSpan === 1))
    },
    MarketingImage_itemList(item)
  );
};

var truncatedLabel = function truncatedLabel(item, largeScreenColumnSpan) {
  return largeScreenColumnSpan === 3 ? item.label.substring(0, 26) : item.label.substring(0, 36);
};

var MarketingImage_itemList = function itemList(_ref2) {
  var items = _ref2.items,
      largeScreenColumnSpan = _ref2.largeScreenColumnSpan;
  return items.map(function (item) {
    var labelClasses = defineProperty_default()({}, MarketingImage_default.a["label__" + item.largeScreenStyleType], true);

    var thumbnailGradientType = function thumbnailGradientType(numberOfItems, numberOfCols) {
      var type = numberOfItems / numberOfCols;
      return type > 2 ? "horizontal" : "vertical";
    };

    return reactfrom_dll_reference_vendor_default.a.createElement(
      Navigation_NavAnchor,
      {
        key: item.id,
        item: item,
        className: MarketingImage_default.a.item,
        "data-testid": "marketing-image"
      },
      reactfrom_dll_reference_vendor_default.a.createElement("img", {
        alt: "",
        src: navigationBackgroundImageResolver_getBackgroundImageUrl(item.largeScreenImageUrl, 320),
        className: MarketingImage_default.a.image
      }),
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        className: MarketingImage_cx(MarketingImage_default.a.thumbnail, MarketingImage_default.a[thumbnailGradientType(items.length, largeScreenColumnSpan)], MarketingImage_default.a[item.largeScreenStyleType])
      }),
      item.largeScreenStyleType !== "noTitle" ? reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        { className: MarketingImage_cx(MarketingImage_default.a.label, labelClasses) },
        truncatedLabel(item, largeScreenColumnSpan)
      ) : null
    );
  });
};

/* harmony default export */ var Navigation_LargeSecondaryNavigation_MarketingImage = (MarketingImage_MarketingImage);
// EXTERNAL MODULE: ./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css
var LargeSecondaryNavigation_CircleImageList = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css");
var CircleImageList_default = /*#__PURE__*/__webpack_require__.n(LargeSecondaryNavigation_CircleImageList);

// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/CircleImageLink.js









var CircleImageLink_cx = classnamesfrom_dll_reference_vendor_default.a.bind(CircleImageList_default.a);

var CircleImageLink_CircleImageLink = function CircleImageLink(_ref) {
  var _cx;

  var item = _ref.item;
  var label = item.label,
      largeScreenImageUrl = item.largeScreenImageUrl,
      largeScreenStyleType = item.largeScreenStyleType;


  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: CircleImageList_default.a.circleImageLink },
    reactfrom_dll_reference_vendor_default.a.createElement(
      Navigation_NavAnchor,
      { item: item },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: CircleImageList_default.a.circleImageBorder },
        reactfrom_dll_reference_vendor_default.a.createElement("div", {
          "aria-hidden": "true",
          className: CircleImageList_default.a.circleImage,
          role: "presentation",
          style: {
            backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(largeScreenImageUrl, 240) + ")"
          }
        })
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        {
          className: CircleImageLink_cx(CircleImageList_default.a.label, (_cx = {}, defineProperty_default()(_cx, CircleImageList_default.a.label__sale, largeScreenStyleType === "sale"), defineProperty_default()(_cx, CircleImageList_default.a.label__bold, largeScreenStyleType === "premium"), _cx))
        },
        label.substring(0, 16)
      )
    )
  );
};

/* harmony default export */ var CircleImageList_CircleImageLink = (CircleImageLink_CircleImageLink);
// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.js





var CircleImageList_CircleImageList = function CircleImageList(_ref) {
  var links = _ref.item.items;

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: CircleImageList_default.a.circleImageList },
    links.map(function (item) {
      return reactfrom_dll_reference_vendor_default.a.createElement(CircleImageList_CircleImageLink, { item: item, key: item.id });
    })
  );
};

/* harmony default export */ var Navigation_LargeSecondaryNavigation_CircleImageList = (CircleImageList_CircleImageList);
// EXTERNAL MODULE: ./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css
var LargeSecondaryNavigation_GridCircleImage = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css");
var GridCircleImage_default = /*#__PURE__*/__webpack_require__.n(LargeSecondaryNavigation_GridCircleImage);

// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.js









var GridCircleImage_cx = classnamesfrom_dll_reference_vendor_default.a.bind(GridCircleImage_default.a);

var MAX_ITEM_COUNT = 4;
var MAX_LETTER_COUNT = 26;

var GridCircleImage_GridCircleImage = function GridCircleImage(_ref) {
  var item = _ref.item;

  var items = [].concat(item.items);
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: GridCircleImage_default.a.container },
    items.splice(0, MAX_ITEM_COUNT).map(GridCircleImage_gridItem)
  );
};

var GridCircleImage_gridItem = function gridItem(item) {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    Navigation_NavAnchor,
    {
      key: item.id,
      item: item,
      className: GridCircleImage_cx(GridCircleImage_default.a.gridItem, defineProperty_default()({}, GridCircleImage_default.a.gridItem__sale, item.largeScreenStyleType === "sale"))
    },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: GridCircleImage_default.a.gridItemImageBorder },
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        "aria-hidden": "true",
        className: GridCircleImage_default.a.gridItemImage,
        role: "presentation",
        style: {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.largeScreenImageUrl, 240) + ")"
        },
        title: item.label
      })
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      null,
      item.label.substr(0, MAX_LETTER_COUNT)
    )
  );
};

/* harmony default export */ var Navigation_LargeSecondaryNavigation_GridCircleImage = (GridCircleImage_GridCircleImage);
// EXTERNAL MODULE: ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css
var LargeSecondaryNavigation_ImageCardsWithDescription = __webpack_require__("./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css");
var ImageCardsWithDescription_default = /*#__PURE__*/__webpack_require__.n(LargeSecondaryNavigation_ImageCardsWithDescription);

// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/ImageCardWithDescription.js







var ImageCardWithDescription_cx = classnamesfrom_dll_reference_vendor_default.a.bind(ImageCardsWithDescription_default.a);

var ImageCardWithDescription_ImageCardWithDescription = function ImageCardWithDescription(_ref) {
  var item = _ref.item;
  var label = item.label,
      subtitle = item.subtitle,
      largeScreenImageUrl = item.largeScreenImageUrl,
      _item$largeScreenStyl = item.largeScreenStyleType,
      largeScreenStyleType = _item$largeScreenStyl === undefined ? "light" : _item$largeScreenStyl;


  return reactfrom_dll_reference_vendor_default.a.createElement(
    Navigation_NavAnchor,
    { item: item, className: ImageCardsWithDescription_default.a.card },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: ImageCardsWithDescription_default.a.thumbnailWrapper },
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        "aria-hidden": "true",
        className: ImageCardsWithDescription_default.a.image,
        role: "presentation",
        style: largeScreenImageUrl && {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(largeScreenImageUrl, 320) + ")"
        }
      }),
      reactfrom_dll_reference_vendor_default.a.createElement("div", {
        className: ImageCardWithDescription_cx(ImageCardsWithDescription_default.a.thumbnailCover, ImageCardsWithDescription_default.a[largeScreenStyleType])
      }),
      item.largeScreenStyleType !== "noTitle" && reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        { className: ImageCardWithDescription_cx(ImageCardsWithDescription_default.a.cardTitle, ImageCardsWithDescription_default.a[largeScreenStyleType]) },
        label.substring(0, 24)
      )
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "span",
      { className: ImageCardsWithDescription_default.a.cardDescription },
      subtitle && subtitle.substring(0, 45)
    )
  );
};

/* harmony default export */ var ImageCardsWithDescription_ImageCardWithDescription = (ImageCardWithDescription_ImageCardWithDescription);
// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.js





var ImageCardsWithDescription_ImageCardsWithDescription = function ImageCardsWithDescription(_ref) {
  var items = _ref.item.items;

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: ImageCardsWithDescription_default.a.cardList },
    items.slice(0, 8).map(function (item) {
      return reactfrom_dll_reference_vendor_default.a.createElement(ImageCardsWithDescription_ImageCardWithDescription, { item: item, key: item.id });
    })
  );
};

/* harmony default export */ var Navigation_LargeSecondaryNavigation_ImageCardsWithDescription = (ImageCardsWithDescription_ImageCardsWithDescription);
// CONCATENATED MODULE: ./template/helpers/navigationTemplatesResolver.js














var MOBILE_TEMPLATES = {
  1: Navigation_SideNavigationContainer_MenuItem,
  2: Navigation_SideNavigationContainer_CircleImageRightItem,
  3: Navigation_SideNavigationContainer_CircleImageLeftItem,
  4: Navigation_SideNavigationContainer_InspirationItem,
  6: Navigation_SideNavigationContainer_SquareItem,
  7: Navigation_SideNavigationContainer_FlatItem
};

var DESKTOP_TEMPLATES = {
  1: LargeSecondaryNavigation_TextList,
  2: Navigation_LargeSecondaryNavigation_MarketingImage,
  3: Navigation_LargeSecondaryNavigation_MarketingImage,
  4: Navigation_LargeSecondaryNavigation_MarketingImage,
  5: Navigation_LargeSecondaryNavigation_CircleImageList,
  6: Navigation_LargeSecondaryNavigation_GridCircleImage,
  7: Navigation_LargeSecondaryNavigation_ImageCardsWithDescription
};

var navigationTemplatesResolver_getTemplate = function getTemplate(collection, defaultIndex) {
  return function (index) {
    if (!is_integer_default()(index)) {
      console.warn("no navigation template index to resolve");
    }

    return collection[index] || collection[defaultIndex];
  };
};

var getMobileTemplate = navigationTemplatesResolver_getTemplate(MOBILE_TEMPLATES, 3);
var getDesktopTemplate = navigationTemplatesResolver_getTemplate(DESKTOP_TEMPLATES, 1);
// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/LargeSecondaryNavigation.js
















var LargeSecondaryNavigation_cx = bind_default.a.bind(LargeSecondaryNavigation_default.a);

var LargeSecondaryNavigation_inferTemplateComponent = function inferTemplateComponent(item) {
  var id = item.largeScreenTemplateId;

  var TemplateComponent = getDesktopTemplate(id);

  return reactfrom_dll_reference_vendor_default.a.createElement(TemplateComponent, { item: item });
};

var LargeSecondaryNavigation_LargeSecondaryNavigation = function (_Component) {
  inherits_default()(LargeSecondaryNavigation, _Component);

  function LargeSecondaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, LargeSecondaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = LargeSecondaryNavigation.__proto__ || get_prototype_of_default()(LargeSecondaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.isVisible = function () {
      return _this.props.item.id === _this.props.largeNavActiveItemId && _this.props.viewport === LARGE_VIEWPORT;
    }, _this.globalTrackingTimer = null, _this.renderHeading = function (label) {
      if (!label) return null;
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: LargeSecondaryNavigation_default.a.columnHeaderContainer },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          { className: LargeSecondaryNavigation_default.a.columnHeader },
          label
        )
      );
    }, _this.renderContainer = function (item) {
      var largeScreenStyleType = item.largeScreenStyleType,
          largeScreenColumnSpan = item.largeScreenColumnSpan;

      var showHeading = largeScreenStyleType !== "noTitle";

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "section",
        {
          key: item.id,
          className: LargeSecondaryNavigation_cx(LargeSecondaryNavigation_default.a.column, LargeSecondaryNavigation_default.a["colspan-" + (largeScreenColumnSpan || 1)])
        },
        showHeading && _this.renderHeading(item.label),
        LargeSecondaryNavigation_inferTemplateComponent(item)
      );
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(LargeSecondaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _props = this.props,
          hasClickedInside = _props.hasClickedInside,
          clearNavActiveItem = _props.clearNavActiveItem;


      this.globalClickListener = template_globalEventHandler.addListener(globalEventHandler_events.click, function (event) {
        if (_this2.isVisible() && !hasClickedInside(event)) {
          clearNavActiveItem();
        }
      });
      this.globalKeyDownListener = template_globalEventHandler.addListener(globalEventHandler_events.keyDown, function (event) {
        if (event.key === globalEventHandler_keys.escape) {
          clearNavActiveItem();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.globalClickListener && this.globalClickListener.remove();
      this.globalKeyDownListener && this.globalKeyDownListener.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          item = _props2.item,
          clearNavActiveItem = _props2.clearNavActiveItem;

      var classes = LargeSecondaryNavigation_cx(LargeSecondaryNavigation_default.a.container, defineProperty_default()({}, LargeSecondaryNavigation_default.a.visible, this.isVisible()));

      var hasNoItems = !item.items.length;

      //The window type checking is a work around to
      //make the classes match server and client side
      var flyoutClasses = LargeSecondaryNavigation_cx(LargeSecondaryNavigation_default.a.flyout, defineProperty_default()({}, LargeSecondaryNavigation_default.a.isLoading, hasNoItems || typeof window === "undefined"));

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          className: classes,
          "data-testid": "secondarynav-container",
          ref: function ref(c) {
            return _this3.container = c;
          }
        },
        reactfrom_dll_reference_vendor_default.a.createElement("div", {
          className: LargeSecondaryNavigation_default.a.backdrop,
          onClick: clearNavActiveItem,
          onMouseMove: clearNavActiveItem,
          "aria-hidden": "true",
          "data-testid": "backdrop"
        }),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: LargeSecondaryNavigation_default.a.flyoutContainer },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            {
              className: flyoutClasses,
              "data-id": item.id,
              "data-testid": "secondarynav-flyout"
            },
            hasNoItems ? reactfrom_dll_reference_vendor_default.a.createElement(template_components_Spinner, { size: "x-large" }) : item.items.map(this.renderContainer)
          )
        )
      );
    }
  }]);

  return LargeSecondaryNavigation;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var Navigation_LargeSecondaryNavigation_LargeSecondaryNavigation = (LargeSecondaryNavigation_LargeSecondaryNavigation);
// CONCATENATED MODULE: ./template/components/Navigation/LargeSecondaryNavigation/index.js






var LargeSecondaryNavigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ setNavActiveItem: actions_setNavActiveItem, clearNavActiveItem: actions_clearNavActiveItem }, dispatch);
};

var LargeSecondaryNavigation_mapStateToProps = function mapStateToProps(state) {
  return {
    largeNavActiveItemId: getNavActiveItem(state),
    viewport: getViewport(state)
  };
};

/* harmony default export */ var components_Navigation_LargeSecondaryNavigation = (Object(esfrom_dll_reference_vendor["connect"])(LargeSecondaryNavigation_mapStateToProps, LargeSecondaryNavigation_mapDispatchToProps)(Navigation_LargeSecondaryNavigation_LargeSecondaryNavigation));
// EXTERNAL MODULE: ./template/components/Navigation/LargePrimaryNavigation/index.css
var Navigation_LargePrimaryNavigation = __webpack_require__("./template/components/Navigation/LargePrimaryNavigation/index.css");
var LargePrimaryNavigation_default = /*#__PURE__*/__webpack_require__.n(Navigation_LargePrimaryNavigation);

// CONCATENATED MODULE: ./template/components/Navigation/LargePrimaryNavigation/LargePrimaryNavigation.js


















var LargePrimaryNavigation_cx = bind_default.a.bind(LargePrimaryNavigation_default.a);

var DOCUMENT_POSITION_CONTAINS = 8;
var HOVER_DELAY = 250;

var LargePrimaryNavigation_LargePrimaryNavigation = function (_Component) {
  inherits_default()(LargePrimaryNavigation, _Component);

  function LargePrimaryNavigation() {
    classCallCheck_default()(this, LargePrimaryNavigation);

    var _this = possibleConstructorReturn_default()(this, (LargePrimaryNavigation.__proto__ || get_prototype_of_default()(LargePrimaryNavigation)).call(this));

    _this.globalTrackingTimer = null;

    _this.handleKeyDown = /* istanbul ignore next - focus is not supported in jsdom */function (event) {
      if (event.key === globalEventHandler_keys.tab && event.originalEvent.shiftKey) {
        if (document.activeElement.attributes["data-id"] && _this.props.items[0].id === document.activeElement.attributes["data-id"].value) {
          event.originalEvent.preventDefault();
          focusFloorNavigationFor(_this.props.forGender);
        }
      }
    };

    _this.isHidden = function () {
      return _this.props.forGender !== _this.props.currentGender;
    };

    _this.handleActiveChild = function (id) {
      _this.props.setNavActiveItem(id);
    };

    _this.handleClick = function (event) {
      var current = _this.getCurrentItemFromEvent(event);
      _this.handleActiveChild(current.id);
      _this.track(current.label, ANALYTICS_INTERACTION_CLICK);
    };

    _this.handleMouseEnter = function (event) {
      var current = _this.getCurrentItemFromEvent(event);
      _this.delayedHover = setTimeout(function () {
        _this.handleActiveChild(current.id);
        _this.beginTracking(current.label);
      }, HOVER_DELAY);
    };

    _this.handleMouseLeave = function (event) {
      if (_this.state.isTouch) {
        event.preventDefault();
      } else {
        if (_this.delayedHover) {
          clearTimeout(_this.delayedHover);
          _this.delayedHover = null;
        }
        _this.clearTracking();
      }
    };

    _this.handleTouchStart = function () {
      _this.setState({ isTouch: true });
      setTimeout(function () {
        _this.setState({ isTouch: false });
      }, 600);
    };

    _this.track = function (label, interaction) {
      var context = interaction === "click" ? ANALYTICS_CONTEXT.openNav : ANALYTICS_CONTEXT.navHover;

      trackNavOpen({
        context: context,
        interaction: interaction,
        elementText: label,
        properties: {
          positionOnPage: ANALYTICS_POSITION_HEADER,
          gender: events_getGender(_this.props.forGender)
        }
      });
    };

    _this.beginTracking = function (label) {
      _this.globalTrackingTimer = setTimeout(function () {
        return _this.track(label, ANALYTICS_INTERACTION_HOVER);
      }, 2000);
    };

    _this.clearTracking = function () {
      clearTimeout(_this.globalTrackingTimer);
    };

    _this.hasClickedInside = function (event) {
      return (event.target.compareDocumentPosition(_this.container) & DOCUMENT_POSITION_CONTAINS) !== 0;
    };

    _this.handleTabListEvents = function (event) {
      var _this$props = _this.props,
          items = _this$props.items,
          setNavActiveItem = _this$props.setNavActiveItem,
          largeNavActiveItemId = _this$props.largeNavActiveItemId;

      var currentButton = items.find(function (_ref) {
        var id = _ref.id;
        return id === largeNavActiveItemId;
      });
      var currentIndex = items.findIndex(function (item) {
        return item === currentButton;
      });

      var targetIndex = void 0;

      switch (event.key) {
        case "ArrowLeft":
          {
            targetIndex = currentIndex ? currentIndex - 1 : items.length - 1;
            break;
          }
        case "ArrowRight":
          {
            targetIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
            break;
          }
        case "Home":
          {
            event.preventDefault();
            targetIndex = 0;
            break;
          }
        case "End":
          {
            event.preventDefault();
            targetIndex = items.length - 1;
            break;
          }
        default:
          {
            return;
          }
      }

      var targetId = items[targetIndex].id;
      setNavActiveItem(targetId);
      document.querySelector("[data-id=\"" + targetId + "\"]").focus();
    };

    _this.state = {
      isTouch: false
    };
    return _this;
  }

  createClass_default()(LargePrimaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.keyDownEventListener = template_globalEventHandler.addListener(globalEventHandler_events.keyDown, this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.keyDownEventListener && this.keyDownEventListener.remove();
    }
  }, {
    key: "getCurrentItemFromEvent",
    value: function getCurrentItemFromEvent(event) {
      var currentId = event.currentTarget.attributes["data-id"].value;
      return this.props.items.find(function (item) {
        return item.id === currentId;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          clearNavActiveItem = _props.clearNavActiveItem,
          largeNavActiveItemId = _props.largeNavActiveItemId,
          setNavActiveItem = _props.setNavActiveItem;


      return (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        reactfrom_dll_reference_vendor_default.a.createElement(
          components_TabOutside,
          { disabled: this.isHidden(), callback: clearNavActiveItem },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "nav",
            {
              "aria-hidden": this.isHidden(),
              className: LargePrimaryNavigation_cx([LargePrimaryNavigation_default.a.container], defineProperty_default()({}, LargePrimaryNavigation_default.a.container__hidden, this.isHidden())),
              "data-testid": "primarynav-large",
              ref: function ref(container) {
                return _this2.container = container;
              }
            },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: LargePrimaryNavigation_default.a.navigation },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                {
                  className: LargePrimaryNavigation_default.a.navButtons,
                  role: "tablist",
                  onFocus: function onFocus() {
                    !largeNavActiveItemId ? setNavActiveItem(items[0].id) : null;
                  },
                  onKeyDown: this.handleTabListEvents
                },
                items.map(function (_ref2, index) {
                  var _cx3;

                  var id = _ref2.id,
                      label = _ref2.label,
                      largeScreenStyleType = _ref2.largeScreenStyleType;
                  return reactfrom_dll_reference_vendor_default.a.createElement(
                    "button",
                    {
                      key: id,
                      "data-id": id,
                      "data-index": index,
                      role: "tab",
                      tabIndex: id === largeNavActiveItemId || !largeNavActiveItemId && index === 0 ? "0" : "-1",
                      className: LargePrimaryNavigation_cx(LargePrimaryNavigation_default.a.navButton, defineProperty_default()({}, LargePrimaryNavigation_default.a.navButton__active, id === largeNavActiveItemId)),
                      "data-testid": "primarynav-button",
                      onClick: _this2.handleClick,
                      onMouseEnter: _this2.handleMouseEnter,
                      onMouseLeave: _this2.handleMouseLeave,
                      onTouchStart: _this2.handleTouchStart
                    },
                    reactfrom_dll_reference_vendor_default.a.createElement(
                      "span",
                      {
                        className: LargePrimaryNavigation_cx((_cx3 = {}, defineProperty_default()(_cx3, LargePrimaryNavigation_default.a.slant, largeScreenStyleType === "sale"), defineProperty_default()(_cx3, LargePrimaryNavigation_default.a.bold, largeScreenStyleType === "premium"), _cx3))
                      },
                      reactfrom_dll_reference_vendor_default.a.createElement(
                        "span",
                        null,
                        label
                      )
                    )
                  );
                })
              ),
              items.map(function (item) {
                return reactfrom_dll_reference_vendor_default.a.createElement(
                  "div",
                  { role: "tabpanel", key: item.id, className: "tabpanel" },
                  reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_LargeSecondaryNavigation, {
                    item: item,
                    hasClickedInside: _this2.hasClickedInside
                  })
                );
              })
            )
          )
        )
      );
    }
  }]);

  return LargePrimaryNavigation;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var Navigation_LargePrimaryNavigation_LargePrimaryNavigation = (Viewport_withViewport(LargePrimaryNavigation_LargePrimaryNavigation));
// CONCATENATED MODULE: ./template/components/Navigation/LargePrimaryNavigation/index.js






var LargePrimaryNavigation_itemsSelector = function itemsSelector(forGender, state) {
  switch (forGender) {
    case MALE:
      return maleLargePrimaryNavigationItems(state);
    case FEMALE:
      return femaleLargePrimaryNavigationItems(state);
    default:
      return [];
  }
};

var LargePrimaryNavigation_mapStateToProps = function mapStateToProps(state, _ref) {
  var forGender = _ref.forGender;
  return {
    currentGender: state.layout.gender,
    items: LargePrimaryNavigation_itemsSelector(forGender, state),
    largeNavActiveItemId: getNavActiveItem(state)
  };
};

var LargePrimaryNavigation_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ setNavActiveItem: actions_setNavActiveItem, clearNavActiveItem: actions_clearNavActiveItem }, dispatch);
};

/* harmony default export */ var components_Navigation_LargePrimaryNavigation = (Object(esfrom_dll_reference_vendor["connect"])(LargePrimaryNavigation_mapStateToProps, LargePrimaryNavigation_mapDispatchToProps)(Navigation_LargePrimaryNavigation_LargePrimaryNavigation));
// CONCATENATED MODULE: ./template/components/Navigation/LargeNavigation/index.js




var LargeNavigation_LargeNavigation = function LargeNavigation() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    null,
    reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_LargePrimaryNavigation, { forGender: FEMALE, viewable: [LARGE_VIEWPORT] }),
    reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_LargePrimaryNavigation, { forGender: MALE, viewable: [LARGE_VIEWPORT] })
  );
};

/* harmony default export */ var Navigation_LargeNavigation = (LargeNavigation_LargeNavigation);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css
var SideNavigationContainer_ViewAllBlock = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css");
var ViewAllBlock_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_ViewAllBlock);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.js





var ViewAllBlock_ViewAllBlock = function ViewAllBlock(_ref) {
  var item = _ref.item;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: ViewAllBlock_default.a.block },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: ViewAllBlock_default.a.fakeOutsideBlock },
      reactfrom_dll_reference_vendor_default.a.createElement(
        Navigation_NavAnchor,
        { item: item },
        item.label
      )
    )
  );
};

/* harmony default export */ var Navigation_SideNavigationContainer_ViewAllBlock = (ViewAllBlock_ViewAllBlock);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/ListContainer/index.css
var SideNavigationContainer_ListContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/ListContainer/index.css");
var ListContainer_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_ListContainer);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/ListContainer/index.js









// At the moment only templateId 4 (Inspiration Item) needs transparent background
var COMPONENT_WITH_NO_BACKGROUND = [4];

var hasNoBackground = function hasNoBackground(_ref) {
  var smallAndMediumTemplateId = _ref.smallAndMediumTemplateId;
  return COMPONENT_WITH_NO_BACKGROUND.indexOf(smallAndMediumTemplateId) !== -1;
};

var ListContainer_cx = classnamesfrom_dll_reference_vendor_default.a.bind(ListContainer_default.a);

var ListContainer_ListContainer = function ListContainer(_ref2) {
  var item = _ref2.item,
      setNavActiveItem = _ref2.setNavActiveItem,
      saveNavigationItem = _ref2.saveNavigationItem;

  var Component = getMobileTemplate(item.smallAndMediumTemplateId);

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "ul",
    {
      className: ListContainer_cx(ListContainer_default.a.container, defineProperty_default()({}, ListContainer_default.a.container__noBackground, hasNoBackground(item))),
      "data-testid": "list-container"
    },
    item.items.map(function (item) {
      if (item.type === "aToZBrands") {
        return reactfrom_dll_reference_vendor_default.a.createElement(Navigation_SideNavigationContainer_ViewAllBlock, { key: item.id, item: item });
      }

      return reactfrom_dll_reference_vendor_default.a.createElement(Component, {
        key: item.id,
        item: item,
        setNavActiveItem: setNavActiveItem,
        saveNavigationItem: saveNavigationItem
      });
    })
  );
};

/* harmony default export */ var Navigation_SideNavigationContainer_ListContainer = (ListContainer_ListContainer);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css
var SideNavigationContainer_CarouselContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css");
var CarouselContainer_default = /*#__PURE__*/__webpack_require__.n(SideNavigationContainer_CarouselContainer);

// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css
var Carousel_CarouselLink = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css");
var CarouselLink_default = /*#__PURE__*/__webpack_require__.n(Carousel_CarouselLink);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.js









var CarouselLink_cx = classnamesfrom_dll_reference_vendor_default.a.bind(this);

var CarouselLink_CarouselLink = function CarouselLink(_ref) {
  var _cx;

  var item = _ref.item,
      className = _ref.className,
      _ref$tabIndex = _ref.tabIndex,
      tabIndex = _ref$tabIndex === undefined ? 0 : _ref$tabIndex;

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "li",
    { className: CarouselLink_cx(CarouselLink_default.a.container, className) },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "a",
      {
        href: addAnalyticsDataToLink_addAnalyticsDataToLink(item),
        className: CarouselLink_default.a.carouselLink,
        tabIndex: tabIndex,
        style: {
          backgroundImage: "url(" + navigationBackgroundImageResolver_getBackgroundImageUrl(item.smallAndMediumImageUrl, 320) + ")"
        }
      },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        {
          className: CarouselLink_cx(CarouselLink_default.a.label, (_cx = {}, defineProperty_default()(_cx, CarouselLink_default.a.label__sale, item.smallAndMediumStyleType === "sale"), defineProperty_default()(_cx, CarouselLink_default.a.label__light, item.smallAndMediumStyleType === "light"), _cx))
        },
        item.smallAndMediumStyleType !== "noTitle" && reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          null,
          truncateTitle(item)
        ),
        item.subtitle && reactfrom_dll_reference_vendor_default.a.createElement(
          "span",
          { className: CarouselLink_default.a.subtitle },
          item.subtitle.substring(0, 24)
        )
      )
    )
  );
};

/* harmony default export */ var CarouselContainer_Carousel_CarouselLink = (CarouselLink_CarouselLink);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css
var CarouselContainer_Carousel = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css");
var Carousel_default = /*#__PURE__*/__webpack_require__.n(CarouselContainer_Carousel);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.js









var Carousel_cx = classnamesfrom_dll_reference_vendor_default.a.bind(Carousel_default.a);

var Carousel_Carousel = function Carousel(_ref) {
  var items = _ref.items,
      currentIndex = _ref.currentIndex,
      swipeOffset = _ref.swipeOffset;

  var activeItemPosition = -100 * currentIndex + "%";

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "ul",
    {
      className: Carousel_cx(Carousel_default.a.list, defineProperty_default()({}, Carousel_default.a.list__animate, swipeOffset === 0)),
      style: {
        transform: "translateX(" + activeItemPosition + ") translateX(" + swipeOffset + "px)"
      },
      "data-testid": "carousel"
    },
    items.map(function (item) {
      return reactfrom_dll_reference_vendor_default.a.createElement(CarouselContainer_Carousel_CarouselLink, {
        key: item.id,
        className: Carousel_default.a.carouselLink,
        item: item,
        tabIndex: items.length > 1 ? -1 : null
      });
    })
  );
};

/* harmony default export */ var SideNavigationContainer_CarouselContainer_Carousel = (Carousel_Carousel);
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css
var NavigationDots = __webpack_require__("./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css");
var NavigationDots_default = /*#__PURE__*/__webpack_require__.n(NavigationDots);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.js







var NavigationDots_cx = classnamesfrom_dll_reference_vendor_default.a.bind(NavigationDots_default.a);

var renderOnlyIf = function renderOnlyIf(predicate, component) {
  return function (props) {
    return predicate(props) ? component(props) : null;
  };
};

var hasMultipleItems = function hasMultipleItems(_ref) {
  var items = _ref.items;
  return items.length > 1;
};

var NavigationDots_NavigationDots = renderOnlyIf(hasMultipleItems, function (_ref2) {
  var items = _ref2.items,
      currentIndex = _ref2.currentIndex,
      setCurrentItem = _ref2.setCurrentItem;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "ul",
    { className: NavigationDots_default.a.dotContainer, "data-testid": "navigation-dots" },
    items.map(function (item, index) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "li",
        { key: item.id, className: NavigationDots_default.a.dotItem },
        reactfrom_dll_reference_vendor_default.a.createElement("button", {
          type: "button",
          className: NavigationDots_cx(NavigationDots_default.a.dot, defineProperty_default()({}, NavigationDots_default.a.dot__selected, index === currentIndex)),
          onClick: setCurrentItem(index),
          onFocus: setCurrentItem(index),
          "aria-label": item.label
        })
      );
    })
  );
});

NavigationDots_NavigationDots.propTypes = {
  items: prop_typesfrom_dll_reference_vendor_default.a.arrayOf(navigationPropType).isRequired,
  currentIndex: prop_typesfrom_dll_reference_vendor_default.a.number.isRequired,
  setCurrentItem: prop_typesfrom_dll_reference_vendor_default.a.func.isRequired
};

/* harmony default export */ var CarouselContainer_NavigationDots = (NavigationDots_NavigationDots);
// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/CarouselContainer.js















var CarouselContainer_cx = bind_default.a.bind(CarouselContainer_default.a);

var CarouselContainer_CarouselContainer = function (_PureComponent) {
  inherits_default()(CarouselContainer, _PureComponent);

  function CarouselContainer() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, CarouselContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = CarouselContainer.__proto__ || get_prototype_of_default()(CarouselContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentIndex: 0,
      swipeOffset: 0
    }, _this.setCurrentItem = function (currentIndex) {
      return function () {
        return _this.setState({ currentIndex: currentIndex });
      };
    }, _this.isNextChevronVisible = function () {
      return _this.state.currentIndex < _this.props.item.items.length - 1;
    }, _this.isPreviousChevronVisible = function () {
      return _this.state.currentIndex > 0;
    }, _this.isSingleItem = function () {
      return _this.props.item.items.length === 1;
    }, _this.startingTouchX = null, _this.touchMoveFrameRequest = null, _this.touchEndFrameRequest = null, _this.touchStart = function (_ref2) {
      var touches = _ref2.touches;

      if (!_this.isSingleItem()) {
        _this.startingTouchX = _this.startingTouchX || touches[0].clientX;
      }
    }, _this.touchMove = function (_ref3) {
      var touches = _ref3.touches;

      cancelAnimationFrame(_this.touchMoveFrameRequest);
      _this.touchMoveFrameRequest = requestAnimationFrame(function () {
        _this.requested = false;
        if (_this.startingTouchX) {
          _this.setState({
            swipeOffset: _this.adjustSwipeOffset(touches[0].clientX - _this.startingTouchX)
          });
        }
      });
    }, _this.touchEnd = function (event) {
      var _this$state = _this.state,
          currentIndex = _this$state.currentIndex,
          swipeOffset = _this$state.swipeOffset;


      if (swipeOffset !== 0) {
        var swipeDirection = swipeOffset > 0 ? -1 : 1;
        cancelAnimationFrame(_this.touchEndFrameRequest);
        _this.touchEndFrameRequest = requestAnimationFrame(function () {
          _this.requested = false;
          _this.setState({
            swipeOffset: 0,
            currentIndex: _this.adjustSuggestedIndex(currentIndex + swipeDirection)
          });
        });
        event.preventDefault();
      }

      _this.startingTouchX = null;
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(CarouselContainer, [{
    key: "adjustSwipeOffset",
    value: function adjustSwipeOffset(suggestedOffset) {
      var currentIndex = this.state.currentIndex;
      var item = this.props.item;

      if (currentIndex === 0) {
        return Math.min(suggestedOffset, 40);
      } else if (currentIndex === item.items.length - 1) {
        return Math.max(suggestedOffset, -40);
      }
      return suggestedOffset;
    }
  }, {
    key: "adjustSuggestedIndex",
    value: function adjustSuggestedIndex(suggestedIndex) {
      var item = this.props.item;

      if (suggestedIndex < 0) {
        return 0;
      }
      if (suggestedIndex > item.items.length - 1) {
        return item.items.length - 1;
      }
      return suggestedIndex;
    }
  }, {
    key: "renderChevrons",
    value: function renderChevrons() {
      var currentIndex = this.state.currentIndex;


      if (this.isSingleItem()) {
        return null;
      }

      return [this.isPreviousChevronVisible() && reactfrom_dll_reference_vendor_default.a.createElement("button", {
        type: "button",
        className: CarouselContainer_default.a.chevronLeft,
        tabIndex: -1,
        onClick: this.setCurrentItem(currentIndex - 1),
        key: "1",
        "aria-hidden": "true",
        "data-testid": "left-chevron"
      }), this.isNextChevronVisible() && reactfrom_dll_reference_vendor_default.a.createElement("button", {
        type: "button",
        className: CarouselContainer_default.a.chevronRight,
        tabIndex: -1,
        onClick: this.setCurrentItem(currentIndex + 1),
        key: "2",
        "aria-hidden": "true",
        "data-testid": "right-chevron"
      })];
    }
  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          currentIndex = _state.currentIndex,
          swipeOffset = _state.swipeOffset;
      var _props = this.props,
          item = _props.item,
          setNavActiveItem = _props.setNavActiveItem,
          saveNavigationItem = _props.saveNavigationItem,
          viewportCategory = _props.viewportCategory,
          sideNavLevel = _props.sideNavLevel;


      var containerClassName = CarouselContainer_cx(CarouselContainer_default.a.container, defineProperty_default()({}, CarouselContainer_default.a.container__extraPadding, item.items.length > 1 && sideNavLevel === PRIMARY));

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: containerClassName },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: CarouselContainer_default.a.hitArea,
            onTouchStart: this.touchStart,
            onTouchMove: this.touchMove,
            onTouchEnd: this.touchEnd,
            onTouchCancel: this.touchEnd,
            "data-testid": "carousel-area"
          },
          reactfrom_dll_reference_vendor_default.a.createElement(SideNavigationContainer_CarouselContainer_Carousel, {
            items: item.items,
            setNavActiveItem: setNavActiveItem,
            saveNavigationItem: saveNavigationItem,
            currentIndex: currentIndex,
            viewportCategory: viewportCategory,
            swipeOffset: swipeOffset
          }),
          reactfrom_dll_reference_vendor_default.a.createElement(CarouselContainer_NavigationDots, {
            items: item.items,
            currentIndex: currentIndex,
            setCurrentItem: this.setCurrentItem
          }),
          this.renderChevrons()
        )
      );
    }
  }]);

  return CarouselContainer;
}(reactfrom_dll_reference_vendor["PureComponent"]);

/* harmony default export */ var SideNavigationContainer_CarouselContainer_CarouselContainer = (CarouselContainer_CarouselContainer);
// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.js




function CarouselContainer_mapStateToProps(state) {
  return {
    viewportCategory: getViewport(state)
  };
}

/* harmony default export */ var Navigation_SideNavigationContainer_CarouselContainer = (Object(esfrom_dll_reference_vendor["connect"])(CarouselContainer_mapStateToProps)(SideNavigationContainer_CarouselContainer_CarouselContainer));
// EXTERNAL MODULE: ./template/components/Navigation/SideNavigationContainer/index.css
var Navigation_SideNavigationContainer = __webpack_require__("./template/components/Navigation/SideNavigationContainer/index.css");
var SideNavigationContainer_default = /*#__PURE__*/__webpack_require__.n(Navigation_SideNavigationContainer);

// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/SideNavigationContainer.js







var sideNavigationContainers = {
  list: Navigation_SideNavigationContainer_ListContainer,
  carousel: Navigation_SideNavigationContainer_CarouselContainer
};

var SideNavigationContainer_renderTitle = function renderTitle(label, styleType) {
  return label && styleType !== "noTitle" ? reactfrom_dll_reference_vendor_default.a.createElement(
    "h3",
    { className: SideNavigationContainer_default.a.title },
    label
  ) : null;
};

var SideNavigationContainer_SideNavigationContainer = function SideNavigationContainer(_ref) {
  var setNavActiveItem = _ref.setNavActiveItem,
      saveNavigationItem = _ref.saveNavigationItem,
      item = _ref.item,
      sideNavLevel = _ref.sideNavLevel;

  var isValidLayout = sideNavigationContainers.hasOwnProperty(item.smallAndMediumLayout);

  var Container = isValidLayout ? sideNavigationContainers[item.smallAndMediumLayout] : Navigation_SideNavigationContainer_ListContainer;

  if (!item.items || !item.items.length) {
    return null;
  }

  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: SideNavigationContainer_default.a.listContainer },
    SideNavigationContainer_renderTitle(item.label, item.smallAndMediumStyleType),
    reactfrom_dll_reference_vendor_default.a.createElement(Container, {
      setNavActiveItem: setNavActiveItem,
      saveNavigationItem: saveNavigationItem,
      item: item,
      sideNavLevel: sideNavLevel
    })
  );
};

SideNavigationContainer_SideNavigationContainer.defaultProps = {
  saveNavigationItem: /* istanbul ignore next */function saveNavigationItem() {}
};

/* harmony default export */ var Navigation_SideNavigationContainer_SideNavigationContainer = (SideNavigationContainer_SideNavigationContainer);
// CONCATENATED MODULE: ./template/components/Navigation/SideNavigationContainer/index.js





function SideNavigationContainer_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ setNavActiveItem: actions_setNavActiveItem }, dispatch);
}

/* harmony default export */ var components_Navigation_SideNavigationContainer = (Object(esfrom_dll_reference_vendor["connect"])(null, SideNavigationContainer_mapDispatchToProps)(Navigation_SideNavigationContainer_SideNavigationContainer));
// EXTERNAL MODULE: ./template/components/Navigation/SidePrimaryNavigation/index.css
var Navigation_SidePrimaryNavigation = __webpack_require__("./template/components/Navigation/SidePrimaryNavigation/index.css");
var SidePrimaryNavigation_default = /*#__PURE__*/__webpack_require__.n(Navigation_SidePrimaryNavigation);

// CONCATENATED MODULE: ./template/components/Navigation/SidePrimaryNavigation/index.js













var SidePrimaryNavigation_isVisible = function isVisible(navActiveItem, forGender, currentGender) {
  return !navActiveItem && (forGender === currentGender || forGender === FEMALE && currentGender === DEFAULT);
};

var SidePrimaryNavigation_SidePrimaryNavigation = function (_Component) {
  inherits_default()(SidePrimaryNavigation, _Component);

  function SidePrimaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, SidePrimaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = SidePrimaryNavigation.__proto__ || get_prototype_of_default()(SidePrimaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.selectFirstNavigationItem = /* istanbul ignore next - focus is not supported in jsdom  */function (selectedGender) {
      if (selectedGender === _this.props.forGender) {
        _this.firstItem && _this.firstItem.focus();
      }
    }, _this.handleKeyDown = /* istanbul ignore next - focus is not supported in jsdom  */function (event) {
      if (event.key === globalEventHandler_keys.tab && event.originalEvent.shiftKey) {
        if (_this.firstItem && _this.firstItem === document.activeElement) {
          event.originalEvent.preventDefault();
          focusFloorNavigationFor(_this.props.forGender);
        }
      }
    }, _this.saveNavigationItem = /* istanbul ignore next - focus is not supported in jsdom  */function (component) {
      if (typeof _this.firstItem === "undefined") {
        _this.firstItem = component;
      }
    }, _this.renderContainer = function (item) {
      return reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SideNavigationContainer, {
        key: item.id,
        item: item,
        setNavActiveItem: _this.props.setNavActiveItem,
        saveNavigationItem: _this.saveNavigationItem,
        sideNavLevel: PRIMARY
      });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(SidePrimaryNavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.removeFloorSelectedEventHandler = template_globalEventHandler.addListener(globalEventHandler_events.focusFirstPrimaryNavigationItem, this.selectFirstNavigationItem);

      this.keyDownEventListener = template_globalEventHandler.addListener(globalEventHandler_events.keyDown, this.handleKeyDown);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeFloorSelectedEventHandler && this.removeFloorSelectedEventHandler.remove();
      this.keyDownEventListener && this.keyDownEventListener.remove();
    }

    // will use item.display.mobileDisplayLayout to decide the type of the container

  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          forGender = _props.forGender,
          currentGender = _props.currentGender,
          navActiveItem = _props.navActiveItem,
          groupNavigationItems = _props.items;

      var visible = SidePrimaryNavigation_isVisible(navActiveItem, forGender, currentGender);

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "nav",
        {
          className: SidePrimaryNavigation_default.a.container,
          "aria-hidden": !visible,
          "data-testid": "sidePanel-itemsList"
        },
        groupNavigationItems.map(this.renderContainer)
      );
    }
  }]);

  return SidePrimaryNavigation;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_Navigation_SidePrimaryNavigation = (SidePrimaryNavigation_SidePrimaryNavigation);
// EXTERNAL MODULE: ./template/components/Navigation/SideSecondaryNavigation/index.css
var Navigation_SideSecondaryNavigation = __webpack_require__("./template/components/Navigation/SideSecondaryNavigation/index.css");
var SideSecondaryNavigation_default = /*#__PURE__*/__webpack_require__.n(Navigation_SideSecondaryNavigation);

// CONCATENATED MODULE: ./template/components/Navigation/SideSecondaryNavigation/index.js















var SideSecondaryNavigation_cx = classnamesfrom_dll_reference_vendor_default.a.bind(SideSecondaryNavigation_default.a);

var SideSecondaryNavigation_SideSecondaryNavigation = function (_PureComponent) {
  inherits_default()(SideSecondaryNavigation, _PureComponent);

  function SideSecondaryNavigation() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, SideSecondaryNavigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = SideSecondaryNavigation.__proto__ || get_prototype_of_default()(SideSecondaryNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.state = { animating: "" }, _this.renderNavigationPanel = function (_ref2) {
      var label = _ref2.label,
          id = _ref2.id,
          items = _ref2.items;
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          key: id,
          className: SideSecondaryNavigation_cx(SideSecondaryNavigation_default.a.item, defineProperty_default()({}, SideSecondaryNavigation_default.a.item__visible, _this.props.navActiveItem === id || _this.state.animating === id))
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "section",
          { className: SideSecondaryNavigation_default.a.header },
          _this.renderCloseSecondaryButton(),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "h3",
            null,
            label
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "nav",
          { className: SideSecondaryNavigation_default.a.secondary, ref: function ref(el) {
              return el && (el.scrollTop = 0);
            } },
          !items.length ? reactfrom_dll_reference_vendor_default.a.createElement(template_components_Spinner, { size: "x-large", position: "centre" }) : items.map(function (item) {
            return reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SideNavigationContainer, {
              key: item.id,
              item: item,
              sideNavLevel: SECONDARY
            });
          })
        )
      );
    }, _this.clearNavActiveItem = function () {
      _this.setState({ animating: _this.props.navActiveItem });
      _this.props.clearNavActiveItem();
    }, _this.renderCloseSecondaryButton = function () {
      return reactfrom_dll_reference_vendor_default.a.createElement("button", { className: SideSecondaryNavigation_default.a.close, onClick: _this.clearNavActiveItem });
    }, _this.saveSecondaryPanel = function (component) {
      return _this.secondaryPanel = component;
    }, _this.isVisible = function () {
      var _this$props = _this.props,
          forGender = _this$props.forGender,
          currentGender = _this$props.currentGender,
          navActiveItem = _this$props.navActiveItem;


      return !!navActiveItem && (forGender === currentGender || forGender === FEMALE && currentGender === DEFAULT);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(SideSecondaryNavigation, [{
    key: "componentDidMount",


    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
    value: function componentDidMount() {
      var _this2 = this;

      this.secondaryPanel.addEventListener("transitionend", function (_ref3) {
        var target = _ref3.target,
            currentTarget = _ref3.currentTarget;

        if (target === currentTarget) {
          _this2.setState({ animating: "" });
        }
      });
    }

    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentWillUnmmount",
    value: function componentWillUnmmount() {
      this.secondaryPanel.removeEventListener("transitionend");
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var groupNavigationItems = this.props.items;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          className: SideSecondaryNavigation_cx(SideSecondaryNavigation_default.a.container, defineProperty_default()({}, SideSecondaryNavigation_default.a.container__visible, this.isVisible())),
          ref: this.saveSecondaryPanel,
          "aria-hidden": !this.isVisible(),
          "data-testid": "secondary-nav"
        },
        groupNavigationItems.map(function (_ref4) {
          var primaryNavigationItems = _ref4.items;
          return primaryNavigationItems.map(_this3.renderNavigationPanel);
        })
      );
    }
  }]);

  return SideSecondaryNavigation;
}(reactfrom_dll_reference_vendor["PureComponent"]);

/* harmony default export */ var components_Navigation_SideSecondaryNavigation = (SideSecondaryNavigation_SideSecondaryNavigation);
// EXTERNAL MODULE: ./template/components/LegalBar/LegalBar.css
var LegalBar_LegalBar = __webpack_require__("./template/components/LegalBar/LegalBar.css");
var LegalBar_default = /*#__PURE__*/__webpack_require__.n(LegalBar_LegalBar);

// CONCATENATED MODULE: ./template/components/LegalBar/LegalBar.js





var LegalBar_LegalBar_LegalBar = function LegalBar(_ref) {
  var formatTranslation = _ref.formatTranslation,
      defaultStoreUrl = _ref.defaultStoreUrl;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: LegalBar_default.a.container },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: LegalBar_default.a.body, "data-testid": "legalbar" },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        { className: LegalBar_default.a.copyright },
        "\xA9 ",
        new Date().getFullYear(),
        " ASOS"
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "ul",
        { className: LegalBar_default.a.links },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.PrivacyLink"))
            },
            formatTranslation("LegalBar.Privacy")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.TermsLink"))
            },
            formatTranslation("LegalBar.Terms")
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          { className: LegalBar_default.a.hideOnSmallViewport },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              href: defaultStoreUrl.concat(formatTranslation("LegalBar.AccessibilityLink"))
            },
            formatTranslation("LegalBar.Accessibility")
          )
        )
      )
    )
  );
};

/* harmony default export */ var components_LegalBar_LegalBar = (translation(LegalBar_LegalBar_LegalBar));
// CONCATENATED MODULE: ./template/components/LegalBar/index.js





function LegalBar_mapStateToProps(state) {
  return {
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

/* harmony default export */ var components_LegalBar = (Object(esfrom_dll_reference_vendor["connect"])(LegalBar_mapStateToProps)(components_LegalBar_LegalBar));
// EXTERNAL MODULE: ./template/components/Footer/LinkGroup/index.css
var Footer_LinkGroup = __webpack_require__("./template/components/Footer/LinkGroup/index.css");
var LinkGroup_default = /*#__PURE__*/__webpack_require__.n(Footer_LinkGroup);

// CONCATENATED MODULE: ./template/components/Footer/LinkGroup/LinkGroup.js













var LinkGroup_cx = classnamesfrom_dll_reference_vendor_default.a.bind(LinkGroup_default.a);

var LinkGroup_LinkGroup = function (_Component) {
  inherits_default()(LinkGroup, _Component);

  function LinkGroup() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, LinkGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = LinkGroup.__proto__ || get_prototype_of_default()(LinkGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      hideFocus: false
    }, _this.handleOpen = function (e) {
      var isAccordion = _this.props.isAccordion;


      if (!isAccordion) {
        e.preventDefault();
      } else if (!_this.details.open) {
        trackNavOpen({
          context: ANALYTICS_CONTEXT.footerExpandable,
          elementText: _this.props.groupItem.label,
          interaction: ANALYTICS_INTERACTION_EXPAND,
          properties: {
            positionOnPage: ANALYTICS_POSITION_FOOTER
          }
        });
      }
    }, _this.handleMouseDown = function () {
      _this.setState({ hideFocus: true });
    }, _this.handleBlur = function () {
      _this.setState({ hideFocus: false });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(LinkGroup, [{
    key: "render",


    /* eslint-disable jsx-a11y/no-static-element-interactions */
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          country = _props.countryCode,
          groupItem = _props.groupItem,
          isAccordion = _props.isAccordion,
          keyStoreDataversion = _props.keyStoreDataversion,
          lang = _props.lang,
          store = _props.storeCode;


      var withAdditionalParams = function withAdditionalParams(link, alias) {
        if (alias === "track_my_order") {
          return queryString_withParams(link, {
            country: country,
            keyStoreDataversion: keyStoreDataversion,
            lang: lang,
            store: store
          });
        }

        if (link.indexOf("marketplace") !== -1) {
          return queryString_withParams(link, {
            ctaref: "Global footer"
          });
        }

        return link;
      };

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "details",
        {
          className: LinkGroup_default.a.container,
          open: !isAccordion,
          "data-testid": "footer-links",
          ref: function ref(e) {
            return _this2.details = e;
          }
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "summary",
          {
            className: LinkGroup_cx(LinkGroup_default.a.header, defineProperty_default()({}, LinkGroup_default.a.header__focused, this.state.hideFocus)),
            onMouseDown: this.handleMouseDown,
            onClick: this.handleOpen,
            onKeyPress: this.handleOpen,
            onBlur: this.handleBlur,
            tabIndex: !isAccordion ? -1 : null,
            role: isAccordion ? "button" : null
          },
          groupItem.label
        ),
        groupItem.items.map(function (_ref2) {
          var alias = _ref2.alias,
              id = _ref2.id,
              label = _ref2.label,
              link = _ref2.link,
              linkType = _ref2.linkType;
          return reactfrom_dll_reference_vendor_default.a.createElement(
            "a",
            {
              key: id,
              className: LinkGroup_default.a.link,
              href: withAdditionalParams(link, alias),
              target: linkType === "external" ? "_blank" : "_self"
            },
            label
          );
        })
      );
    }
    /* eslint-enable */

  }]);

  return LinkGroup;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var Footer_LinkGroup_LinkGroup = (LinkGroup_LinkGroup);
// CONCATENATED MODULE: ./template/components/Footer/LinkGroup/index.js





function LinkGroup_mapStateToProps(state) {
  return {
    storeCode: selectors_getStoreCode(state),
    lang: getDefaultLanguage(state),
    countryCode: getCountryCode(state),
    keyStoreDataversion: selectors_getKeyStoreDataversion(state)
  };
}

/* harmony default export */ var components_Footer_LinkGroup = (Object(esfrom_dll_reference_vendor["connect"])(LinkGroup_mapStateToProps)(Footer_LinkGroup_LinkGroup));
// EXTERNAL MODULE: ./template/components/Footer/Links.css
var Footer_Links = __webpack_require__("./template/components/Footer/Links.css");
var Links_default = /*#__PURE__*/__webpack_require__.n(Footer_Links);

// CONCATENATED MODULE: ./template/components/Footer/Links.js







var Links_Links = function Links(_ref) {
  var groupItems = _ref.items,
      isAccordion = _ref.isAccordion;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: Links_default.a.container },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: Links_default.a.body },
      groupItems.map(function (groupItem) {
        return reactfrom_dll_reference_vendor_default.a.createElement(components_Footer_LinkGroup, {
          key: groupItem.id,
          groupItem: groupItem,
          isAccordion: isAccordion
        });
      }),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Links_default.a.group },
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_CountrySelectorButton, {
          withLabels: true,
          position: ANALYTICS_POSITION_FOOTER
        })
      )
    )
  );
};

Links_Links.defaultProps = {
  isAccordion: false
};

/* harmony default export */ var components_Footer_Links = (Links_Links);
// EXTERNAL MODULE: ./template/components/Footer/Footer.css
var Footer_Footer = __webpack_require__("./template/components/Footer/Footer.css");
var Footer_Footer_default = /*#__PURE__*/__webpack_require__.n(Footer_Footer);

// EXTERNAL MODULE: ./template/components/Footer/SocialLinks/index.css
var Footer_SocialLinks = __webpack_require__("./template/components/Footer/SocialLinks/index.css");
var SocialLinks_default = /*#__PURE__*/__webpack_require__.n(Footer_SocialLinks);

// CONCATENATED MODULE: ./template/components/Footer/SocialLinks/SocialLinks.js








var SocialLinks_SocialLinks = function SocialLinks(_ref) {
  var links = _ref.links;
  return links ? reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: SocialLinks_default.a.socialLinks, "data-testid": "social-links-bar" },
    keys_default()(links).map(function (link, index) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "a",
        {
          title: link,
          className: classnamesfrom_dll_reference_vendor_default()(SocialLinks_default.a.socialLink, SocialLinks_default.a[link]),
          href: links[link],
          target: "_blank",
          onClick: function onClick() {
            return trackClick(link);
          },
          key: index,
          "data-testid": "social-link"
        },
        link
      );
    })
  ) : null;
};

function trackClick(name) {
  trackSocialClick({
    context: ANALYTICS_CONTEXT.social,
    interaction: ANALYTICS_INTERACTION_CLICK,
    elementText: name.toLowerCase(),
    properties: {
      positionOnPage: ANALYTICS_POSITION_FOOTER
    }
  });
}

/* harmony default export */ var Footer_SocialLinks_SocialLinks = (translation(SocialLinks_SocialLinks));
// CONCATENATED MODULE: ./template/components/Footer/SocialLinks/index.js




function SocialLinks_mapStateToProps(state) {
  return {
    links: selectors_getSocialLinks(state)
  };
}

/* harmony default export */ var components_Footer_SocialLinks = (Object(esfrom_dll_reference_vendor["connect"])(SocialLinks_mapStateToProps, null)(Footer_SocialLinks_SocialLinks));
// EXTERNAL MODULE: ./template/components/Footer/PaymentOptions/index.css
var Footer_PaymentOptions = __webpack_require__("./template/components/Footer/PaymentOptions/index.css");
var PaymentOptions_default = /*#__PURE__*/__webpack_require__.n(Footer_PaymentOptions);

// CONCATENATED MODULE: ./template/components/Footer/PaymentOptions/PaymentOptions.js





var PaymentOptions_maxProvidersFor = function maxProvidersFor(viewport) {
  return viewport === MEDIUM_VIEWPORT ? 7 : 10;
};

var PaymentOptions_PaymentOptions = function PaymentOptions(_ref) {
  var paymentProviders = _ref.paymentProviders,
      viewport = _ref.viewport;
  return viewport !== SMALL_VIEWPORT && reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: PaymentOptions_default.a.paymentOptions },
    paymentProviders.slice(0, PaymentOptions_maxProvidersFor(viewport)).map(function (provider) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "span",
        { key: provider.name, className: PaymentOptions_default.a.provider },
        reactfrom_dll_reference_vendor_default.a.createElement("img", { src: provider.logo, alt: provider.name })
      );
    })
  );
};

/* harmony default export */ var Footer_PaymentOptions_PaymentOptions = (PaymentOptions_PaymentOptions);
// CONCATENATED MODULE: ./template/components/Footer/PaymentOptions/index.js





function PaymentOptions_mapStateToProps(state) {
  return {
    paymentProviders: getPaymentProviders(state),
    viewport: getViewport(state)
  };
}

/* harmony default export */ var components_Footer_PaymentOptions = (Object(esfrom_dll_reference_vendor["connect"])(PaymentOptions_mapStateToProps)(Footer_PaymentOptions_PaymentOptions));
// CONCATENATED MODULE: ./template/components/Footer/Footer.js













var Footer_cx = bind_default.a.bind(Footer_Footer_default.a);

var Footer_Footer_Footer = function Footer(_ref) {
  var isAccordion = _ref.isAccordion,
      items = _ref.items;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "footer",
    {
      className: Footer_cx(Footer_Footer_default.a.container, defineProperty_default()({}, Footer_Footer_default.a.container__accordion, isAccordion)),
      "data-testid": "footer"
    },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: Footer_Footer_default.a.mainContent },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Footer_Footer_default.a.iconBar },
        reactfrom_dll_reference_vendor_default.a.createElement(components_Footer_SocialLinks, null),
        reactfrom_dll_reference_vendor_default.a.createElement(components_Footer_PaymentOptions, null)
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Footer_Footer_default.a.greeterWrapper },
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_Greeter, { viewable: [SMALL_VIEWPORT] })
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: Footer_Footer_default.a.myAccountLinksWrapper },
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_MyAccountLinks, {
          viewable: [SMALL_VIEWPORT],
          queryParams: { nlid: "nav footer" }
        })
      ),
      reactfrom_dll_reference_vendor_default.a.createElement(components_Footer_Links, { items: items, isAccordion: isAccordion })
    ),
    reactfrom_dll_reference_vendor_default.a.createElement(components_LegalBar, null)
  );
};

/* harmony default export */ var components_Footer_Footer = (Footer_Footer_Footer);
// CONCATENATED MODULE: ./template/components/Footer/index.js




function Footer_mapStateToProps(state) {
  return {
    items: footerNavigation(state)
  };
}

/* harmony default export */ var components_Footer = (Object(esfrom_dll_reference_vendor["connect"])(Footer_mapStateToProps)(components_Footer_Footer));
// EXTERNAL MODULE: ./template/components/Navigation/SidePanel/index.css
var Navigation_SidePanel = __webpack_require__("./template/components/Navigation/SidePanel/index.css");
var SidePanel_default = /*#__PURE__*/__webpack_require__.n(Navigation_SidePanel);

// CONCATENATED MODULE: ./template/components/Navigation/SidePanel/SidePanel.js





















var SidePanel_cx = bind_default.a.bind(SidePanel_default.a);

var SidePanel_SidePanel = function (_PureComponent) {
  inherits_default()(SidePanel, _PureComponent);

  function SidePanel() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, SidePanel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = SidePanel.__proto__ || get_prototype_of_default()(SidePanel)).call.apply(_ref, [this].concat(args))), _this), _this.shouldAnimate = false, _this.handleTransitionEnd = /* istanbul ignore next - dom el eventlistener is not supported in jsdom */function (_ref2) {
      var target = _ref2.target,
          currentTarget = _ref2.currentTarget;

      _this.triggerRedraw();
      if (target === currentTarget) {
        _this.props.clearNavActiveItem();
      }
    }, _this.saveDialog = function (component) {
      return _this.dialog = component;
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(SidePanel, [{
    key: "componentDidUpdate",


    /* istanbul ignore next - focus is not supported in jsdom */
    value: function componentDidUpdate(_ref3) {
      var isSidePanelOpen = _ref3.isSidePanelOpen;

      if (this.props.isSidePanelOpen !== isSidePanelOpen && this.component) {
        this.component.focus();
      }
    }
    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.dialog.addEventListener("transitionend", this.handleTransitionEnd);
    }

    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.dialog.removeEventListener("transitionend", this.handleTransitionEnd);
    }
  }, {
    key: "triggerRedraw",


    /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
    value: function triggerRedraw() {
      this.dialog.style.display = "none";
      this.dialog.offsetHeight;
      this.dialog.style.display = "block";
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this,
          _cx2,
          _cx3;

      var _props = this.props,
          formatTranslation = _props.formatTranslation,
          isSidePanelOpen = _props.isSidePanelOpen,
          isVisible = _props.isVisible,
          closeSidePanel = _props.closeSidePanel,
          navActiveItem = _props.navActiveItem,
          setNavActiveItem = _props.setNavActiveItem,
          clearNavActiveItem = _props.clearNavActiveItem,
          currentGender = _props.currentGender,
          maleItems = _props.maleItems,
          femaleItems = _props.femaleItems;

      this.shouldAnimate = this.shouldAnimate || isSidePanelOpen && isVisible;

      var navProps = {
        currentGender: currentGender,
        navActiveItem: navActiveItem,
        setNavActiveItem: setNavActiveItem,
        clearNavActiveItem: clearNavActiveItem
      };

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            role: "dialog",
            "aria-label": formatTranslation("SidePanel.NavigationLabel"),
            "aria-hidden": !isSidePanelOpen,
            ref: this.saveDialog,
            className: SidePanel_cx(SidePanel_default.a.dialog, (_cx = {}, defineProperty_default()(_cx, SidePanel_default.a.dialog__visible, isSidePanelOpen && isVisible), defineProperty_default()(_cx, SidePanel_default.a.dialog__animate, this.shouldAnimate), _cx)),
            "data-testid": "sidepanel"
          },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: SidePanel_default.a.container },
            reactfrom_dll_reference_vendor_default.a.createElement("button", {
              className: SidePanel_default.a.close,
              onClick: closeSidePanel,
              "aria-label": formatTranslation("SidePanel.CloseNavigationLabel"),
              ref: function ref(c) {
                return _this2.component = c;
              },
              "data-testid": "close-button"
            }),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: SidePanel_default.a.dontHideButtonContainer },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                {
                  className: SidePanel_cx(SidePanel_default.a.primarySideContainer, (_cx2 = {}, defineProperty_default()(_cx2, SidePanel_default.a.primarySideContainer__hidden, !!navActiveItem), defineProperty_default()(_cx2, SidePanel_default.a.primarySideContainer__animate, this.shouldAnimate), _cx2))
                },
                reactfrom_dll_reference_vendor_default.a.createElement(components_FloorNavigation, { viewable: [SMALL_VIEWPORT, MEDIUM_VIEWPORT] }),
                reactfrom_dll_reference_vendor_default.a.createElement(
                  "div",
                  { className: SidePanel_default.a.content },
                  reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SidePrimaryNavigation, extends_default()({}, navProps, {
                    items: femaleItems,
                    forGender: FEMALE
                  })),
                  reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SidePrimaryNavigation, extends_default()({}, navProps, {
                    items: maleItems,
                    forGender: MALE
                  })),
                  reactfrom_dll_reference_vendor_default.a.createElement(components_Footer, { isAccordion: true })
                )
              ),
              reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SideSecondaryNavigation, extends_default()({}, navProps, {
                items: femaleItems,
                forGender: FEMALE
              })),
              reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SideSecondaryNavigation, extends_default()({}, navProps, {
                items: maleItems,
                forGender: MALE
              }))
            )
          )
        ),
        reactfrom_dll_reference_vendor_default.a.createElement("aside", {
          className: SidePanel_cx(SidePanel_default.a.overlay, (_cx3 = {}, defineProperty_default()(_cx3, SidePanel_default.a.overlay__show, isSidePanelOpen && isVisible), defineProperty_default()(_cx3, SidePanel_default.a.overlay__animate, this.shouldAnimate), _cx3)),
          role: "button",
          onClick: closeSidePanel,
          onTouchMove: function onTouchMove(event) {
            event.preventDefault();
            return false;
          },
          "aria-hidden": "true"
        })
      );
    }
  }]);

  return SidePanel;
}(reactfrom_dll_reference_vendor["PureComponent"]);

/* harmony default export */ var Navigation_SidePanel_SidePanel = (Viewport_withViewport(translation(SidePanel_SidePanel)));
// CONCATENATED MODULE: ./template/components/Navigation/SidePanel/index.js






var SidePanel_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ closeSidePanel: actions_closeSidePanel, clearNavActiveItem: actions_clearNavActiveItem, setNavActiveItem: actions_setNavActiveItem }, dispatch);
};

var SidePanel_mapStateToProps = function mapStateToProps(state) {
  return {
    isSidePanelOpen: selectors_isSidePanelOpen(state),
    navActiveItem: getNavActiveItem(state),
    currentGender: getCurrentGender(state),
    maleItems: maleSidePrimaryNavigationItems(state),
    femaleItems: femaleSidePrimaryNavigationItems(state)
  };
};

/* harmony default export */ var components_Navigation_SidePanel = (Object(esfrom_dll_reference_vendor["connect"])(SidePanel_mapStateToProps, SidePanel_mapDispatchToProps)(Navigation_SidePanel_SidePanel));
// EXTERNAL MODULE: ./template/components/Header/CookieDisclaimer/index.css
var Header_CookieDisclaimer = __webpack_require__("./template/components/Header/CookieDisclaimer/index.css");
var CookieDisclaimer_default = /*#__PURE__*/__webpack_require__.n(Header_CookieDisclaimer);

// CONCATENATED MODULE: ./template/components/Header/CookieDisclaimer/CookieDisclaimer.js





var CookieDisclaimer_CookieDisclaimer = function CookieDisclaimer(props) {
  var formatTranslation = props.formatTranslation,
      closeCookieMessage = props.closeCookieMessage,
      cookieMessageOpen = props.cookieMessageOpen,
      isSidePanelOpen = props.isSidePanelOpen,
      defaultStoreUrl = props.defaultStoreUrl;


  var shouldDisplayCookieDisclaimer = !isSidePanelOpen && cookieMessageOpen;

  return shouldDisplayCookieDisclaimer ? reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: CookieDisclaimer_default.a.cookieDisclaimer },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: CookieDisclaimer_default.a.container, "data-testid": "cookie-disclaimer" },
      reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        { className: CookieDisclaimer_default.a.summary },
        formatTranslation("CookieDisclaimer.summary"),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "a",
          {
            className: CookieDisclaimer_default.a.readMore,
            href: defaultStoreUrl.concat(formatTranslation("CookieDisclaimer.link"))
          },
          formatTranslation("CookieDisclaimer.readMore")
        )
      ),
      reactfrom_dll_reference_vendor_default.a.createElement("button", {
        type: "button",
        className: CookieDisclaimer_default.a.closeButton,
        onClick: closeCookieMessage,
        "data-testid": "close-button",
        "aria-label": formatTranslation("Icon.Close")
      })
    )
  ) : null;
};

/* harmony default export */ var Header_CookieDisclaimer_CookieDisclaimer = (translation(CookieDisclaimer_CookieDisclaimer));
// CONCATENATED MODULE: ./template/components/Header/CookieDisclaimer/index.js







function CookieDisclaimer_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ closeCookieMessage: actions_closeCookieMessage }, dispatch);
}

function CookieDisclaimer_mapStateToProps(state) {
  return {
    cookieMessageOpen: isCookieMessageOpen(state),
    isSidePanelOpen: selectors_isSidePanelOpen(state),
    defaultStoreUrl: getDefaultStoreUrl(state)
  };
}

/* harmony default export */ var components_Header_CookieDisclaimer = (Object(esfrom_dll_reference_vendor["connect"])(CookieDisclaimer_mapStateToProps, CookieDisclaimer_mapDispatchToProps)(Header_CookieDisclaimer_CookieDisclaimer));
// EXTERNAL MODULE: ./template/components/UnsupportedBrowserMessage/index.css
var components_UnsupportedBrowserMessage = __webpack_require__("./template/components/UnsupportedBrowserMessage/index.css");
var UnsupportedBrowserMessage_default = /*#__PURE__*/__webpack_require__.n(components_UnsupportedBrowserMessage);

// CONCATENATED MODULE: ./template/components/UnsupportedBrowserMessage/index.js










var UnsupportedBrowserMessage_UnsupportedBrowserMessage = function (_Component) {
  inherits_default()(UnsupportedBrowserMessage, _Component);

  function UnsupportedBrowserMessage() {
    classCallCheck_default()(this, UnsupportedBrowserMessage);

    return possibleConstructorReturn_default()(this, (UnsupportedBrowserMessage.__proto__ || get_prototype_of_default()(UnsupportedBrowserMessage)).apply(this, arguments));
  }

  createClass_default()(UnsupportedBrowserMessage, [{
    key: "render",
    value: function render() {
      var formatTranslation = this.props.formatTranslation;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          className: UnsupportedBrowserMessage_default.a.container,
          "data-testid": "unsupported-browser-message"
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: UnsupportedBrowserMessage_default.a.content },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: UnsupportedBrowserMessage_default.a.message },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: UnsupportedBrowserMessage_default.a.header },
              formatTranslation("UnsupportedBrowserMessage.Header")
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: UnsupportedBrowserMessage_default.a.details },
              formatTranslation("UnsupportedBrowserMessage.Details")
            )
          )
        )
      );
    }
  }]);

  return UnsupportedBrowserMessage;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var template_components_UnsupportedBrowserMessage = (translation(UnsupportedBrowserMessage_UnsupportedBrowserMessage));
// CONCATENATED MODULE: ./template/components/LayoutManager/LayoutManager.js









var MEDIUM_VIEWPORT_MEDIA = "(min-width: 768px)";
var LARGE_VIEWPORT_MEDIA = "(min-width: 1024px)";

var LayoutManager_LayoutManager = function (_Component) {
  inherits_default()(LayoutManager, _Component);

  function LayoutManager() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, LayoutManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = LayoutManager.__proto__ || get_prototype_of_default()(LayoutManager)).call.apply(_ref, [this].concat(args))), _this), _this.watchers = {}, _this.onResize = function () {
      var _this$watchers = _this.watchers,
          medium = _this$watchers.medium,
          large = _this$watchers.large;
      var _this$props = _this.props,
          updateViewportCategory = _this$props.updateViewportCategory,
          closeSidePanel = _this$props.closeSidePanel;


      if (large.matches) {
        updateViewportCategory(LARGE_VIEWPORT);
        closeSidePanel();
      } else if (medium.matches) {
        updateViewportCategory(MEDIUM_VIEWPORT);
      } else {
        updateViewportCategory(SMALL_VIEWPORT);
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(LayoutManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.watchers.medium = window.matchMedia(MEDIUM_VIEWPORT_MEDIA);
      this.watchers.large = window.matchMedia(LARGE_VIEWPORT_MEDIA);
      setTimeout(function () {
        // don't change state too early
        // if not, we will get warning
        // in react if the user has a different
        // viewport as expected
        _this2.onResize();
      }, 0);
      this.watchers.medium.addListener(this.onResize);
      this.watchers.large.addListener(this.onResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _watchers = this.watchers,
          medium = _watchers.medium,
          large = _watchers.large;

      medium.removeListener(this.onResize);
      large.removeListener(this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return LayoutManager;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_LayoutManager_LayoutManager = (LayoutManager_LayoutManager);
// CONCATENATED MODULE: ./template/components/LayoutManager/index.js





var LayoutManager_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    updateViewportCategory: actions_updateViewportCategory,
    closeSidePanel: actions_closeSidePanel
  }, dispatch);
};

var LayoutManager_mapStateToProps = function mapStateToProps(state) {
  return {
    viewportCategory: getViewport(state)
  };
};

/* harmony default export */ var components_LayoutManager = (Object(esfrom_dll_reference_vendor["connect"])(LayoutManager_mapStateToProps, LayoutManager_mapDispatchToProps)(components_LayoutManager_LayoutManager));
// EXTERNAL MODULE: ../node_modules/react-headroom/dist/index.js
var dist = __webpack_require__("../node_modules/react-headroom/dist/index.js");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css
var NotQuiteStickyHeader_NotQuiteStickyHeader = __webpack_require__("./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css");
var NotQuiteStickyHeader_default = /*#__PURE__*/__webpack_require__.n(NotQuiteStickyHeader_NotQuiteStickyHeader);

// CONCATENATED MODULE: ./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.js














var NotQuiteStickyHeader_cx = bind_default.a.bind(NotQuiteStickyHeader_default.a);

var NotQuiteStickyHeader_getCookieMessageOffset = function getCookieMessageOffset(open, viewport) {
  var _offsets;

  if (!open) return 0;

  var offsets = (_offsets = {}, defineProperty_default()(_offsets, LARGE_VIEWPORT, 50), defineProperty_default()(_offsets, MEDIUM_VIEWPORT, 70), defineProperty_default()(_offsets, SMALL_VIEWPORT, 105), _offsets);

  return offsets[viewport];
};

var NotQuiteStickyHeader_NotQuiteStickyHeader_NotQuiteStickyHeader = function (_PureComponent) {
  inherits_default()(NotQuiteStickyHeader, _PureComponent);

  function NotQuiteStickyHeader() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, NotQuiteStickyHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = NotQuiteStickyHeader.__proto__ || get_prototype_of_default()(NotQuiteStickyHeader)).call.apply(_ref, [this].concat(args))), _this), _this.getPinStart = function () {
      var cookieMessageOffset = NotQuiteStickyHeader_getCookieMessageOffset(_this.props.cookieMessageOpen, _this.props.viewportCategory);
      var miscBarHeight = _this.props.viewportCategory === LARGE_VIEWPORT ? 30 : 0;

      return cookieMessageOffset + miscBarHeight;
    }, _this.updateHeadRoom = function () {
      _this.headroom && _this.headroom.handleResize();
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(NotQuiteStickyHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateHeadRoom();
      events.addListener("sc-sticky-header-update", this.updateHeadRoom);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return reactfrom_dll_reference_vendor_default.a.createElement(
        dist_default.a,
        {
          className: NotQuiteStickyHeader_cx("stickyHeader", {
            stickyHeader__sidePanelOpen: this.props.isSidePanelOpen
          }),
          disableInlineStyles: true,
          pinStart: this.getPinStart,
          id: "chrome-sticky-header",
          upTolerance: 17,
          ref: function ref(d) {
            return _this2.headroom = d;
          }
        },
        this.props.children,
        reactfrom_dll_reference_vendor_default.a.createElement("div", { id: "sc-sticky-header-portal" })
      );
    }
  }]);

  return NotQuiteStickyHeader;
}(reactfrom_dll_reference_vendor["PureComponent"]);

/* harmony default export */ var components_NotQuiteStickyHeader_NotQuiteStickyHeader = (NotQuiteStickyHeader_NotQuiteStickyHeader_NotQuiteStickyHeader);
// CONCATENATED MODULE: ./template/components/NotQuiteStickyHeader/index.js




function NotQuiteStickyHeader_mapStateToProps(state) {
  return {
    viewportCategory: getViewport(state),
    isSidePanelOpen: selectors_isSidePanelOpen(state),
    cookieMessageOpen: isCookieMessageOpen(state)
  };
}

/* harmony default export */ var components_NotQuiteStickyHeader = (Object(esfrom_dll_reference_vendor["connect"])(NotQuiteStickyHeader_mapStateToProps)(components_NotQuiteStickyHeader_NotQuiteStickyHeader));
// EXTERNAL MODULE: ../node_modules/asos-content-api-global-banner/dist/asos-content-api-global-banner.min.js
var asos_content_api_global_banner_min = __webpack_require__("../node_modules/asos-content-api-global-banner/dist/asos-content-api-global-banner.min.js");
var asos_content_api_global_banner_min_default = /*#__PURE__*/__webpack_require__.n(asos_content_api_global_banner_min);

// CONCATENATED MODULE: ./template/components/GlobalBanner/WithTargetedContent.js










var WithTargetedContent_WithTargetedContent = function (_React$Component) {
  inherits_default()(WithTargetedContent, _React$Component);

  function WithTargetedContent() {
    classCallCheck_default()(this, WithTargetedContent);

    var _this = possibleConstructorReturn_default()(this, (WithTargetedContent.__proto__ || get_prototype_of_default()(WithTargetedContent)).call(this));

    _this.state = {
      contentRequested: false
    };
    return _this;
  }

  createClass_default()(WithTargetedContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.manageRequest();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.manageRequest();
    }
  }, {
    key: "manageRequest",
    value: function manageRequest() {
      if (this.props.identityHasResponded && !this.state.contentRequested) {
        var parameters = this.getParameters(extends_default()({}, this.props));
        var context = this.getContext(extends_default()({}, this.props));

        this.props.requestTargetedContent(parameters, context);
        this.setState({ contentRequested: true });
      }
    }
  }, {
    key: "getParameters",
    value: function getParameters(props) {
      return {
        country: props.country,
        store: props.store,
        lang: props.lang,
        viewscope: this.getViewScope(),
        keystoredataversion: props.keystoredataversion
      };
    }
  }, {
    key: "getContext",
    value: function getContext(props) {
      return {
        premier: props.premier ? "T" : "F",
        customerStatus: props.isRecognised || props.isLoggedIn ? "known" : "unknown"
      };
    }
  }, {
    key: "getViewScope",
    value: function getViewScope() {
      var metaItem = document.head.querySelector("meta[property='viewscope']");
      return metaItem ? metaItem.getAttribute("content") : null;
    }
  }, {
    key: "render",
    value: function render() {
      var emptyReturnValue = this.props.contentTargetingStatus === "SUCCESS" && !this.props.content;

      if (this.props.contentTargetingStatus === "ERROR" || emptyReturnValue) {
        return null;
      }

      return reactfrom_dll_reference_vendor_default.a.createElement(asos_content_api_global_banner_min_default.a, {
        content: this.props.content,
        status: this.props.contentTargetingStatus
      });
    }
  }]);

  return WithTargetedContent;
}(reactfrom_dll_reference_vendor_default.a.Component);

WithTargetedContent_WithTargetedContent.defaultProps = {
  isRecognised: false
};

/* harmony default export */ var GlobalBanner_WithTargetedContent = (WithTargetedContent_WithTargetedContent);
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/constants.js
var FETCHING_TARGETED_CONTENT = "FETCHING_TARGETED_CONTENT";
var FETCHED_TARGETED_CONTENT = "FETCHED_TARGETED_CONTENT";
var GET_STORED_TARGETED_CONTENT = "GET_STORED_TARGETED_CONTENT";
var API_ERROR = "API_ERROR";

var STATUS_IDLE = "IDLE";
var STATUS_FETCHING = "FETCHING";
var STATUS_SUCCESS = "SUCCESS";
var STATUS_ERROR = "ERROR";
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/events.js
var emitContentTargetingEvent = function emitContentTargetingEvent(data) {
  if (window.asos.contentTargeting) {
    window.asos.contentTargeting.emit(data);
  }
};

var emitNewRelicEvent = function emitNewRelicEvent(data) {
  if (window.NREUM) {
    window.NREUM.addPageAction("globalBannerApiError", data);
  }
};
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/storage.js




var storage_Storage = function () {
  function Storage() {
    classCallCheck_default()(this, Storage);

    this.storageKey = "Asos.Content.Targeting";
    this.storageType = "sessionStorage";
    this.storageTimeout = 300000;
  }

  createClass_default()(Storage, [{
    key: "isAvailable",
    value: function isAvailable() {
      try {
        var storage = window[this.storageType];
        var x = "__storage_test__";

        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return false;
      }
    }
  }, {
    key: "isValid",
    value: function isValid(storedData) {
      if (!storedData) {
        return false;
      }
      if (new Date().getTime() - storedData.timestamp >= this.storageTimeout) {
        return false;
      }

      return true;
    }
  }, {
    key: "parseData",
    value: function parseData(storageData) {
      try {
        return JSON.parse(storageData);
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "getData",
    value: function getData(parameters) {
      if (!this.isAvailable()) {
        return null;
      }

      var key = this.getKey(parameters);
      var storageData = window[this.storageType].getItem(key);
      var data = this.parseData(storageData);

      if (!this.isValid(data)) {
        return null;
      }

      return data.content;
    }
  }, {
    key: "setData",
    value: function setData(data, parameters) {
      if (this.isAvailable()) {
        var value = {
          content: data,
          timestamp: new Date().getTime()
        };

        var key = this.getKey(parameters);
        var storageValue = json_stringify_default()(value);
        window[this.storageType].setItem(key, storageValue);
      }
    }
  }, {
    key: "getKey",
    value: function getKey(parameters) {
      var keyName = json_stringify_default()(parameters);
      var encryptedKey = btoa(keyName);
      return this.storageKey + "-" + encryptedKey;
    }
  }]);

  return Storage;
}();

/* harmony default export */ var contentTargeting_storage = (storage_Storage);
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/actions.js





var actions_requestTargetedContent = function requestTargetedContent(parameters, context) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;
    var fetchTargetedContent = api.fetchTargetedContent;

    var parametersAndContext = extends_default()({}, parameters, context);

    var storage = new contentTargeting_storage();
    var storedData = storage.getData(parametersAndContext);

    if (storedData) {
      emitContentTargetingEvent(storedData);
      dispatch({ type: GET_STORED_TARGETED_CONTENT, payload: storedData });
    } else {
      dispatch({ type: FETCHING_TARGETED_CONTENT });
      fetchTargetedContent(parameters, context).then(function (res) {
        storage.setData(res, parametersAndContext);
        emitContentTargetingEvent(res);
        dispatch({ type: FETCHED_TARGETED_CONTENT, payload: res });
      }).catch(function (err) {
        emitContentTargetingEvent(null);
        emitNewRelicEvent(err);
        dispatch({ type: API_ERROR });
      });
    }
  };
};
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/selectors.js


var targetedContentSelector = function targetedContentSelector(state) {
  return state.contentTargeting;
};

var getAllTargetedContent = Object(lib["createSelector"])(targetedContentSelector, function (targetedContent) {
  return targetedContent.content;
});

var getContentTargetingStatus = Object(lib["createSelector"])(targetedContentSelector, function (targetedContent) {
  return targetedContent.status;
});

var getGlobalBannerContent = Object(lib["createSelector"])(targetedContentSelector, function (targetedContent) {
  var content = targetedContent.content;

  for (var i = 0; i < content.length; i++) {
    if (content[i].type === "GlobalBanner") {
      return content[i].data;
    }
  }

  return null;
});
// CONCATENATED MODULE: ./template/state/modules/contentTargeting/index.js






var contentTargeting_initialState = {
  status: STATUS_IDLE,
  content: []
};

/* harmony default export */ var contentTargeting = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : contentTargeting_initialState;
  var action = arguments[1];

  switch (action.type) {
    case FETCHING_TARGETED_CONTENT:
      return {
        status: STATUS_FETCHING,
        content: []
      };
    case FETCHED_TARGETED_CONTENT:
      return {
        status: STATUS_SUCCESS,
        content: action.payload
      };
    case GET_STORED_TARGETED_CONTENT:
      return {
        status: STATUS_SUCCESS,
        content: action.payload
      };
    case API_ERROR:
      return {
        status: STATUS_ERROR,
        content: []
      };
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/GlobalBanner/index.js






var GlobalBanner_mapStateToProps = function mapStateToProps(state) {
  return {
    content: getGlobalBannerContent(state),
    country: getCountryCode(state),
    store: selectors_getStoreCode(state),
    lang: getDefaultLanguage(state),
    keystoredataversion: selectors_getKeyStoreDataversion(state),
    premier: getIsPremier(state),
    isRecognised: getIsRecognised(state),
    isLoggedIn: selectors_isLoggedIn(state),
    identityHasResponded: getIdentityHasResponded(state),
    contentTargetingStatus: getContentTargetingStatus(state)
  };
};

var GlobalBanner_mapDispatchToProps = {
  requestTargetedContent: actions_requestTargetedContent
};

/* harmony default export */ var GlobalBanner = (Object(esfrom_dll_reference_vendor["connect"])(GlobalBanner_mapStateToProps, GlobalBanner_mapDispatchToProps)(GlobalBanner_WithTargetedContent));
// CONCATENATED MODULE: ./template/components/GDPR/index.js








var GDPR_getMvtContent = function getMvtContent(state) {
  var gdprFeature = getFeature(state, "t1161-gdpr-test-web");

  if (gdprFeature && gdprFeature.content) {
    setGlobalFeatureName(gdprFeature.mvtTestName);
    var content = gdprFeature.content;
    return {
      greeting: content.bubbleText,
      title: content.modalTitle,
      subtitle: content.modalSubtitle
    };
  }
  return undefined;
};

var GDPR_mapStateToProps = function mapStateToProps(state) {
  var _getPageInfo = getPageInfo(),
      section = _getPageInfo.section;

  var platform = selectors_getPlatform(state);
  var ctaRef = platform + "|" + section + "|control my content";

  return {
    ctaRef: ctaRef,
    customerGuid: getCustomerGuid(state),
    gdprPhaseTwoFeature: getFeature(state, "stc-gdpr-phase-two"),
    hasError: getHasErrors(state),
    hasReconsented: getHasReconsented(state),
    isOptInLoading: getIsOptInLoading(state),
    isOptOutLoading: getIsOptOutLoading(state),
    isReconsentRequired: getIsReconsentRequired(state),
    preferences: getPreferences(state),
    privacyUrlSegment: getPrivacyUrlSegment(state),
    termsUrlSegment: getTermsUrlSegment(state),
    testContent: GDPR_getMvtContent(state),
    testIsLoaded: getFeaturesLoaded(state)
  };
};

var GDPR_mapDispatchToProps = {
  optIn: actions_optIn,
  optOut: actions_optOut,
  setUserPreferences: actions_setUserPreferences
};

/* harmony default export */ var components_GDPR = (Object(esfrom_dll_reference_vendor["connect"])(GDPR_mapStateToProps, GDPR_mapDispatchToProps)(components_GDPR_GDPR));
// EXTERNAL MODULE: ./template/components/Header/SkipToContent/index.css
var Header_SkipToContent = __webpack_require__("./template/components/Header/SkipToContent/index.css");
var SkipToContent_default = /*#__PURE__*/__webpack_require__.n(Header_SkipToContent);

// CONCATENATED MODULE: ./template/components/Header/SkipToContent/index.js





var SkipToContent_SkipToContent = function SkipToContent(_ref) {
  var formatTranslation = _ref.formatTranslation;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "a",
    {
      href: "#chrome-app-container",
      className: SkipToContent_default.a.skipLink,
      "data-testid": "skip-to-content"
    },
    formatTranslation("Accessibility.SkipToContent")
  );
};

/* harmony default export */ var components_Header_SkipToContent = (translation(SkipToContent_SkipToContent));
// EXTERNAL MODULE: ./template/components/CountrySelector/Fade.css
var CountrySelector_Fade = __webpack_require__("./template/components/CountrySelector/Fade.css");
var CountrySelector_Fade_default = /*#__PURE__*/__webpack_require__.n(CountrySelector_Fade);

// CONCATENATED MODULE: ./template/components/CountrySelector/Fade.js










var CountrySelector_Fade_Fade = function (_Component) {
  inherits_default()(Fade, _Component);

  function Fade() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Fade);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Fade.__proto__ || get_prototype_of_default()(Fade)).call.apply(_ref, [this].concat(args))), _this), _this.handleEnter = /* istanbul ignore next */function () {
      _this.y = window.scrollY;
      scrollTo(0, 0);

      document.body.classList.add("chrome-bodylock");
    }, _this.handleExit = /* istanbul ignore next */function () {
      document.body.classList.remove("chrome-bodylock");

      scrollTo(0, _this.y);
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }
  // HACK: iOS 10 and below do not like fixed with forms


  createClass_default()(Fade, [{
    key: "render",

    // end

    value: function render() {
      var _props = this.props,
          isActive = _props.isActive,
          children = _props.children;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        CSSTransition_default.a,
        {
          "in": isActive,
          mountOnEnter: true,
          unmountOnExit: true,
          timeout: 500,
          onEnter: this.handleEnter,
          onExited: this.handleExit,
          classNames: {
            enter: CountrySelector_Fade_default.a.fade__entered,
            enterActive: CountrySelector_Fade_default.a.fade__entering,
            exit: CountrySelector_Fade_default.a.fade__exited,
            exitActive: CountrySelector_Fade_default.a.fade__exiting
          }
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: CountrySelector_Fade_default.a.fade },
          children
        )
      );
    }
  }]);

  return Fade;
}(reactfrom_dll_reference_vendor["Component"]);

CountrySelector_Fade_Fade.defaultProps = {
  isActive: false
};

/* harmony default export */ var components_CountrySelector_Fade = (CountrySelector_Fade_Fade);
// EXTERNAL MODULE: ./template/components/CountrySelector/Backdrop.css
var CountrySelector_Backdrop = __webpack_require__("./template/components/CountrySelector/Backdrop.css");
var CountrySelector_Backdrop_default = /*#__PURE__*/__webpack_require__.n(CountrySelector_Backdrop);

// CONCATENATED MODULE: ./template/components/CountrySelector/Backdrop.js




var CountrySelector_Backdrop_Backdrop = function Backdrop(_ref) {
  var children = _ref.children;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: CountrySelector_Backdrop_default.a.backdrop },
    children
  );
};

/* harmony default export */ var components_CountrySelector_Backdrop = (CountrySelector_Backdrop_Backdrop);
// EXTERNAL MODULE: ./template/components/CountrySelector/Form.css
var CountrySelector_Form = __webpack_require__("./template/components/CountrySelector/Form.css");
var Form_default = /*#__PURE__*/__webpack_require__.n(CountrySelector_Form);

// CONCATENATED MODULE: ./template/components/CountrySelector/constants.js
var LANGUAGE_MAP = {
  de: "German",
  es: "Spanish",
  en: "English",
  fr: "French",
  it: "Italian",
  ru: "Russian"
};
// CONCATENATED MODULE: ./template/components/CountrySelector/Form.js















var Form_cx = bind_default.a.bind(Form_default.a);

var cleanUrl = function cleanUrl(url) {
  if (!url) return url;
  return url.replace(/&amp;/gi, "&").replace(/&#x3D;/gi, "=");
};

var Form_Form = function (_Component) {
  inherits_default()(Form, _Component);

  function Form(props) {
    classCallCheck_default()(this, Form);

    var _this = possibleConstructorReturn_default()(this, (Form.__proto__ || get_prototype_of_default()(Form)).call(this, props));

    _this.handleCountryChange = function (e) {
      var _this$props = _this.props,
          onCountryChange = _this$props.onCountryChange,
          countryCode = _this$props.countryCode,
          countries = _this$props.countries;

      var country = countries.find(function (country) {
        return country.countryCode === e.target.value;
      });

      /* istanbul ignore next */
      if (countryCode.toLowerCase() !== e.target.value.toLowerCase() && country) {
        onCountryChange(e.target.value, country.defaultLanguage);
      }
    };

    _this.handleCurrencyChange = function (e) {
      if (_this.state.currencyId !== Number(e.target.value)) {
        _this.setState({
          currencyId: e.target.value,
          isCurrencyUpdateManual: true
        });
      }
    };

    _this.handleCloseClick = function () {
      var onClose = _this.props.onClose;


      onClose();
    };

    _this.handleCloseKeyDown = function (e) {
      // Tab
      if (e.keyCode === 9) {
        e.preventDefault();

        if (e.shiftKey) {
          _this.submitButton.focus();
        } else {
          _this.countrySelect.focus();
        }
      }
    };

    _this.handleCountryKeyDown = function (e) {
      // Tab && shift
      if (e.keyCode === 9 && e.shiftKey) {
        e.preventDefault();
        _this.closeButton.focus();
      }
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();

      var _this$props2 = _this.props,
          countryCode = _this$props2.countryCode,
          lang = _this$props2.lang,
          currencies = _this$props2.currencies,
          onSubmit = _this$props2.onSubmit,
          labels = _this$props2.labels,
          regionalStore = _this$props2.regionalStore,
          storeCode = _this$props2.storeCode,
          siteId = _this$props2.siteId,
          storeUrl = _this$props2.storeUrl,
          countries = _this$props2.countries,
          sizeSchema = _this$props2.sizeSchema;
      var _this$state = _this.state,
          currencyId = _this$state.currencyId,
          isCurrencyUpdateManual = _this$state.isCurrencyUpdateManual;


      var currentCurrencies = currencies.filter(function (currency) {
        return currency.currencyId == currencyId;
      }).map(function (currency) {
        return {
          currencyId: currency.currencyId,
          currencyCode: currency.currency
        };
      });
      var currentCurrency = currentCurrencies[0];

      var country = countries.find(function (country) {
        return country.countryCode === countryCode;
      });
      var affiliateId = getContext() && getContext().getAffiliateId();
      var isoLanguage = lang.slice(0, 2).toLowerCase();

      trackSubmitCountrySelector({
        context: ANALYTICS_CONTEXT.countrySelector,
        interaction: ANALYTICS_INTERACTION_SAVED,
        elementText: labels.update,
        properties: {
          positionOnPage: ANALYTICS_POSITION_COUNTRY_SELECTOR,
          formFields: {
            country: {
              countryISOFrom: regionalStore.countryCode,
              countryISOTo: countryCode,
              storeFrom: regionalStore.storeCode,
              storeTo: storeCode,
              siteIDFrom: regionalStore.siteId,
              siteIDTo: siteId,
              isUpdateManual: regionalStore.countryCode !== countryCode
            },
            currency: {
              currencyISOFrom: regionalStore.currency,
              currencyISOTo: currentCurrency.currencyCode,
              isUpdateManual: isCurrencyUpdateManual
            },
            language: {
              languageISOFrom: regionalStore.language.slice(0, 2).toLowerCase(),
              languageISOTo: isoLanguage,
              languageTextFrom: LANGUAGE_MAP[regionalStore.language.slice(0, 2).toLowerCase()],
              languageTextTo: LANGUAGE_MAP[lang.slice(0, 2).toLowerCase()],
              isUpdateManual: false
            }
          }
        }
      });

      onSubmit(countryCode, currentCurrency.currencyCode, cleanUrl(storeUrl) || "//" + country.url, regionalStore.countryCode, affiliateId);

      setCookies({
        browseCountry: countryCode,
        browseCurrency: currentCurrency.currencyCode,
        browseCurrencyId: currentCurrency.currencyId,
        browseLanguage: isoLanguage,
        browseSizeSchema: sizeSchema,
        storeId: storeCode
      });
    };

    _this.state = {
      currencyId: _this.getCurrency(),
      isCurrencyUpdateManual: false
    };
    return _this;
  }

  createClass_default()(Form, [{
    key: "shouldDisplayWarning",
    value: function shouldDisplayWarning() {
      var _props = this.props,
          hasSetCurrencyError = _props.hasSetCurrencyError,
          noOfProductsInBag = _props.noOfProductsInBag,
          countryCode = _props.countryCode,
          regionalStore = _props.regionalStore;


      return !hasSetCurrencyError && noOfProductsInBag > 0 && countryCode !== regionalStore.countryCode;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return _this2.context.showWarning(_this2.shouldDisplayWarning());
      }, 0);
    }
  }, {
    key: "getCurrency",
    value: function getCurrency() {
      var _props2 = this.props,
          currencies = _props2.currencies,
          regionalStore = _props2.regionalStore,
          countryCode = _props2.countryCode;


      var currentCurrency = currencies.find(function (currency) {
        return currency.currency === regionalStore.currency;
      });
      var defaultCurrency = currencies[0];

      return countryCode === regionalStore.countryCode && currentCurrency ? currentCurrency.currencyId : defaultCurrency.currencyId;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          countries = _props3.countries,
          countryCode = _props3.countryCode,
          currencies = _props3.currencies,
          formatTranslation = _props3.formatTranslation,
          hasSetCurrencyError = _props3.hasSetCurrencyError,
          hasVoucherError = _props3.hasVoucherError,
          labels = _props3.labels,
          paymentProviders = _props3.paymentProviders,
          propositions = _props3.propositions;
      var currencyId = this.state.currencyId;

      var displayWarning = this.shouldDisplayWarning();

      return reactfrom_dll_reference_vendor_default.a.createElement(
        "section",
        {
          className: Form_default.a.container,
          "data-testid": "country-selector-form",
          role: "dialog",
          "aria-labelledby": "country-title"
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "h1",
          { id: "country-title", className: Form_default.a.header },
          labels.title
        ),
        reactfrom_dll_reference_vendor_default.a.createElement(
          "form",
          { className: Form_default.a.form, onSubmit: this.handleSubmit },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.field },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "label",
              { htmlFor: "country", className: Form_default.a.label },
              labels.countrySelect
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "select",
              {
                id: "country",
                className: Form_default.a.select,
                autoFocus: true,
                onChange: this.handleCountryChange,
                onKeyDown: this.handleCountryKeyDown,
                ref: function ref(c) {
                  return _this3.countrySelect = c;
                },
                defaultValue: countryCode
              },
              countries.map(function (country) {
                return reactfrom_dll_reference_vendor_default.a.createElement(
                  "option",
                  { key: country.countryCode, value: country.countryCode },
                  country.name
                );
              })
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: Form_default.a.features },
              propositions.length > 0 && reactfrom_dll_reference_vendor_default.a.createElement(
                "ol",
                { className: Form_default.a.propositions },
                propositions.map(function (proposition, i) {
                  return reactfrom_dll_reference_vendor_default.a.createElement(
                    "li",
                    { key: i, className: Form_default.a.proposition },
                    proposition
                  );
                })
              ),
              paymentProviders.length > 0 && reactfrom_dll_reference_vendor_default.a.createElement(
                "ol",
                { className: Form_default.a.providers },
                paymentProviders.map(function (provider) {
                  return reactfrom_dll_reference_vendor_default.a.createElement(
                    "li",
                    { key: provider.name, className: Form_default.a.provider },
                    reactfrom_dll_reference_vendor_default.a.createElement("img", { src: provider.logo, alt: provider.name })
                  );
                })
              )
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.field },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "label",
              {
                htmlFor: "currency",
                className: Form_cx([Form_default.a.label], defineProperty_default()({}, Form_default.a.label__disabled, hasSetCurrencyError))
              },
              labels.currencySelect
            ),
            currencies.length > 1 ? reactfrom_dll_reference_vendor_default.a.createElement(
              "select",
              {
                id: "currency",
                className: Form_default.a.select,
                defaultValue: currencyId,
                onBlur: this.handleCurrencyChange,
                disabled: hasSetCurrencyError
              },
              currencies.map(function (currency) {
                return reactfrom_dll_reference_vendor_default.a.createElement(
                  "option",
                  { key: currency.currencyId, value: currency.currencyId },
                  currency.text
                );
              })
            ) : reactfrom_dll_reference_vendor_default.a.createElement(
              "span",
              { id: "singleCurrency", className: Form_default.a.currency },
              currencies.length && currencies[0].text
            )
          ),
          hasSetCurrencyError && hasVoucherError && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.error, "data-testid": "currency-message" },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "p",
              null,
              labels.voucherErrorMessage
            )
          ),
          hasSetCurrencyError && !hasVoucherError && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.error, "data-testid": "set-currency-message" },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "p",
              null,
              formatTranslation("Errors.SomethingDoesntLookRight")
            )
          ),
          !hasSetCurrencyError && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.actions },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "button",
              {
                type: "submit",
                className: Form_default.a.submitButton,
                "data-testid": "save-country-button",
                ref: function ref(c) {
                  return _this3.submitButton = c;
                }
              },
              labels.update
            )
          ),
          displayWarning && reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: Form_default.a.warning },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "p",
              null,
              labels.bagErrorMessage
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "button",
            {
              type: "button",
              className: Form_default.a.closeButton,
              "data-testid": "close-button",
              onClick: this.handleCloseClick,
              onKeyDown: this.handleCloseKeyDown,
              ref: function ref(c) {
                return _this3.closeButton = c;
              }
            },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "span",
              null,
              "Close"
            )
          )
        )
      );
    }
  }]);

  return Form;
}(reactfrom_dll_reference_vendor["Component"]);

Form_Form.defaultProps = {
  countries: [],
  currencies: [],
  propositions: [],
  paymentProviders: []
};
Form_Form.contextTypes = {
  showWarning: prop_typesfrom_dll_reference_vendor_default.a.func
};


/* harmony default export */ var components_CountrySelector_Form = (translation(Form_Form));
// EXTERNAL MODULE: ./template/components/CountrySelector/Container.css
var CountrySelector_Container = __webpack_require__("./template/components/CountrySelector/Container.css");
var CountrySelector_Container_default = /*#__PURE__*/__webpack_require__.n(CountrySelector_Container);

// CONCATENATED MODULE: ./template/components/CountrySelector/Container.js











var Container_cx = bind_default.a.bind(CountrySelector_Container_default.a);

var CountrySelector_Container_Container = function (_Component) {
  inherits_default()(Container, _Component);

  function Container() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Container);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Container.__proto__ || get_prototype_of_default()(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = { warningShowing: true }, _this.handleClose = /* istanbul ignore next */function (e) {
      var onClose = _this.props.onClose;

      // Escape

      if (e.keyCode === 27) {
        e.preventDefault();
        onClose();
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Container, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        showWarning: this.showWarning.bind(this)
      };
    }

    /* istanbul ignore next */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener("keyup", this.handleClose);
    }

    /* istanbul ignore next */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("keyup", this.handleClose);
    }
  }, {
    key: "showWarning",
    value: function showWarning(isShowing) {
      if (isShowing) this.wrapper.scrollTop = this.wrapper.scrollHeight;
      this.setState({
        warningShowing: isShowing
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _cx;

      var children = this.props.children;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: CountrySelector_Container_default.a.wrapper, ref: function ref(el) {
            return _this2.wrapper = el;
          } },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          {
            className: Container_cx([CountrySelector_Container_default.a.container], (_cx = {}, defineProperty_default()(_cx, CountrySelector_Container_default.a.container__withError, this.props.withError), defineProperty_default()(_cx, CountrySelector_Container_default.a.container__notLoading, !this.props.isLoading), _cx))
          },
          children
        )
      );
    }
  }]);

  return Container;
}(reactfrom_dll_reference_vendor["Component"]);

CountrySelector_Container_Container.childContextTypes = {
  showWarning: prop_typesfrom_dll_reference_vendor_default.a.func
};


/* harmony default export */ var components_CountrySelector_Container = (CountrySelector_Container_Container);
// CONCATENATED MODULE: ./template/components/CountrySelector/CountrySelector.js









var CountrySelector_CountrySelector = function CountrySelector(_ref) {
  var alternateUrls = _ref.alternateUrls,
      country = _ref.country,
      hasSetCurrencyError = _ref.hasSetCurrencyError,
      hasVoucherError = _ref.hasVoucherError,
      isLoading = _ref.isLoading,
      isOpen = _ref.isOpen,
      noOfProductsInBag = _ref.noOfProductsInBag,
      onClose = _ref.onClose,
      onCountryChange = _ref.onCountryChange,
      onSubmit = _ref.onSubmit,
      regionalStore = _ref.regionalStore;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    components_CountrySelector_Fade,
    { isActive: isOpen },
    reactfrom_dll_reference_vendor_default.a.createElement(components_CountrySelector_Backdrop, null),
    reactfrom_dll_reference_vendor_default.a.createElement(
      components_CountrySelector_Container,
      {
        onClose: onClose,
        isLoading: isLoading,
        withError: hasVoucherError || hasSetCurrencyError
      },
      isLoading || country == null ? reactfrom_dll_reference_vendor_default.a.createElement(template_components_Spinner, { size: "x-large" }) : reactfrom_dll_reference_vendor_default.a.createElement(components_CountrySelector_Form, extends_default()({}, country, {
        hasSetCurrencyError: hasSetCurrencyError,
        hasVoucherError: hasVoucherError,
        noOfProductsInBag: noOfProductsInBag,
        onClose: onClose,
        onCountryChange: onCountryChange,
        onSubmit: onSubmit,
        regionalStore: regionalStore,
        storeUrl: alternateUrls && alternateUrls[country.lang] && alternateUrls[country.lang].url
      }))
    )
  );
};

/* harmony default export */ var components_CountrySelector_CountrySelector = (CountrySelector_CountrySelector);
// CONCATENATED MODULE: ./template/components/CountrySelector/index.js







function CountrySelector_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({
    onClose: actions_closeCountrySelector,
    onCountryChange: actions_setCountry,
    onSubmit: actions_updatePreferences
  }, dispatch);
}

function CountrySelector_mapStateToProps(state) {
  return {
    alternateUrls: getCountrySelectorAlternateUrls(state),
    country: getCountrySelectorCountry(state),
    error: getCountrySelectorError(state),
    hasSetCurrencyError: getHasSetCurrencyError(state),
    hasVoucherError: getHasVoucherError(state),
    isLoading: getCountrySelectorLoading(state),
    isOpen: getCountrySelectorVisibility(state),
    noOfProductsInBag: getTotalQuantity(state),
    regionalStore: {
      countryCode: getCountryCode(state),
      storeCode: selectors_getStoreCode(state),
      siteId: getSiteId(state),
      currency: selectors_getCurrency(state),
      language: getDefaultLanguage(state),
      countryName: getCountryName(state),
      sizeSchema: getDefaultSizeSchema(state)
    }
  };
}

/* harmony default export */ var components_CountrySelector = (Object(esfrom_dll_reference_vendor["connect"])(CountrySelector_mapStateToProps, CountrySelector_mapDispatchToProps)(components_CountrySelector_CountrySelector));
// EXTERNAL MODULE: ./template/components/HtmlHeader/HtmlHeader.css
var HtmlHeader_HtmlHeader = __webpack_require__("./template/components/HtmlHeader/HtmlHeader.css");
var HtmlHeader_default = /*#__PURE__*/__webpack_require__.n(HtmlHeader_HtmlHeader);

// CONCATENATED MODULE: ./template/components/HtmlHeader/HtmlHeader.js























var HtmlHeader_HtmlHeader_HtmlHeader = function (_Component) {
  inherits_default()(HtmlHeader, _Component);

  function HtmlHeader() {
    classCallCheck_default()(this, HtmlHeader);

    return possibleConstructorReturn_default()(this, (HtmlHeader.__proto__ || get_prototype_of_default()(HtmlHeader)).apply(this, arguments));
  }

  createClass_default()(HtmlHeader, [{
    key: "render",
    value: function render() {
      var viewport = this.props.viewport;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "header",
        null,
        reactfrom_dll_reference_vendor_default.a.createElement(components_LayoutManager, null),
        reactfrom_dll_reference_vendor_default.a.createElement(components_Header_SkipToContent, null),
        reactfrom_dll_reference_vendor_default.a.createElement(components_Header_CookieDisclaimer, null),
        reactfrom_dll_reference_vendor_default.a.createElement(template_components_UnsupportedBrowserMessage, null),
        reactfrom_dll_reference_vendor_default.a.createElement(components_MiscBar, { viewable: [LARGE_VIEWPORT] }),
        reactfrom_dll_reference_vendor_default.a.createElement(
          components_NotQuiteStickyHeader,
          null,
          reactfrom_dll_reference_vendor_default.a.createElement(template_components_Header, null),
          viewport === LARGE_VIEWPORT ? reactfrom_dll_reference_vendor_default.a.createElement(Navigation_LargeNavigation, null) : null
        ),
        [SMALL_VIEWPORT, MEDIUM_VIEWPORT].indexOf(viewport) !== -1 ? reactfrom_dll_reference_vendor_default.a.createElement(components_Navigation_SidePanel, { viewable: [SMALL_VIEWPORT, MEDIUM_VIEWPORT] }) : null,
        reactfrom_dll_reference_vendor_default.a.createElement(components_GDPR, null),
        reactfrom_dll_reference_vendor_default.a.createElement(GlobalBanner, { viewable: [LARGE_VIEWPORT, MEDIUM_VIEWPORT] }),
        reactfrom_dll_reference_vendor_default.a.createElement(components_CountrySelector, null)
      );
    }
  }]);

  return HtmlHeader;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_HtmlHeader_HtmlHeader = (HtmlHeader_HtmlHeader_HtmlHeader);
// CONCATENATED MODULE: ./template/components/HtmlHeader/index.js




var HtmlHeader_mapStateToProps = function mapStateToProps(state) {
  return {
    viewport: getViewport(state)
  };
};

/* harmony default export */ var components_HtmlHeader = (Object(esfrom_dll_reference_vendor["connect"])(HtmlHeader_mapStateToProps)(components_HtmlHeader_HtmlHeader));
// CONCATENATED MODULE: ./template/components/WelcomeMat/Message/getRedirectionUrl.js




var getRedirectionUrl_getRedirectionUrl = function getRedirectionUrl(url, browseCountry) {
  var parsedUrl = url_parse_default()("//" + url);
  var extraParams = { r: 1, ctaref: "welcome mat", browseCountry: browseCountry };

  var affiliateId = getContext().getAffiliateId();
  if (affiliateId) {
    extraParams.xaffid = affiliateId;
  }

  parsedUrl.query = extends_default()({}, parsedUrl.query, extraParams);

  return parsedUrl;
};

/* harmony default export */ var Message_getRedirectionUrl = (getRedirectionUrl_getRedirectionUrl);
// EXTERNAL MODULE: ./template/components/WelcomeMat/Message/Message.css
var Message_Message = __webpack_require__("./template/components/WelcomeMat/Message/Message.css");
var Message_default = /*#__PURE__*/__webpack_require__.n(Message_Message);

// CONCATENATED MODULE: ./template/components/WelcomeMat/Message/Message.js






var Message_StaticLink = function StaticLink(_ref) {
  var url = _ref.url,
      label = _ref.label,
      browseCountry = _ref.browseCountry;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "a",
    {
      className: Message_default.a.redirectLink,
      href: Message_getRedirectionUrl(url, browseCountry).toString(),
      "data-testid": "shop-there-button"
    },
    label
  );
};

var Message_ChangeButton = function ChangeButton(_ref2) {
  var label = _ref2.label,
      openCountrySelector = _ref2.openCountrySelector;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "button",
    {
      className: Message_default.a.changeButton,
      onClick: openCountrySelector,
      "data-testid": "change-button"
    },
    label
  );
};

var Message_Message_Message = function Message(_ref3) {
  var text = _ref3.text,
      redirectUrl = _ref3.redirectUrl,
      imageUrl = _ref3.imageUrl,
      imageLabel = _ref3.imageLabel,
      openCountrySelector = _ref3.openCountrySelector,
      withCountrySelector = _ref3.withCountrySelector,
      targetCountryCode = _ref3.targetCountryCode;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: Message_default.a.container },
    imageUrl && reactfrom_dll_reference_vendor_default.a.createElement("img", {
      src: imageUrl,
      alt: imageLabel,
      className: Message_default.a.flag,
      "data-testid": "icon"
    }),
    reactfrom_dll_reference_vendor_default.a.createElement(
      "p",
      { className: Message_default.a.text, "data-testid": "text" },
      text
    ),
    withCountrySelector ? reactfrom_dll_reference_vendor_default.a.createElement(Message_ChangeButton, {
      label: redirectUrl.label,
      openCountrySelector: openCountrySelector
    }) : reactfrom_dll_reference_vendor_default.a.createElement(Message_StaticLink, extends_default()({}, redirectUrl, { browseCountry: targetCountryCode }))
  );
};

Message_Message_Message.defaultProps = {
  withCountrySelector: false
};

/* harmony default export */ var WelcomeMat_Message_Message = (Message_Message_Message);
// CONCATENATED MODULE: ./template/components/WelcomeMat/Message/index.js





function Message_mapDispatchToProps(dispatch) {
  return Object(redux_esfrom_dll_reference_vendor["bindActionCreators"])({ openCountrySelector: actions_openCountrySelector }, dispatch);
}

/* harmony default export */ var WelcomeMat_Message = (Object(esfrom_dll_reference_vendor["connect"])(null, Message_mapDispatchToProps)(WelcomeMat_Message_Message));
// EXTERNAL MODULE: ./template/components/WelcomeMat/ValueProposition.css
var WelcomeMat_ValueProposition = __webpack_require__("./template/components/WelcomeMat/ValueProposition.css");
var ValueProposition_default = /*#__PURE__*/__webpack_require__.n(WelcomeMat_ValueProposition);

// CONCATENATED MODULE: ./template/components/WelcomeMat/ValueProposition.js




var ValueProposition_ValueProposition = function ValueProposition(_ref) {
  var messages = _ref.messages,
      header = _ref.header;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: ValueProposition_default.a.container, "data-testid": "value-proposition" },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "div",
      { className: ValueProposition_default.a.header },
      header
    ),
    messages.map(function (message) {
      return reactfrom_dll_reference_vendor_default.a.createElement(
        "p",
        { key: message, className: ValueProposition_default.a.message },
        message
      );
    })
  );
};

/* harmony default export */ var components_WelcomeMat_ValueProposition = (ValueProposition_ValueProposition);
// EXTERNAL MODULE: ./template/components/WelcomeMat/PaymentOptions.css
var WelcomeMat_PaymentOptions = __webpack_require__("./template/components/WelcomeMat/PaymentOptions.css");
var WelcomeMat_PaymentOptions_default = /*#__PURE__*/__webpack_require__.n(WelcomeMat_PaymentOptions);

// CONCATENATED MODULE: ./template/components/WelcomeMat/PaymentOptions.js




var WelcomeMat_PaymentOptions_PaymentOptions = function PaymentOptions(_ref) {
  var paymentOptions = _ref.paymentOptions;
  return reactfrom_dll_reference_vendor_default.a.createElement(
    "div",
    { className: WelcomeMat_PaymentOptions_default.a.wrapper },
    reactfrom_dll_reference_vendor_default.a.createElement(
      "ul",
      {
        className: WelcomeMat_PaymentOptions_default.a.container,
        "data-testid": "payment-options",
        "aria-label": "Available payment methods"
      },
      paymentOptions.map(function (option) {
        return reactfrom_dll_reference_vendor_default.a.createElement(
          "li",
          { key: option.name, className: WelcomeMat_PaymentOptions_default.a.paymentOption },
          reactfrom_dll_reference_vendor_default.a.createElement("img", {
            src: option.logo,
            alt: option.name,
            className: WelcomeMat_PaymentOptions_default.a.logo,
            width: "32",
            height: "20"
          })
        );
      })
    )
  );
};

/* harmony default export */ var components_WelcomeMat_PaymentOptions = (WelcomeMat_PaymentOptions_PaymentOptions);
// EXTERNAL MODULE: ./template/components/WelcomeMat/WelcomeMat.css
var WelcomeMat_WelcomeMat = __webpack_require__("./template/components/WelcomeMat/WelcomeMat.css");
var WelcomeMat_default = /*#__PURE__*/__webpack_require__.n(WelcomeMat_WelcomeMat);

// CONCATENATED MODULE: ./template/components/WelcomeMat/WelcomeMat.js
















var WelcomeMat_WelcomeMat_WelcomeMat = function (_PureComponent) {
  inherits_default()(WelcomeMat, _PureComponent);

  function WelcomeMat() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, WelcomeMat);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = WelcomeMat.__proto__ || get_prototype_of_default()(WelcomeMat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isClosed: false
    }, _this.close = function () {
      var isCorrectCountry = _this.props.isCorrectCountry;


      if (!isCorrectCountry) {
        client_setWelcomeMatClosedForWrongCountry(true);
      }

      _this.setState({
        isClosed: true
      });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(WelcomeMat, [{
    key: "shouldRequestWelcomeMatData",
    value: function shouldRequestWelcomeMatData() {
      var isCorrectCountry = this.props.isCorrectCountry;

      var hasCookieForCountry = isCorrectCountry ? client_getWelcomeMatClosedForCorrectCountry : client_getWelcomeMatClosedForWrongCountry;
      return !hasCookieForCountry();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props = this.props,
          requestWelcomeMat = _props.requestWelcomeMat,
          platform = _props.platform;


      if (this.shouldRequestWelcomeMatData()) {
        requestWelcomeMat(platform);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          country = _props2.country,
          formatTranslation = _props2.formatTranslation,
          isCorrectCountry = _props2.isCorrectCountry,
          messages = _props2.messages,
          paymentOptions = _props2.paymentOptions,
          redirectUrl = _props2.redirectUrl,
          text = _props2.text,
          valueHeader = _props2.valueHeader,
          welcome = _props2.welcome;
      var isClosed = this.state.isClosed;


      if (isClosed || !redirectUrl || !getContext()) {
        return null;
      }

      if (isCorrectCountry) {
        client_setWelcomeMatClosedForCorrectCountry(true);
      }

      var imageUrl = country.imageUrl,
          imageLabel = country.name;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        { className: WelcomeMat_default.a.container },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: WelcomeMat_default.a.containerWrapper },
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: WelcomeMat_default.a.titleBarWrapper },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: WelcomeMat_default.a.titleBar },
              reactfrom_dll_reference_vendor_default.a.createElement(
                "div",
                { className: WelcomeMat_default.a.title },
                welcome
              ),
              reactfrom_dll_reference_vendor_default.a.createElement(template_components_IconButton, {
                icon: "close",
                className: WelcomeMat_default.a.closeButton,
                "data-testid": "close-button",
                onClick: this.close,
                "aria-label": formatTranslation("Icon.Close")
              })
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            { className: WelcomeMat_default.a.contentBarWrapper },
            reactfrom_dll_reference_vendor_default.a.createElement(
              "div",
              { className: WelcomeMat_default.a.contentBar },
              reactfrom_dll_reference_vendor_default.a.createElement(WelcomeMat_Message, {
                text: text,
                redirectUrl: redirectUrl,
                imageUrl: imageUrl,
                imageLabel: imageLabel,
                withCountrySelector: isCorrectCountry,
                targetCountryCode: country.countryCode
              }),
              messages && messages.length > 0 && reactfrom_dll_reference_vendor_default.a.createElement(components_WelcomeMat_ValueProposition, { messages: messages, header: valueHeader }),
              paymentOptions.length > 0 && reactfrom_dll_reference_vendor_default.a.createElement(components_WelcomeMat_PaymentOptions, { paymentOptions: paymentOptions })
            )
          )
        )
      );
    }
  }]);

  return WelcomeMat;
}(reactfrom_dll_reference_vendor["PureComponent"]);

/* harmony default export */ var components_WelcomeMat_WelcomeMat = (translation(WelcomeMat_WelcomeMat_WelcomeMat));
// CONCATENATED MODULE: ./template/state/modules/welcomeMat/constants.js
var RECEIVE_WELCOME_MAT = "RECEIVE_WELCOME_MAT";
// CONCATENATED MODULE: ./template/state/modules/welcomeMat/actions.js


var actions_requestWelcomeMat = function requestWelcomeMat(platform) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    var keyStoreDataversion = regionalStore.keyStoreDataversion,
        countryCode = regionalStore.countryCode;
    var fetchWelcomeMat = api.fetchWelcomeMat;

    fetchWelcomeMat(countryCode, platform, keyStoreDataversion).then(function (res) {
      dispatch({ type: RECEIVE_WELCOME_MAT, payload: res });
    });
  };
};
// CONCATENATED MODULE: ./template/state/modules/welcomeMat/selectors.js


var getWelcomeMat = function getWelcomeMat(state) {
  return state.welcomeMat;
};

var selectors_getWelcomeMessage = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.text;
});

var getWelcomeMatRedirectUrl = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.redirectUrl;
});

var getWelcomeMatCountry = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.country;
});

var getValuePropositionMessages = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.messages;
});

var getValueHeader = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.valueHeader;
});

var getPaymentOptions = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.paymentProviders;
});

var getWelcomeText = Object(lib["createSelector"])(getWelcomeMat, function (welcomeMat) {
  return welcomeMat.welcome;
});
// CONCATENATED MODULE: ./template/state/modules/welcomeMat/index.js







/* harmony default export */ var welcomeMat = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case RECEIVE_WELCOME_MAT:
      return extends_default()({}, state, action.payload.data);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/components/WelcomeMat/index.js






var WelcomeMat_mapStateToProps = function mapStateToProps(state) {
  return {
    text: selectors_getWelcomeMessage(state),
    redirectUrl: getWelcomeMatRedirectUrl(state),
    country: getWelcomeMatCountry(state),
    messages: getValuePropositionMessages(state),
    platform: selectors_getPlatform(state),
    isCorrectCountry: selectors_isCorrectCountry(state),
    paymentOptions: getPaymentOptions(state),
    valueHeader: getValueHeader(state),
    welcome: getWelcomeText(state)
  };
};

var WelcomeMat_mapDispatchToProps = {
  requestWelcomeMat: actions_requestWelcomeMat
};

/* harmony default export */ var components_WelcomeMat = (Object(esfrom_dll_reference_vendor["connect"])(WelcomeMat_mapStateToProps, WelcomeMat_mapDispatchToProps)(components_WelcomeMat_WelcomeMat));
// CONCATENATED MODULE: ./template/state/modules/welcomeMessage/constants.js
var RECEIVE_WELCOME_MESSAGE = "RECEIVE_WELCOME_MESSAGE";
// CONCATENATED MODULE: ./template/state/modules/welcomeMessage/actions.js


var actions_requestWelcomeMessage = function requestWelcomeMessage(platform) {
  return function (dispatch, getState, _ref) {
    var api = _ref.api;

    var _getState = getState(),
        regionalStore = _getState.regionalStore;

    var keyStoreDataversion = regionalStore.keyStoreDataversion,
        countryCode = regionalStore.countryCode;
    var fetchWelcomeMessage = api.fetchWelcomeMessage;

    fetchWelcomeMessage(countryCode, platform, keyStoreDataversion).then(function (res) {
      dispatch({ type: RECEIVE_WELCOME_MESSAGE, payload: res });
    });
  };
};
// EXTERNAL MODULE: ./template/components/WelcomeMessage/index.css
var components_WelcomeMessage = __webpack_require__("./template/components/WelcomeMessage/index.css");
var WelcomeMessage_default = /*#__PURE__*/__webpack_require__.n(components_WelcomeMessage);

// CONCATENATED MODULE: ./template/components/WelcomeMessage/WelcomeMessage.js















var WelcomeMessage_WelcomeMessage = function (_Component) {
  inherits_default()(WelcomeMessage, _Component);

  function WelcomeMessage() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, WelcomeMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = WelcomeMessage.__proto__ || get_prototype_of_default()(WelcomeMessage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.close = function () {
      client_setWelcomeMessage(true);
      _this.setState({
        isClosed: true
      });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(WelcomeMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hasWelcomeMatBeenClosed = client_getWelcomeMessage();
      if (hasWelcomeMatBeenClosed) {
        return;
      }

      return this.props.requestWelcomeMessage(this.props.platform);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          browsingLocalStore = _props.browsingLocalStore,
          redirectUrl = _props.redirectUrl,
          text = _props.text,
          formatTranslation = _props.formatTranslation;


      if (this.state.isClosed || !redirectUrl || browsingLocalStore) {
        return null;
      }

      var affid = getContext().getAffiliateId();
      var url = url_parse_default()("//" + redirectUrl.url);

      if (affid) {
        url.query = extends_default()({}, url.query, { xaffid: affid });
      }

      url.query = extends_default()({}, url.query, {
        r: 1,
        ctaref: "welcome mat",
        browseCountry: this.props.country && this.props.country.countryCode
      });

      var imageUrl = this.props.country.imageUrl;


      return reactfrom_dll_reference_vendor_default.a.createElement(
        "div",
        {
          className: WelcomeMessage_default.a.container,
          role: "region",
          "aria-labelledby": "welcomeMessageText",
          "data-testid": "welcome-message"
        },
        reactfrom_dll_reference_vendor_default.a.createElement(
          "div",
          { className: WelcomeMessage_default.a.wrapper },
          reactfrom_dll_reference_vendor_default.a.createElement("img", {
            src: imageUrl,
            alt: "",
            className: WelcomeMessage_default.a.flag,
            "data-testid": "icon"
          }),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "div",
            null,
            reactfrom_dll_reference_vendor_default.a.createElement(
              "p",
              { className: WelcomeMessage_default.a.text, id: "welcomeMessageText" },
              text
            ),
            reactfrom_dll_reference_vendor_default.a.createElement(
              "a",
              {
                onClick: this.close,
                className: WelcomeMessage_default.a.redirectLink,
                href: url.toString(),
                "data-testid": "link"
              },
              redirectUrl.label
            )
          ),
          reactfrom_dll_reference_vendor_default.a.createElement(
            "button",
            {
              className: WelcomeMessage_default.a.closeButton,
              onClick: this.close,
              "data-testid": "close-button",
              "aria-label": formatTranslation("Icon.Close")
            },
            reactfrom_dll_reference_vendor_default.a.createElement(template_components_Icon, { icon: "close" })
          )
        )
      );
    }
  }]);

  return WelcomeMessage;
}(reactfrom_dll_reference_vendor["Component"]);

/* harmony default export */ var components_WelcomeMessage_WelcomeMessage = (translation(WelcomeMessage_WelcomeMessage));
// CONCATENATED MODULE: ./template/components/WelcomeMessage/index.js






var WelcomeMessage_mapStateToProps = function mapStateToProps(state) {
  return extends_default()({}, state.welcomeMessage, {
    platform: selectors_getPlatform(state)
  });
};

var WelcomeMessage_mapDispatchToProps = {
  requestWelcomeMessage: actions_requestWelcomeMessage
};

/* harmony default export */ var template_components_WelcomeMessage = (Object(esfrom_dll_reference_vendor["connect"])(WelcomeMessage_mapStateToProps, WelcomeMessage_mapDispatchToProps)(components_WelcomeMessage_WelcomeMessage));
// CONCATENATED MODULE: ./template/components/WelcomeWrapper/WelcomeWrapper.js





var WelcomeWrapper_WelcomeWrapper = function WelcomeWrapper(_ref) {
  var useWelcomeMat = _ref.useWelcomeMat;

  return useWelcomeMat ? reactfrom_dll_reference_vendor_default.a.createElement(components_WelcomeMat, null) : reactfrom_dll_reference_vendor_default.a.createElement(template_components_WelcomeMessage, null);
};

/* harmony default export */ var components_WelcomeWrapper_WelcomeWrapper = (WelcomeWrapper_WelcomeWrapper);
// CONCATENATED MODULE: ./template/components/WelcomeWrapper/index.js




var WelcomeWrapper_mapStateToProps = function mapStateToProps(state) {
  return {
    useWelcomeMat: !!isFeatureActive(state, "stc-welcome-mat-changes")
  };
};

/* harmony default export */ var components_WelcomeWrapper = (Object(esfrom_dll_reference_vendor["connect"])(WelcomeWrapper_mapStateToProps)(components_WelcomeWrapper_WelcomeWrapper));
// EXTERNAL MODULE: ../node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__("../node_modules/redux-devtools-extension/index.js");
var redux_devtools_extension_default = /*#__PURE__*/__webpack_require__.n(redux_devtools_extension);

// CONCATENATED MODULE: ./client/sdk/bagConfiguration.js


var bagConfiguration_buildConfiguration = function buildConfiguration(config) {
  if (clientConfig["a" /* default */].isLocal()) {
    return {
      postMessageUrl: config.SDK_POST_MESSAGE_URL,
      xSiteOrigin: config.SDK_X_SITE_ORIGIN,
      bagApiUrl: config.SDK_BAG_API_URL
    };
  }

  return {
    xSiteOrigin: clientConfig["a" /* default */].getXSiteOrigin()
  };
};

var bagConfiguration_getConfiguration = function getConfiguration() {
  return bagConfiguration_buildConfiguration(clientConfig["a" /* default */].get());
};
// CONCATENATED MODULE: ./helpers/logger.js
var shouldLog = typeof window === "undefined" || "production" === "development";

var logger_logger = {
  info: function info() {
    var _console;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return shouldLog && (_console = console).info.apply(_console, ["[" + new Date().toISOString() + "]"].concat(args));
  },
  error: function error() {
    var _console2;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return shouldLog && (_console2 = console).error.apply(_console2, ["[" + new Date().toISOString() + "]"].concat(args));
  },
  warn: function warn() {
    var _console3;

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return shouldLog && (_console3 = console).warn.apply(_console3, ["[" + new Date().toISOString() + "]"].concat(args));
  }
};

/* harmony default export */ var helpers_logger = (logger_logger);
// CONCATENATED MODULE: ./helpers/promiseWithTimeout.js

var PROMISE_TIMEOUT = 5000;

var promiseWithTimeout_wrapPromiseWithTimeout = function wrapPromiseWithTimeout(promise) {
  var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PROMISE_TIMEOUT;
  return new promise_default.a(function (resolve, reject) {
    promise.then(resolve).catch(reject);
    setTimeout(function () {
      reject(new Error("Bag SDK not responding"));
    }, ms);
  });
};

/* harmony default export */ var promiseWithTimeout = (promiseWithTimeout_wrapPromiseWithTimeout);
// CONCATENATED MODULE: ./client/sdk/bag.js

/* global requirejs */






var bag_initialise = function initialise(context) {
  return new promise_default.a(function (resolve) {
    return requirejs(["bagSdk/sdk"], function (sdk) {
      return resolve(sdk.getInstance(context, bagConfiguration_getConfiguration()));
    });
  });
};

var bag_waitForBagSDK = function waitForBagSDK() {
  return new promise_default.a(function (resolve, reject) {
    if (clientConfig["a" /* default */].isServer()) {
      return reject();
    }

    if (window.asos && window.asos.sdk && window.asos.sdk.bag) {
      resolve(window.asos.sdk.bag);
    } else {
      events.addListener("bag-sdk-ready", resolve);
    }
  });
};

var bag_getBagSummary = function getBagSummary() {
  return bag_waitForBagSDK().then(function (bag) {
    return bag.getBagSummary();
  }).catch( /* istanbul ignore next */helpers_logger.error);
};

var bag_removeItem = function removeItem(itemId, itemType) {
  return bag_waitForBagSDK().then(function (bag) {
    return promiseWithTimeout(bag.removeItem(itemId, itemType));
  });
};

var bag_getBag = function getBag() {
  return bag_waitForBagSDK().then(function (bag) {
    return bag.getBag();
  }).catch( /* istanbul ignore next */helpers_logger.error);
};

var bag_subscribeToUpdates = function subscribeToUpdates(callback) {
  return bag_waitForBagSDK().then(function (bag) {
    //eslint-disable-next-line no-undef
    $(bag).on("bagUpdated:completed", function () {
      var _ref = arguments.length <= 2 ? undefined : arguments[2],
          bag = _ref.bag,
          messages = _ref.messages;

      callback({ bag: bag, messages: messages });
    });
  }).catch( /* istanbul ignore next */helpers_logger.error);
};

var bag_startCheckout = function startCheckout() {
  return bag_waitForBagSDK().then(function (bag) {
    return bag.startCheckout();
  }).catch( /* istanbul ignore next */helpers_logger.error);
};
// CONCATENATED MODULE: ./template/state/modules/bodyScroll/index.js

var DISABLE_BODY_SCROLL = "DISABLE_BODY_SCROLL";
var ENABLE_BODY_SCROLL = "ENABLE_BODY_SCROLL";

var bodyScroll_initialState = {
  bodyScrollEnabled: true
};

/* harmony default export */ var bodyScroll = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : bodyScroll_initialState;
  var action = arguments[1];

  switch (action.type) {
    case DISABLE_BODY_SCROLL:
      return extends_default()({}, state, {
        bodyScrollEnabled: false
      });
    case ENABLE_BODY_SCROLL:
      return extends_default()({}, state, {
        bodyScrollEnabled: true
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/state/middleware/bag/helpers/miniBagEnabled.js



function miniBagEnabled(state) {
  return isFeatureActive(state, "stc-minibag-dropdown") && getViewport(state) !== SMALL_VIEWPORT;
}
// CONCATENATED MODULE: ./template/state/middleware/bag/helpers/bagWithProductLinks.js



var bagWithProductLinks_withProductLink = function withProductLink(defaultStoreUrl) {
  return function (item) {
    return item.variantId ? extends_default()({}, item, { productUrl: defaultStoreUrl + "prd/" + item.variantId }) : item;
  };
};

function bagWithProductLinks(bag, getState) {
  var state = getState();
  var defaultStoreUrl = getDefaultStoreUrl(state);
  return extends_default()({}, bag, {
    items: bag.items.map(bagWithProductLinks_withProductLink(defaultStoreUrl))
  });
}
// CONCATENATED MODULE: ./template/state/middleware/bag/index.js











var closeMinibagTimerId = void 0;

var bag_bagMiddleware = function bagMiddleware(_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;

  bag_getBagSummary().then(function (summary) {
    return dispatch({
      type: SET_BAG,
      payload: { bag: { summary: summary } }
    });
  });

  bag_subscribeToUpdates(function (_ref2) {
    var bag = _ref2.bag,
        messages = _ref2.messages;

    var state = getState();
    var current = getBagItems(state) || [];
    var next = getBagItems({ bag: bag });
    var oldQuantity = getTotalQuantity(state);
    var newQuantity = getTotalQuantity({ bag: bag });

    var removed = current.filter(function (_ref3) {
      var id = _ref3.id;
      return !next.find(function (item) {
        return item.id === id;
      });
    });
    var miniBagIsEnabled = miniBagEnabled(state);

    if (miniBagIsEnabled && removed.length) {
      var items = current.map(function (item) {
        return removed.find(function (_ref4) {
          var id = _ref4.id;
          return id === item.id;
        }) ? extends_default()({}, item, { transition: "exiting" }) : item;
      });
      if (helpers_isBagPage(window.location.pathname)) {
        dispatch({
          type: SET_BAG,
          payload: {
            bag: extends_default()({}, bagWithProductLinks(extends_default()({}, state.bag, { items: items }), getState), {
              incoming: bag,
              isUpdated: true,
              summary: {
                totalQuantity: newQuantity
              }
            }),
            messages: messages
          }
        });
      } else {
        dispatch({
          type: SET_BAG,
          payload: {
            bag: extends_default()({}, bagWithProductLinks(extends_default()({}, state.bag, { items: items }), getState), {
              incoming: bag,
              isUpdated: true
            }),
            messages: messages
          }
        });
      }

      return;
    }

    dispatch({
      type: SET_BAG,
      payload: {
        bag: extends_default()({}, bagWithProductLinks(bag, getState), {
          isUpdated: true
        }),
        messages: messages
      }
    });

    if (!miniBagIsEnabled) {
      return;
    }

    if (newQuantity > oldQuantity) {
      dispatch({
        type: OPEN_DROPDOWN,
        name: MINIBAG,
        programmatic: true
      });

      dispatch({
        type: SHOW_RESERVATION_MESSAGE
      });

      clearTimeout(closeMinibagTimerId);

      closeMinibagTimerId = setTimeout(function () {
        var state = getState();

        var isProgrammatic = getDropdownProgrammatic(state, {
          name: MINIBAG
        });

        if (isProgrammatic) {
          dispatch({
            type: CLOSE_DROPDOWN,
            name: MINIBAG,
            programmatic: true
          });
        }
      }, 3000);
    }
  });

  return function (next) {
    return function (action) {
      var state = getState();

      if (!miniBagEnabled(state)) {
        return next(action);
      }

      if (action.type === CLOSE_DROPDOWN && action.name === MINIBAG) {
        dispatch({ type: ENABLE_BODY_SCROLL });
      }

      if (action.type === START_REMOVE_BAG_ITEM) {
        dispatch({
          type: "DEFER_ACTIONS",
          payload: {
            actionsToDefer: [OPEN_DROPDOWN, CLOSE_DROPDOWN],
            actionToWaitFor: BAG_ITEM_DELETE_TRANSITION_END,
            actionsToCancelOn: [BAG_ERROR]
          }
        });
      }

      if (action.type === START_REMOVE_BAG_ITEM) {
        var items = getBagItems(state);
        var item = items.find(function (_ref5) {
          var id = _ref5.id;
          return id === action.item;
        });

        bag_removeItem(item.id, item.itemType.toLowerCase()).then(function () {
          return dispatch({ type: FINISH_REMOVE_BAG_ITEM, itemId: action.item });
        }).catch(function () {
          return dispatch({ type: BAG_ERROR });
        });
      }

      if (action.type === OPEN_DROPDOWN && action.name === MINIBAG && !action.programmatic) {
        var miniBagDropdownIsOpen = getDropdownIsOpen(state, { name: MINIBAG });

        if (!miniBagDropdownIsOpen) {
          dispatch({ type: DISABLE_BODY_SCROLL });
          dispatch({ type: SET_LOADING });
          bag_getBag().then(function (_ref6) {
            var bag = _ref6.bag,
                messages = _ref6.messages;
            return dispatch({
              type: SET_BAG,
              payload: {
                bag: bagWithProductLinks(bag, getState),
                messages: messages
              }
            });
          }).catch(function () {
            return dispatch({ type: BAG_ERROR });
          });
        }
      }

      if (action.type === DROPDOWN_CLOSED && action.name === MINIBAG) {
        dispatch({
          type: HIDE_RESERVATION_MESSAGE
        });

        /* if the dropdown closed after the last item was removed then we still need to update state with the latest items... */
        var incoming = state.bag.incoming;

        if (incoming && incoming.items.length === 0) {
          dispatch({
            type: SET_BAG,
            payload: {
              bag: bagWithProductLinks(extends_default()({}, incoming, { incoming: undefined }), getState)
            }
          });
        }
      }

      if (action.type === BAG_ITEM_DELETE_TRANSITION_END && action.itemId === state.bag.lastItemRemoved) {
        var _incoming = state.bag.incoming;
        var _items = getBagItems({ bag: _incoming });
        /*
          If the user has deleted the last item in the minibag, then close the bag before updating state so that the dropdown doesn't just vanish.
        */

        if (_items.length === 0) {
          dispatch({
            type: CLOSE_DROPDOWN,
            name: MINIBAG
          });
        } else {
          dispatch({
            type: SET_BAG,
            payload: {
              bag: bagWithProductLinks(extends_default()({}, _incoming, { incoming: undefined }), getState)
            }
          });
        }
      }

      if (action.type === START_CHECKOUT) {
        var _state = getState();
        var checkoutLink = getSecureStoreUrl(_state);

        bag_startCheckout().then(function () {
          var checkoutUrl = checkoutLink + "initialise";
          window.location.replace(queryString_withParams(checkoutUrl, { ctaref: "mini bag" }));
        }).catch(console.err);
      }

      return next(action);
    };
  };
};

/* harmony default export */ var middleware_bag = (bag_bagMiddleware);
// CONCATENATED MODULE: ./template/state/middleware/bodyScroll/index.js


var hideOverflowClass = "chrome-bodylock-with-scrollbar";

/* harmony default export */ var middleware_bodyScroll = (function () {
  return function (next) {
    return function (action) {
      if (action.type === DISABLE_BODY_SCROLL) {
        document.body.classList.add(hideOverflowClass);
      }
      if (action.type === ENABLE_BODY_SCROLL) {
        document.body.classList.remove(hideOverflowClass);
      }
      next(action);
    };
  };
});
// EXTERNAL MODULE: ../node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("../node_modules/babel-runtime/helpers/toConsumableArray.js");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./template/state/middleware/actionDeferral/index.js



var DEFER_ACTIONS = "DEFER_ACTIONS";

/*
For example...

const actions = {
  BAG_ITEM_DELETE_TRANSITION_END: [{},{},{}]
}

const types = {
  OPEN_DROPDOWN: BAG_ITEM_DELETE_TRANSITION_END,
  CLOSE_DROPDOWN: BAG_ITEM_DELETE_TRANSITION_END
}

const cancel = {
  BAG_ERROR: BAG_ITEM_DELETE_TRANSITION_END
}
*/

var actionDeferral_actionDeferralMiddleware = function actionDeferralMiddleware() {
  var actions = new map_default.a();
  var types = new map_default.a();
  var cancel = new map_default.a();

  var clear = function clear(actionType) {
    actions.delete(actionType);

    [].concat(toConsumableArray_default()(types)).filter(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 2),
          type = _ref2[1];

      return type === actionType;
    }).forEach(function (_ref3) {
      var _ref4 = slicedToArray_default()(_ref3, 1),
          key = _ref4[0];

      return types.delete(key);
    });

    [].concat(toConsumableArray_default()(cancel)).filter(function (_ref5) {
      var _ref6 = slicedToArray_default()(_ref5, 2),
          type = _ref6[1];

      return type === actionType;
    }).forEach(function (_ref7) {
      var _ref8 = slicedToArray_default()(_ref7, 1),
          key = _ref8[0];

      return cancel.delete(key);
    });
  };

  return function (next) {
    return function (action) {
      if (action.type === DEFER_ACTIONS) {
        var _action$payload = action.payload,
            actionsToDefer = _action$payload.actionsToDefer,
            _actionToWaitFor = _action$payload.actionToWaitFor,
            _action$payload$actio = _action$payload.actionsToCancelOn,
            actionsToCancelOn = _action$payload$actio === undefined ? [] : _action$payload$actio;


        actions.set(_actionToWaitFor, []);

        actionsToDefer.forEach(function (type) {
          types.set(type, _actionToWaitFor);
        });

        actionsToCancelOn.forEach(function (type) {
          cancel.set(type, _actionToWaitFor);
        });

        return next(action);
      }

      var cancelled = cancel.get(action.type);

      if (cancelled) {
        clear(cancelled);
      }

      var actionToWaitFor = types.get(action.type);

      if (actionToWaitFor) {
        var _deferredActions = actions.get(actionToWaitFor).concat(action);

        actions.set(actionToWaitFor, _deferredActions);

        return next({ type: null });
      }

      var deferredActions = actions.get(action.type);

      if (deferredActions) {
        deferredActions.forEach(function (action) {
          return next(action);
        });
        clear(action.type);
      }

      return next(action);
    };
  };
};

/* harmony default export */ var actionDeferral = (actionDeferral_actionDeferralMiddleware);
// EXTERNAL MODULE: delegated ../node_modules/redux-thunk/lib/index.js from dll-reference vendor
var libfrom_dll_reference_vendor = __webpack_require__("../node_modules/redux-thunk/lib/index.js");
var libfrom_dll_reference_vendor_default = /*#__PURE__*/__webpack_require__.n(libfrom_dll_reference_vendor);

// EXTERNAL MODULE: ../node_modules/babel-runtime/core-js/object/create.js
var object_create = __webpack_require__("../node_modules/babel-runtime/core-js/object/create.js");
var create_default = /*#__PURE__*/__webpack_require__.n(object_create);

// EXTERNAL MODULE: ../node_modules/agentkeepalive/browser.js
var agentkeepalive_browser = __webpack_require__("../node_modules/agentkeepalive/browser.js");
var agentkeepalive_browser_default = /*#__PURE__*/__webpack_require__.n(agentkeepalive_browser);

// CONCATENATED MODULE: ./api/request.js






// Until we're ES6 end to end we have to use this form because with Babel subclasses must extend a class https://github.com/babel/babel/issues/3083
function ApiError(message) {
  var fetchMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  this.name = "ApiError";
  this.message = message || "Api Error";
  this.stack = new Error().stack;
  this.status = fetchMetadata.status;
  this.statusText = fetchMetadata.statusText;
  this.url = fetchMetadata.url;
  this.responseText = fetchMetadata.responseText;
}
ApiError.prototype = create_default()(Error.prototype);
ApiError.prototype.constructor = ApiError;

var request_handleErrors = function handleErrors(response) {
  return new promise_default.a(function (resolve, reject) {
    if (response.status >= 200 && response.status < 300) {
      resolve(response);
    } else {
      var status = response.status,
          statusText = response.statusText,
          url = response.url;


      response.text().then(function (responseText) {
        var error = new ApiError(response.statusText, {
          status: status,
          statusText: statusText,
          url: url,
          responseText: responseText
        });

        helpers_logger.error("Error response from API:", error);

        reject(error);
      });
    }
  });
};

var httpsKeepAliveAgent = new agentkeepalive_browser["HttpsAgent"]({
  maxSockets: 160,
  keepAliveMsecs: 3000
});

var request_request = function request(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var addHttpsKeepalives = arguments[2];

  if (addHttpsKeepalives) {
    opts.agent = httpsKeepAliveAgent;
  }

  return fetch(url, opts).then(request_handleErrors).then(function (response) {
    return response.json();
  });
};

/* harmony default export */ var api_request = (request_request);
// CONCATENATED MODULE: ./api/contentApi/contentApiParameters.js






var contentApiParameters_ContentApiParameters = function () {
  function ContentApiParameters() {
    classCallCheck_default()(this, ContentApiParameters);
  }

  createClass_default()(ContentApiParameters, [{
    key: "generate",
    value: function generate(parameters, context) {
      var encodedContext = this.objectToBase64(context);
      var queryParameters = extends_default()({}, parameters, {
        context: encodedContext
      });
      var filteredQueryParameters = this.filterEmptyParameters(queryParameters);

      return this.buildQueryString(filteredQueryParameters);
    }
  }, {
    key: "filterEmptyParameters",
    value: function filterEmptyParameters(parameters) {
      var queryParameters = {};

      keys_default()(parameters).forEach(function (key) {
        if (parameters[key]) {
          queryParameters[key] = parameters[key];
        }
      });

      return queryParameters;
    }
  }, {
    key: "objectToBase64",
    value: function objectToBase64(contextParameters) {
      if (!contextParameters || keys_default()(contextParameters).length === 0) {
        return null;
      }

      var stringifiedParams = json_stringify_default()(contextParameters);
      var encodedParams = btoa(stringifiedParams);
      return encodedParams.replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    }
  }, {
    key: "buildQueryString",
    value: function buildQueryString(queryParameters) {
      if (keys_default()(queryParameters).length === 0) {
        return "";
      }

      var queryString = "/?";

      for (var parameter in queryParameters) {
        if (queryString === "/?") {
          queryString = "" + queryString + parameter + "=" + queryParameters[parameter];
        } else {
          queryString = queryString + "&" + parameter + "=" + queryParameters[parameter];
        }
      }

      return queryString;
    }
  }]);

  return ContentApiParameters;
}();

/* harmony default export */ var contentApiParameters = (new contentApiParameters_ContentApiParameters());
// CONCATENATED MODULE: ./api/constants.js
/* These ought to be env vars */
var SEARCH_API_SUGGESTIONS_PATH = "/product/search/v1/suggestions";
var COUNTRY_API_SELECTOR_PATH = "/web/countrymetadata/v1/countrySelector";
var COUNTRY_API_WELCOME_MESSAGE_PATH = "/web/countrymetadata/v1/welcomeMessage";
var COUNTRY_API_WELCOME_MAT_PATH = "/web/countrymetadata/v1/welcomeMat";
var PAYMENT_PROVIDER_API_PATH = "/web/countrymetadata/v1/paymentProviders";
var PREFERENCES_API_PATH = "/customer/preference/v1/preferences";
// CONCATENATED MODULE: ./api/apiUrls.js










/* These are going to be env vars */


var clientVariables = clientConfig["a" /* default */].get();

var apiUrls_xSiteOrginCheck = function xSiteOrginCheck(params) {
  if ((clientConfig["a" /* default */].isLocal() || clientConfig["a" /* default */].isServer()) && clientVariables.API_XSITEORIGIN_BASE) {
    return extends_default()({}, params, { "x-site-origin": clientVariables.API_XSITEORIGIN_BASE });
  }

  if (!clientConfig["a" /* default */].isServer() && clientConfig["a" /* default */].getXSiteOrigin()) {
    return extends_default()({}, params, { "x-site-origin": clientConfig["a" /* default */].getXSiteOrigin() });
  }

  return params;
};

var apiUrls_checkEmptyParams = function checkEmptyParams(params) {
  var ret = {};
  keys_default()(params).forEach(function (key) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
      ret[key] = params[key];
    }
  });
  return ret;
};

var apiUrls_getKSDV = function getKSDV() {
  var context = getContext();
  if (!context) {
    return client_getKeyStoreDataversion();
  }
  return context.getKeyStoreDataversion();
};

var apiUrls_ensureKeyStoreDataversion = function ensureKeyStoreDataversion(params) {
  return params.keyStoreDataversion ? params : extends_default()({}, params, { keyStoreDataversion: apiUrls_getKSDV() });
};

var apiUrls_buildUrl = function buildUrl(origin) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  params = apiUrls_ensureKeyStoreDataversion(params);
  params = apiUrls_xSiteOrginCheck(params);
  params = apiUrls_checkEmptyParams(params);

  var queryString = Object(query_stringfrom_dll_reference_vendor["stringify"])(params);
  var url = origin + (queryString ? "?" + queryString : "");
  return url;
};

var apiUrls_getSuggestionsUrl = function getSuggestionsUrl(siteId, lang, query, country) {
  var params = { store: siteId, lang: lang, q: query, country: country, limit: 10 };
  var baseUrl = "" + clientVariables.API_BASE + SEARCH_API_SUGGESTIONS_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var getNavigationUrl = function getNavigationUrl(params) {
  var API_BASE = clientVariables.API_BASE,
      NAVIGATION_API_PATH = clientVariables.NAVIGATION_API_PATH;

  var baseUrl = "" + API_BASE + NAVIGATION_API_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var getNavigationSubtreeUrl = function getNavigationSubtreeUrl(params) {
  var API_BASE = clientVariables.API_BASE,
      NAVIGATION_SUBTREE_API_PATH = clientVariables.NAVIGATION_SUBTREE_API_PATH;

  var baseUrl = "" + API_BASE + NAVIGATION_SUBTREE_API_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var apiUrls_getCountryUrl = function getCountryUrl(country, lang, platform) {
  var params = { lang: lang, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + COUNTRY_API_SELECTOR_PATH + "/" + country;
  return apiUrls_buildUrl(baseUrl, params);
};

var apiUrls_getPaymentProviderUrl = function getPaymentProviderUrl(params) {
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + PAYMENT_PROVIDER_API_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var apiUrls_getWelcomeMessageUrl = function getWelcomeMessageUrl(geoCountry, browseCountry, platform) {
  var params = { geoCountry: geoCountry, browseCountry: browseCountry, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + COUNTRY_API_WELCOME_MESSAGE_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var apiUrls_getWelcomeMatUrl = function getWelcomeMatUrl(geoCountry, browseCountry, platform) {
  var params = { geoCountry: geoCountry, browseCountry: browseCountry, platform: platform };
  var baseUrl = "" + clientVariables.COUNTRY_API_DOMAIN + COUNTRY_API_WELCOME_MAT_PATH;
  return apiUrls_buildUrl(baseUrl, params);
};

var apiUrls_getContentApiUrl = function getContentApiUrl(parameters, context) {
  var queryString = contentApiParameters.generate(parameters, context);
  if (clientVariables.CONTENT_API_PATH) {
    return "" + clientVariables.CONTENT_API_PATH + queryString;
  }
  return null;
};

var apiUrls_getPreferencesUrl = function getPreferencesUrl(customerGuid) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  params = apiUrls_checkEmptyParams(params);

  var queryString = Object(query_stringfrom_dll_reference_vendor["stringify"])(params);
  var baseUrl = "" + clientVariables.PREFERENCES_API_DOMAIN + PREFERENCES_API_PATH + (customerGuid ? "/" + customerGuid : "");

  return baseUrl + (queryString ? "?" + queryString : "");
};
// EXTERNAL MODULE: ./env/index.js
var env = __webpack_require__("./env/index.js");

// CONCATENATED MODULE: ./api/navigation/navigationUtils.js



var navigationUtils_getViewportExclusions = function getViewportExclusions() {
  var channelExclusions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var viewportExclusion = [];

  channelExclusions.forEach(function (exclusion) {
    if (exclusion === "webLarge") {
      viewportExclusion.push(LARGE_VIEWPORT);
    }
    if (exclusion === "webSmall") {
      viewportExclusion.push(SMALL_VIEWPORT);
      viewportExclusion.push(MEDIUM_VIEWPORT);
    }
  });

  return viewportExclusion;
};

var navigationUtils_hasItems = function hasItems(tree) {
  var maleExists = maleLargePrimaryNavigationItems({ navigation: { tree: tree } });
  var femaleExists = femaleLargePrimaryNavigationItems({
    navigation: { tree: tree }
  });

  return !!(maleExists && femaleExists && maleExists.length && femaleExists.length);
};

var validateMappedNavigation = function validateMappedNavigation(mappedNavigation) {
  return !!(mappedNavigation && mappedNavigation.tree && navigationUtils_hasItems(mappedNavigation.tree));
};
// CONCATENATED MODULE: ./api/navigation/mapNavigationState.js





var mapNavigationState_mapNavigationState = function mapNavigationState(navigation, gender) {
  var labelPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var platform = arguments[3];
  var storeUrl = arguments[4];
  return navigation.map(function (navigationItem) {
    var label = get_get(navigationItem, "content.title");
    var alias = get_get(navigationItem, "alias");
    var newLabelPath = [].concat(labelPath, [label]);
    var useGender = gender || alias;
    var link = get_get(navigationItem, "link.webUrl");
    var linkType = get_get(navigationItem, "link.linkType");
    if (link && platform && storeUrl) {
      if (platform === "mobile") {
        link = desktopToMobile(link, storeUrl);
      } else {
        link = isProtocolHttps(storeUrl) ? setHttpUrlsToHttps(link) : link;
      }
    }

    return {
      id: get_get(navigationItem, "id"),
      alias: alias,
      label: label,
      subtitle: get_get(navigationItem, "content.subTitle"),
      link: link,
      linkType: linkType,
      type: get_get(navigationItem, "type"),
      labelPath: newLabelPath,
      gender: useGender,
      excludes: navigationUtils_getViewportExclusions(navigationItem.channelExclusions),
      largeScreenPriority: get_get(navigationItem, "webLargePriority"),
      largeScreenColumnSpan: get_get(navigationItem, "display.webLargeColumnSpan"),
      largeScreenTemplateId: get_get(navigationItem, "display.webLargeTemplateId"),
      smallAndMediumTemplateId: get_get(navigationItem, "display.mobileTemplateId"),
      smallAndMediumLayout: get_get(navigationItem, "display.mobileDisplayLayout"),
      smallAndMediumImageUrl: get_get(navigationItem, "content.mobileImageUrl"),
      largeScreenImageUrl: get_get(navigationItem, "content.webLargeImageUrl"),
      largeScreenStyleType: get_get(navigationItem, "style.webLargeStyleType"),
      smallAndMediumStyleType: get_get(navigationItem, "style.mobileStyleType"),
      items: mapNavigationState(navigationItem.children, useGender, newLabelPath, platform, storeUrl)
    };
  });
};
// CONCATENATED MODULE: ./api/fetchClientNavigation.js



var fetchClientNavigation__this = this;







var fetchClientNavigation = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref2.country,
        lang = _ref2.lang,
        dateTime = _ref2.dateTime,
        includeDraft = _ref2.includeDraft,
        showTestContent = _ref2.showTestContent,
        platform = _ref2.platform,
        storeUrl = _ref2.storeUrl,
        keyStoreDataversion = _ref2.keyStoreDataversion,
        _ref2$opts = _ref2.opts,
        opts = _ref2$opts === undefined ? {} : _ref2$opts;

    var url, navigation, mappedNavigation;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = getNavigationSubtreeUrl({
              country: country,
              lang: lang,
              keyStoreDataversion: keyStoreDataversion,
              dateTime: dateTime,
              includeDraft: includeDraft,
              showTestContent: showTestContent
            });


            helpers_logger.info("Fetching navigation API from", url);
            _context.next = 4;
            return api_request(url, opts, false);

          case 4:
            navigation = _context.sent;
            mappedNavigation = {
              countryCode: country,
              tree: mapNavigationState_mapNavigationState(navigation, null, null, platform, storeUrl)
            };

            if (validateMappedNavigation(mappedNavigation)) {
              _context.next = 8;
              break;
            }

            throw new Error("Nav API response not valid");

          case 8:
            return _context.abrupt("return", mappedNavigation);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, fetchClientNavigation__this);
  }));

  return function fetchClientNavigation() {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var api_fetchClientNavigation = (fetchClientNavigation);
// CONCATENATED MODULE: ./api/storePresentation.js




var threeHours = 1000 * 60 * 60 * 3;
var services = void 0;

var storePresentation_setupStorePresentation = function setupStorePresentation() {
  return services = module_storePresentation({
    storeApiEndpoint: Object(env["a" /* default */])("ASOS_STORE_API_ENDPOINT"),
    storeExpiryMs: threeHours,
    versionManifestEndpoint: Object(env["a" /* default */])("VERSION_MANIFEST_ENDPOINT"),
    versionManifestExpiryMs: threeHours,
    warn: helpers_logger.warn,
    environmentMode: Object(env["a" /* default */])("CLIENT_ENVIRONMENT_MODE")
  });
};

var storePresentation_getStore = function getStore() {
  return services.store;
};
// CONCATENATED MODULE: ./helpers/storeUrls.js





var storeUrls__this = this;






var TYPES = [DEFAULT, FEMALE, MALE, SECURE];



var addTrailingSlash = function addTrailingSlash(str) {
  return str + "/";
};

var storeUrlsForAllFloors = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(countryCode, platform, keyStoreDataversion) {
    var shouldUseHttps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var storeUrls, i, type;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            storeUrls = {};
            _context.t0 = regenerator_default.a.keys(TYPES);

          case 2:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 12;
              break;
            }

            i = _context.t1.value;
            type = TYPES[i];
            _context.t2 = addTrailingSlash;
            _context.next = 8;
            return storePresentation_getStore().getStoreUrlByCountryCode({
              countryCode: countryCode,
              type: type,
              keyStoreDataversion: keyStoreDataversion,
              includeProtocol: true,
              shouldUseHttps: shouldUseHttps,
              isMobile: platform === "mobile"
            });

          case 8:
            _context.t3 = _context.sent;
            storeUrls[type] = (0, _context.t2)(_context.t3);
            _context.next = 2;
            break;

          case 12:
            return _context.abrupt("return", storeUrls);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, storeUrls__this);
  }));

  return function storeUrlsForAllFloors(_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var storeUrls_storeLinksForAllFloors = function storeLinksForAllFloors(storeCode) {
  return TYPES.reduce(function (links, type) {
    return extends_default()({}, links, defineProperty_default()({}, type, utilities_getSocialLinks({ storeCode: storeCode, floor: type })));
  }, {});
};
// CONCATENATED MODULE: ./api/fetchNavigation.js



var fetchNavigation__this = this;









var fetchNavigation = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        country = _ref2.country,
        lang = _ref2.lang,
        dateTime = _ref2.dateTime,
        includeDraft = _ref2.includeDraft,
        showTestContent = _ref2.showTestContent,
        platform = _ref2.platform,
        storeUrl = _ref2.storeUrl,
        keyStoreDataversion = _ref2.keyStoreDataversion,
        _ref2$opts = _ref2.opts,
        opts = _ref2$opts === undefined ? {} : _ref2$opts;

    var url, navigation, mappedNavigation;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = getNavigationUrl({
              country: country,
              lang: lang,
              keyStoreDataversion: keyStoreDataversion,
              dateTime: dateTime,
              includeDraft: includeDraft,
              showTestContent: showTestContent
            });

            if (!(!storeUrl && platform && country)) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return storeUrlsForAllFloors(country, platform, keyStoreDataversion);

          case 4:
            storeUrl = _context.sent;

            storeUrl = storeUrl[DEFAULT];

          case 6:

            helpers_logger.info("Fetching navigation API from", url);
            _context.next = 9;
            return api_request(url, opts, clientConfig["a" /* default */].isServer());

          case 9:
            navigation = _context.sent;
            mappedNavigation = {
              countryCode: country,
              tree: mapNavigationState_mapNavigationState(navigation.navigation, null, null, platform, storeUrl),
              footer: mapNavigationState_mapNavigationState(navigation.footer, null, null, platform, storeUrl)
            };

            if (validateMappedNavigation(mappedNavigation)) {
              _context.next = 13;
              break;
            }

            throw new Error("Nav API response not valid");

          case 13:
            return _context.abrupt("return", mappedNavigation);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, fetchNavigation__this);
  }));

  return function fetchNavigation() {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ var api_fetchNavigation = (fetchNavigation);
// CONCATENATED MODULE: ./api/index.js












var api_getIsRunningOnServer = function getIsRunningOnServer() {
  return clientConfig["a" /* default */].isServer();
};




var api_fetchSuggestions = function fetchSuggestions(siteId, lang, query, country) {
  var url = apiUrls_getSuggestionsUrl(siteId, lang, query, country);

  helpers_logger.info("(" + siteId + ") - Fetching navigation from " + url);
  return api_request(url);
};

var api_fetchCountry = function fetchCountry(country, lang, platform) {
  var url = apiUrls_getCountryUrl(country, lang, platform);
  helpers_logger.info("Fetching country data for " + country + " from " + url);
  return api_request(url);
};

var api_fetchPaymentProviders = function fetchPaymentProviders(keyStoreDataversion) {
  var url = apiUrls_getPaymentProviderUrl({ keyStoreDataversion: keyStoreDataversion });
  helpers_logger.info("Fetching payment providers from " + url);
  return api_request(url);
};

var api_fetchWelcomeMessage = function fetchWelcomeMessage(browseCountry, platform, keyStoreDataversion) {
  var context = getContext();
  var geoCountry = context && context.getGeoCountry();

  var url = apiUrls_getWelcomeMessageUrl(geoCountry, browseCountry, platform, keyStoreDataversion);
  helpers_logger.info("Fetching welcome message for " + geoCountry + " from " + url);
  return api_request(url);
};

var api_fetchWelcomeMat = function fetchWelcomeMat(browseCountry, platform, keyStoreDataversion) {
  var context = getContext();
  var geoCountry = context && context.getGeoCountry();

  var url = apiUrls_getWelcomeMatUrl(geoCountry, browseCountry, platform, keyStoreDataversion);
  helpers_logger.info("Fetching welcome mat for " + geoCountry + " from " + url);
  return api_request(url);
};

var api_fetchTargetedContent = function fetchTargetedContent(parameters, context) {
  var fetchUrl = apiUrls_getContentApiUrl(parameters, context);
  var method = "GET";
  var credentials = "same-origin";

  if (!fetchUrl) {
    helpers_logger.error("Content Targeting Fetch URL is not defined");
    return promise_default.a.reject("Content Targeting Fetch URL is not defined");
  }

  helpers_logger.info("Fetching targeted content from " + fetchUrl);
  return api_request(fetchUrl, { method: method, credentials: credentials });
};

var api_fetchSitecoreBearerToken = function fetchSitecoreBearerToken() {
  var _process$env = process.env,
      url = _process$env.SITECORE_LOGIN_URL,
      username = _process$env.SITECORE_LOGIN_USER,
      password = _process$env.SITECORE_LOGIN_PASS,
      domain = _process$env.SITECORE_LOGIN_DOMAIN;

  var body = json_stringify_default()({
    username: username,
    password: password,
    domain: domain
  });
  var method = "POST";
  var headers = new Headers({
    "Content-Type": "application/json"
  });
  return api_request(url, { method: method, headers: headers, body: body });
};

var api_updatePreferences = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(customerGuid, preferences) {
    var url, body, method, headers;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = apiUrls_getPreferencesUrl(customerGuid);

            helpers_logger.info("Patching preferences for customer '" + customerGuid + "' from '" + url + "'");
            body = json_stringify_default()({
              sourceReason: "SiteChrome",
              services: {
                marketing: preferences
              }
            });
            method = "PATCH";
            _context.t0 = Headers;
            _context.next = 7;
            return window.asos.sdk.identity.getAccessToken();

          case 7:
            _context.t1 = _context.sent;
            _context.t2 = "Bearer " + _context.t1;
            _context.t3 = {
              "asos-c-name": "asos-web-site-chrome",
              "Content-Type": "application/json",
              Authorization: _context.t2
            };
            headers = new _context.t0(_context.t3);
            return _context.abrupt("return", fetch(url, {
              method: method,
              headers: headers,
              body: body
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function updatePreferences(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var api_fetchPreferences = function fetchPreferences(country, lang) {
  var url = apiUrls_getPreferencesUrl(null, {
    lang: lang,
    country: country
  });
  helpers_logger.info("Fetching preferences for system from '" + url + "'");

  return api_request(url);
};

var api_fetchFeaturesManifest = function fetchFeaturesManifest() {
  return api_request(Object(env["a" /* default */])("FEATURES_MANIFEST_JSON"));
};

var api_sendEventToAlfred = function sendEventToAlfred(event, url) {
  var method = "POST";
  var headers = new Headers({
    "Content-Type": "application/json"
  });

  var body = json_stringify_default()(event);
  return api_request(url, { method: method, headers: headers, body: body }, api_getIsRunningOnServer()).catch(function (e) {
    console.error("Alfred event failed", e);
  });
};
// CONCATENATED MODULE: ./template/state/enhancers.js










/* harmony default export */ var enhancers = (function () {
  return Object(redux_devtools_extension["composeWithDevTools"])({ name: "SiteChrome" })(Object(redux_esfrom_dll_reference_vendor["applyMiddleware"])(actionDeferral, //must go first!
  libfrom_dll_reference_vendor_default.a.withExtraArgument({
    api: api_namespaceObject,
    get identity() {
      return window.asos.sdk.identity;
    }
  }), middleware_bag, middleware_bodyScroll), autoRehydrate());
});
// CONCATENATED MODULE: ./template/state/modules/version/index.js
/* harmony default export */ var version = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return state;
});
// CONCATENATED MODULE: ./template/state/modules/welcomeMessage/index.js



/* harmony default export */ var welcomeMessage = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case RECEIVE_WELCOME_MESSAGE:
      return extends_default()({}, state, action.payload);
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./template/state/modules/index.js

















/* harmony default export */ var modules = (Object(redux_esfrom_dll_reference_vendor["combineReducers"])({
  layout: modules_layout,
  navigation: modules_navigation,
  regionalStore: modules_regionalStore,
  search: modules_search,
  savedItems: savedItems,
  bag: modules_bag,
  countrySelector: countrySelector,
  version: version,
  welcomeMessage: welcomeMessage,
  welcomeMat: welcomeMat,
  user: modules_user,
  dropdown: dropdown,
  features: modules_features,
  bodyScroll: bodyScroll,
  contentTargeting: contentTargeting
}));
// CONCATENATED MODULE: ./template/state/index.js




var composedEnhancers = enhancers();

/* harmony default export */ var template_state = (function (preloadedState) {
  return Object(redux_esfrom_dll_reference_vendor["createStore"])(modules, preloadedState, composedEnhancers);
});
// EXTERNAL MODULE: ./template/styles/fonts.css
var fonts = __webpack_require__("./template/styles/fonts.css");
var fonts_default = /*#__PURE__*/__webpack_require__.n(fonts);

// EXTERNAL MODULE: ./template/styles/global.css
var global = __webpack_require__("./template/styles/global.css");
var global_default = /*#__PURE__*/__webpack_require__.n(global);

// EXTERNAL MODULE: ./template/components/Breadcrumbs/index.css
var Breadcrumbs = __webpack_require__("./template/components/Breadcrumbs/index.css");
var Breadcrumbs_default = /*#__PURE__*/__webpack_require__.n(Breadcrumbs);

// CONCATENATED MODULE: ./helpers/loadTokenBlock.js




var loadTokenBlock_isValidGender = function isValidGender(gender) {
  return [FEMALE, MALE].indexOf(gender) !== -1;
};

var loadTokenBlock_getTokenGender = function getTokenGender(tokens) {
  return loadTokenBlock_isValidGender(tokens.gender) ? tokens.gender : DEFAULT;
};

var getStateGender = function getStateGender(state) {
  return state.layout.gender;
};

var loadTokenBlock_getGender = function getGender(state, tokens) {
  var genders = [loadTokenBlock_getTokenGender(tokens), client_getFloor(), getStateGender(state)];

  return genders.find(loadTokenBlock_isValidGender) || DEFAULT;
};

var loadTokenBlock_updateGenderCookie = function updateGenderCookie(gender) {
  client_setFloor(gender);
  return gender;
};

/* harmony default export */ var loadTokenBlock = (function (_ref) {
  var store = _ref.store,
      initialState = _ref.initialState,
      newState = _ref.newState;

  var newGender = loadTokenBlock_updateGenderCookie(loadTokenBlock_getGender(initialState, newState));

  if (getStateGender(initialState) !== newGender) {
    store.dispatch(actions_setGender(newGender));
  }
});
// CONCATENATED MODULE: ./client/navigation/constants.js
var siteChromeNavigationStoreKey = "chrome:navigation";
var expirationInMs = 5 * 60 * 1000;
// CONCATENATED MODULE: ./client/navigation/navigationLocalStorage.js



var navigationLocalStorage_getFromLocalStorage = function getFromLocalStorage(_ref) {
  var countryCode = _ref.countryCode,
      language = _ref.language;

  var storedJson = localStorage.getItem(siteChromeNavigationStoreKey);

  try {
    var stored = JSON.parse(storedJson);

    if (stored.countryCode === countryCode && stored.language === language) {
      return stored;
    }
  } catch (e) {
    return {};
  }

  return {};
};

var navigationLocalStorage_addToLocalStorage = function addToLocalStorage(_ref2) {
  var data = _ref2.data,
      countryCode = _ref2.countryCode,
      language = _ref2.language,
      keyStoreDataversion = _ref2.keyStoreDataversion;
  return localStorage.setItem(siteChromeNavigationStoreKey, json_stringify_default()({
    data: data,
    countryCode: countryCode,
    language: language,
    time: Date.now() + expirationInMs,
    keyStoreDataversion: keyStoreDataversion
  }));
};
// CONCATENATED MODULE: ./client/navigation/updateFromApi.js



var updateFromApi__this = this;





var updateFromApi = function () {
  var _ref2 = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref) {
    var countryCode = _ref.countryCode,
        language = _ref.language,
        store = _ref.store,
        storeUrl = _ref.storeUrl,
        platform = _ref.platform,
        fromLocalStorage = _ref.fromLocalStorage,
        keyStoreDataversion = _ref.keyStoreDataversion;
    var hasUpdateHappened, data;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hasUpdateHappened = false;
            _context.prev = 1;
            _context.next = 4;
            return api_fetchClientNavigation({
              country: countryCode,
              lang: language,
              storeUrl: storeUrl,
              platform: platform
            });

          case 4:
            data = _context.sent;


            try {
              navigationLocalStorage_addToLocalStorage({
                data: data,
                countryCode: countryCode,
                language: language,
                keyStoreDataversion: keyStoreDataversion
              });
              hasUpdateHappened = true;
            } catch (e) {
              console.warn("Saving navigation to localStorage failed: ", e);
            }

            store.dispatch(actions_updateNavigationTree(data));
            _context.next = 13;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);

            console.error("Nav update failed", _context.t0);
            if (fromLocalStorage) {
              store.dispatch(actions_updateNavigationTree(fromLocalStorage));
              if (hasUpdateHappened) {
                navigationLocalStorage_addToLocalStorage({ data: fromLocalStorage, countryCode: countryCode, language: language });
              }
            }

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, updateFromApi__this, [[1, 9]]);
  }));

  return function updateFromApi(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var navigation_updateFromApi = (updateFromApi);
// CONCATENATED MODULE: ./client/navigation/index.js




var navigation__this = this;





var getCountryData = function getCountryData(store) {
  var _store$getState = store.getState(),
      _store$getState$regio = _store$getState.regionalStore,
      countryCode = _store$getState$regio.countryCode,
      defaultLanguage = _store$getState$regio.defaultLanguage,
      storeUrls = _store$getState$regio.storeUrls,
      keyStoreDataversion = _store$getState$regio.keyStoreDataversion,
      platform = _store$getState.layout.platform;

  return [defaultLanguage, countryCode, storeUrls.default, platform, keyStoreDataversion];
};

var reloadNavigation = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(store) {
    var _getCountryData, _getCountryData2, language, countryCode, storeUrl, platform, ksdvFromRegionalStore, _getFromLocalStorage, data, time, ksdvFromLocalStorage;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _getCountryData = getCountryData(store), _getCountryData2 = slicedToArray_default()(_getCountryData, 5), language = _getCountryData2[0], countryCode = _getCountryData2[1], storeUrl = _getCountryData2[2], platform = _getCountryData2[3], ksdvFromRegionalStore = _getCountryData2[4];
            _getFromLocalStorage = navigationLocalStorage_getFromLocalStorage({
              countryCode: countryCode,
              language: language
            }), data = _getFromLocalStorage.data, time = _getFromLocalStorage.time, ksdvFromLocalStorage = _getFromLocalStorage.keyStoreDataversion;


            if (data && time > Date.now() && ksdvFromLocalStorage === ksdvFromRegionalStore) {
              store.dispatch(actions_updateNavigationTree(data));
            } else {
              navigation_updateFromApi({
                countryCode: countryCode,
                language: language,
                store: store,
                storeUrl: storeUrl,
                platform: platform,
                fromLocalStorage: data,
                keyStoreDataversion: ksdvFromRegionalStore
              });
            }

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, navigation__this);
  }));

  return function reloadNavigation(_x) {
    return _ref.apply(this, arguments);
  };
}();
// CONCATENATED MODULE: ./client/sdk/identity.js

/* global requirejs */


var TOKEN_TYPES = "id_token token";
var IDENTITY_SCOPES = "openid sensitive profile";

var identity_initialise = function initialise(store) {
  return new promise_default.a(function (resolve) {
    var config = clientConfig["a" /* default */].get();
    var state = store.getState();
    var identityConfig = {
      lang: getDefaultLanguage(state),
      regionalIsoCode: getDefaultLanguage(state),
      clientId: config.IDENTITY_SDK_CLIENT_ID,
      customerApiUrl: config.IDENTITY_SDK_CUSTOMER_API_URL,
      authenticationHost: config.IDENTITY_SDK_AUTH_HOST,
      identityOrigin: config.IDENTITY_SDK_IDENTITY_ORIGIN,
      responseMode: "json",
      store: selectors_getStoreCode(state),
      countryCode: getCountryCode(state),
      keyStoreDataversion: selectors_getKeyStoreDataversion(state),
      types: TOKEN_TYPES,
      scope: IDENTITY_SCOPES,
      redirectUri: window.location.href
    };

    requirejs(["asos.identity.sdk.config"], function (configurator) {
      configurator.setConfig(identityConfig);

      requirejs(["asos.identity.web.clientsdk"], resolve);
    });
  });
};
// CONCATENATED MODULE: ./client/sdk/savedItemsConfiguration.js


var savedItemsConfiguration_buildConfiguration = function buildConfiguration(config) {
  if (clientConfig["a" /* default */].isLocal()) {
    return {
      postMessageUrl: config.SDK_POST_MESSAGE_URL,
      xSiteOrigin: config.SDK_X_SITE_ORIGIN,
      savedItemsApiUrl: config.SDK_SAVED_ITEMS_API_URL
    };
  }

  return {
    xSiteOrigin: clientConfig["a" /* default */].getXSiteOrigin()
  };
};

var savedItemsConfiguration_getConfiguration = function getConfiguration() {
  return savedItemsConfiguration_buildConfiguration(clientConfig["a" /* default */].get());
};
// CONCATENATED MODULE: ./client/sdk/savedItems.js

/* global requirejs */


var savedItems_initialise = function initialise(context) {
  return new promise_default.a(function (resolve) {
    return requirejs(["savedItemsSdk/sdk"], function (sdk) {
      return resolve(sdk.getInstance(context, savedItemsConfiguration_getConfiguration()));
    });
  });
};
// CONCATENATED MODULE: ./client/sdk/features.js

/* global requirejs */

var getVersionManifestFeatures = function getVersionManifestFeatures() {
  return window.__versionManifest && window.__versionManifest.features;
};

var getFeatureManifest = function getFeatureManifest() {
  return window.__featureManifest || {
    features: {},
    mvt: {}
  };
};

var features_initialise = function initialise(context) {
  return new promise_default.a(function (resolve) {
    requirejs(["asos-web-features"], function (_ref) {
      var features = _ref.default;

      var instance = features.getInstance(getFeatureManifest(), context);
      resolve(instance);
    });
  });
};

var addManifestFeatures = function addManifestFeatures(instance) {
  return instance.addManifest({ features: getVersionManifestFeatures() });
};
// CONCATENATED MODULE: ./client/sdk/index.js





var sdk__this = this;






var getMappedContext = function getMappedContext(values) {
  return {
    storeId: values.storeId,
    country: values.browseCountry,
    originCountry: values.geoCountry,
    currency: values.browseCurrency,
    language: values.browseLanguage,
    sizeSchema: values.browseSizeSchema,
    keyStoreDataversion: values.keyStoreDataversion
  };
};

var ready = function ready(name) {
  return function (sdk) {
    window.asos.sdk[name] = sdk;
    window.asos.eventBus.emit(name + "-sdk-ready", sdk);
    return sdk;
  };
};

var sdk_initialise = function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(store, context) {
    var webContext, mappedWebContext, bagSdkContext, country, savedItemsSdkContext;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            webContext = context.getWebContext();
            mappedWebContext = getMappedContext(webContext);
            bagSdkContext = mappedWebContext;
            country = mappedWebContext.country, savedItemsSdkContext = objectWithoutProperties_default()(mappedWebContext, ["country"]); // eslint-disable-line no-unused-vars

            return _context.abrupt("return", promise_default.a.all([features_initialise(webContext).then(ready("features")).then(addManifestFeatures).then(function () {
              window.asos.eventBus.emit("features-mvt-ready", window.asos.sdk.features);
            }), identity_initialise(store).then(ready("identity")).then(function () {
              return bag_initialise(bagSdkContext).then(ready("bag"));
            }).then(function () {
              return savedItems_initialise(savedItemsSdkContext).then(ready("savedItems"));
            })]).then(function () {
              return window.asos.eventBus.emit("sdk-ready", window.asos.sdk);
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, sdk__this);
  }));

  return function initialise(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// CONCATENATED MODULE: ./client/constants.js
var IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";
// CONCATENATED MODULE: ./client/loadUserProfile.js






var loadUserProfile_fetchUserProfile = function fetchUserProfile(store) {
  if (!window.asos.sdk.identity) return;

  var identitySDK = window.asos.sdk.identity;


  if (cookies_getCookieValue(IDENTITY_SDK_RESET_COOKIE) === "true") {
    var domain = "." + stripSubdomain(window.location.hostname);

    identitySDK.customer.resetLocalCopy();
    cookies_removeCookie(IDENTITY_SDK_RESET_COOKIE, domain);
  }

  store.dispatch(actions_setUserFetchingState(FETCHING));

  return identitySDK.customer.profile().then(function (profile) {
    if (!profile) {
      throw new Error("Empty profile");
    }

    store.dispatch(actions_setUserProfile(profile));
    store.dispatch(actions_setLoggedInState(profile.isAuthenticated));
    store.dispatch(actions_setUserFetchingState(SUCCESS));

    if (profile.isAuthenticated || profile.isRecognised) {
      return identitySDK.customer.isReconsentRequired().then(function (reconsentRequired) {
        return store.dispatch(actions_setUserReconsentStatus(reconsentRequired));
      }).catch(helpers_logger.warn);
    }
  }).catch(function () {
    store.dispatch(actions_setUserFetchingState(FAILED));
  });
};

/* harmony default export */ var loadUserProfile = (function (store) {
  if (window.asos.sdk.identity) return loadUserProfile_fetchUserProfile(store);
  return window.asos.eventBus.addListener("sdk-ready", function () {
    return loadUserProfile_fetchUserProfile(store);
  });
});
// CONCATENATED MODULE: ./client/addFeaturesToStore.js

/*

Add features to store, waiting until DOM content has loaded to avoid template mismatches.

*/



/* harmony default export */ var addFeaturesToStore = (function (store, emitter) {
  var dispatchFeatures = function dispatchFeatures(event) {
    return store.dispatch(actions_setFeatures(extends_default()({
      loadComplete: event === "features-mvt-ready"
    }, window.asos.sdk.features.getFeatures())));
  };

  var postHydrate = false;
  var calledBeforeHydrate = false;
  var pendingCalls = [];

  emitter.addListener("hydrate-ready", function () {
    postHydrate = true;
    if (calledBeforeHydrate && pendingCalls.length) {
      pendingCalls.forEach(function (fn) {
        return fn();
      });
    }
  });

  return function (event) {
    if (postHydrate) {
      dispatchFeatures(event);
    } else {
      calledBeforeHydrate = true;
      pendingCalls.push(function () {
        return dispatchFeatures(event);
      });
    }
  };
});
// CONCATENATED MODULE: ./client/Root.js
/* eslint-disable no-underscore-dangle */
























var _clientConfig$get = clientConfig["a" /* default */].get(),
    NAVIGATION_SUBTREE_API_PATH = _clientConfig$get.NAVIGATION_SUBTREE_API_PATH;

var firstVisit = client_isFirstVisit();
var Root_store = template_state(window[constants["d" /* siteChromeInitialStore */]]);

var Root__context = context_context(Root_store),
    contextFns = Root__context.context,
    Root_updateRegionalStore = Root__context.updateRegionalStore;

window.asos = {
  contentTargeting: contentTargetingEvents,
  eventBus: events,
  sdk: {}
};

window.__sdk = window.asos.sdk; /* backwards compatibility */
window.analyticsEventEmitter = window.asos.eventBus; /* backwards compatibility */

window[constants["e" /* siteChromePublicWindowApi */]] = {
  context: contextFns
};

var updateFeatures = addFeaturesToStore(Root_store, events);

events.addListener("features-sdk-ready", function () {
  return updateFeatures("features-sdk-ready");
});
events.addListener("features-mvt-ready", function () {
  return updateFeatures("features-mvt-ready");
});

sdk_initialise(Root_store, contextFns);

var Root_updateStateWithClientData = function updateStateWithClientData() {
  Root_updateRegionalStore(function () {
    if (!(NAVIGATION_SUBTREE_API_PATH.indexOf("/preview/") !== -1)) {
      reloadNavigation(Root_store);
    }
  });
  loadUserProfile(Root_store);

  loadTokenBlock({
    store: Root_store,
    initialState: window[constants["d" /* siteChromeInitialStore */]],
    newState: window[constants["f" /* siteChromeTokenValues */]]
  });

  if (firstVisit) {
    Root_store.dispatch(actions_openCookieMessage());
  }

  persistStore(Root_store, {
    keyPrefix: "chrome:",
    whitelist: ["search"]
  });
};

var Root_Header = function Header() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    esfrom_dll_reference_vendor["Provider"],
    { store: Root_store },
    reactfrom_dll_reference_vendor_default.a.createElement(components_HtmlHeader, null)
  );
};

var Root_Footer = function Footer() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    esfrom_dll_reference_vendor["Provider"],
    { store: Root_store },
    reactfrom_dll_reference_vendor_default.a.createElement(components_Footer, { viewable: [LARGE_VIEWPORT, MEDIUM_VIEWPORT] })
  );
};

var Root_WelcomeWrapper =
/* istanbul ignore next */
function WelcomeWrapper() {
  return reactfrom_dll_reference_vendor_default.a.createElement(
    esfrom_dll_reference_vendor["Provider"],
    { store: Root_store },
    reactfrom_dll_reference_vendor_default.a.createElement(components_WelcomeWrapper, null)
  );
};
// CONCATENATED MODULE: ./client/thirdPartyCookie.js



var ALLOWED_DOMAINS = ["local.asos.com", "www.asos.com", "www.asos.fr", "www.asos.de", "test.asosservices.com", "test.asosservices.fr", "test.asosservices.de"];

var alreadyRedirected = function alreadyRedirected(query) {
  return query && query.crd && query.crd === "true";
};

function startIframe() {
  var iframeUrl = clientConfig["a" /* default */].get().IFRAME_URL;
  var currentUrl = Object(url_url["parse"])(window.location.href, true, false);
  if (iframeUrl && !alreadyRedirected(currentUrl.query)) {
    window.addEventListener("message", function (event) {
      var domain = Object(url_url["parse"])(event.origin);
      if (ALLOWED_DOMAINS.indexOf(domain.hostname) !== -1 && event.data === "redirection_needed") {
        currentUrl.query["crd"] = "true";
        delete currentUrl.search;

        window.location.href = iframeUrl + "?doRedirect=true&referrer=" + encodeURIComponent(decodeURIComponent(Object(url_url["format"])(currentUrl)));
      }
    });

    var iframe = document.createElement("iframe");
    iframe.src = iframeUrl;
    iframe.width = 0;
    iframe.height = 0;
    iframe.style.display = "none";
    document.body.appendChild(iframe);
  }
}
// EXTERNAL MODULE: ./client/reactAxe.js
var reactAxe = __webpack_require__("./client/reactAxe.js");
var reactAxe_default = /*#__PURE__*/__webpack_require__.n(reactAxe);

// CONCATENATED MODULE: ./client/index.js









































































































document.addEventListener("DOMContentLoaded", function () {
  var headerElement = document.getElementById("chrome-header");
  var footerElement = document.getElementById("chrome-footer");
  var welcomeMatElement = document.getElementById("chrome-welcome-mat");

  Object(react_domfrom_dll_reference_vendor["hydrate"])(reactfrom_dll_reference_vendor_default.a.createElement(Root_Header, null), headerElement);
  Object(react_domfrom_dll_reference_vendor["hydrate"])(reactfrom_dll_reference_vendor_default.a.createElement(Root_Footer, null), footerElement);
  Object(react_domfrom_dll_reference_vendor["hydrate"])(reactfrom_dll_reference_vendor_default.a.createElement(Root_WelcomeWrapper, null), welcomeMatElement);

  window.asos.eventBus.emit("hydrate-ready");

  Root_updateStateWithClientData();
});

startIframe();

/***/ }),

/***/ "./client/reactAxe.js":
/***/ (function(module, exports, __webpack_require__) {

if (false) {
  var React = require("react");
  var ReactDom = require("react-dom");
  var axe = require("react-axe");
  var config = {
    runOnly: {
      type: "tag",
      values: ["wcag2a", "wcag2aa"]
    }
  };
  axe(React, ReactDom, 1000, config);
}

/***/ }),

/***/ "./env/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {var env = function env(key, defaultValue) {
  // eslint-disable-next-line no-prototype-builtins
  if (process.env.hasOwnProperty(key)) {
    return process.env[key];
  }
  if (typeof defaultValue !== "undefined") {
    return defaultValue;
  }
  throw new Error("No " + key + " environment variable is defined.");
};

/* harmony default export */ __webpack_exports__["a"] = (env);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "./template/clientConfig.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("../node_modules/babel-runtime/core-js/object/keys.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("./template/constants.js");



var getClientConfigFromWindow = function getClientConfigFromWindow() {
  if (typeof window !== "undefined" && window[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* siteChromeClientConfig */]]) {
    return window[__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* siteChromeClientConfig */]];
  }
  return false;
};

var isLocal = function isLocal() {
  return typeof window !== "undefined" && window.location.hostname.indexOf("local") !== -1;
};

var isServer = function isServer() {
  return typeof window === "undefined";
};

var getXSiteOrigin = function getXSiteOrigin() {
  var cookies = document.cookie.split(";");
  var xSite = cookies.find(function (cookie) {
    return cookie.toLowerCase().indexOf("x-site-origin=") !== -1;
  });

  if (!xSite) return;

  return xSite.split("=")[1];
};

var getClientConfig = function getClientConfig() {
  return getClientConfigFromWindow() || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(process.env).filter(function (key) {
    return key.startsWith(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* clientEnvPrefix */]);
  }).reduce(function (acc, key) {
    acc[key.replace(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* clientEnvPrefix */], "")] = process.env[key];
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = ({
  get: getClientConfig,
  isLocal: isLocal,
  isServer: isServer,
  getXSiteOrigin: getXSiteOrigin
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../node_modules/process/browser.js")))

/***/ }),

/***/ "./template/components/Breadcrumbs/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_26dhdzA","list":"_3_HulsW"};

/***/ }),

/***/ "./template/components/Burger/Burger.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"burger":"_387JN2Z","burger__hidden":"_2CZGxSY"};

/***/ }),

/***/ "./template/components/Button/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_1DSc_jN","button__isPrimary":"cFiVQcw","button__isSecondary":"_3-TPxFN","button__isTertiary":"_2vYGg5k","button__isGreen":"_2qfI174","button__hasInvertedSize":"_1go2Ewe","content":"wAc4igN","content__isHidden":"_3cNyKVT","spinner":"_3CaW0je"};

/***/ }),

/***/ "./template/components/CountrySelector/Backdrop.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_2l01zku"};

/***/ }),

/***/ "./template/components/CountrySelector/Container.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_37-lec9","container":"_1IWXq8E","container__notLoading":"_2Yqh5U6","container__withError":"Bb4CiTc"};

/***/ }),

/***/ "./template/components/CountrySelector/Fade.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fade":"SnnTmDC","fade__entered":"dDRZo3X","fade__entering":"_3Sf7HnX","fade__exited":"_2DGNX8Z","fade__exiting":"_3IzcYIk"};

/***/ }),

/***/ "./template/components/CountrySelector/Form.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2WNIJuP","header":"_9Su1VYo","form":"_3uy0rRO","field":"OVtBwTj","features":"_3MEhp6k","proposition":"_2OFFw51","propositions":"_3-JfxSf","providers":"_1tjzQfV","provider":"_3P6snIZ","currency":"_1QmYx4Z","label":"kryyYP3","label__disabled":"_3odbvKF","select":"_3JpRU2l","actions":"_3qiSl8R","submitButton":"V7TpTZV","closeButton":"wXnknxI","error":"_12D7Y4x","warning":"_1BeDSc8"};

/***/ }),

/***/ "./template/components/CountrySelectorButton/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2yzMbJD","header":"_3g4nBO9","button":"YvZ3lbB","locationText":"_2F4ufl5","changeLabel":"Tg743C9","countryFlag":"_2S5PiQY","withLabels":"_3n7i0ux"};

/***/ }),

/***/ "./template/components/Dropdown/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xLEaimc","wrapper__open":"_1NIO-n7","outerWrapper":"_1__Ug8F","slidedown":"_2Ydfmv-","wrapper__hidden":"_3YiroC7","innerWrapper":"_2jIx_En","body":"_4dx9Nn7","header":"Zb-NiHG","footer":"_2-UJgpr","close":"_3rZlkmo","container":"_2nFo01D"};

/***/ }),

/***/ "./template/components/FloorNavigation/FloorNavigation.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2htQAml","container__large":"_3nGd4mQ","button":"_1DZnw9e","selected":"_2O3Pt9j"};

/***/ }),

/***/ "./template/components/Footer/Footer.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_170bFmT","mainContent":"SKoJwiD","container__accordion":"seWJYwj","iconBar":"G2lBJZk","greeterWrapper":"HZ254Fm","myAccountLinksWrapper":"_2kRRN8_"};

/***/ }),

/***/ "./template/components/Footer/LinkGroup/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Rg3LvF7","header":"AyPVvkm","header__focused":"_1s_xFHS","link":"_26xJFIo"};

/***/ }),

/***/ "./template/components/Footer/Links.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container__hidden":"_1c2IHsB","group":"_3RAMPY8","container":"_1gmIo4T","body":"_1ysB59M"};

/***/ }),

/***/ "./template/components/Footer/PaymentOptions/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"paymentOptions":"d3hEogn","provider":"_2t5mfE3"};

/***/ }),

/***/ "./template/components/Footer/SocialLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"socialLinks":"_2WkalZ6","socialLink":"_1gagYVR","Facebook":"i8FxB9X","Instagram":"EOORuiO","Snapchat":"uQdwP38","Vk":"_2mLsYUT"};

/***/ }),

/***/ "./template/components/GDPR/Banner/Banner.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"transitionDurationMs":"1000","wrapper":"_366tGHh","container":"_3PytKwX","show":"_1fuIZin","content":"_1wuV2zN","close":"_16Yw48I","greeting":"_2wGzpIi","cta":"DDNlINf","error":"MvORN1Q"};

/***/ }),

/***/ "./template/components/GDPR/Confirmation/Confirmation.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3zuzTWZ","container__isIn":"siJXd1v","heading":"_7mMnkyq","body":"_3kmOQHR","actions":"B9-V2DF"};

/***/ }),

/***/ "./template/components/GDPR/ContactPreferences/ContactPreferences.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_-5QS2ky","header":"_3XVXPvs","body":"_2SyPnzx","footer":"_3xW3Ae8","small":"_2CfrGrH","optionListWrapper":"S97O2xk","optionList":"kQx1gKn","cta":"_271gBtw","errorWrapper":"_1TrNYB2","errorMessage":"_3YGziOA"};

/***/ }),

/***/ "./template/components/GDPR/Option/Option.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3JF4T0N","wrapper":"TA65A10","image":"_3k_xFTF","name":"_2gB5Prx","optedOut":"_29dCOp8"};

/***/ }),

/***/ "./template/components/Greeter/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"VbnjanM","welcome":"_2T5vKuV","link":"_1k1reGo","links":"_1GV6Ntf","pipe":"_1tXI178"};

/***/ }),

/***/ "./template/components/Header/CookieDisclaimer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cookieDisclaimer":"_2pMurAl","container":"_1cJDHsE","summary":"_2EMw4Zz","readMore":"_2afHWeu","closeButton":"_1EF2tpx"};

/***/ }),

/***/ "./template/components/Header/HomeLogo/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"link":"_25irHcd"};

/***/ }),

/***/ "./template/components/Header/Logo/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo":"_23G0l8x"};

/***/ }),

/***/ "./template/components/Header/SkipToContent/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"skipLink":"_2ddmVSH"};

/***/ }),

/***/ "./template/components/Header/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2tINcUI","body":"_1UGQQJn"};

/***/ }),

/***/ "./template/components/HtmlHeader/HtmlHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./template/components/Icon/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_31xW4F2","medium":"OLtHnkd","small":"_1BuJJ3-"};

/***/ }),

/***/ "./template/components/IconButton/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"_3TGKcxB"};

/***/ }),

/***/ "./template/components/IconNotification/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"eNJgAGE"};

/***/ }),

/***/ "./template/components/LegalBar/LegalBar.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2jz2mjA","body":"nUQMpvx","copyright":"_28lMicj","links":"W1vTixy","hideOnSmallViewport":"_2xktXa3"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/BagLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"bagLinks":"OWGtwg_","buttonContainer":"_2VB_6B_"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/DeliveryProposition/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deliveryProposition":"_36n_JsH","title":"_21tn5Nb","description":"_4ldbEX5","descriptionLink":"s1XF5zI"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/GermanVATIncluded/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"germanVATInc":"_3BT-YhX"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/USSalesTax/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"USSalesTax":"_1aqDVfV"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/SubTotal/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"subTotalContainer":"_2AvxZ7t","germanVATInc":"_3avmlO4","USSalesTax":"Sm7Ss_M"};

/***/ }),

/***/ "./template/components/MiniBag/Footer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"minibagFooter":"_3L-aps4"};

/***/ }),

/***/ "./template/components/MiniBag/Header/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"-JJfifv","bagTitle":"_1vvMfU_"};

/***/ }),

/***/ "./template/components/MiniBag/LineItem/DeleteItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"deleteItem":"XBF4Pwh"};

/***/ }),

/***/ "./template/components/MiniBag/LineItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1W0zOsK","link":"_1hLNXDL","image":"_36eVKGL","details":"_11v_yFR","term":"_1NGI_3f","price":"_3GC3ciN","item":"_2AqO0mn","product":"_1X9v1ZD","name":"_3GJua_o","meta":"_3FcFWyr","color":"_2iqu9DU","size":"_1DeddFy","quantity":"_11JyDT0"};

/***/ }),

/***/ "./template/components/MiniBag/Price/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_38kkGWl","current":"he3XXzJ","highlight":"_1uD507y","previous":"_206h8Fg","rrp":"_255x-wT","rrpLabel":"_3a-eLYZ"};

/***/ }),

/***/ "./template/components/MiniBag/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"_3y1fLq5","miniBag":"_13bi4_K","link":"_11qZWTX","spinnerContainer":"_26s4UbK","error":"wm-Y41N"};

/***/ }),

/***/ "./template/components/MiscBar/MiscBar.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2mW0vnV","container__hidden":"_3Jzwqs8","body":"_2kDR6LR","navigation":"_2gP-s5Y"};

/***/ }),

/***/ "./template/components/Modal/Backdrop.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"backdrop":"_20Pj1VE"};

/***/ }),

/***/ "./template/components/Modal/Container.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1IrYKRb","container":"_2GCIzUy","close":"_1afbYq-"};

/***/ }),

/***/ "./template/components/Modal/Fade.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fade":"_1Ak4Mxk","isAndroid":"oKBSAEs","isIos":"_1f8FALW","fade__entered":"_1nheg_4","fade__entering":"_1kv7c7T","fade__exited":"Glsad_N","fade__exiting":"_20ztZF3"};

/***/ }),

/***/ "./template/components/MyAccountLinks/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3C22DSI","notificationContainer":"_1FUcAu2","link":"_1U-LQGT","MyAccount":"CbK3vyi","MyOrders":"sEG4Jt8","ReturnsInformation":"gWnk_r7","ContactPreferences":"lWdTQ9X","MyAccountChristmasLoggedIn":"MExq9lg","MyAccountChristmasLoggedOut":"_3IDuJDB"};

/***/ }),

/***/ "./template/components/Navigation/LargePrimaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3kg3G5e","container__hidden":"_3VhrZsw","navigation":"_25By0Z8","navButtons":"_3r7rW4o","navButton":"_2Ac9WRp","navButton__active":"QlRTIh7","slant":"_2mZjF9Z","bold":"VukdW2l"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/CircleImageList/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"circleImageList":"_3rpsc2u","circleImageLink":"_3X9INkc","circleImageBorder":"tIg6Zov","circleImage":"CzRt8da","label":"_1dHc1LM","label__sale":"BLIJwya","label__bold":"_3wvpOZT"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/GridCircleImage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3j3wPvK","gridItem":"_3V0KF--","gridItem__sale":"_3fZXQRD","gridItemImageBorder":"_2GC-7QL","gridItemImage":"_38TV2Q5"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"cardList":"lxl1m4p","card":"cEafYrU","thumbnailWrapper":"Es0d-oL","thumbnailCover":"_9q4POoy","light":"_3QYsQtS","dark":"_1VbtZ8X","image":"_3ARlt8n","cardTitle":"_3skrDb5","cardDescription":"_2DUsWiv"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/MarketingImage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1NtxSD3","container__column":"_26_yujQ","item":"_2uD85Ca","label":"_3ORur7s","label__dark":"_30YKIbT","label__light":"_16EFHZ4","image":"_2PBH9Tw","thumbnail":"zgb64R9","vertical":"_2_fWyUH","light":"_3RbcbtV","dark":"_2Qt4a5S","horizontal":"_3t_t-Xe"};

/***/ }),

/***/ "./template/components/Navigation/LargeSecondaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1c4zf5o","backdrop":"rbfmVpk","flyoutContainer":"_1Exx-PU","flyout":"_1dZZci7","isLoading":"_20X3gNb","visible":"_2Fshgzz","column":"_1QmxDO_","colspan-1":"nEoIIe5","textList":"z36sLT1","colspan-2":"YlqXo8e","colspan-3":"_1D_SQB6","colspan-4":"_3iT6Z7q","columnHeaderContain":"qHb8CDW","columnHeader":"_2HjZSOc","textLink":"_2Aejr0d","textLink__sale":"_2rDFtsg","textLink__bold":"_1iUbby0"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/CarouselLink.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1UgySfN","carouselLink":"_3H8AuY1","label":"lFlpBn6","label__light":"_1ivrAR2","label__sale":"J4dMEZd","subtitle":"_1-ghia1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"list":"_2JwYR9n","list__animate":"DfrfywO","carouselLink":"_1Fg6Mkn"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/NavigationDots/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dotContainer":"IxXpg-P","dotItem":"_2dX_dN9","dot":"_1ooe7Gy","dot__selected":"_1rTNrrq"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CarouselContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"UEG5lkc","container__extraPadding":"_7o2iemF","hitArea":"_3l4GUXL","chevronRight":"_2aCAEI1","chevronLeft":"_22cDiP5"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageLeftItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"menuItem":"_2qt4H8Z","button":"_1xJ3tLR","circleImage":"_2e3YCj1","label":"_39II9oU","label__sale":"_1sIwZh0","label__bold":"_3G7NJJ1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/CircleImageRightItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uiF0ti","menuItem":"_3-GouR_","label":"_2KVLkPB","label__sale":"_1mGvVLn","image":"_2ipto0o"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/FlatItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2CKCa0c","menuItem":"_2ZrmXYA","label":"jsC7K1m","label__light":"_3uQ41qA","label__sale":"_1dvZaW2","subtitle":"_3XTwJYe","flatMenuItem":"_2rvxCv1"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/InspirationItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"tw0FNVJ","wrapper":"_33t9V20","image":"id8ZbV1","title":"_1bdcYOM","description":"_2ZyLvxL","dark":"RSfOR1U","light":"_14_kzQ5"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ListContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3sonpri","container__noBackground":"_2uQ-C2e"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/MenuItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_287Xr1i","menuItem":"_1Lr9s52","label":"_2UoQGIz","label__light":"_9unZirh","label__sale":"_3xmb2OY","subtitle":"_1cky1mG"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/SquareItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1yTTgtG","link":"_1z75khH","image":"_30Ntdiu","label":"RYZoujz","label__sale":"_1EDIGUs"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/ViewAllBlock/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"block":"_2tsa3Tm","fakeOutsideBlock":"xGHs8oT"};

/***/ }),

/***/ "./template/components/Navigation/SideNavigationContainer/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"pQxhHu0","listContainer":"_2vx2JAg"};

/***/ }),

/***/ "./template/components/Navigation/SidePanel/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dialog":"e9BXhnn","dialog__animate":"_2vVXZSW","primarySideContainer__animate":"_2Xn4-fu","dialog__visible":"_3xr4O-L","dontHideButtonContainer":"_1cXZlsM","container":"_3mJw6fH","primarySideContainer":"_2LKGpcC","primarySideContainer__hidden":"_15Khghp","content":"_1vPhLeL","close":"_23Cf8RU","overlay":"_2k_yRgJ","overlay__animate":"_1eod1iN","overlay__show":"_3jZhZbN"};

/***/ }),

/***/ "./template/components/Navigation/SidePrimaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2P0dWBm"};

/***/ }),

/***/ "./template/components/Navigation/SideSecondaryNavigation/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SO8a70","container__visible":"_1St3kFK","header":"LugcOmY","close":"R1CKLoS","secondary":"_2ALYZ5D","item":"_1XBO_x3","item__visible":"GSjf4AI"};

/***/ }),

/***/ "./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"stickyHeader":"_2qbxfQF","stickyHeader__sidePanelOpen":"_3VnsaeI"};

/***/ }),

/***/ "./template/components/Notification/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"notification":"EEAetjH","text":"_3OOTF2t","hasBackground":"_2jSFszG","hasIcon":"_1YG5Vyj","success":"_10Z5DXC","error":"_3GU5ymQ","promotion":"_1xX3I5f","alert":"_1qhdF5P"};

/***/ }),

/***/ "./template/components/SearchDropdown/ResultItem/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"label":"_2O1emdg","count":"_3_Y4sZZ","bold":"_179bjqa","button":"_1kpn9KI"};

/***/ }),

/***/ "./template/components/SearchDropdown/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2m6gPa2","list":"_1Sq1DvZ","recentSearchesHeader":"_3WFlxZM","recentSearchesClear":"_27Sj3UY"};

/***/ }),

/***/ "./template/components/SearchForm/SearchControls/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wYFryj","container__hidden":"_254uRVH"};

/***/ }),

/***/ "./template/components/SearchForm/SearchForm.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"_AXFL6D","backdrop":"_2OrxWsX","backdrop__active":"_3mlaV0h","controls":"_37kcNWv","container":"_2Idp6BM","container__active":"_3ChAiVG","fieldContainer":"_3mgvuXW","field":"_2z-tgin","field__active":"_1-Ok1So","button":"_1PEaSbT","button__active":"_3STtqeg","results":"_15ReAU2","label":"_1eJyqnP","results__active":"_1iHsCF4"};

/***/ }),

/***/ "./template/components/Spinner/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3F3-zot","rotate":"_1EbMuyW","small":"_1PHabRi","medium":"_2SN11Ha","large":"_3x2345_","x-large":"_24EDmS-","default":"w0zXMnO","centre":"_2QWwebb"};

/***/ }),

/***/ "./template/components/TransitionList/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3jJF-YY","transitionList__element":"_7A5raQ3","transitionList__overlay":"_5za5cGj","transitionList__element--exiting":"_33JlLjK","transitionList_itemDeletedLabel":"_1iNwCvT","scaler":"_14Vh9ji"};

/***/ }),

/***/ "./template/components/UnsupportedBrowserMessage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_3lW8Y31","content":"_1eJmCBp","message":"_23QFXRT","header":"_2PQizAW","details":"_3CnPFRy"};

/***/ }),

/***/ "./template/components/WelcomeMat/Message/Message.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1rQzr0T","flag":"EjR5TbT","text":"_3dXU2qH","redirectLink":"sE0SDig","changeButton":"_3qeH1gO"};

/***/ }),

/***/ "./template/components/WelcomeMat/PaymentOptions.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_40vlZJG","container":"uVISX5m","paymentOption":"_1dJsPRL","logo":"XFU8Dea"};

/***/ }),

/***/ "./template/components/WelcomeMat/ValueProposition.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"Krmchy1","header":"_3mY3SxI","message":"_323c2w8"};

/***/ }),

/***/ "./template/components/WelcomeMat/WelcomeMat.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2zbKZA9","containerWrapper":"_1G5WFnO","slideUp":"_1TLIkUE","titleBarWrapper":"pd-tTev","contentBarWrapper":"_2RzbZoX","titleBar":"_1Mm24sv","title":"_1YuC05z","closeButton":"_1jxNAGm","contentBar":"_1jlh44H"};

/***/ }),

/***/ "./template/components/WelcomeMessage/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_21wIL3t","wrapper":"fDaZ3Z4","slideUp":"_2avUdZl","flag":"zTT_AGe","text":"BRd5uim","redirectLink":"_3Mus2JK","closeButton":"_2np3kDs"};

/***/ }),

/***/ "./template/components/Widgets/Widget/index.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_2F9qY-C","container__hidden":"_2X1h55w","myAccountWidget":"_46ucpdl"};

/***/ }),

/***/ "./template/components/Widgets/Widgets.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"_1OLInBo","widgetButton":"wN7TsRy","noOfBagItems":"_1EbtfBz","bounce-minibag":"_26mzG9J"};

/***/ }),

/***/ "./template/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return siteChromePublicWindowApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return manifestWindowKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return siteChromeInitialStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return siteChromeTokenValues; });
/* unused harmony export RECENT_SEARCHES_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return siteChromeClientConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clientEnvPrefix; });
/* unused harmony export getExternalScripts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__clientConfig__ = __webpack_require__("./template/clientConfig.js");


var siteChromePublicWindowApi = "__siteChrome";
var manifestWindowKey = "__versionManifest";
var siteChromeInitialStore = "__siteChromeInitialStore";
var siteChromeTokenValues = "__siteChromeTokenValues";
var RECENT_SEARCHES_KEY = "__asosRecentSearches";
var siteChromeClientConfig = "__chromeConfig";
var clientEnvPrefix = "CLIENT_";
var getExternalScripts = function getExternalScripts() {
  return [__WEBPACK_IMPORTED_MODULE_0__clientConfig__["a" /* default */].get().WEB_ANALYTICS_URL];
};

/***/ }),

/***/ "./template/styles/fonts.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"web-fonts-base-path":"https\\://assets.asosservices.com/MasterLayout/WebFonts","web-fonts-futura-pt-book":"FTN45__W","web-fonts-futura-pt-heavy":"FTN75__W","web-fonts-futura-pt-oblique":"FTN46__W","web-fonts-futura-pt-extra-bold-oblique":"FTN96__W"};

/***/ }),

/***/ "./template/styles/global.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./template/styles/icons recursive ^\\.\\/.*\\.svg$":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./a.svg": "./template/styles/icons/a.svg",
	"./account.svg": "./template/styles/icons/account.svg",
	"./accountChristmasFilled.svg": "./template/styles/icons/accountChristmasFilled.svg",
	"./accountChristmasFilledMobile.svg": "./template/styles/icons/accountChristmasFilledMobile.svg",
	"./accountChristmasUnfilled.svg": "./template/styles/icons/accountChristmasUnfilled.svg",
	"./accountChristmasUnfilledMobile.svg": "./template/styles/icons/accountChristmasUnfilledMobile.svg",
	"./accountFilled.svg": "./template/styles/icons/accountFilled.svg",
	"./accountUnfilled.svg": "./template/styles/icons/accountUnfilled.svg",
	"./alert.svg": "./template/styles/icons/alert.svg",
	"./backArrow.svg": "./template/styles/icons/backArrow.svg",
	"./bagFilled.svg": "./template/styles/icons/bagFilled.svg",
	"./bagUnfilled.svg": "./template/styles/icons/bagUnfilled.svg",
	"./bin.svg": "./template/styles/icons/bin.svg",
	"./burger.svg": "./template/styles/icons/burger.svg",
	"./chevron-right.svg": "./template/styles/icons/chevron-right.svg",
	"./close.svg": "./template/styles/icons/close.svg",
	"./communication-preferences.svg": "./template/styles/icons/communication-preferences.svg",
	"./emoji-content.svg": "./template/styles/icons/emoji-content.svg",
	"./emoji-happy.svg": "./template/styles/icons/emoji-happy.svg",
	"./heartFilled.svg": "./template/styles/icons/heartFilled.svg",
	"./heartFilledValentines.svg": "./template/styles/icons/heartFilledValentines.svg",
	"./heartPrideFilled.svg": "./template/styles/icons/heartPrideFilled.svg",
	"./heartUnfilled.svg": "./template/styles/icons/heartUnfilled.svg",
	"./heartUnfilledValentines.svg": "./template/styles/icons/heartUnfilledValentines.svg",
	"./icon-share-facebook-normal.svg": "./template/styles/icons/icon-share-facebook-normal.svg",
	"./icon-share-google-normal.svg": "./template/styles/icons/icon-share-google-normal.svg",
	"./icon-share-instagram-normal.svg": "./template/styles/icons/icon-share-instagram-normal.svg",
	"./icon-share-pinterest-normal.svg": "./template/styles/icons/icon-share-pinterest-normal.svg",
	"./icon-share-snapchat-normal.svg": "./template/styles/icons/icon-share-snapchat-normal.svg",
	"./icon-share-twitter-normal.svg": "./template/styles/icons/icon-share-twitter-normal.svg",
	"./icon-share-vk-normal.svg": "./template/styles/icons/icon-share-vk-normal.svg",
	"./icon-share-youtube-normal.svg": "./template/styles/icons/icon-share-youtube-normal.svg",
	"./minus.svg": "./template/styles/icons/minus.svg",
	"./notification-check-green.svg": "./template/styles/icons/notification-check-green.svg",
	"./notification-exclamation-orange.svg": "./template/styles/icons/notification-exclamation-orange.svg",
	"./notification-exclamation.svg": "./template/styles/icons/notification-exclamation.svg",
	"./notification.svg": "./template/styles/icons/notification.svg",
	"./orders.svg": "./template/styles/icons/orders.svg",
	"./plus.svg": "./template/styles/icons/plus.svg",
	"./returns.svg": "./template/styles/icons/returns.svg",
	"./search.svg": "./template/styles/icons/search.svg",
	"./selected.svg": "./template/styles/icons/selected.svg",
	"./sortdown.svg": "./template/styles/icons/sortdown.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./template/styles/icons recursive ^\\.\\/.*\\.svg$";

/***/ }),

/***/ "./template/styles/icons/a.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"24px\" height=\"25px\" viewBox=\"0 0 24 25\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g id=\"loading\" transform=\"translate(-50.000000, -45.000000)\" fill=\"#2D2D2D\">\r\n            <g id=\"a\" transform=\"translate(50.000000, 45.000000)\">\r\n                <g id=\"Shape\">\r\n                    <g id=\"Page-1\">\r\n                        <path d=\"M12.0943984,19.9996697 C8.55002376,19.9996697 5.30341587,17.2294005 5.30341587,12.2673911 C5.30341587,8.37309605 7.73686712,4.59960313 12.1172061,4.59960313 C14.0149939,4.59960313 18.825194,5.24545398 18.825194,12.2673911 C18.825194,19.3072597 13.8024392,19.9996697 12.0943984,19.9996697 L12.0943984,19.9996697 L12.0943984,19.9996697 Z M24,1.01517812 C24,0.795280538 23.818489,0.615650322 23.5980149,0.615650322 L19.3187266,0.615650322 C19.0979357,0.615650322 18.9170582,0.795280538 18.9170582,1.01517812 L18.9170582,2.1300809 C18.9170582,2.31757584 18.790349,2.38238114 18.636714,2.27353341 C17.1143023,1.17656219 14.8626788,0 12.1530014,0 C10.6305897,0 9.17628426,0.266142142 7.83094873,0.790561707 C6.48371258,1.31529586 5.2052162,2.11498064 4.03030462,3.16790941 C2.69225491,4.37593051 1.67446281,5.75351493 1.00733858,7.26070998 C0.33831371,8.76884878 0,10.4531573 0,12.2673911 C0,13.9605081 0.299984162,15.5466649 0.891082837,16.9818191 C1.48249828,18.4166587 2.38245077,19.7442236 3.56686553,20.9270775 C4.75159707,22.1108753 6.07570878,23.0102847 7.50245498,23.6007679 C8.92793412,24.1909365 10.4997624,24.4897959 12.1748588,24.4897959 C15.0559104,24.4897959 17.2172536,23.2720226 18.632596,22.1640408 C18.7890819,22.0466991 18.9170582,22.1099315 18.9170582,22.3040328 L18.9170582,23.4739886 C18.9170582,23.6935716 19.0979357,23.8732018 19.3187266,23.8732018 L23.5980149,23.8732018 C23.818489,23.8732018 24,23.6935716 24,23.4739886 L24,1.01517812 L24,1.01517812 Z\" id=\"Shape\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/account.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#2D2D2D\" stroke-width=\"2\" d=\"M15 6A5 5 0 1 1 5 6a5 5 0 0 1 10 0zm3.725 13H1.275c1.064-2.895 4.54-5 8.725-5 4.186 0 7.66 2.105 8.725 5z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountChristmasFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"29px\" viewBox=\"0 0 22 29\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-55.000000, -4.000000)\" fill-rule=\"nonzero\">\r\n            <g transform=\"translate(55.000000, 4.000000)\">\r\n                <path d=\"M6.16315117,10.1953718 C5.87566366,9.52025111 5.46980247,9.03558175 4.94709822,8.71787876 C3.89516857,8.07850919 2.7001763,7.17376424 1.35559918,6.00225468 C0.00993425005,4.57747934 -0.318210215,2.88047165 0.30076807,0.996823588 C0.473182,0.47214094 1.03829043,0.18657072 1.56297308,0.358984651 C2.08765573,0.531398581 2.37322595,1.09650701 2.20081202,1.62118966 C1.80415592,2.82827642 1.98382865,3.75745863 2.74125747,4.56350273 C3.93457475,5.59662745 5.04223232,6.43525011 5.98588297,7.00880701 C6.2790728,7.18700967 6.54808155,7.39319091 6.79296699,7.62646437 C6.86439981,6.56737936 6.43926425,5.51790009 5.49447571,4.41968952 C5.13429261,4.00101712 5.18170756,3.36962998 5.60037996,3.00944688 C6.01905237,2.64926378 6.6504395,2.69667873 7.0106226,3.11535113 C8.69735151,5.07598407 9.20512084,7.16427468 8.48186986,9.24866056 C9.19279728,9.08705102 10.0270382,9 11,9 C11.987158,9 12.8268595,9.11004762 13.5377271,9.30599162 C12.7850604,7.20257844 13.2865768,5.09396015 14.9887705,3.11535113 C15.3489536,2.69667873 15.9803407,2.64926378 16.3990131,3.00944688 C16.8176855,3.36962998 16.8651005,4.00101712 16.5049174,4.41968952 C15.5607971,5.51712331 15.1355949,6.56589471 15.2062753,7.62421706 C15.4505285,7.3918665 15.7187505,7.1864372 16.0109985,7.00880701 C16.9546491,6.43525011 18.0623067,5.59662745 19.255624,4.56350273 C20.0130528,3.75745863 20.1927255,2.82827642 19.7960694,1.62118966 C19.6236555,1.09650701 19.9092257,0.531398581 20.4339084,0.358984651 C20.958591,0.18657072 21.5236994,0.47214094 21.6961134,0.996823588 C22.3150917,2.88047165 21.9869472,4.57747934 20.6412823,6.00225468 C19.2967051,7.17376424 18.1017129,8.07850919 17.0497832,8.71787876 C16.5108915,9.04542058 16.0961919,9.55043034 15.8073616,10.2586432 C17.4926418,9.71895467 19.2235212,10.0238574 21,11.1733513 C20.3581029,12.4317697 19.6876923,13.14822 18.9887683,13.3227024 C18.6062052,13.4182071 17.9348253,13.2467857 16.9746284,12.8084381 C17.1196736,13.5380641 17.1082764,14.2943338 17,15 C16.594212,17.6446291 14.0004494,21 11,21 C7.99955062,21 5.34371078,17.0503029 5,15 C4.88676157,14.3245103 4.84380247,13.6719051 4.89505259,13.061587 C4.05385014,13.4194068 3.45451049,13.5536956 3.09703364,13.4644536 C2.36829253,13.2825275 1.66928132,12.5355124 1,11.2234081 C2.76418055,10.0818719 4.48523094,9.73919315 6.16315117,10.1953718 Z M21,29 L1,29 C1.55340756,24.9938955 5.81855872,22 11.0004658,22 C16.1814413,22 20.4465924,24.9938955 21,29 Z\" fill=\"#FFFFFF\"></path>\r\n                <circle fill=\"#FF2828\" cx=\"11\" cy=\"17\" r=\"2\"></circle>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountChristmasFilledMobile.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"22px\" height=\"29px\" viewBox=\"0 0 22 29\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-55.000000, -4.000000)\" fill-rule=\"nonzero\">\r\n            <g transform=\"translate(55.000000, 4.000000)\">\r\n                <path d=\"M6.17653245,10.2271385 C5.88831072,9.53542865 5.47796482,9.04054288 4.94709822,8.71787876 C3.89516857,8.07850919 2.7001763,7.17376424 1.35559918,6.00225468 C0.00993425005,4.57747934 -0.318210215,2.88047165 0.30076807,0.996823588 C0.473182,0.47214094 1.03829043,0.18657072 1.56297308,0.358984651 C2.08765573,0.531398581 2.37322595,1.09650701 2.20081202,1.62118966 C1.80415592,2.82827642 1.98382865,3.75745863 2.74125747,4.56350273 C3.93457475,5.59662745 5.04223232,6.43525011 5.98588297,7.00880701 C6.2790728,7.18700967 6.54808155,7.39319091 6.79296699,7.62646437 C6.86439981,6.56737936 6.43926425,5.51790009 5.49447571,4.41968952 C5.13429261,4.00101712 5.18170756,3.36962998 5.60037996,3.00944688 C6.01905237,2.64926378 6.6504395,2.69667873 7.0106226,3.11535113 C8.69735151,5.07598407 9.20512084,7.16427468 8.48186986,9.24866056 C9.19279728,9.08705102 10.0270382,9 11,9 C11.987158,9 12.8268595,9.11004762 13.5377271,9.30599162 C12.7850604,7.20257844 13.2865768,5.09396015 14.9887705,3.11535113 C15.3489536,2.69667873 15.9803407,2.64926378 16.3990131,3.00944688 C16.8176855,3.36962998 16.8651005,4.00101712 16.5049174,4.41968952 C15.5607971,5.51712331 15.1355949,6.56589471 15.2062753,7.62421706 C15.4505285,7.3918665 15.7187505,7.1864372 16.0109985,7.00880701 C16.9546491,6.43525011 18.0623067,5.59662745 19.255624,4.56350273 C20.0130528,3.75745863 20.1927255,2.82827642 19.7960694,1.62118966 C19.6236555,1.09650701 19.9092257,0.531398581 20.4339084,0.358984651 C20.958591,0.18657072 21.5236994,0.47214094 21.6961134,0.996823588 C22.3150917,2.88047165 21.9869472,4.57747934 20.6412823,6.00225468 C19.2967051,7.17376424 18.1017129,8.07850919 17.0497832,8.71787876 C16.5186593,9.04069926 16.108173,9.53590837 15.81993,10.2281444 C17.5012471,9.74955495 19.2279371,10.0239356 21,11.0512862 C20.3581029,12.1787899 19.6876923,12.8207071 18.9887683,12.9770379 C18.5962956,13.0648236 17.8998495,12.9009014 16.89943,12.4852713 C17.1209218,13.3122413 17.1243621,14.1894986 17,15 C16.594212,17.6446291 14.0004494,21 11,21 C7.99955062,21 5.34371078,17.0503029 5,15 C4.85388466,14.128393 4.82478162,13.2948878 4.96410082,12.541168 C4.0365612,12.9154853 3.38560483,13.0607752 3.01123169,12.9770379 C2.31230765,12.8207071 1.64189709,12.1787899 1,11.0512862 C2.7708201,10.0246561 4.49633092,9.74994018 6.17653245,10.2271385 Z M21,29 L1,29 C1.55340756,24.9938955 5.81855872,22 11.0004658,22 C16.1814413,22 20.4465924,24.9938955 21,29 Z\" fill=\"#2D2D2D\"></path>\r\n                <circle fill=\"#FF2828\" cx=\"11\" cy=\"17\" r=\"2\"></circle>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountChristmasUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"29px\" viewBox=\"0 0 22 29\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-11.000000, -4.000000)\" fill-rule=\"nonzero\">\r\n            <g transform=\"translate(11.000000, 4.000000)\">\r\n                <path d=\"M11.0004658,24 C7.93229139,24 5.3298502,25.2232499 3.96504502,27 L18.0349748,27 C16.6702444,25.2232742 14.0680371,24 11.0004658,24 Z M21,29 L1,29 C1.55340756,24.9938955 5.81855872,22 11.0004658,22 C16.1814413,22 20.4465924,24.9938955 21,29 Z\" fill=\"#FFFFFF\"></path>\r\n                <path d=\"M6.16260756,10.1952241 C5.87515962,9.51994954 5.471518,9.03666082 4.94703839,8.71787876 C3.89510874,8.07850919 2.70011647,7.17376424 1.35553935,6.00225468 C0.00987442173,4.57747934 -0.318270043,2.88047165 0.300708241,0.996823588 C0.473122172,0.47214094 1.0382306,0.18657072 1.56291325,0.358984651 C2.0875959,0.531398581 2.37316612,1.09650701 2.20075219,1.62118966 C1.80409609,2.82827642 1.98376882,3.75745863 2.74119765,4.56350273 C3.93451492,5.59662745 5.04217249,6.43525011 5.98582314,7.00880701 C6.27867508,7.1868043 6.54777071,7.39313607 6.79294328,7.62681562 C6.8644938,6.56761141 6.4393687,5.5180215 5.49447571,4.41968952 C5.13429261,4.00101712 5.18170756,3.36962998 5.60037996,3.00944688 C6.01905237,2.64926378 6.6504395,2.69667873 7.0106226,3.11535113 C8.69735151,5.07598407 9.20512084,7.16427468 8.48186986,9.24866056 C9.19279728,9.08705102 10.0270382,9 11,9 C11.987158,9 12.8268595,9.11004762 13.5377271,9.30599162 C12.7850604,7.20257844 13.2865768,5.09396015 14.9887705,3.11535113 C15.3489536,2.69667873 15.9803407,2.64926378 16.3990131,3.00944688 C16.8176855,3.36962998 16.8651005,4.00101712 16.5049174,4.41968952 C15.5607075,5.51722749 15.1355142,6.56609384 15.2062954,7.62451847 C15.4508258,7.39177776 15.7191171,7.18621441 16.0109985,7.00880701 C16.9546491,6.43525011 18.0623067,5.59662745 19.255624,4.56350273 C20.0130528,3.75745863 20.1927255,2.82827642 19.7960694,1.62118966 C19.6236555,1.09650701 19.9092257,0.531398581 20.4339084,0.358984651 C20.958591,0.18657072 21.5236994,0.47214094 21.6961134,0.996823588 C22.3150917,2.88047165 21.9869472,4.57747934 20.6412823,6.00225468 C19.2967051,7.17376424 18.1017129,8.07850919 17.0497832,8.71787876 C16.5090233,9.04655608 16.0968049,9.55002705 15.807861,10.2584833 C17.4929837,9.71901492 19.2236967,10.0239709 21,11.1733513 C20.3581029,12.4317697 19.6876923,13.14822 18.9887683,13.3227024 C18.6062052,13.4182071 17.9348253,13.2467857 16.9746284,12.8084381 C17.1196736,13.5380641 17.1082764,14.2943338 17,15 C16.594212,17.6446291 14.0004494,21 11,21 C7.99955062,21 5.34371078,17.0503029 5,15 C4.88676157,14.3245103 4.84380247,13.6719051 4.89505259,13.061587 C4.05385014,13.4194068 3.45451049,13.5536956 3.09703364,13.4644536 C2.36829253,13.2825275 1.66928132,12.5355124 1,11.2234081 C2.76399004,10.0819952 4.48485923,9.73926717 6.16260756,10.1952241 Z M15.0231357,14.6966728 C15.3840994,12.3441756 14.3848212,11 11,11 C7.36691593,11 6.52998343,12.0297805 6.97247595,14.6693361 C7.26424487,16.4097956 9.51761949,19 11,19 C12.6545337,19 14.7054115,16.7673665 15.0231357,14.6966728 Z\" fill=\"#FFFFFF\"></path>\r\n                <circle fill=\"#FF2828\" cx=\"11\" cy=\"17\" r=\"2\"></circle>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountChristmasUnfilledMobile.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"22px\" height=\"29px\" viewBox=\"0 0 22 29\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-11.000000, -4.000000)\" fill-rule=\"nonzero\">\r\n            <g transform=\"translate(11.000000, 4.000000)\">\r\n                <path d=\"M11.0004658,24 C7.93229139,24 5.3298502,25.2232499 3.96504502,27 L18.0349748,27 C16.6702444,25.2232742 14.0680371,24 11.0004658,24 Z M21,29 L1,29 C1.55340756,24.9938955 5.81855872,22 11.0004658,22 C16.1814413,22 20.4465924,24.9938955 21,29 Z\" fill=\"#2D2D2D\"></path>\r\n                <path d=\"M6.17598152,10.2269821 C5.88772969,9.53507527 5.4797037,9.04163615 4.94703839,8.71787876 C3.89510874,8.07850919 2.70011647,7.17376424 1.35553935,6.00225468 C0.00987442173,4.57747934 -0.318270043,2.88047165 0.300708241,0.996823588 C0.473122172,0.47214094 1.0382306,0.18657072 1.56291325,0.358984651 C2.0875959,0.531398581 2.37316612,1.09650701 2.20075219,1.62118966 C1.80409609,2.82827642 1.98376882,3.75745863 2.74119765,4.56350273 C3.93451492,5.59662745 5.04217249,6.43525011 5.98582314,7.00880701 C6.27867508,7.1868043 6.54777071,7.39313607 6.79294328,7.62681562 C6.8644938,6.56761141 6.4393687,5.5180215 5.49447571,4.41968952 C5.13429261,4.00101712 5.18170756,3.36962998 5.60037996,3.00944688 C6.01905237,2.64926378 6.6504395,2.69667873 7.0106226,3.11535113 C8.70184288,5.08120477 9.20781662,7.17539683 8.47606614,9.26531116 C9.19001127,9.09303813 10.0329502,9 11.0216159,9 C12.0031336,9 12.8363393,9.11261168 13.5401803,9.31283482 C12.783974,7.20715203 13.2847308,5.09610588 14.9887705,3.11535113 C15.3489536,2.69667873 15.9803407,2.64926378 16.3990131,3.00944688 C16.8176855,3.36962998 16.8651005,4.00101712 16.5049174,4.41968952 C15.5607075,5.51722749 15.1355142,6.56609384 15.2062954,7.62451847 C15.4508258,7.39177776 15.7191171,7.18621441 16.0109985,7.00880701 C16.9546491,6.43525011 18.0623067,5.59662745 19.255624,4.56350273 C20.0130528,3.75745863 20.1927255,2.82827642 19.7960694,1.62118966 C19.6236555,1.09650701 19.9092257,0.531398581 20.4339084,0.358984651 C20.958591,0.18657072 21.5236994,0.47214094 21.6961134,0.996823588 C22.3150917,2.88047165 21.9869472,4.57747934 20.6412823,6.00225468 C19.2967051,7.17376424 18.1017129,8.07850919 17.0497832,8.71787876 C16.5168104,9.04182304 16.1087037,9.53556305 15.8204203,10.2280048 C17.5015828,9.7496083 19.2281094,10.0240354 21,11.0512862 C20.3581029,12.1787899 19.6876923,12.8207071 18.9887683,12.9770379 C18.5847269,13.0674112 17.858528,12.8910191 16.8101717,12.4478615 C17.03775,13.2857451 17.043107,14.1772657 16.9190264,15 C16.5201766,17.6446291 13.9707628,21 11.0216159,21 C8.0724689,21 5.46203927,17.0503029 5.12420534,15 C4.97706218,14.106993 4.95064757,13.2539818 5.09930647,12.4857962 C4.09956411,12.9010394 3.40353919,13.0647866 3.01123169,12.9770379 C2.31230765,12.8207071 1.64189709,12.1787899 1,11.0512862 C2.77062656,10.0247683 4.49595373,9.75000024 6.17598152,10.2269821 Z M14.9413907,14.7017429 C15.2975432,12.340224 14.3182384,11 11.0216159,11 C7.47964942,11 6.66095275,12.0248661 7.09759593,14.6748391 C7.38447081,16.4158733 9.59411969,19 11.0216159,19 C12.619148,19 14.6288418,16.7741421 14.9413907,14.7017429 Z\" fill=\"#2D2D2D\"></path>\r\n                <circle fill=\"#FF2828\" cx=\"11\" cy=\"17\" r=\"2\"></circle>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n  <path fill=\"#fff\" d=\"M16 6A6 6 0 1 1 4 6a6 6 0 0 1 12 0zm4 14H0c.553-4.006 4.819-7 10-7s9.447 2.994 10 7z\"></path>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/accountUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n  <path fill=\"#fff\" d=\"M14 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0zm2 0A6 6 0 1 1 4 6a6 6 0 0 1 12 0zm-6 9c-3.068 0-5.67 1.223-7.035 3h14.07c-1.365-1.777-3.967-3-7.035-3zm10 5H0c.553-4.006 4.819-7 10-7s9.447 2.994 10 7z\"></path>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/alert.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <defs>\r\n        <filter id=\"a\" width=\"101.9%\" height=\"105.4%\" x=\"-.9%\" y=\"-1.9%\" filterUnits=\"objectBoundingBox\">\r\n            <feOffset dy=\"1\" in=\"SourceAlpha\" result=\"shadowOffsetOuter1\"/>\r\n            <feGaussianBlur in=\"shadowOffsetOuter1\" result=\"shadowBlurOuter1\" stdDeviation=\"1\"/>\r\n            <feColorMatrix in=\"shadowBlurOuter1\" result=\"shadowMatrixOuter1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"/>\r\n            <feMerge>\r\n                <feMergeNode in=\"shadowMatrixOuter1\"/>\r\n                <feMergeNode in=\"SourceGraphic\"/>\r\n            </feMerge>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\" filter=\"url(#a)\" transform=\"translate(-14 -18)\">\r\n        <path fill-rule=\"nonzero\" d=\"M25 35a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm0-16a9 9 0 1 0 0 18 9 9 0 0 0 0-18z\"/>\r\n        <path d=\"M24 27v6h2v-6h-2zm0-3c0 .548.452 1 1 1s1-.452 1-1-.452-1-1-1-1 .452-1 1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/backArrow.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"15\" viewBox=\"0 0 21 15\">\r\n    <path d=\"M3.817 8.06h16.194v-2H3.817l4.646-4.646L7.05 0 0 7.049l.011.011L0 7.071l7.049 7.049 1.414-1.414L3.817 8.06z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bagFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M4.083 5a6.002 6.002 0 0 1 11.834 0H20v14.986L0 20V5h4.083zM14 5c0-1.001-1.06-3.274-4-3.274S6 4.006 6 5c0 0 8 .012 8 0z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bagUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M18 17.987V7H2v11l16-.013zM4.077 5A5.996 5.996 0 0 1 10 0c2.973 0 5.562 2.162 6.038 5H20v14.986L0 20V5h4.077zm9.902-.005C13.531 3.275 11.86 2 10 2 8.153 2 6.604 3.294 6.144 4.995c.92 0 7.654.03 7.835 0z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/bin.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"20\" viewBox=\"0 0 16 20\">\r\n    <path fill=\"#666\" fill-rule=\"evenodd\" d=\"M0 5h16v2H0V5zm14 3.07v9.27c0 1.47-1.15 2.66-2.574 2.66H4.574C3.153 20 2 18.797 2 17.34V8.07h12zM4 17.15c0 .462.363.85.803.85h6.394c.446 0 .803-.381.803-.85V8.1H4v9.05zM6 9h1v8H6V9zm3 0h1v8H9V9zM7 0h2c1.656 0 3 1.339 3 3v1.038H4V3c0-1.656 1.339-3 3-3zm3 3.999V3c0-.554-.446-1-1-1H7c-.554 0-1 .446-1 1v.999h4z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/burger.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 14\">\r\n    <g>\r\n        <path d=\"M0 0h18v2H0zM0 6h18v2H0zM0 12h18v2H0z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/chevron-right.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 44 44\">\r\n    <path fill=\"#2D2D2D\" fill-rule=\"evenodd\" d=\"M26.364 21.293l.707.707L20 29.071l-1.414-1.414L24.243 22l-5.657-5.657L20 14.93l6.364 6.364z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/close.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" focusable=\"false\">\r\n    <path d=\"M9.97 8.274L2.335.637.637 2.334 8.274 9.97.637 17.607l1.697 1.697 7.637-7.636 7.636 7.636 1.697-1.697-7.636-7.636 7.636-7.637L17.607.637 9.971 8.274z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/communication-preferences.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M4.667 14h11.339c1.1 0 1.994-.9 1.994-2.009V4.01A2.003 2.003 0 0 0 16.006 2H3.994C2.894 2 2 2.9 2 4.009V16l2.667-2zm.666 2L0 20V4.009A4.002 4.002 0 0 1 3.994 0h12.012C18.215 0 20 1.8 20 4.009v7.982A4.002 4.002 0 0 1 16.006 16H5.333z\"/>\r\n        <path d=\"M6 8.333c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833S7 7.04 7 7.5c0 .46-.448.833-1 .833zm4 0c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833s1 .373 1 .833c0 .46-.448.833-1 .833zm4 0c-.552 0-1-.373-1-.833 0-.46.448-.833 1-.833s1 .373 1 .833c0 .46-.448.833-1 .833z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/emoji-content.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"88\" height=\"88\" viewBox=\"0 0 88 88\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFD95A\">\r\n            <path d=\"M29 0h30v88H29z\"/>\r\n            <path d=\"M18 6h52v76H18z\"/>\r\n            <path d=\"M12 12h64v64H12z\"/>\r\n            <path d=\"M6 18h76v52H6z\"/>\r\n            <path d=\"M0 30h88v28H0z\"/>\r\n            <g opacity=\".6\" style=\"mix-blend-mode:multiply\">\r\n                <path d=\"M29 0h30v88H29z\"/>\r\n                <path d=\"M18 6h52v76H18z\"/>\r\n                <path d=\"M12 12h64v64H12z\"/>\r\n                <path d=\"M6 18h76v52H6z\"/>\r\n                <path d=\"M0 30h88v28H0z\"/>\r\n            </g>\r\n        </g>\r\n        <path fill=\"#2D2D2D\" d=\"M22 29h6v6h-6zM60 29h6v6h-6zM16 35h6v6h-6zM54 35h6v6h-6zM28 35h6v6h-6zM66 35h6v6h-6zM29 55h6v6h-6zM53 55h6v6h-6z\"/>\r\n        <path fill=\"#D01345\" d=\"M59 49h12v6H59zM17 49h12v6H17z\" opacity=\".6\"/>\r\n        <path fill=\"#2D2D2D\" d=\"M35 61h18v6H35z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/emoji-happy.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"88\" height=\"88\" viewBox=\"0 0 88 88\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"#FFD95A\">\r\n            <path d=\"M29 0h30v88H29z\"/>\r\n            <path d=\"M18 6h52v76H18z\"/>\r\n            <path d=\"M12 12h64v64H12z\"/>\r\n            <path d=\"M6 18h76v52H6z\"/>\r\n            <path d=\"M0 30h88v28H0z\"/>\r\n            <g opacity=\".6\" style=\"mix-blend-mode:multiply\">\r\n                <path d=\"M29 0h30v88H29z\"/>\r\n                <path d=\"M18 6h52v76H18z\"/>\r\n                <path d=\"M12 12h64v64H12z\"/>\r\n                <path d=\"M6 18h76v52H6z\"/>\r\n                <path d=\"M0 30h88v28H0z\"/>\r\n            </g>\r\n        </g>\r\n        <path fill=\"#2D2D2D\" d=\"M23 51h42v6H23zM29 57h30v6H29zM35 63h18v6H35zM24 37h6v6h-6zM58 37h6v6h-6zM24 31h6v6h-6zM58 31h6v6h-6z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartFilledValentines.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"21\" viewBox=\"0 0 23 21\">\r\n    <g fill=\"none\" fill-rule=\"nonzero\">\r\n        <path fill=\"#FFF\" d=\"M10.996 2.763l.203-.2A5.726 5.726 0 0 1 15.116 1C18.362.996 20.996 3.725 21 7.097 21.01 14.845 11.014 19 11.014 19S1.01 14.87 1 7.124C.997 3.752 3.624 1.014 6.87 1.01a5.733 5.733 0 0 1 3.921 1.553l.205.199z\"/>\r\n        <path fill=\"#FFF\" d=\"M5 15.333V15h1v1h-.333l-.167.5-.5.5v3H4v-2l-1 1v2H2v-2H0v-1h2l1-1H1v-1h3l.5-.5.5-.167zM23 0h-4v1h2l-4.359 3.47.938 1.144L22 2v2h1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartPrideFilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"18\" viewBox=\"0 0 20 18\">\r\n    <defs>\r\n        <path id=\"a\" d=\"M9.966 3.105l.17-.166A4.772 4.772 0 0 1 13.4 1.636c2.705-.003 4.9 2.271 4.903 5.08.009 6.458-8.321 9.92-8.321 9.92S1.644 13.195 1.636 6.74C1.634 3.93 3.823 1.65 6.527 1.645A4.778 4.778 0 0 1 9.796 2.94l.17.165z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <mask id=\"b\" fill=\"#fff\">\r\n            <use xlink:href=\"#a\"/>\r\n        </mask>\r\n        <use fill=\"#FFF\" fill-rule=\"nonzero\" xlink:href=\"#a\"/>\r\n        <g mask=\"url(#b)\">\r\n            <path fill=\"#BD10E0\" d=\"M20 16H.364v-3H20z\"/>\r\n            <path fill=\"#0770CF\" d=\"M20 13H.364v-2H20z\"/>\r\n            <path fill=\"#00AA5B\" d=\"M20 11H.364V9H20z\"/>\r\n            <path fill=\"#F8E71C\" d=\"M20 9H.364V7H20z\"/>\r\n            <path fill=\"#F5A623\" d=\"M20 7H.364V5H20z\"/>\r\n            <path fill=\"#D0021B\" d=\"M20 5H.364V2H20z\"/>\r\n        </g>\r\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M10.618 15.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C3.749 2.013 1.998 3.837 2 6.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zM9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartUnfilled.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\">\r\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M10.618 15.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C3.749 2.013 1.998 3.837 2 6.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zM9.996 1.763l.203-.2A5.726 5.726 0 0 1 14.116 0c3.246-.004 5.88 2.725 5.884 6.097C20.01 13.845 10.014 18 10.014 18S.01 13.87 0 6.124C-.003 2.752 2.624.014 5.87.01A5.733 5.733 0 0 1 9.79 1.564l.205.199z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/heartUnfilledValentines.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"23\" height=\"21\" viewBox=\"0 0 23 21\">\r\n    <g fill=\"none\" fill-rule=\"nonzero\">\r\n        <path fill=\"#FFF\" d=\"M11.618 16.474a21.327 21.327 0 0 0 3.137-2.076c2.697-2.166 4.249-4.619 4.245-7.299-.003-2.284-1.757-4.101-3.881-4.099-1.016 0-1.97.417-2.69 1.158l-1.43 1.467-1.432-1.463a3.748 3.748 0 0 0-2.695-1.151C4.749 3.013 2.998 4.837 3 7.12c.003 2.677 1.559 5.123 4.256 7.281a21.32 21.32 0 0 0 3.756 2.39c.191-.096.394-.202.606-.318zm-.622-13.711l.203-.2A5.726 5.726 0 0 1 15.116 1C18.362.996 20.996 3.725 21 7.097 21.01 14.845 11.014 19 11.014 19S1.01 14.87 1 7.124C.997 3.752 3.624 1.014 6.87 1.01a5.733 5.733 0 0 1 3.921 1.553l.205.199z\"/>\r\n        <path fill=\"#FFF\" d=\"M5 15.333V15h1v1h-.333l-.167.5-.5.5v3H4v-2l-1 1v2H2v-2H0v-1h2l1-1H1v-1h3l.5-.5.5-.167zM23 0h-4v1h2l-4.359 3.47.938 1.144L22 2v2h1z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-facebook-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\">\r\n    <path fill=\"#3C5A99\" fill-rule=\"evenodd\" d=\"M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm6.075-21.75H8.925c-.341 0-.675.334-.675.675v12.15c0 .341.333.675.675.675H15v-5.4h-1.35v-2.025H15v-1.35c.46-1.737 1.526-2.686 2.7-2.7 1.126.014 1.767.07 2.025 0V12.3h-1.35c-.646-.108-.81.294-1.35.675v1.35h2.7l-.675 2.025h-2.025v5.4h4.05c.341 0 .675-.334.675-.675V8.925c0-.341-.334-.675-.675-.675z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-google-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle cx=\"20\" cy=\"20\" r=\"20\" fill=\"#FFF\" stroke=\"#CCC\" stroke-width=\"2\"/>\r\n        <path fill=\"#FFF\" d=\"M17.192 11.502a9.2 9.2 0 0 0-5.184 4.539 9.057 9.057 0 0 0-.797 2.302 9.18 9.18 0 0 0 .792 5.916 9.23 9.23 0 0 0 2.484 3.054 9.115 9.115 0 0 0 3.324 1.677c1.525.408 3.148.399 4.682.05 1.387-.32 2.7-.984 3.748-1.948 1.107-1.018 1.898-2.356 2.316-3.797.458-1.569.517-3.246.232-4.859h-8.607v3.57h4.987a4.309 4.309 0 0 1-1.83 2.828 5.24 5.24 0 0 1-2.016.797 6.035 6.035 0 0 1-2.184-.005 5.416 5.416 0 0 1-2.036-.88 5.656 5.656 0 0 1-2.095-2.808 5.551 5.551 0 0 1 0-3.561 5.714 5.714 0 0 1 1.328-2.159 5.426 5.426 0 0 1 2.734-1.52 5.458 5.458 0 0 1 2.686.109c.737.22 1.416.63 1.972 1.16l1.682-1.682c.295-.3.605-.59.89-.9a8.92 8.92 0 0 0-2.946-1.824 9.233 9.233 0 0 0-6.162-.06z\"/>\r\n        <path fill=\"#EA4335\" d=\"M17.192 11.502a9.263 9.263 0 0 1 6.162.054A8.89 8.89 0 0 1 26.3 13.38c-.285.31-.595.6-.89.9l-1.682 1.682a4.982 4.982 0 0 0-1.972-1.16 5.4 5.4 0 0 0-2.686-.109 5.466 5.466 0 0 0-2.734 1.52 5.676 5.676 0 0 0-1.328 2.16c-.998-.778-1.997-1.55-3-2.327a9.191 9.191 0 0 1 5.184-4.544z\"/>\r\n        <path fill=\"#FBBC05\" d=\"M11.216 18.338a9.123 9.123 0 0 1 .797-2.302c.998.777 1.997 1.55 3 2.326a5.518 5.518 0 0 0 0 3.561c-.998.777-1.997 1.554-2.995 2.326a9.102 9.102 0 0 1-.802-5.911z\"/>\r\n        <path fill=\"#4285F4\" d=\"M20.182 18.431h8.607a10.82 10.82 0 0 1-.232 4.86c-.418 1.44-1.21 2.778-2.316 3.796l-2.907-2.257a4.309 4.309 0 0 0 1.83-2.828h-4.987c.005-1.19.005-2.38.005-3.57z\"/>\r\n        <path fill=\"#34A853\" d=\"M12.008 24.254c.999-.772 1.997-1.55 2.995-2.326a5.685 5.685 0 0 0 2.095 2.808 5.45 5.45 0 0 0 2.036.88c.718.148 1.461.128 2.184.005a5.24 5.24 0 0 0 2.016-.796l2.907 2.257c-1.048.969-2.36 1.628-3.748 1.948-1.534.349-3.157.359-4.682-.05a9.039 9.039 0 0 1-3.324-1.677 9.21 9.21 0 0 1-2.479-3.049z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-instagram-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"30\" height=\"30\" viewBox=\"0 0 30 30\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path fill=\"#8433B7\" d=\"M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-21.147c2.002 0 2.24.008 3.03.044.73.033 1.128.155 1.392.258.35.136.6.299.862.561.262.262.425.512.56.862.104.264.226.661.259 1.392.036.79.044 1.028.044 3.03s-.008 2.24-.044 3.03c-.033.73-.155 1.128-.258 1.392-.136.35-.299.6-.561.862a2.323 2.323 0 0 1-.862.56c-.264.104-.661.226-1.392.259-.79.036-1.028.044-3.03.044s-2.24-.008-3.03-.044c-.73-.033-1.128-.155-1.392-.258-.35-.136-.6-.299-.862-.561a2.323 2.323 0 0 1-.56-.862c-.104-.264-.226-.661-.259-1.392-.036-.79-.044-1.028-.044-3.03s.008-2.24.044-3.03c.033-.73.155-1.128.258-1.392.136-.35.299-.6.561-.862.262-.262.512-.425.862-.56.264-.104.661-.226 1.392-.259.79-.036 1.028-.044 3.03-.044zm0-1.35c-2.036 0-2.292.008-3.091.044-.798.037-1.343.164-1.82.349a3.675 3.675 0 0 0-1.328.865 3.675 3.675 0 0 0-.865 1.328c-.185.477-.312 1.022-.349 1.82-.036.8-.045 1.055-.045 3.091 0 2.036.009 2.292.045 3.091.037.798.164 1.343.349 1.82.192.493.448.911.865 1.328.417.417.835.673 1.328.865.477.185 1.022.312 1.82.349.8.036 1.055.045 3.091.045 2.036 0 2.292-.009 3.091-.045.798-.037 1.343-.164 1.82-.349a3.675 3.675 0 0 0 1.328-.865c.417-.417.673-.835.865-1.328.185-.477.312-1.022.349-1.82.036-.8.045-1.055.045-3.091 0-2.036-.009-2.292-.045-3.091-.037-.798-.164-1.343-.349-1.82a3.675 3.675 0 0 0-.865-1.328 3.675 3.675 0 0 0-1.328-.865c-.477-.185-1.022-.312-1.82-.349-.8-.036-1.055-.045-3.091-.045zm0 3.647a3.85 3.85 0 1 0 0 7.7 3.85 3.85 0 0 0 0-7.7zm0 6.35a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm4.902-6.502a.9.9 0 1 0-1.8 0 .9.9 0 0 0 1.8 0z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-pinterest-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <path fill=\"#BD081C\" fill-rule=\"evenodd\" d=\"M0 20C0 8.954 8.952 0 20 0c11.046 0 20 8.952 20 20 0 11.046-8.952 20-20 20C8.954 40 0 31.048 0 20zm15.875 6.151c-.175.75.303 2.805.303 2.805s1.469-1.47 1.678-2.229c.12-.437.691-3.572.691-3.572.343.652 1.342 1.225 2.404 1.225 3.163 0 5.309-2.883 5.309-6.743 0-2.917-2.473-5.637-6.23-5.637-4.673 0-7.03 3.352-7.03 6.147 0 1.693.64 3.197 2.016 3.759.224.094.424.003.491-.245.045-.173.154-.61.2-.79.066-.247.042-.333-.14-.55-.397-.466-.649-1.071-.649-1.93 0-2.485 1.86-4.71 4.843-4.71 2.642 0 4.093 1.614 4.093 3.77 0 2.837-1.255 5.23-3.118 5.23-1.03 0-1.8-.85-1.554-1.894.296-1.246.869-2.593.869-3.492 0-.805-.433-1.477-1.327-1.477-1.052 0-1.897 1.089-1.897 2.547 0 .928.314 1.558.314 1.558s-1.077 5.432-1.266 6.228z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-snapchat-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path fill=\"#FFFC02\" d=\"M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20A20 20 0 0 0 20 0zm10 25.94c-.12.28-.66.68-2.54 1a.72.72 0 0 0-.3.65c0 .15-.07.31-.11.47a.25.25 0 0 1-.27.2 2.32 2.32 0 0 1-.42-.05 5.54 5.54 0 0 0-1.13-.12 5 5 0 0 0-.82.07c-.57.146-1.1.42-1.55.8A4.35 4.35 0 0 1 20.13 30h-.26a4.35 4.35 0 0 1-2.68-1.07 3.89 3.89 0 0 0-1.55-.8 5 5 0 0 0-.81-.07 5.51 5.51 0 0 0-1.13.13 2.45 2.45 0 0 1-.42.06A.26.26 0 0 1 13 28c0-.16-.08-.32-.11-.47a.75.75 0 0 0-.3-.65c-1.88-.29-2.42-.69-2.54-1a.37.37 0 0 1 0-.12.21.21 0 0 1 .18-.22c2.89-.48 4.18-3.47 4.24-3.6a1.13 1.13 0 0 0 .1-.94 2 2 0 0 0-1.27-.82l-.3-.05c-.85-.34-.93-.69-.89-.87a.81.81 0 0 1 .78-.52.54.54 0 0 1 .23 0c.31.16.651.252 1 .27a.84.84 0 0 0 .62-.2v-.62a10.35 10.35 0 0 1 .24-4.08A5.22 5.22 0 0 1 19.79 11h.4a5.23 5.23 0 0 1 4.86 3.17c.35 1.33.432 2.718.24 4.08V18.87a.82.82 0 0 0 .56.2 2.55 2.55 0 0 0 1-.27.72.72 0 0 1 .3-.06c.12 0 .24.024.35.07a.64.64 0 0 1 .48.53 1.06 1.06 0 0 1-.9.81l-.28.1a2 2 0 0 0-1.27.82 1.13 1.13 0 0 0 .1.94c.05.13 1.35 3.11 4.24 3.6a.21.21 0 0 1 .18.22.37.37 0 0 1-.05.11z\"/>\r\n        <path fill=\"#000\" fill-rule=\"nonzero\" d=\"M29.446 25.569a.297.297 0 0 0-.026.048l.026-.048zm-2.45-6.08a.393.393 0 0 0 .192-.079.334.334 0 0 0-.05-.003c-.007 0-.014.001.013-.012a3.19 3.19 0 0 1-.27.121l.116-.027zm-13.44 8.05c.435-.094.85-.141 1.277-.146.308.002.615.028.972.091.669.171 1.29.491 1.824.944a3.669 3.669 0 0 0 2.241.905h.246a3.685 3.685 0 0 0 2.313-.882 4.587 4.587 0 0 1 1.87-.948c.307-.052.618-.079.933-.08.423.002.844.046 1.259.133-.01-.457.207-.892.583-1.16l.274-.113c.589-.1 1.037-.207 1.36-.304-.98-.379-1.823-1.031-2.533-1.875-.579-.687-1.007-1.438-1.118-1.753a1.797 1.797 0 0 1-.159-1.494l.086-.169c.353-.505.868-.87 1.387-1.019.056-.016.112-.03.169-.04a3.232 3.232 0 0 1-.671.107 1.487 1.487 0 0 1-1.016-.362l-.23-.2v-.864l.007-.153a9.73 9.73 0 0 0-.193-3.724 4.566 4.566 0 0 0-4.247-2.766h-.405c-1.814-.013-3.462 1.053-4.16 2.613a9.926 9.926 0 0 0-.218 3.91v.926l-.232.2a1.493 1.493 0 0 1-1.09.36 3.137 3.137 0 0 1-1.27-.343l.305-.593-.142.651a.416.416 0 0 1-.107.015c-.061-.001-.117.036-.11-.001.019-.085 0-.162-.018-.185.018.023.048.05.09.08.038.027.086.057.146.088a2.692 2.692 0 0 0 .269.123L13 20.13l.11-.658.313.053a2.666 2.666 0 0 1 1.693 1.093l.086.169c.168.497.11 1.043-.127 1.432a8.177 8.177 0 0 1-1.306 1.995c-.693.777-1.504 1.374-2.444 1.72a5.455 5.455 0 0 1-1 .266.457.457 0 0 0 .39-.478l-.007.146a.297.297 0 0 0 .004-.055c-.001-.014-.222.009-.662.067l.622-.24c.022.058.223.17.653.295.321.093.77.194 1.367.286l.164.025.133.1a1.417 1.417 0 0 1 .568 1.193c0 .008-.223.005-.667-.009l.654-.13a6.498 6.498 0 0 0 .032.107c.066.215.09.327.09.47a.407.407 0 0 0-.423-.393 1.764 1.764 0 0 0 .313-.045zm14.27.013c0 .217-.025.324-.097.56a2.468 2.468 0 0 0-.03.1c-.101.451-.522.757-.937.714a2.984 2.984 0 0 1-.54-.064 4.531 4.531 0 0 0-1.647-.056 3.22 3.22 0 0 0-1.282.661 5.026 5.026 0 0 1-3.163 1.2h-.288a5.01 5.01 0 0 1-3.083-1.228 3.208 3.208 0 0 0-1.23-.652 4.312 4.312 0 0 0-.692-.06 4.83 4.83 0 0 0-.986.112 3.06 3.06 0 0 1-.52.076.927.927 0 0 1-.998-.915c0 .008-.005-.016-.03-.093a2.036 2.036 0 0 1-.067-.246l-.01-.165c-1.672-.284-2.538-.704-2.798-1.375l-.036-.133a1.037 1.037 0 0 1-.009-.27.872.872 0 0 1 .738-.836c1.03-.17 1.912-.725 2.653-1.556a6.856 6.856 0 0 0 1.123-1.727.463.463 0 0 0 .061-.303 1.322 1.322 0 0 0-.768-.458l-.3-.05-.138-.039c-.973-.39-1.439-.976-1.265-1.727a1.477 1.477 0 0 1 1.345-.949c.143-.02.289-.015.43.016l.163.058c.2.103.416.167.654.191a11.222 11.222 0 0 1 .291-4.497 5.885 5.885 0 0 1 5.42-3.508h.393c2.38-.024 4.542 1.386 5.512 3.667.372 1.417.46 2.893.262 4.25v.14c.207-.029.412-.094.626-.201.182-.08.38-.119.567-.116.208 0 .414.042.51.09.516.127.904.555.98 1.082l-.01.247c-.16.68-.711 1.194-1.395 1.309l-.312.104a1.333 1.333 0 0 0-.78.46c-.014.108.015.232.11.406.482 1.254 1.834 2.86 3.711 3.179a.877.877 0 0 1 .752.918l-.022.135c-.024.09-.06.175-.106.254-.295.597-1.157.998-2.762 1.295z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-twitter-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"41\" viewBox=\"0 0 40 41\">\r\n    <path fill=\"#1DA1F2\" fill-rule=\"evenodd\" d=\"M0 20C0 8.954 8.952 0 20 0c11.046 0 20 8.952 20 20 0 11.046-8.952 20-20 20C8.954 40 0 31.048 0 20zm30.14-6.126a6.926 6.926 0 0 1-2.14.63 3.973 3.973 0 0 0 1.641-2.21 7.48 7.48 0 0 1-2.368.973c-.677-.78-1.648-1.267-2.715-1.267-2.056 0-3.722 1.788-3.722 4 0 .31.033.616.094.905-3.087-.159-5.833-1.757-7.67-4.17a4.213 4.213 0 0 0-.501 2.009c0 1.383.656 2.615 1.656 3.322a3.527 3.527 0 0 1-1.686-.498v.055c0 1.934 1.283 3.547 2.985 3.92-.312.091-.642.133-.983.133-.24 0-.467-.017-.696-.072.472 1.595 1.847 2.753 3.475 2.777A7.116 7.116 0 0 1 12 26.036c1.646 1.139 3.599 1.803 5.705 1.803 6.845 0 10.59-6.094 10.59-11.377 0-.17-.004-.34-.013-.512a8.093 8.093 0 0 0 1.858-2.076z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-vk-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <path fill=\"#507299\" fill-rule=\"evenodd\" d=\"M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm-1.257-12.059h1.434s.433-.048.655-.292c.203-.224.197-.644.197-.644s-.028-1.969.865-2.258c.88-.286 2.012 1.902 3.21 2.743.907.636 1.596.497 1.596.497l3.205-.046s1.676-.105.881-1.453c-.065-.11-.463-.997-2.383-2.82-2.01-1.907-1.74-1.598.68-4.897 1.475-2.01 2.064-3.236 1.88-3.762-.176-.5-1.26-.368-1.26-.368l-3.609.023s-.267-.037-.466.084c-.194.119-.318.396-.318.396s-.572 1.555-1.333 2.877c-1.607 2.79-2.25 2.938-2.512 2.764-.611-.404-.458-1.622-.458-2.487 0-2.704.4-3.832-.782-4.123-.392-.097-.68-.162-1.684-.172-1.288-.013-2.378.004-2.994.313-.411.206-.728.664-.535.69.239.033.779.15 1.065.548.37.514.357 1.67.357 1.67s.213 3.182-.496 3.577c-.487.272-1.154-.282-2.587-2.813-.734-1.297-1.288-2.73-1.288-2.73s-.106-.268-.297-.411c-.231-.174-.555-.229-.555-.229l-3.429.023s-.515.015-.703.244c-.169.203-.014.624-.014.624s2.685 6.423 5.724 9.66c2.789 2.967 5.954 2.772 5.954 2.772z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/icon-share-youtube-normal.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 40 40\">\r\n    <path fill=\"#CD201F\" fill-rule=\"evenodd\" d=\"M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm9.8-23.98s-.195-1.371-.795-1.976c-.76-.792-1.613-.796-2.004-.843C24.203 13 20.004 13 20.004 13h-.008s-4.198 0-6.997.201c-.391.047-1.243.05-2.004.843-.6.605-.795 1.976-.795 1.976s-.2 1.611-.2 3.222v1.51c0 1.61.2 3.221.2 3.221s.195 1.372.795 1.976c.76.793 1.76.768 2.205.85 1.6.154 6.8.201 6.8.201s4.203-.006 7.001-.208c.391-.046 1.244-.05 2.004-.843.6-.604.795-1.976.795-1.976s.2-1.61.2-3.22v-1.511c0-1.611-.2-3.222-.2-3.222zM18 23v-6l5 3.01L18 23z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/minus.svg":
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"10px\" height=\"1px\" viewBox=\"0 0 10 1\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-332.000000, -387.000000)\" fill=\"#2D2D2D\">\r\n            <g transform=\"translate(-1.000000, 0.000000)\">\r\n                <g transform=\"translate(0.000000, 72.000000)\">\r\n                    <g transform=\"translate(0.000000, 220.000000)\">\r\n                        <rect x=\"333\" y=\"95\" width=\"10\" height=\"1\"></rect>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>"

/***/ }),

/***/ "./template/styles/icons/notification-check-green.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"#00AA5B\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M9 16A7 7 0 1 1 9 2a7 7 0 0 1 0 14zM9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0z\"/>\r\n        <path d=\"M7.91 9.642L12.153 5.4l1.311 1.311-4.242 4.243-1.414 1.414L5.339 9.9l1.414-1.414L7.91 9.642z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification-exclamation-orange.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path stroke=\"#FFBC00\" stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n        <text fill=\"#FFBC00\" font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n            <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n        </text>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification-exclamation.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path stroke=\"#262626\" stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n        <text fill=\"#262626\" font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n            <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n        </text>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/notification.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\">\r\n    <path stroke-width=\"2\" d=\"M17 9A8 8 0 1 1 1 9a8 8 0 0 1 16 0z\"/>\r\n    <text font-family=\"HelveticaNeue-Bold, Helvetica Neue\" font-size=\"12\" font-weight=\"bold\" transform=\"translate(0 1)\">\r\n      <tspan x=\"7.332\" y=\"12\">!</tspan>\r\n    </text>\r\n  </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/orders.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <g fill=\"#2D2D2D\" fill-rule=\"evenodd\">\r\n        <path fill-rule=\"nonzero\" d=\"M18 4.667L16 2H4L2 4.667V18h16V4.667zM0 4l3-4h14l3 4v16H0V4z\"/>\r\n        <path d=\"M0 4h20v2H0z\"/>\r\n        <path d=\"M9 1.111h2v4H9z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/plus.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"10px\" height=\"10px\" viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <g transform=\"translate(-332.000000, -338.000000)\" fill=\"#2D2D2D\">\r\n            <g transform=\"translate(-1.000000, 0.000000)\">\r\n                <g transform=\"translate(0.000000, 72.000000)\">\r\n                    <g transform=\"translate(0.000000, 220.000000)\">\r\n                        <path d=\"M338.625,50.375 L338.625,46 L337.375,46 L337.375,50.375 L333,50.375 L333,51.625 L337.375,51.625 L337.375,56 L338.625,56 L338.625,51.625 L343,51.625 L343,50.375 L338.625,50.375 Z\"></path>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>"

/***/ }),

/***/ "./template/styles/icons/returns.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\r\n    <path fill=\"#2D2D2D\" fill-rule=\"nonzero\" d=\"M9.7 13l1.8 1.5-1.436 1.5L6 12l4-4 1.5 1.5L9.7 11H20v9H0V3.605L3 0h14l3 3.605V9h-2V6H2v12h16v-5H9.7zM2.5 4H9V2H4L2.5 4zm15 0L16 2h-5v2h6.5z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/search.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"21\" viewBox=\"0 0 17 17\">\r\n    <path fill-rule=\"nonzero\" d=\"M7.65 15.3a7.65 7.65 0 1 1 5.997-2.9c-.01.012 3.183 3.297 3.183 3.297l-1.22 1.18s-3.144-3.283-3.154-3.275A7.618 7.618 0 0 1 7.65 15.3zm0-2a5.65 5.65 0 1 0 0-11.3 5.65 5.65 0 0 0 0 11.3z\"/>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/selected.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <circle cx=\"8\" cy=\"8\" r=\"7.68\" fill=\"#0770CF\"/>\r\n        <path fill=\"#FFF\" d=\"M6.404 9.222l3.879-3.878 1.199 1.199-3.88 3.878-1.292 1.293-2.257-2.257 1.293-1.292 1.058 1.057z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ "./template/styles/icons/sortdown.svg":
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"12\" viewBox=\"0 0 12 12\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <path d=\"M0 0h11.996v11.616H0z\"/>\r\n        <path fill=\"#2D2D2D\" d=\"M4.604 7.684l-.002.002 1.41 1.41.002-.002.007.006 1.41-1.41-.007-.006 2.83-2.83-1.41-1.41-2.83 2.83L3.19 3.449l-1.41 1.41 2.825 2.825z\"/>\r\n    </g>\r\n</svg>\r\n"

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("./client/index.js");


/***/ }),

/***/ "dll-reference vendor":
/***/ (function(module, exports) {

module.exports = vendor;

/***/ })

/******/ });


// WEBPACK FOOTER //
// client.sitechrome.47bfd6.js